(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){
/* global room_data TimelineLite TweenLite ajax_obj obj_file mtl_file Power1 */
var THREE = (typeof window !== "undefined" ? window['THREE'] : typeof global !== "undefined" ? global['THREE'] : null);
var SVG = require('svg.js');
require('../three/pan-controls');
require('three/examples/js/loaders/OBJLoader');
require('three/examples/js/loaders/MTLLoader');
//require('three/examples/js/loaders/GLTFLoader');
//require('three/examples/js/controls/OrbitControls');
//require('three/examples/js/effects/OutlineEffect');
require('three/examples/js/postprocessing/EffectComposer');
require('three/examples/js/postprocessing/RenderPass');
require('three/examples/js/postprocessing/ShaderPass');
//require('three/examples/js/postprocessing/OutlinePass');
require('three/examples/js/shaders/CopyShader');
const castShadows = false;

/*
const shadowObjects = [
    'sides',
    'door',
    'door_1',
    'Side_02_2',
    'Side_01_6',
    'Bottom_5',
    'Top_3',
    'Horizontal_01',
    'Horizontal_02',
    'Horizontal_03',
    'Horizontal_04',
    'Vertical_01',
    'Vertical_02',
    'Vertical_03',
];*/
const recieveShadows = [
    '1st_left_inner_wall',
    '2nd_left_inner_wall',
    'Far_left_wall',
    'Plane_LR',
    'Cube.12',
    //'Back_wall',
    'Back_wall.1',
    'Back_wall.2',
    'Back_wall.3',
    'Cube.14',
    'Cube.16',
    'Cube.6_5',
];
const backButton = document.querySelector('.go-back');
const buttons = document.querySelector('.buttons');
var loaded = false;
const defaultAskew =  {
    x: 0,
    y: 20,
    z: 80,
    rotx: -0.5,
    roty: 0,
    rotz: 0,
};

const askewMod = 
{
    x: 0,
    y: 20,
    z: 80,
    rotx: -0.5,
    roty: 0,
    rotz: 0,
};

const markerPosition = {
    offsetx: -100,
    offsety: 100,
    heightlevel: -1,
    boxpointer: -1,
}

const storedPosition = {
    x:0,
    y: 0,
    z:0,
}

let tempPointerPosition = {
    x:0,
    y: 0,
    z:0,
}

let controllerx
let controllery
let controllerz
let controllerrotx
let controllerroty
let controllerrotz
let markerx
let markery
let selected;
let markerpos;
//let boxpointer;
let dat;
let gui;
if(location.search === '?editor' || location.search == '?lights'){
    
    dat = require('dat.gui');
    gui = new dat.GUI();
    if(location.search === '?editor'){
        controllerx = gui.add(askewMod, 'x', -120, 120);
        controllery = gui.add(askewMod, 'y', -120, 120);
        controllerz = gui.add(askewMod, 'z', -40, 220);
        controllerrotx = gui.add(askewMod, 'rotx', -2, 2);
        controllerroty = gui.add(askewMod, 'roty', -2, 2);
        controllerrotz = gui.add(askewMod, 'rotz', -2, 2);
        markerx = gui.add(markerPosition, 'offsetx', -200, 200);
        markery = gui.add(markerPosition, 'offsety', -200, 200);
        markerpos = gui.add(markerPosition, 'heightlevel', -1, 3, 1);
        //boxpointer = gui.add(markerPosition, 'boxpointer', -1, 1, 1);
        let saveSelected = '';
        var save = { save:function(){ 
            return;
            fetch(ajax_obj.ajax_url+"?action=save_position", 
                {"body":JSON.stringify({
                    post_id,
                    askewMod,
                    markerPosition,
                    pointerPosition:tempPointerPosition,
                    saveSelected,
                }), "method":"POST"}).then(function(){
                location.reload();
            });

        }, selected: ''};
        selected = gui.add(save, 'selected');
        gui.add(save, 'save');
        selected.onChange((value) => {
            saveSelected = value;
        });
    }
    
}

const walls = [
    '1st_left_inner_wall',
    //'1st_left_inner_wall.1',
    '2nd_left_inner_wall',
    '1st_left_inner_wall.2',
    //'Plane_LR'
    //'Cube.14',
    //'Cube.15',
    //'Cube.16',
    //'Cube.6_5',
];

let zoomed = false;
let markersReady = false;
let markerColour;
let markers;
let additional = [];
if(typeof room_data != 'undefined'){
    markers = room_data.markers;
    markerColour = room_data.colour;
    Object.keys(markers).forEach(key => {
        const item = markers[key];
        if(typeof item.additional !== 'undefined'){
            additional = [...additional, ...item.additional];
        }
    });
}


/*
fetch('/wp-content/themes/titon/assets/3d/'+room+'/room.json').
then((response) => {
    return response.json();
}).then((data) => {
    markers = data.markers;
    markerColour = data.colour;
    contentIframe.style.borderColor = markerColour;
});
*/

const TitonHouse = function (element) {
    const that = this;
    this.renderer = null;
    this.canvas = element;
    this.aspectRatio = 1;
    this.highlights = [];
    this.markers = [];
    this.recalcAspectRatio();
    this.scene = null;
    this.savedPoint1 = null;
    this.savedPoint2 = null;
    this.savedMarker = null;
    //390
    this.cameraDefaults = {
        posCamera: new THREE.Vector3( -1100, 110, 600 ),
        posCameraTarget: new THREE.Vector3(0, 0, 0),
        near: 0.1,
        far: 10000,
        fov: 53,
    };
    this.camera = null;
    this.cameraTarget = this.cameraDefaults.posCameraTarget;

    this.controls = null;
    
    this.raycaster = new THREE.Raycaster();
    
    // postprocessing
    this.composer = null;

    this.frustum = new THREE.Frustum()

    this.mouse = new THREE.Vector2(2, 2);
    this.screen = new THREE.Vector2(0, 0);
    this.currentlyIntersected = null;

    this.tooltip = document.querySelector('.overlay');
    this.tooltipText = document.querySelector('.overlay-text');

    this.phongMaterial;

    this.qtip = $(element).qtip({
        content: {
            text: '',
            button: true,
        },
        hide: {
            event: false,
        },
        position: {
            target: [100, 200],
            my: 'right top',
            container: $(element.parentNode),
            adjust: {
                method: 'flip',
            },
        },
        style: {
            width: false, // No set width
            height: false, // No set height
            tip: { // Requires Tips plugin
                width: 25, 
                height: 50,
                border: true,
                //corner: 'top left',
            },
        },
        show: { event: false, ready: false },
        events: {
            hide: function() {
                that.resetCamera();
                that.controls.enabled = true;
            },
        },
    });

    this.qtipapi = this.qtip.qtip('api');

    const testAskew = function(){
        const position = Object.assign({}, storedPosition);
        position.x += askewMod.x;
        position.y += askewMod.y;
        position.z += askewMod.z;
        position.rotx = 0 + askewMod.rotx;
        position.roty = 0 + askewMod.roty;
        position.rotz = 0 + askewMod.rotz;
        that.camera.position.set(position.x, position.y, position.z);
        that.camera.rotation.set(position.rotx, position.roty, position.rotz);
        //cube.position.set(test.x, test.y, test.z);
    }
    if(location.search === '?editor'){
        controllerx.onChange(testAskew);
        controllery.onChange(testAskew);
        controllerz.onChange(testAskew);
        controllerrotx.onChange(testAskew);
        controllerroty.onChange(testAskew);
        controllerrotz.onChange(testAskew);
        markerx.onChange(function() {
            //disable change
            return;
            if(save.selected){
                markers[save.selected].offsetx = markerPosition.offsetx;
                markers[save.selected].offsety = markerPosition.offsety;
                that.markers.forEach((markerObject, key) => {
                    if(markerObject.mesh.name === save.selected){
                        const mesh = markerObject.mesh;
                        that.markers[key].marker.parentNode.removeChild(that.markers[key].marker);
                        that.markers[key] = that.drawMarker(save.selected);
                        that.markers[key].mesh = mesh;
                    }
                });
            }
        });
        markery.onChange(function() {
            //disable change
            return;
            if(save.selected){
                markers[save.selected].offsetx = markerPosition.offsetx;
                markers[save.selected].offsety = markerPosition.offsety;
                that.markers.forEach((markerObject, key) => {
                    if(markerObject.mesh.name === save.selected){
                        const mesh = markerObject.mesh;
                        that.markers[key].marker.parentNode.removeChild(that.markers[key].marker);
                        that.markers[key] = that.drawMarker(save.selected);
                        that.markers[key].mesh = mesh;
                    }
                });
            }
        })
    }


    this.tweenCamera = function(position, pointAt = false, marker = {}){
        this.savedPoint1 = position;
        this.savedPoint2 = pointAt;
        this.savedMarker = marker;
        const that = this;

        let {askew, boxpointer} = marker;
        
        const original = position.clone();

        if (!pointAt){
            pointAt = that.cameraDefaults.posCameraTarget;
        }
        
        const from = {
            x : this.camera.position.x,
            y : this.camera.position.y,
            z : this.camera.position.z,
            rotx : this.camera.rotation.x,
            roty : this.camera.rotation.y,
            rotz : this.camera.rotation.z,
            lx: this.cameraTarget.x,
            ly: this.cameraTarget.y,
            lz: this.cameraTarget.z,
        };
        storedPosition.x = position.x;
        storedPosition.y = position.y;
        storedPosition.z = position.z;
        if (askew){
            if(window.innerWidth < 420){
                position.z += 40;
                position.x += 5;
                position.y += 10;
            } else {
                position.z += askew.z;
                position.y += askew.y;
                position.x += askew.x;
                if(window.innerWidth < 690){
                    position.x -= 20;
                }
            }
            if(location.search === '?editor'){
                controllerx.setValue(askew.x);
                controllery.setValue(askew.y);
                controllerz.setValue(askew.z);
                controllerrotx.setValue(askew.rotx);
                controllerroty.setValue(askew.roty);
                controllerrotz.setValue(askew.rotz);
            }
        }
        
        const to = {
            x : position.x,
            y : position.y,
            z : position.z,
            rotx : 0,
            roty : 0,
            rotz : 0,
            lx: pointAt.x,
            ly: pointAt.y,
            lz: pointAt.z,
            ease:Power1.easeInOut,
            onUpdate() {
                that.camera.position.set(from.x, from.y, from.z);
                //if (askew){
                //that.camera.lookAt(pointAt);
                //} else {
                that.camera.rotation.set(from.rotx, from.roty, from.rotz);
                if(typeof that.qtipapi !== 'undefined' && that.qtipapi.tooltip){
                    that.qtipapi.tooltip.removeClass('show');
                }
                if(askew){
                    let contentPos = that.vectorToScreen(original.clone(), that.camera);
                    const {width, height} = that.renderer.getContext().canvas;

                    const middleWidth = 0.5 * width;
                    const middleHeight = 0.5 * height;
                    let tipPoint = '';
                    if(contentPos.x > middleWidth){
                        tipPoint += 'right ';
                    } else {
                        tipPoint += 'left ';
                    }
                    if(contentPos.y > middleHeight){
                        tipPoint += 'bottom';
                    } else {
                        tipPoint += 'top';
                    }
                    if(typeof boxpointer != 'undefined' && boxpointer == 1){
                        tipPoint = tipPoint.replace(/([^ ]*) ([^ ]*)/, "$2 $1");
                    }
                    if(window.innerWidth < 420){
                        tipPoint = 'bottom left';
                    }
                    that.qtipapi.set({
                        'position.target': [contentPos.x, contentPos.y],
                    });
                    if(that.qtipapi.get('position.my') != tipPoint){
                        that.qtipapi.tooltip.removeClass('qtip-pos-br qtip-pos-bl qtip-pos-tr qtip-pos-tl qtip-pos-rb qtip-pos-lb qtip-pos-rt qtip-pos-lt');
                        that.qtipapi.set({
                            'position.my': tipPoint,
                        });
                    }

                }
                //}
            },
            onComplete() {
                //if (askew){
                //that.camera.lookAt(pointAt);
                //} else {
                setTimeout(() => {
                    if(typeof that.qtipapi !== 'undefined' && that.qtipapi.tooltip){
                        that.qtipapi.tooltip.toggleClass('show', askew);
                    }
                }, askew ? 366 : 333);
                that.camera.rotation.set(from.rotx, from.roty, from.rotz);
                markersReady = false;
                if(askew){
                    setTimeout(() => {
                        const contentPos = that.vectorToScreen(original.clone(), that.camera);
                        const {width, height} = that.renderer.getContext().canvas;

                        const middleWidth = 0.5 * width;
                        const middleHeight = 0.5 * height;
                        let tipPoint = '';
                        if(contentPos.x > middleWidth){
                            tipPoint += 'right ';
                        } else {
                            tipPoint += 'left ';
                        }
                        if(contentPos.y > middleHeight){
                            tipPoint += 'bottom';
                        } else {
                            tipPoint += 'top';
                        }
                        if(typeof boxpointer != 'undefined' && boxpointer == 1){
                            tipPoint = tipPoint.replace(/([^ ]*) ([^ ]*)/, "$2 $1");
                        }
                        if(window.innerWidth < 420){
                            tipPoint = 'bottom left';
                        }
                        that.qtipapi.set({
                            'position.target': [contentPos.x, contentPos.y],
                        });
                        if(that.qtipapi.get('position.my') != tipPoint){
                            that.qtipapi.tooltip.removeClass('qtip-pos-br qtip-pos-bl qtip-pos-tr qtip-pos-tl qtip-pos-rb qtip-pos-lb qtip-pos-rt qtip-pos-lt');
                            that.qtipapi.set({
                                'position.my': tipPoint,
                            });
                        }
                    }, 333);
                }
                //}
                //that.cameraTarget = new THREE.Vector3(from.lx,from.ly,from.lz);
            },
        };

        if (askew){
            to.rotx += askew.rotx;
            to.roty += askew.roty;
            to.rotz += askew.rotz;
        }

        if(window.innerWidth < 420){
            to.rotx = 0;
            to.roty = 0;
            to.rotz = 0;
        }

        const tl = new TimelineLite();
        tl.add( TweenLite.to(from, 1, to) );

        if (askew){
            //tl.add( TweenLite.set(contentIframe, {width: 10, height:0}) );
            //tl.add( TweenLite.to(contentIframe, 2, {width: 10, height: 200}) );
            //tl.add( TweenLite.to(contentIframe, 2, {width: 200, height: 200}) );
        }
    };
    if(backButton){
        backButton.addEventListener('click', () => {
            this.resetCamera();
            this.controls.enabled = true;
            backButton.classList.remove('active');
            //.setAttribute('src', '');
            
        });
    }

    /*
    this.canvas.addEventListener('click', () => {
        if (this.highlights.length === 0){
            return;
        }
        this.raycaster.setFromCamera(this.mouse, this.camera);
    
        const intersects = this.raycaster.intersectObjects(this.highlights);
        console.log(intersects);
        
        if (intersects.length > 0) {
            //const point = this.getCenterPoint(intersects[0].object);
            const pointonScreen = this.toScreenPosition(intersects[0].object, this.camera);
            console.log(pointonScreen);
            //backButton.classList.add('active');
            //contentIframe.classList.add('active');
            //contentIframe.setAttribute('src', 'https://en.wikipedia.org/wiki/Special:Random');
            //this.tweenCamera(point, point, true);
            
            //console.log(point);
        }
    });
    */
};
  

TitonHouse.prototype = {
    constructor: TitonHouse,
    lights: 0,
    addLight(x, y, z, intensity = .6, distance=0, castShadow = false) {
        const spotlight = new THREE.PointLight(0xffffff, intensity, distance, 2);
        spotlight.position.set(x, y, z);
        spotlight.castShadow = castShadow;
                    
        spotlight.shadow.radius = 0.3;
        spotlight.shadow.mapSize.width = 2000;
        spotlight.shadow.mapSize.height = 2000;
        spotlight.shadow.camera.near = 0.1;
        spotlight.shadow.camera.far = 10000;
        


        this.scene.add(spotlight);
        this.lights++;        
        if(location.search == '?lights'){
            var geometry = new THREE.BoxGeometry( 5, 5, 5 );
            var material = new THREE.MeshLambertMaterial( {color: 0xff0000} );
            var cube = new THREE.Mesh( geometry, material );
            cube.castShadow = false;
            cube.position.set(x, y, z);
            this.scene.add(cube);
            const test = {};
            test.x = x;
            test.y = y;
            test.z = z;
            test.intensity = intensity;
            test.distance = distance
            const controllerx = gui.add(test, 'x', -1500, 1500).name(this.lights+' : x');
            const controllery = gui.add(test, 'y', -1500, 1500).name(this.lights+' : y');
            const controllerz = gui.add(test, 'z', -200, 1500).name(this.lights+' : z');
            const controlleri = gui.add(test, 'intensity', 0, 1).name(this.lights+' : intensity');
            const controllerd = gui.add(test, 'distance', 0, 10000).name(this.lights+' : distance');

            controllerx.onChange(function() {
                spotlight.position.set(test.x, test.y, test.z);
                cube.position.set(test.x, test.y, test.z);
            });
            controllery.onChange(function() {
                spotlight.position.set(test.x, test.y, test.z);
                cube.position.set(test.x, test.y, test.z);
            });
            controllerz.onChange(function() {
                spotlight.position.set(test.x, test.y, test.z);
                cube.position.set(test.x, test.y, test.z);
            });
            controlleri.onChange(function() {
                spotlight.intensity = test.intensity;
            });
            controllerd.onChange(function() {
                spotlight.distance = test.distance;
            });
        }
        
    },
    initGL () {
        this.renderer = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            autoClear: true,
        });
        this.canvas.parentNode.classList.add('loading');
        this.composer = new THREE.EffectComposer( this.renderer );
        
        this.renderer.setClearColor(0x050505);
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;

        this.scene = new THREE.Scene();
        this.scene.background = new THREE.Color(0xf0f0f0);
        //this.scene.fog = new THREE.FogExp2( 0xffffff, 0.0003 );
        this.camera = new THREE.PerspectiveCamera(
            this.cameraDefaults.fov,
            this.aspectRatio,
            this.cameraDefaults.near,
            this.cameraDefaults.far
        );

        

        this.walls = [];
        /*
        new THREE.OrbitControls( this.camera, this.renderer.domElement );
        setInterval(() => {
            console.log(this.camera.position);
        }, 500);*/

        const renderPass = new THREE.RenderPass( this.scene, this.camera );
        //const fxaaPass = new THREE.ShaderPass( THREE.FXAAShader );
        this.composer.addPass( renderPass );
        //this.composer.addPass( fxaaPass );

        /*
        const resolution = new THREE.Vector2( window.innerWidth, window.innerHeight );
        this.outlinePass = new THREE.OutlinePass( resolution, this.scene, this.camera );
        this.outlinePass.edgeStrength = 3;
        this.outlinePass.edgeGlow = 0.5;
        this.outlinePass.visibleEdgeColor.set(0xba2334); 
        this.outlinePass.renderToScreen = true;
        this.composer.addPass( this.outlinePass );
        */
        this.resetCamera();
    
        this.controls = new THREE.PanControls(this.camera, this.renderer.domElement);

        //this.controls = new THREE.OrbitControls( this.camera );

        if(location.search === '?flattest') {
        //this.addLight(-1274, 89, 286, 1, 0, false);
        //this.addLight(-1107, 89, 900, .8, 0, false);
        //this.addLight(-941, 56, 211, .59, 775, false);
        //this.addLight(-808, 89, 60, .49, 1526, false);

            //this.addLight(-675, 56, 60, .47, 533, false);
            //this.addLight(-509, 56, 900, .3, 0, false);
            //this.addLight(-346, 56, 154, .5, 531, false);

            //this.addLight(-160, 155, 900, .4, 0, false);

            //this.addLight(-177, 155, 135, .76, 976, false);
            //this.addLight(185, 185, 900, .2, 0, false);

            //this.addLight(388, 152, 59, .9, 0, false);
            //this.addLight(616, 152, 900, .7, 976, false);
            //this.addLight(700, 152, 900, .7, 3634, false);
            //this.addLight(848, 155, 360, 1, 0, false);
            const light2 = new THREE.AmbientLight(0xffffff, .8);
            this.scene.add(light2);
            const light = new THREE.DirectionalLight( 0xffffff, .8 );
            light.position.set(new THREE.Vector3(0, 0, -1));
            this.scene.add(light);
        } else {
        
            const light = new THREE.AmbientLight(0xffffff, 0.75);
            this.scene.add(light);

        
            this.addLight(-1274, 155, 441, .43, 0, false);
            this.addLight(-1274, 693, 54, .14, 0, false);
            //this.addLight(-900, 89, 441, .1, 0, false);
            //this.addLight(-600, 89, 441, .1, 0, false);
            //this.addLight(-300, 89, 441, .1, 0, false);
            this.addLight(-108, 217, 147, .15, 7133, false);
            this.addLight(802, 130, 561, .30, 9253, false);

            //7
            //this.addLight(-642, 89, -53, .17, 201, false);
            //this.addLight(-509, 89, -15, .23, 312, false);
            //this.addLight(-346, 56, 154, .1, 531, false);
            //this.addLight(-410, 122, 154, .3, 1300, castShadows);

            //11
            //this.addLight(-177, 155, 173, .5, 1198, false);
            //this.addLight(-144, 288, 173, .2, 201, false);

            //this.addLight(-11, 56, -34, .27, 421, false);
            //this.addLight(185, 185, -147, .22, 421, false);
            //this.addLight(222, 56, 211, .35, 755, false);

            //this.addLight(384, 152, 59, .52, 976, false);
            //this.addLight(616, 152, -91, .59, 531, false);
            //this.addLight(820, 155, 305, .76, 533, false);
        
        }
        //this.addLight(-880, 50, -200, .05, false);
        //this.addLight(-460, 150, 0, .1);
        //this.addLight(-140, 200, 600, .02, false);
        //this.addLight(-140, 185, 257, 0.42, true);
        //this.addLight(152, 185, 884, .44, true);
        
    },

    drawMarker(name, pointerPosition = false){
        
        const that = this;
        const marker = document.createElement('div');

        marker.classList.add('marker');
        that.canvas.parentNode.appendChild(marker);
        let xoffset = markers[name].offsetx;
        let yoffset = markers[name].offsety;
        let heightlevel = markers[name].heightlevel;
        let product = markers[name].product;
        const askew = markers[name].askew ? markers[name].askew : defaultAskew;
        const boxpointer = markers[name].boxpointer ? markers[name].boxpointer : -1;
        const line = SVG(marker).size(30, 30);
        let startx = 17;
        let starty = 17;
        let endx = Math.abs(xoffset);
        let endy = Math.abs(yoffset);
        let midx = endx;
        let contentXOffset = 0;
        let contentYOffset = 0;
        const midy = endy/2;
        const inactiveLine = line.nested();
        const svgline = inactiveLine.line().stroke({ color: markerColour, width: 1 });
        const svgline2 = inactiveLine.line().stroke({ color: markerColour, width: 1 });

        /*
        if (yoffset > 0){
            yoffset -= 17;
            line.node.style.marginTop = `-${yoffset}px`;
            starty = yoffset;
            endy = 0;
        }
        let upside = false;
        
        if (xoffset > 0){
            xoffset -= 17;
            midx -= 17;
            line.node.style.marginLeft = `-${xoffset}px`;
            startx = xoffset;
            endx = 0;
        } else if(yoffset < 0){
            upside = true;
        }

        if (yoffset < 0 && xoffset < 0){
            contentYOffset -= 200 - 17;
        }

        if (yoffset > 0 && xoffset > 0){
            contentYOffset -= yoffset;
        }*/
        
        svgline.plot([[startx, starty], [midx, midy]]);
        svgline2.plot([[midx, midy], [endx, endy]]);
        var group = line.nested();
        var circle = group.circle(30).attr({ cx: startx, cy: starty }).stroke({ color: markerColour, width: 2 }).fill('#ffffff');
        var circleline1 = group.line().stroke({ color: markerColour, width: 1 }).plot([[startx, starty-5], [startx, starty+5]]);
        var circleline2 = group.line().stroke({ color: markerColour, width: 1 }).plot([[startx-5, starty], [startx+5, starty]])
        
        marker.addEventListener('mouseover', () =>{ 
            
            if(location.search === '?editor'){
                selected.setValue(name);                
                if(markerPosition.offsetx !== markers[name].offsetx){
                    markerx.setValue(markers[name].offsetx);
                }
                if(markerPosition.offsety !== markers[name].offsety){
                    markery.setValue(markers[name].offsety);
                }
                if(typeof markers[name].heightlevel != 'undefined'){
                    markerpos.setValue(markers[name].heightlevel);
                }  
                if(typeof markers[name].boxpointer != 'undefined'){
                    boxpointer.setValue(markers[name].boxpointer);
                }      
            }     
            that.controls.slowdown();        
                     
            circle.finish().animate(500, '>').attr({ fill: markerColour });
            circleline1.finish().animate(500, '>').stroke({ color: '#ffffff' });
            circleline2.finish().animate(500, '>').stroke({ color: '#ffffff' });
        });
        marker.addEventListener('mouseout', () =>{ 
            circle.finish().animate(500, '>').attr({ fill: '#ffffff' });
            circleline1.finish().animate(500, '>').stroke({ color: markerColour });
            circleline2.finish().animate(500, '>').stroke({ color: markerColour });
        })
        let track = false;
        if(typeof markers[name].track === 'string'){
            circle.hide();
            circleline1.hide();
            circleline2.hide();
            track = markers[name].track;
            that.canvas.parentNode.insertBefore(marker, that.canvas.parentNode.firstChild);
        }
        const markerobject = {name, marker, pointerPosition, line, xoffset, yoffset, askew, boxpointer, circle, group, inactiveLine, contentXOffset, contentYOffset, svgline, svgline2, heightlevel, track};
        markerobject.marker.addEventListener('mouseover', () => {
            console.log(name);
            console.log(markerobject.pointerPosition);
            tempPointerPosition = markerobject.pointerPosition.clone();
        });

        markerobject.marker.addEventListener('click', (event) => {
            const myMarker = event.currentTarget;
            if(!myMarker.classList.contains('show')){
                return;
            }
            event.preventDefault();
            marker.classList.toggle('active');
            if(marker.classList.contains('active') && zoomed === false){
                zoomed = true;
                markerobject.group.hide();
                markerobject.inactiveLine.hide();
                that.cameraDefaults.posCamera = that.camera.position.clone();
                that.controls.enabled = false;
                that.controls.pause();
                if(backButton){
                    backButton.classList.add('active');
                }
                const point = that.getCenterPoint(markerobject.mesh, markerobject.pointerPosition);
                console.log(markerobject);
                that.tweenCamera(point, point, markerobject);
                that.canvas.parentNode.classList.add('focus');
                //contentIframe.setAttribute('src',ajax_obj.ajax_url+'?action=view_product&product='+encodeURIComponent(product));
                that.qtipapi.show();
                that.qtipapi.set({
                    'content.text': '<iframe src="'+ajax_obj.ajax_url+'?action=view_product&product='+encodeURIComponent(product)+'&colour='+encodeURIComponent(markerColour)+'" height="100%" width="100%"></iframe>',
                });
                const iframe = that.qtipapi.tooltip.find('iframe');
                iframe.one('load', (event) => {
                    const height = event.currentTarget.contentWindow.document.body.querySelector('.info').offsetHeight + 20;
                    if(height > 260){
                        that.qtipapi.tooltip.css({maxHeight:height+'px'});
                    }
                });
                //contentIframe.contentWindow.document.body.innerHTML = markerobject.iframe;
            } else if(zoomed === true) {
                markerobject.group.show();
                markerobject.inactiveLine.show();
                
                that.resetCamera();
                that.controls.enabled = true;
                if(backButton){
                    backButton.classList.remove('active');
                }
                //contentIframe.removeAttribute('src');
                that.qtipapi.hide();
                that.qtipapi.set({
                    'content.text': '',
                });
            }
        });
        return markerobject;
    },
    

    initContent () {
        const that = this;        
        const objectLoader = new THREE.OBJLoader();
        //const gltfloader = new THREE.GLTFLoader();
        const callbackOnLoad = function (event) {
            let usedObjectMarkers = [];
            that.canvas.parentNode.classList.remove('loading');
            buttons.classList.remove('hidden');
            that.tooltip.style.visibility = 'hidden';
            //const defaultMaterial = new THREE.MeshPhongMaterial({ color: 0xaaaaaa, shininess: 10 });
            const trackerArray = {};
            let count =0;
            event.traverse( function ( child ) {
                if ( child.isMesh ) {

                    count++;

                    child.renderOrder = 1000 - count;

                    let doNotSelect = true;
                    //const isGlass = child.name.startsWith('Glass_inner') || child.name.startsWith('glass') || child.name.startsWith('Glass')
                    //doNotSelect = /^(Plane|Back_wall)/.test(child.name);
                    
                    
                    //child.material = defaultMaterial;
                    //child.material.map = defaultMaterial.map;
                    //child.material.specular = defaultMaterial.specular;
                    //child.material = new THREE.MeshPhongMaterial({ color: child.material.color, map: child.material.map });
                    
                    if(child.name == 'Sofa'||child.name == 'Back_Pillow_02'||child.name == 'Seat_Right'||child.name == 'Arm_Rest'||child.name=='Cube.4'){
                        //child.material = defaultMaterial;
                    }

                    if(child.name == 'Arm_Rest'||child.name == 'Counter'){
                        //hild.material = new THREE.MeshLambertMaterial({ color: child.material.color });
                        child.visible = true;
                    }

                    if(child.name == 'Bedframe'){
                        child.material.shininess = 0;
                    }
                    
                  
                    if (Object.keys(markers).indexOf(child.name) === -1){
                        //child.material = defaultMaterial;
                        //child.material = new THREE.MeshLambertMaterial({ color: 0xeeeeee });
                    }
                    if (!doNotSelect){
                        that.highlights.push(child);
                    }
                    //console.log(child.name);
                    //if(/^Solid2/.test(child.name)){
                    //console.log(child.name);
                    //console.log(Object.keys(markers).indexOf(child.name));
                    //}
                    if (additional.indexOf(child.name) !== -1){
                        //child.material = new THREE.MeshLambertMaterial({ color: markerColour });
                    }
                    if (Object.keys(markers).indexOf(child.name) !== -1){
                        usedObjectMarkers.push(child.name);
                        //child.material = new THREE.MeshLambertMaterial({ color: markerColour });
                        
                        /*
                        const iframe = `
                        <h1>${child.name}</h1>
                        <p>Configuration</p>
                        <code>
                        ${JSON.stringify(markers[child.name], null, 2)}
                        </code>
                        `;
                        */
                        
                        const markerobject = that.drawMarker(child.name, markers[child.name].pointerPosition);
                        if(markerobject.track){
                            trackerArray[markerobject.track] = markerobject.name;
                        }
                        markerobject.mesh = child;
                        markerobject.pointerPosition = that.getCenterPoint(child, markers[child.name].pointerPosition);
                        that.markers.push(markerobject);
                        
                    }
                        
                    child.receiveShadow = (castShadows && recieveShadows.indexOf(child.name) !== -1);
                    //child.castShadow = (castShadows && shadowObjects.indexOf(child.name) !== -1);
                    child.castShadow = castShadows;

                    if(walls.indexOf(child.name) !== -1){
                        child.castShadow = false;
                        child.receiveShadow = true;
                        that.walls.push(child);
                    }

                    if(child.name.startsWith("Window_espay_standard_600mm_hotspot")){
                        child.position.z += 1;
                    }

                    if(child.name === 'airer' || child.name === 'Oven_and_Hob'){
                        const originalMaterial = child.material.clone();
                        child.material = new THREE.MeshPhongMaterial(
                            {color: originalMaterial.color,
                                specular: originalMaterial.specular,
                                shading: THREE.FlatShading });
                    }
                    child.onAfterRender = function() {
                        if(that.controls.firstrun === false){
                            that.controls.firstrun = true;
                            that.controls.resume(100, 0);
                        }
                    }
                }
            });

            Object.keys(trackerArray).forEach(key => {
                const value = trackerArray[key];
                that.markers.forEach((marker) => {
                    if(marker.name === key){
                        marker.trackedby = value;
                    }
                });
            });


            that.scene.add(...event.children);
            //that.controls.play();
            Object.keys(markers).forEach(name => {
                if(usedObjectMarkers.indexOf(name) === -1){
                    if(typeof markers[name].pointerPosition == 'object'){
                        const markerobject = that.drawMarker(name, markers[name].pointerPosition);
                        markerobject.mesh = null;
                        markerobject.pointerPosition = markers[name].pointerPosition;
                        that.markers.push(markerobject);
                    } else {
                        console.log(name+' is orphaned!');  
                        console.log(markers[name]);
                    }
                }
            });
        };
        const callbackProgress = function(xhr){
            const req = xhr.target;
            that.tooltip.style.visibility = 'visible';
            let progressText = `Loading...`;
            //let progressAvailable = false;
            if (xhr.lengthComputable) {
                progressText = `${Math.round( xhr.loaded / xhr.total * 100 )}% loaded`;
            } else {
                var total = req.getResponseHeader('content-length')
                var encoding = req.getResponseHeader('content-encoding')
                if (total && encoding && (encoding.indexOf('gzip') > -1)) {
                    // assuming average gzip compression ratio to be 25%
                    total *= 4 // original size / compressed size
                    progressText = `${Math.round( Math.min(100, xhr.loaded / total * 100) )}% loaded`;
                }
            }
              
            that.tooltipText.innerHTML = progressText;
            if (xhr.loaded === xhr.total && !loaded){
                loaded = true;
                //that.tooltip.innerHTML = 'Building room...';
                that.tooltip.style.visibility = 'hidden';
            }
        };
        /*
        if(location.search === '?gltftest') {
            gltfloader.load(
                // resource URL
                '/wp-content/themes/titon/baked/Gltf/Roomset-Hardware-texture test-2.gltf',
                // called when the resource is loaded
                function ( gltf ) {
                    that.canvas.parentNode.classList.remove('loading');
                    buttons.classList.remove('hidden');
                    that.tooltip.style.visibility = 'hidden';
                    that.scene.add( gltf.scene );
                    
                    console.log(gltf.animations); // Array<THREE.AnimationClip>
                    console.log(gltf.scene); // THREE.Scene
                    console.log(gltf.scenes); // Array<THREE.Scene>
                    console.log(gltf.cameras); // Array<THREE.Camera>
                    console.log(gltf.asset); // Object
            
                },
                callbackProgress, null
            );
            */
        //} else {
        
        new THREE.MTLLoader()
            .load( mtl_file, function ( materials ) {

                materials.preload();

                objectLoader
                    .setMaterials( materials )
                    .load(obj_file, callbackOnLoad, callbackProgress, null);

            } );
        //}
    },

    getCenterPoint(mesh, pointerPosition = false) {
        if(pointerPosition){
            return new THREE.Vector3(pointerPosition.x, pointerPosition.y, pointerPosition.z);
        }
        const middle = new THREE.Vector3();
        const {geometry} = mesh;

        geometry.computeBoundingBox();

        middle.x = (geometry.boundingBox.max.x + geometry.boundingBox.min.x) / 2;
        middle.y = (geometry.boundingBox.max.y + geometry.boundingBox.min.y) / 2;
        middle.z = (geometry.boundingBox.max.z + geometry.boundingBox.min.z) / 2;

        mesh.localToWorld( middle );
        return middle;
    },

    resizeDisplayGL () {
        const width = window.innerWidth;
        const height = window.innerHeight;
        this.aspectRatio= width / height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize( width, height );
        this.composer.setSize( width, height );
        markersReady = false;
        this.resetCamera();
        this.qtipapi.hide();
        this.controls.enabled = true;
    },

    recalcAspectRatio () {
        this.aspectRatio = (this.canvas.offsetHeight === 0) ? 1 : this.canvas.offsetWidth / this.canvas.offsetHeight;
    },

    resetCamera () {
        zoomed = false;
        this.tweenCamera(this.cameraDefaults.posCamera, this.cameraDefaults.posCameraTarget);
        this.canvas.parentNode.classList.remove('focus');
        const activeMarkers = this.canvas.parentNode.querySelectorAll('.marker.active');
        activeMarkers.forEach(activeMarker => {
            activeMarker.classList.remove('active');
        });
        this.markers.forEach((markerObject) => {
            markerObject.group.show();
            markerObject.inactiveLine.show();
        });
        this.updateCamera();
        if(this.controls){
            this.controls.resume();
        }
    },

    updateCamera () {
        this.camera.aspect = this.aspectRatio;
        //this.camera.lookAt(this.cameraTarget);
        this.camera.updateProjectionMatrix();
    },

    setMarkers(){
        const that = this;
        if(markersReady && (zoomed || !that.controls.moving)){
            return;
        }
        if(this.markers.length > 0){
            markersReady = true;
        }
        this.markers.forEach(data => {
            /*
             < -730 : living room
             - 220 kitchen
             - 40 cuboard
             320 : bathroom
             690: bedroom
            */
            const meshPosition = that.getCenterPoint(data.mesh, data.pointerPosition).x;
            const cameraPosition = that.camera.position.x;
            let skip = false;
            //console.log(cameraPosition);
            if(cameraPosition < -1100){
                //glass door
                if(meshPosition >= -1180){
                    skip = true;
                }
            } else if(cameraPosition >= -1100 && cameraPosition < -730){
                //in living room
                if(meshPosition < -1180 || meshPosition >= -730){
                    skip = true;
                }
            }
            else if(cameraPosition >= -730 && cameraPosition < -220){
                //in kitchen
                if(meshPosition < -720 || meshPosition >= -220){
                    skip = true;
                }
            }
            else if(cameraPosition >= -220 && cameraPosition < -40){
                //in cupboard
                if(meshPosition < -220 || meshPosition >= -40){
                    skip = true;
                }
            }
            else if(cameraPosition >= -40 && cameraPosition < 320){
                //in bathroom
                if(meshPosition < -40 || meshPosition >= 320){
                    skip = true;
                }
            }
            else if(cameraPosition >= 320 && cameraPosition < 690){
                //in bedroom
                if(meshPosition < 320 || meshPosition >= 690){
                    skip = true;
                }
            } else if(cameraPosition >= 690) {
                //in front door
                if(meshPosition < 690){
                    skip = true;
                }
            }           

            if(skip){
                data.marker.classList.remove('show');
                return;
            }
            let tracked = false;
            if(data.track){
                that.markers.forEach(totrack=> {
                    if(totrack.name === data.track){
                        tracked = totrack;
                        data.heightlevel = totrack.heightlevel;
                        data.xoffset = totrack.xoffset;
                    }
                });
            }
            const newPosition = that.toScreenPosition(data.mesh, data.pointerPosition, that.camera);
            //const trackedPosition = tracked ? that.toScreenPosition(tracked.mesh, tracked.pointerPosition, that.camera) : false;
            //const center = this.getCenterPoint(data.mesh, data.pointerPosition);
            /*
            if(data.mesh.name == 'Friction_hinge_top_hotspot.1_1'){
                console.log(newPosition);
                console.log(that.camera.position);
                console.log(new THREE.Vector2(newPosition.vectorx,0));
            }
            */

            if(newPosition.vectorx > 0.8 || newPosition.vectorx < -0.8){
                data.marker.classList.remove('show');
                return;
            }
            data.marker.classList.add('show');
            
            //that.raycaster.setFromCamera(newPosition, that.camera);
            /*
            if(center.y < 260 && center.z < 90){
                that.raycaster.setFromCamera(new THREE.Vector2(newPosition.vectorx, newPosition.vectory), that.camera);
                const intersects = that.raycaster.intersectObjects(that.walls);
                if(data.mesh.name == 'Friction_hinge_top_hotspot.1_1'){
                    //console.log(intersects);
                    console.log(intersects);
                    const newInter = [];
                    data.mesh.raycast(that.raycaster,newInter);
                    console.log(newInter);
                    
                }
                //let objectsIntersect = 0;
                if(intersects.length > 0){
                    data.marker.classList.remove('show');
                    return;
                } else {
                    data.marker.classList.add('show');
                }
            }
            */

            /*
            if (newPosition.vectorx < -1 || newPosition.vectorx> 1 || objectsIntersect > 1){
                data.marker.style.display = 'none';
            } else {
                data.marker.style.display = 'block';
            }
            */
            //data.marker.style.left = `${newPosition.x}px`;
            
            const height = this.canvas.offsetHeight;
            const heights = [
                height/5,
                (height/5)*2,
                (height/5)*3,
                (height/5)*4,
            ];

            let closesty = heights.reduce((prev, curr) => {
                return (Math.abs(curr - newPosition.y) > 50 && Math.abs(curr - newPosition.y) < Math.abs(prev - newPosition.y)) ? curr : prev;
            });

            if(typeof data.heightlevel !== 'undefined' && typeof heights[data.heightlevel] !== 'undefined'){
                closesty = heights[data.heightlevel];
            }

            data.marker.style.top = tracked ? tracked.marker.style.top : `${closesty}px`;
            let xoffset = data.xoffset;
            let yoffset = newPosition.y-closesty;
            let midway = false;
            if(data.trackedby){
                that.markers.forEach(totrackby=> {
                    if(totrackby.name === data.trackedby){
                        const trackedByPosition = that.toScreenPosition(totrackby.mesh, totrackby.pointerPosition, that.camera);
                        if(newPosition.x < trackedByPosition.x && (trackedByPosition.x - newPosition.x) > 30){
                            midway = newPosition.x + ((trackedByPosition.x - newPosition.x) / 2);  
                        }
                        if(newPosition.x > trackedByPosition.x && (newPosition.x - trackedByPosition.x) > 30){
                            midway = trackedByPosition.x + ((newPosition.x - trackedByPosition.x) / 2); 
                        }
                    }
                });
            }
            //data.line.size(100, Math.abs(yoffset));
            const pointRight = xoffset < 0;
            const pointUp = closesty > newPosition.y;
            const pointerdiff = 100;
            if(tracked){
                //const midway = trackedPosition.x + (newPosition.x - trackedPosition.x) / 2;
                //tracked.marker.style.left = midway+'px';
                data.marker.style.left = tracked.marker.style.left;
            } else if(midway) {
                data.marker.style.left = midway+'px';
            } else {
                data.marker.style.left = pointRight ? `${newPosition.x-pointerdiff}px` : `${newPosition.x+pointerdiff}px`;
            }
            let startx = 15;
            let starty = 15;
            let midx = 15;
            let midy = pointUp ? yoffset+50 : yoffset-50;

            let endx = pointRight ? pointerdiff : -pointerdiff;
            let endy = yoffset;

            if(tracked){
                /*
                const tpointUp = closesty > trackedPosition.y;
                let tyoffset = newPosition.y-closesty;

                startx = 15;
                starty = tpointUp ? tyoffset+50 : tyoffset-50;*/
                endx = newPosition.x - parseInt(tracked.marker.style.left, 10);
                endy = newPosition.y - parseInt(tracked.marker.style.top, 10);
            } else if(midway) {
                endx = newPosition.x - midway;
                //endy = newPosition.y - parseInt(tracked.marker.style.top,10);
            }

            const diff = Math.abs(starty - midy);
            if(diff < 30){
                if(midway){
                    if(!tracked){
                        const adjust = starty > midy ? -30 : 30;
                        data.marker.style.top = `${closesty-adjust}px`;
                    
                        midy += adjust;
                        data.marker.dataset.midy = adjust;
                        endy += adjust;
                    }
                    data.svgline.plot(startx, starty, midx, midy).show(); 
                } else if (tracked && typeof tracked.marker.dataset.midy != 'undefined'){
                    midy += parseInt(tracked.marker.dataset.midy, 10);
                    data.svgline.plot(startx, starty, midx, midy).show(); 
                    
                } else {
                    midx = startx;
                    midy = starty;
                    data.svgline.hide();
                }
            } else {
                if(tracked){
                    starty = starty < midy ? starty + 15 : starty - 15;
                }
                data.svgline.plot(startx, starty, midx, midy).show(); 
            }
            data.svgline2.plot(midx, midy, endx, endy);
            //const xoffset = data.xoffset - (data.marker.offsetWidth/2);
            //const yoffset = data.yoffset - (data.marker.offsetHeight/2);
            //data.marker.style.marginLeft = `${xoffset}px`;  
            //data.marker.style.marginTop = `${yoffset}px`;
        });
    },

    hightlightObject () {
        if (this.highlights.length === 0 || zoomed || this.controls.moving){            
            return;
        }
        this.raycaster.setFromCamera(this.mouse, this.camera);
    
        const intersects = this.raycaster.intersectObjects(this.highlights);

        if (intersects.length > 0) {
            this.tooltip.style.visibility = 'visible';
            
            this.tooltip.style.left = `${this.screen.x + 5}px`;
            this.tooltip.style.top = `${this.screen.y + 5}px`;
            if (this.currentlyIntersected != intersects[0].object) {
                if (this.currentlyIntersected) {
                    //this.currentlyIntersected.material.emissive.setHex(this.currentlyIntersected.currentHex);
                }
                this.currentlyIntersected = intersects[0].object;
                this.outlinePass.selectedObjects = [this.currentlyIntersected];
                //console.log(this.currentlyIntersected);
                this.tooltipText.innerHTML = this.currentlyIntersected.name;
                //this.scene.updateMatrixWorld();
                //const vector = new THREE.Vector3();
                // vector.setFromMatrixPosition( this.currentlyIntersected.matrixWorld );
                //console.log(vector);
                
                
                //this.currentlyIntersected.currentHex = this.currentlyIntersected.material.emissive.getHex();
                //this.currentlyIntersected.material.emissive.setHex(0xba2334);
                //this.currentlyIntersected.material.emissiveIntensity = 0.2;
        
      
                this.tooltipText.innerHTML = this.currentlyIntersected.name;
            }
        } else {
            this.tooltip.style.visibility = 'hidden';
            
            if (this.currentlyIntersected) {
                //this.currentlyIntersected.material.emissive.setHex(this.currentlyIntersected.currentHex);
            }
            this.currentlyIntersected = null;
        }
    },

    render () {
        if (!this.renderer.autoClear) this.renderer.clear();

        this.hightlightObject();

        this.setMarkers();

        this.composer.render();

    },



    vectorToScreen(vector, camera){
        const {width, height} = this.renderer.getContext().canvas;

        const widthHalf = 0.5 * width;
        const heightHalf = 0.5 * height;
        vector.project(camera);

        const x = ( vector.x * widthHalf ) + widthHalf;
        const y = - ( vector.y * heightHalf ) + heightHalf;

        return { 
            x,
            y,
            vectorx: vector.x,
            vectory: vector.y,
        };
    },

    toScreenPosition(object, pointerPosition, camera) {
        const vector = this.getCenterPoint(object, pointerPosition);

        return this.vectorToScreen(vector, camera);
    },
};

window.addEventListener('load', () => {
    const canvasElement = document.querySelector('#room');
    if(!canvasElement){
        return;
    }
    
    const app = new TitonHouse(canvasElement);

    const resizeWindow = function () {
        app.resizeDisplayGL();
    };

    const render = function () {
        requestAnimationFrame(render);
        app.render();
    };

    const onMouseMove = function (event) {
        event.preventDefault();

        app.screen.x = event.clientX;
        app.screen.y = event.clientY;
        app.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        app.mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
    };

    window.addEventListener('resize', resizeWindow, false);
    document.addEventListener('mousemove', onMouseMove, false);

    app.initGL();
    app.resizeDisplayGL();
    app.initContent();

    render();
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../three/pan-controls":18,"dat.gui":22,"svg.js":24,"three/examples/js/loaders/MTLLoader":25,"three/examples/js/loaders/OBJLoader":26,"three/examples/js/postprocessing/EffectComposer":27,"three/examples/js/postprocessing/RenderPass":28,"three/examples/js/postprocessing/ShaderPass":29,"three/examples/js/shaders/CopyShader":30}],2:[function(require,module,exports){
/**
 * Simultaneously update l/s and m3/h airflow inputs on Products filter
 */
jQuery(document).ready(function($) {
function checkNumbersMinMax() {
    var lsInput = $('input[name="_sfm_airflow_ls_min[]"].sf-range-min');
    var newVal = parseInt( lsInput.val() );
	var max = parseInt( lsInput.attr('max') );
	var min = parseInt( lsInput.attr('min') );

	if ( newVal > max ) {
		lsInput.val( lsInput.attr('max') );
	}
	if ( newVal < min ) {
		lsInput.val( lsInput.attr('min') );
    }
    
    var mhInput = $('input[name="_sfm_airflow_mh_min[]"].sf-range-min');
    var newVal = parseInt( mhInput.val() );
	var max = parseInt( mhInput.attr('max') );
	var min = parseInt( mhInput.attr('min') );

	if ( newVal > max ) {
		mhInput.val( mhInput.attr('max') );
	}

	if ( newVal < min ) {
		mhInput.val( mhInput.attr('min') );
	}
}

$('input[name="_sfm_airflow_ls_min[]"].sf-range-min').on('change blur', function() {
    $('input[name="_sfm_airflow_mh_min[]"].sf-range-min').val( Math.floor( 3.6 * $(this).val() ) );
	checkNumbersMinMax();
});

$('input[name="_sfm_airflow_ls_min[]"].sf-range-min').on('input', function() {
	$('input[name="_sfm_airflow_mh_min[]"].sf-range-min').val( Math.floor( 3.6 * $(this).val() ) );
});

$('input[name="_sfm_airflow_mh_min[]"].sf-range-min').on('change blur', function() {
    $('input[name="_sfm_airflow_ls_min[]"].sf-range-min').val( Math.floor( $(this).val() / 3.6 ) );
    checkNumbersMinMax();
});

$('input[name="_sfm_airflow_mh_min[]"].sf-range-min').on('input', function() {
	$('input[name="_sfm_airflow_ls_min[]"].sf-range-min').val( Math.floor( $(this).val() / 3.6 ) );
});
});
},{}],3:[function(require,module,exports){
(function() {
	var handle = ally.style.focusWithin();
})();
},{}],4:[function(require,module,exports){
$(document).ready(function() {
	// Open and close content toggles
	$('.content-toggle__toggle').on('click', function() {

		// Trigger a window resize so that dimensions of child elements
		// hidden on page load can be recalculated, e.g. a Slick slider
		// within a `display: none;` content toggle div
		$(window).trigger('resize');

		$(this).toggleClass('content-toggle__toggle--active');

		var target = $(this).data( 'target' );
		$('.content-toggle[data-content=' + target + ']').toggleClass('content-toggle--active');

	});

	// Open and close content toggles
	$('.catalogue-block .content-toggle__header').on('click', function() {

		// Trigger a window resize so that dimensions of child elements
		// hidden on page load can be recalculated, e.g. a Slick slider
		// within a `display: none;` content toggle div
		$(window).trigger('resize');

		$(this).find('.content-toggle__toggle').toggleClass('content-toggle__toggle--active');

		var target = $(this).find('.content-toggle__toggle').data( 'target' );
		$('.content-toggle[data-content=' + target + ']').toggleClass('content-toggle--active');

	});

	$('.catalogue-block .content-toggle__toggle').unbind();
});

// Dynamically check the height of the content in a content toggle component
// and set a custom max-height. This allows for custom transition times to 
// avoid anything too fast or slow.
function checkContentToggleHeights() {
	$('.content-toggle__style').remove();
	$('.content-toggle').each(function() {
		$(this).append(
			'<div class="content-toggle__style"><style>.content-toggle[data-content="' + $(this).data('content') + '"].content-toggle--active .content-toggle__content { max-height: ' + $(this).find('.content-toggle__content').prop('scrollHeight') + 'px }.content-toggle[data-content="' + $(this).data('content') + '"].content-toggle--active .content-toggle__content {transition-duration: ' + ( ( ( $(this).find('.content-toggle__content').prop('scrollHeight') / 300 ) * 0.05 ) + 0.2 ) + 's}</style></div>'
		);
	});
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var optimisedContentHeights = debounce(checkContentToggleHeights, 250); // Debounce for performance
window.addEventListener('load', optimisedContentHeights);
window.addEventListener('resize', optimisedContentHeights);
},{}],5:[function(require,module,exports){
$(document).ready(function() {
	// Open and close content toggles
	$('.language-block__toggle').on('click', function() {

		// Trigger a window resize so that dimensions of child elements
		// hidden on page load can be recalculated, e.g. a Slick slider
		// within a `display: none;` content toggle div
		$(window).trigger('resize');

		$(this).toggleClass('language-block__toggle--active');

		var target = $(this).data( 'target' );
		$('.distributors-content[data-content=' + target + ']').toggleClass('distributors-content--active');

	});
});

var toggleButtons = document.querySelectorAll('.language-block__toggle');

if ( toggleButtons.length > 0 ) {
	for (var i = 0; i < toggleButtons.length; i++) {
		toggleButtons[i].addEventListener('click', function(e) {
			var target = this.getAttribute('data-target');
			var el = document.querySelector('.distributors-toggle-content[data-content="' + target + '"]');
			if (el.getAttribute('data-active') !== 'true' ) {
				el.setAttribute('data-active', 'true');
				var elH = getHeight(el);
				window.setTimeout(function() {
					el.style.height = elH+'px';
				}, 100);
			} else {
				el.setAttribute('data-active', 'false')
				el.style.height = '0';
			}
		});
	}
}

function getHeight(el) {
    el.style.height = 'auto';
    elHeight = el.offsetHeight;
    el.style.height = '0';
    return elHeight;
}
},{}],6:[function(require,module,exports){
$(document).ready(function() {
    // Add superscript to airflow label
    $('.sf-field-post-meta-airflow_mh_min h4').html('Airflow (m<sup>3</sup>/h) at 100Pa');
});
},{}],7:[function(require,module,exports){
/**
 * Having a clear :focus state is important for accessibility.
 * However, it is not always aesthetically desirable on click.
 * So, we turn it on when the tab key is pressed.
 */

$(document).ready(function() {
	document.addEventListener('keydown', function(e) {
		// If tab press
		if (e.keyCode === 9) {
			$('body').removeClass('hide-focus-outlines');
		}
	});

	// We use mousedown because 'click' can be triggered by the keyboard
	document.addEventListener('mousedown', function(e) {
		$('body').addClass('hide-focus-outlines');
	});
});
},{}],8:[function(require,module,exports){
/**
 * Sticky header powered by Headroom.js
 *
 * Headroom documentation: https://github.com/WickyNilliams/headroom.js
 */
$(window).bind('load', function() {
	/**
	 * Sticky header powered by Headroom.js
	 *
	 * Headroom documentation: https://github.com/WickyNilliams/headroom.js
	 */
	$('.site-header').headroom({
		offset: 60
	});

	if ( $('body').hasClass('single-products') ) {

		var productNavOffset = $('.product-nav').offset();

		$('.product-nav').headroom({
			offset: productNavOffset.top - 77
		});

	}
});
},{}],9:[function(require,module,exports){
$(document).ready(function() {

	$('.accordion-parent').click(function(){
		$(this).toggleClass('active');
		$(this).nextAll('.accordion-child').toggleClass('active', $(this).hasClass('active'));
	});

	$('.nav3d__nav__item[data-post]').click(function(e){
		const button = $(e.currentTarget);
		const postId = button.data('post');
		const list = $('.nav3d__nav__'+postId);
		if(list.length > 0){
			e.preventDefault();
			const parent = button.parent();
			parent.one('webkitAnimationEnd oanimationend msAnimationEnd animationend',   
				function(e) {
					if(e.originalEvent.animationName === 'slide-out' && parent.hasClass('deactivate')){
						parent.removeClass('active').removeClass('deactivate');
						list.addClass('active');
					}
			});
			parent.addClass('deactivate');
		}
	});

	/**
	 * Instantiate Modals
	 */
	if( document.querySelector('.modal') ) {
		$('a[data-modal]').click(function(event) {
			$(this).modal({
				fadeDuration: 100
			});
			return false;
		});
		$('.touchevents .modal-trigger').bind('mouseover', function() {
			return false;
		});
	}

	/**
	 * Mobile Menu Toggle
	 */
	$('.nav-toggle').on('click', function(e) {
		e.preventDefault();
		$('html').toggleClass('show-menu');
	});

	/**
	 * Filter Block Toggle
	 */
	$('.filter-block-open').on('click', function(e) {
		e.preventDefault();
		$('html').addClass('show-filter-block');
	});
	$('.filter-block__close').on('click', function(e) {
		e.preventDefault();
		$('html').removeClass('show-filter-block');
	});

	/**
	 * Close open navs
	 */
	$('body').on('touchend', function(e) {

		// If not the language menu panel, close that panel
		var languageNavClasses = [
			'language-nav__panel language-nav__panel--visible', // open panel
			'language-nav__toggle' // panel toggle
		];
		if ( ! languageNavClasses.includes(e.target.className) ) {
			$('.language-nav__panel').removeClass('language-nav__panel--visible');
		}

		// If not a desktop nav submenu or link, close the panel
		var desktopNavClasses = [
			'sub-menu sub-menu--visible',
			'desktop-nav-link'
		]
		if ( ! desktopNavClasses.includes(e.target.className) ) {
			$('.desktop-nav .sub-menu').removeClass('sub-menu--visible');
		}
	});

	/**
	 * Language Nav Toggle
	 */
	$('.touchevents .language-nav__toggle').on('click', function(e) {
		e.preventDefault();
		$('.touchevents .language-nav__panel').toggleClass('language-nav__panel--visible');
	});

	/**
	 * Header Search Toggle
	 */
	$('.site-header__search input[type="submit"]').on('click', function(e) {
		e.preventDefault();

		if ( $('.site-header__search').hasClass('site-header__search--open') && $('.site-header__search .sf-input-text').val() !== '' ) {
			$('.site-header__search form').submit();
		} else {
			$('.site-header__search').toggleClass('site-header__search--open');
		}
	});

	/**
	 * Header Nav Toggle
	 */
	$('.touchevents .desktop-nav .menu > li.menu-item-has-children > a').on('click', function(e) {
		e.preventDefault();
		if ( ! $(this).next('.sub-menu').hasClass('sub-menu--visible') ) {
			$('.sub-menu').removeClass('sub-menu--visible');
			$(this).next('.sub-menu').addClass('sub-menu--visible').focus();
		} else {
			window.location.href = $(this).attr('href');
		}
	});

	/**
	 * Mobile Nav Sub-menu Toggle
	 */
	$('.mobile-nav-panel .sub-menu-toggle').on('click', function(e) {
		if ( $(this).next('.sub-menu').hasClass('sub-menu--expanded') ) {
			$(this).next('.sub-menu').removeClass('sub-menu--expanded');
			$(this).html('<i class="fa fa-plus"></i>');
		} else {
			$('.mobile-nav-panel .sub-menu-toggle').html('<i class="fa fa-plus"></i>');
			$('.mobile-nav-panel .sub-menu').removeClass('sub-menu--expanded');
			$(this).next('.sub-menu').addClass('sub-menu--expanded');
			$(this).html('<i class="fa fa-minus"></i>');
		}
	});

	/**
	 * Mobile Panel Language Nav Toggle
	 */
	$('.mobile-nav-panel__language-nav-toggle').on('click', function() {
		$(this).toggleClass('mobile-nav-panel__language-nav-toggle--active');
		$('.mobile-nav-panel__language-nav-panel').toggleClass('mobile-nav-panel__language-nav-panel--expanded');
	});

	/**
	 * Resource Language Selector Toggle
	 */
	$('.touchevents .resource-language-selector__toggle').on('click', function() {
		$(this).toggleClass('resource-language-selector__toggle--active');
		$(this).next('.resource-language-selector__panel').toggleClass('resource-language-selector__panel--active');
	});

});

(function() {
	// Hide form labels if empty
	var formLabels = document.querySelectorAll('.gfield_label');
	var requiredString = '<span class="gfield_required">*</span>';
	if ( formLabels.length > 0 ) {
		for ( var i = 0; i < formLabels.length; i++ ) {
			if ( formLabels[i].innerHTML == requiredString ) {
				formLabels[i].style.display = "none";
			}
		}
	}
})();

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

/**
 * Set Height of thumbnail containers
 */
var resizeThumbnailContainer = debounce(function() {
	$('.thumbnail-container').each(function() {
		$(this).height( $(this).width() * 0.63 );
	})
});
resizeThumbnailContainer();
window.addEventListener('resize', resizeThumbnailContainer);

},{}],10:[function(require,module,exports){
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

$(window).bind('load', function() {

	// If we are on the single product template
	if ( $('body').hasClass('single-products') ) {

		// Set the “active state underline” to same with as first link
		$('.product-nav-underline').css({
			'width': $('.product-nav ul li:first-child a').width() + 'px'
		});

		var checkScrollBlocks = debounce(function() { // Debounce for performance
			// Work out horizontal offset of technical link
			if ( $('a#technical-trigger').length > 0 ) {
				var technicalTriggerOffset = $('a#technical-trigger').position();
				var technicalTriggerX = technicalTriggerOffset.left;
			}

			// Work out horizontal offset of resources link
			var resourcesTriggerOffset = $('a#resources-trigger').position();
			var resourcesTriggerX = resourcesTriggerOffset.left;

			// Work out horizontal offset of similar products link
			if ( $('a#similar-trigger').length > 0 ) {
				var similarTriggerOffset = $('a#similar-trigger').position();
				var similarTriggerX = similarTriggerOffset.left;
			}

			// Work out vertical offset of technical content
			if ( $('section#technical').length > 0 ) {
				var technicalOffset = $('section#technical').offset();
				var technicalStart = technicalOffset.top;
			}

			// Work out vertical offset of resources content
			var resourcesOffset = $('section#resources').offset();
			var resourcesStart = resourcesOffset.top;

			// Work out vertical offset of similar products content
			if ( $('section#similar').length > 0 ) {
				var similarOffset = $('section#similar').offset();
				var similarStart = similarOffset.top;
			}

			// visual scroll position, which is window plus the sticky bar
			var windowScrollOffset = $(window).scrollTop() + $('.product-nav').height();

			// check scroll position and move “active state underline” accordingly
			if ( windowScrollOffset >= similarStart - 130 ) {
				$('.product-nav-underline').css({
					'transform': 'translateX(' + similarTriggerX + 'px)',
					'width': $('a#similar-trigger').width() + 'px'
				});
			} else if ( windowScrollOffset >= resourcesStart - 130 ) {
				$('.product-nav-underline').css({
					'transform': 'translateX(' + resourcesTriggerX + 'px)',
					'width': $('a#resources-trigger').width() + 'px'
				});
			} else if ( windowScrollOffset >= technicalStart - 130 ) {
				$('.product-nav-underline').css({
					'transform': 'translateX(' + technicalTriggerX + 'px)',
					'width': $('a#technical-trigger').width() + 'px'
				});
			} else {
				$('.product-nav-underline').css({
					'transform': 'translateX(0px)',
					'width': $('a#overview-trigger').width() + 'px'
				});
			}

		}, 10);
		
		window.addEventListener('scroll', checkScrollBlocks);
		window.addEventListener('resize', checkScrollBlocks);

	}

});

},{}],11:[function(require,module,exports){
/**
 * AJAX to fetch categories and products for the “Find Your Product”
 * area of the Resources section.
 */
$(document).ready(function() {

	var ajaxGetChildren = function(e) {
		e.preventDefault();

		// Unbind these events, or stack bindings on each interaction
		$('.ajax-get-children-select').unbind('change');
		$('.ajax-get-children-list a').unbind('click');

		// Check whether the user has chosen a division and, depending
		// on choice, hide relevant content to “reset” to the most recent click.
		if ( e.currentTarget.getAttribute('data-division') ) {
			$('.product-selector-columns .product-selector-column').remove();
			$('.division-selector-item a').removeClass('active');
			$(this).addClass('active');
		} else {
			$(this).parents('.product-selector-column').nextAll().remove();
			$(this).parents('.product-selector-list').find('a').removeClass('active');
			$(this).addClass('active');
		}

		// AJAX call to go and fetch requested content
		$.post(
		    ajax_obj.ajax_url,
		    {
		        'action': 'get_child_terms',
		        'id': e.currentTarget.value ? e.currentTarget.value : e.currentTarget.getAttribute('data-id'),
		        'target': e.currentTarget.getAttribute('data-target')
		    },
		    function(response) {
		    	// Append response to the DOM and re-bind required events
		    	$('.product-selector-columns .product-selector-grid').append('<div class="product-selector-column"></div>');
		        $('.product-selector-column').last().append(response);
		        $('.ajax-get-children-select').on('change', ajaxGetChildren);
		        $('.ajax-get-children-list a').on('click', ajaxGetChildren);
		    }
		);
	}

	// Bind events for the first time on document ready
	$('.ajax-get-children-select').on('change', ajaxGetChildren);
	$('.ajax-get-children-list a').on('click', ajaxGetChildren);

});
},{}],12:[function(require,module,exports){
/* eslint-disable */
/*
 * qTip2 - Pretty powerful tooltips - v3.0.3
 * http://qtip2.com
 *
 * Copyright (c) 2016 
 * Released under the MIT licenses
 * http://jquery.org/license
 *
 * Date: Wed May 11 2016 10:31 GMT+0100+0100
 * Plugins: tips modal viewport svg imagemap ie6
 * Styles: core basic css3
 */
/*global window: false, jQuery: false, console: false, define: false */

/* Cache window, document, undefined */
(function( window, document, undefined ) {

    // Uses AMD or browser globals to create a jQuery plugin.
    (function( factory ) {
        "use strict";
        if(typeof define === 'function' && define.amd) {
            define(['jquery'], factory);
        }
        else if(jQuery && !jQuery.fn.qtip) {
            factory(jQuery);
        }
    }
    (function($) {
        "use strict"; // Enable ECMAScript "strict" operation for this function. See more: http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
    ;// Munge the primitives - Paul Irish tip
    var TRUE = true,
    FALSE = false,
    NULL = null,
    
    // Common variables
    X = 'x', Y = 'y',
    WIDTH = 'width',
    HEIGHT = 'height',
    
    // Positioning sides
    TOP = 'top',
    LEFT = 'left',
    BOTTOM = 'bottom',
    RIGHT = 'right',
    CENTER = 'center',
    
    // Position adjustment types
    FLIP = 'flip',
    FLIPINVERT = 'flipinvert',
    SHIFT = 'shift',
    
    // Shortcut vars
    QTIP, PROTOTYPE, CORNER, CHECKS,
    PLUGINS = {},
    NAMESPACE = 'qtip',
    ATTR_HAS = 'data-hasqtip',
    ATTR_ID = 'data-qtip-id',
    WIDGET = ['ui-widget', 'ui-tooltip'],
    SELECTOR = '.'+NAMESPACE,
    INACTIVE_EVENTS = 'click dblclick mousedown mouseup mousemove mouseleave mouseenter'.split(' '),
    
    CLASS_FIXED = NAMESPACE+'-fixed',
    CLASS_DEFAULT = NAMESPACE + '-default',
    CLASS_FOCUS = NAMESPACE + '-focus',
    CLASS_HOVER = NAMESPACE + '-hover',
    CLASS_DISABLED = NAMESPACE+'-disabled',
    
    replaceSuffix = '_replacedByqTip',
    oldtitle = 'oldtitle',
    trackingBound,
    
    // Browser detection
    BROWSER = {
        /*
         * IE version detection
         *
         * Adapted from: http://ajaxian.com/archives/attack-of-the-ie-conditional-comment
         * Credit to James Padolsey for the original implemntation!
         */
        ie: (function() {
            /* eslint-disable no-empty */
            var v, i;
            for (
                v = 4, i = document.createElement('div');
                (i.innerHTML = '<!--[if gt IE ' + v + ']><i></i><![endif]-->') && i.getElementsByTagName('i')[0];
                v+=1
            ) {}
            return v > 4 ? v : NaN;
            /* eslint-enable no-empty */
        })(),
    
        /*
         * iOS version detection
         */
        iOS: parseFloat(
            ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
            .replace('undefined', '3_2').replace('_', '.').replace('_', '')
        ) || FALSE
    };
    ;function QTip(target, options, id, attr) {
        // Elements and ID
        this.id = id;
        this.target = target;
        this.tooltip = NULL;
        this.elements = { target: target };
    
        // Internal constructs
        this._id = NAMESPACE + '-' + id;
        this.timers = { img: {} };
        this.options = options;
        this.plugins = {};
    
        // Cache object
        this.cache = {
            event: {},
            target: $(),
            disabled: FALSE,
            attr: attr,
            onTooltip: FALSE,
            lastClass: ''
        };
    
        // Set the initial flags
        this.rendered = this.destroyed = this.disabled = this.waiting =
            this.hiddenDuringWait = this.positioning = this.triggering = FALSE;
    }
    PROTOTYPE = QTip.prototype;
    
    PROTOTYPE._when = function(deferreds) {
        return $.when.apply($, deferreds);
    };
    
    PROTOTYPE.render = function(show) {
        if(this.rendered || this.destroyed) { return this; } // If tooltip has already been rendered, exit
    
        var self = this,
            options = this.options,
            cache = this.cache,
            elements = this.elements,
            text = options.content.text,
            title = options.content.title,
            button = options.content.button,
            posOptions = options.position,
            deferreds = [];
    
        // Add ARIA attributes to target
        $.attr(this.target[0], 'aria-describedby', this._id);
    
        // Create public position object that tracks current position corners
        cache.posClass = this._createPosClass(
            (this.position = { my: posOptions.my, at: posOptions.at }).my
        );
    
        // Create tooltip element
        this.tooltip = elements.tooltip = $('<div/>', {
            'id': this._id,
            'class': [ NAMESPACE, CLASS_DEFAULT, options.style.classes, cache.posClass ].join(' '),
            'width': options.style.width || '',
            'height': options.style.height || '',
            'tracking': posOptions.target === 'mouse' && posOptions.adjust.mouse,
    
            /* ARIA specific attributes */
            'role': 'alert',
            'aria-live': 'polite',
            'aria-atomic': FALSE,
            'aria-describedby': this._id + '-content',
            'aria-hidden': TRUE
        })
        .toggleClass(CLASS_DISABLED, this.disabled)
        .attr(ATTR_ID, this.id)
        .data(NAMESPACE, this)
        .appendTo(posOptions.container)
        .append(
            // Create content element
            elements.content = $('<div />', {
                'class': NAMESPACE + '-content',
                'id': this._id + '-content',
                'aria-atomic': TRUE
            })
        );
    
        // Set rendered flag and prevent redundant reposition calls for now
        this.rendered = -1;
        this.positioning = TRUE;
    
        // Create title...
        if(title) {
            this._createTitle();
    
            // Update title only if its not a callback (called in toggle if so)
            if(!$.isFunction(title)) {
                deferreds.push( this._updateTitle(title, FALSE) );
            }
        }
    
        // Create button
        if(button) { this._createButton(); }
    
        // Set proper rendered flag and update content if not a callback function (called in toggle)
        if(!$.isFunction(text)) {
            deferreds.push( this._updateContent(text, FALSE) );
        }
        this.rendered = TRUE;
    
        // Setup widget classes
        this._setWidget();
    
        // Initialize 'render' plugins
        $.each(PLUGINS, function(name) {
            var instance;
            if(this.initialize === 'render' && (instance = this(self))) {
                self.plugins[name] = instance;
            }
        });
    
        // Unassign initial events and assign proper events
        this._unassignEvents();
        this._assignEvents();
    
        // When deferreds have completed
        this._when(deferreds).then(function() {
            // tooltiprender event
            self._trigger('render');
    
            // Reset flags
            self.positioning = FALSE;
    
            // Show tooltip if not hidden during wait period
            if(!self.hiddenDuringWait && (options.show.ready || show)) {
                self.toggle(TRUE, cache.event, FALSE);
            }
            self.hiddenDuringWait = FALSE;
        });
    
        // Expose API
        QTIP.api[this.id] = this;
    
        return this;
    };
    
    PROTOTYPE.destroy = function(immediate) {
        // Set flag the signify destroy is taking place to plugins
        // and ensure it only gets destroyed once!
        if(this.destroyed) { return this.target; }
    
        function process() {
            if(this.destroyed) { return; }
            this.destroyed = TRUE;
    
            var target = this.target,
                title = target.attr(oldtitle),
                timer;
    
            // Destroy tooltip if rendered
            if(this.rendered) {
                this.tooltip.stop(1,0).find('*').remove().end().remove();
            }
    
            // Destroy all plugins
            $.each(this.plugins, function() {
                this.destroy && this.destroy();
            });
    
            // Clear timers
            for (timer in this.timers) {
                if (this.timers.hasOwnProperty(timer)) {
                    clearTimeout(this.timers[timer]);
                }
            }
    
            // Remove api object and ARIA attributes
            target.removeData(NAMESPACE)
                .removeAttr(ATTR_ID)
                .removeAttr(ATTR_HAS)
                .removeAttr('aria-describedby');
    
            // Reset old title attribute if removed
            if(this.options.suppress && title) {
                target.attr('title', title).removeAttr(oldtitle);
            }
    
            // Remove qTip events associated with this API
            this._unassignEvents();
    
            // Remove ID from used id objects, and delete object references
            // for better garbage collection and leak protection
            this.options = this.elements = this.cache = this.timers =
                this.plugins = this.mouse = NULL;
    
            // Delete epoxsed API object
            delete QTIP.api[this.id];
        }
    
        // If an immediate destroy is needed
        if((immediate !== TRUE || this.triggering === 'hide') && this.rendered) {
            this.tooltip.one('tooltiphidden', $.proxy(process, this));
            !this.triggering && this.hide();
        }
    
        // If we're not in the process of hiding... process
        else { process.call(this); }
    
        return this.target;
    };
    ;function invalidOpt(a) {
        return a === NULL || $.type(a) !== 'object';
    }
    
    function invalidContent(c) {
        return !($.isFunction(c) || 
                c && c.attr || 
                c.length || 
                $.type(c) === 'object' && (c.jquery || c.then));
    }
    
    // Option object sanitizer
    function sanitizeOptions(opts) {
        var content, text, ajax, once;
    
        if(invalidOpt(opts)) { return FALSE; }
    
        if(invalidOpt(opts.metadata)) {
            opts.metadata = { type: opts.metadata };
        }
    
        if('content' in opts) {
            content = opts.content;
    
            if(invalidOpt(content) || content.jquery || content.done) {
                text = invalidContent(content) ? FALSE : content;
                content = opts.content = {
                    text: text
                };
            }
            else { text = content.text; }
    
            // DEPRECATED - Old content.ajax plugin functionality
            // Converts it into the proper Deferred syntax
            if('ajax' in content) {
                ajax = content.ajax;
                once = ajax && ajax.once !== FALSE;
                delete content.ajax;
    
                content.text = function(event, api) {
                    var loading = text || $(this).attr(api.options.content.attr) || 'Loading...',
    
                    deferred = $.ajax(
                        $.extend({}, ajax, { context: api })
                    )
                    .then(ajax.success, NULL, ajax.error)
                    .then(function(newContent) {
                        if(newContent && once) { api.set('content.text', newContent); }
                        return newContent;
                    },
                    function(xhr, status, error) {
                        if(api.destroyed || xhr.status === 0) { return; }
                        api.set('content.text', status + ': ' + error);
                    });
    
                    return !once ? (api.set('content.text', loading), deferred) : loading;
                };
            }
    
            if('title' in content) {
                if($.isPlainObject(content.title)) {
                    content.button = content.title.button;
                    content.title = content.title.text;
                }
    
                if(invalidContent(content.title || FALSE)) {
                    content.title = FALSE;
                }
            }
        }
    
        if('position' in opts && invalidOpt(opts.position)) {
            opts.position = { my: opts.position, at: opts.position };
        }
    
        if('show' in opts && invalidOpt(opts.show)) {
            opts.show = opts.show.jquery ? { target: opts.show } :
                opts.show === TRUE ? { ready: TRUE } : { event: opts.show };
        }
    
        if('hide' in opts && invalidOpt(opts.hide)) {
            opts.hide = opts.hide.jquery ? { target: opts.hide } : { event: opts.hide };
        }
    
        if('style' in opts && invalidOpt(opts.style)) {
            opts.style = { classes: opts.style };
        }
    
        // Sanitize plugin options
        $.each(PLUGINS, function() {
            this.sanitize && this.sanitize(opts);
        });
    
        return opts;
    }
    
    // Setup builtin .set() option checks
    CHECKS = PROTOTYPE.checks = {
        builtin: {
            // Core checks
            '^id$': function(obj, o, v, prev) {
                var id = v === TRUE ? QTIP.nextid : v,
                    newId = NAMESPACE + '-' + id;
    
                if(id !== FALSE && id.length > 0 && !$('#'+newId).length) {
                    this._id = newId;
    
                    if(this.rendered) {
                        this.tooltip[0].id = this._id;
                        this.elements.content[0].id = this._id + '-content';
                        this.elements.title[0].id = this._id + '-title';
                    }
                }
                else { obj[o] = prev; }
            },
            '^prerender': function(obj, o, v) {
                v && !this.rendered && this.render(this.options.show.ready);
            },
    
            // Content checks
            '^content.text$': function(obj, o, v) {
                this._updateContent(v);
            },
            '^content.attr$': function(obj, o, v, prev) {
                if(this.options.content.text === this.target.attr(prev)) {
                    this._updateContent( this.target.attr(v) );
                }
            },
            '^content.title$': function(obj, o, v) {
                // Remove title if content is null
                if(!v) { return this._removeTitle(); }
    
                // If title isn't already created, create it now and update
                v && !this.elements.title && this._createTitle();
                this._updateTitle(v);
            },
            '^content.button$': function(obj, o, v) {
                this._updateButton(v);
            },
            '^content.title.(text|button)$': function(obj, o, v) {
                this.set('content.'+o, v); // Backwards title.text/button compat
            },
    
            // Position checks
            '^position.(my|at)$': function(obj, o, v){
                if('string' === typeof v) {
                    this.position[o] = obj[o] = new CORNER(v, o === 'at');
                }
            },
            '^position.container$': function(obj, o, v){
                this.rendered && this.tooltip.appendTo(v);
            },
    
            // Show checks
            '^show.ready$': function(obj, o, v) {
                v && (!this.rendered && this.render(TRUE) || this.toggle(TRUE));
            },
    
            // Style checks
            '^style.classes$': function(obj, o, v, p) {
                this.rendered && this.tooltip.removeClass(p).addClass(v);
            },
            '^style.(width|height)': function(obj, o, v) {
                this.rendered && this.tooltip.css(o, v);
            },
            '^style.widget|content.title': function() {
                this.rendered && this._setWidget();
            },
            '^style.def': function(obj, o, v) {
                this.rendered && this.tooltip.toggleClass(CLASS_DEFAULT, !!v);
            },
    
            // Events check
            '^events.(render|show|move|hide|focus|blur)$': function(obj, o, v) {
                this.rendered && this.tooltip[($.isFunction(v) ? '' : 'un') + 'bind']('tooltip'+o, v);
            },
    
            // Properties which require event reassignment
            '^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)': function() {
                if(!this.rendered) { return; }
    
                // Set tracking flag
                var posOptions = this.options.position;
                this.tooltip.attr('tracking', posOptions.target === 'mouse' && posOptions.adjust.mouse);
    
                // Reassign events
                this._unassignEvents();
                this._assignEvents();
            }
        }
    };
    
    // Dot notation converter
    function convertNotation(options, notation) {
        var i = 0, obj, option = options,
    
        // Split notation into array
        levels = notation.split('.');
    
        // Loop through
        while(option = option[ levels[i++] ]) {
            if(i < levels.length) { obj = option; }
        }
    
        return [obj || options, levels.pop()];
    }
    
    PROTOTYPE.get = function(notation) {
        if(this.destroyed) { return this; }
    
        var o = convertNotation(this.options, notation.toLowerCase()),
            result = o[0][ o[1] ];
    
        return result.precedance ? result.string() : result;
    };
    
    function setCallback(notation, args) {
        var category, rule, match;
    
        for(category in this.checks) {
            if (!this.checks.hasOwnProperty(category)) { continue; }
    
            for(rule in this.checks[category]) {
                if (!this.checks[category].hasOwnProperty(rule)) { continue; }
    
                if(match = (new RegExp(rule, 'i')).exec(notation)) {
                    args.push(match);
    
                    if(category === 'builtin' || this.plugins[category]) {
                        this.checks[category][rule].apply(
                            this.plugins[category] || this, args
                        );
                    }
                }
            }
        }
    }
    
    var rmove = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,
        rrender = /^prerender|show\.ready/i;
    
    PROTOTYPE.set = function(option, value) {
        if(this.destroyed) { return this; }
    
        var rendered = this.rendered,
            reposition = FALSE,
            options = this.options,
            name;
    
        // Convert singular option/value pair into object form
        if('string' === typeof option) {
            name = option; option = {}; option[name] = value;
        }
        else { option = $.extend({}, option); }
    
        // Set all of the defined options to their new values
        $.each(option, function(notation, val) {
            if(rendered && rrender.test(notation)) {
                delete option[notation]; return;
            }
    
            // Set new obj value
            var obj = convertNotation(options, notation.toLowerCase()), previous;
            previous = obj[0][ obj[1] ];
            obj[0][ obj[1] ] = val && val.nodeType ? $(val) : val;
    
            // Also check if we need to reposition
            reposition = rmove.test(notation) || reposition;
    
            // Set the new params for the callback
            option[notation] = [obj[0], obj[1], val, previous];
        });
    
        // Re-sanitize options
        sanitizeOptions(options);
    
        /*
         * Execute any valid callbacks for the set options
         * Also set positioning flag so we don't get loads of redundant repositioning calls.
         */
        this.positioning = TRUE;
        $.each(option, $.proxy(setCallback, this));
        this.positioning = FALSE;
    
        // Update position if needed
        if(this.rendered && this.tooltip[0].offsetWidth > 0 && reposition) {
            this.reposition( options.position.target === 'mouse' ? NULL : this.cache.event );
        }
    
        return this;
    };
    ;PROTOTYPE._update = function(content, element) {
        var self = this,
            cache = this.cache;
    
        // Make sure tooltip is rendered and content is defined. If not return
        if(!this.rendered || !content) { return FALSE; }
    
        // Use function to parse content
        if($.isFunction(content)) {
            content = content.call(this.elements.target, cache.event, this) || '';
        }
    
        // Handle deferred content
        if($.isFunction(content.then)) {
            cache.waiting = TRUE;
            return content.then(function(c) {
                cache.waiting = FALSE;
                return self._update(c, element);
            }, NULL, function(e) {
                return self._update(e, element);
            });
        }
    
        // If content is null... return false
        if(content === FALSE || !content && content !== '') { return FALSE; }
    
        // Append new content if its a DOM array and show it if hidden
        if(content.jquery && content.length > 0) {
            element.empty().append(
                content.css({ display: 'block', visibility: 'visible' })
            );
        }
    
        // Content is a regular string, insert the new content
        else { element.html(content); }
    
        // Wait for content to be loaded, and reposition
        return this._waitForContent(element).then(function(images) {
            if(self.rendered && self.tooltip[0].offsetWidth > 0) {
                self.reposition(cache.event, !images.length);
            }
        });
    };
    
    PROTOTYPE._waitForContent = function(element) {
        var cache = this.cache;
    
        // Set flag
        cache.waiting = TRUE;
    
        // If imagesLoaded is included, ensure images have loaded and return promise
        return ( $.fn.imagesLoaded ? element.imagesLoaded() : new $.Deferred().resolve([]) )
            .done(function() { cache.waiting = FALSE; })
            .promise();
    };
    
    PROTOTYPE._updateContent = function(content, reposition) {
        this._update(content, this.elements.content, reposition);
    };
    
    PROTOTYPE._updateTitle = function(content, reposition) {
        if(this._update(content, this.elements.title, reposition) === FALSE) {
            this._removeTitle(FALSE);
        }
    };
    
    PROTOTYPE._createTitle = function()
    {
        var elements = this.elements,
            id = this._id+'-title';
    
        // Destroy previous title element, if present
        if(elements.titlebar) { this._removeTitle(); }
    
        // Create title bar and title elements
        elements.titlebar = $('<div />', {
            'class': NAMESPACE + '-titlebar ' + (this.options.style.widget ? createWidgetClass('header') : '')
        })
        .append(
            elements.title = $('<div />', {
                'id': id,
                'class': NAMESPACE + '-title',
                'aria-atomic': TRUE
            })
        )
        .insertBefore(elements.content)
    
        // Button-specific events
        .delegate('.qtip-close', 'mousedown keydown mouseup keyup mouseout', function(event) {
            $(this).toggleClass('ui-state-active ui-state-focus', event.type.substr(-4) === 'down');
        })
        .delegate('.qtip-close', 'mouseover mouseout', function(event){
            $(this).toggleClass('ui-state-hover', event.type === 'mouseover');
        });
    
        // Create button if enabled
        if(this.options.content.button) { this._createButton(); }
    };
    
    PROTOTYPE._removeTitle = function(reposition)
    {
        var elements = this.elements;
    
        if(elements.title) {
            elements.titlebar.remove();
            elements.titlebar = elements.title = elements.button = NULL;
    
            // Reposition if enabled
            if(reposition !== FALSE) { this.reposition(); }
        }
    };
    ;PROTOTYPE._createPosClass = function(my) {
        return NAMESPACE + '-pos-' + (my || this.options.position.my).abbrev();
    };
    
    PROTOTYPE.reposition = function(event, effect) {
        if(!this.rendered || this.positioning || this.destroyed) { return this; }
    
        // Set positioning flag
        this.positioning = TRUE;
    
        var cache = this.cache,
            tooltip = this.tooltip,
            posOptions = this.options.position,
            target = posOptions.target,
            my = posOptions.my,
            at = posOptions.at,
            viewport = posOptions.viewport,
            container = posOptions.container,
            adjust = posOptions.adjust,
            method = adjust.method.split(' '),
            tooltipWidth = tooltip.outerWidth(FALSE),
            tooltipHeight = tooltip.outerHeight(FALSE),
            targetWidth = 0,
            targetHeight = 0,
            type = tooltip.css('position'),
            position = { left: 0, top: 0 },
            visible = tooltip[0].offsetWidth > 0,
            isScroll = event && event.type === 'scroll',
            win = $(window),
            doc = container[0].ownerDocument,
            mouse = this.mouse,
            pluginCalculations, offset, adjusted, newClass;
    
        // Check if absolute position was passed
        if($.isArray(target) && target.length === 2) {
            // Force left top and set position
            at = { x: LEFT, y: TOP };
            position = { left: target[0], top: target[1] };
        }
    
        // Check if mouse was the target
        else if(target === 'mouse') {
            // Force left top to allow flipping
            at = { x: LEFT, y: TOP };
    
            // Use the mouse origin that caused the show event, if distance hiding is enabled
            if((!adjust.mouse || this.options.hide.distance) && cache.origin && cache.origin.pageX) {
                event =  cache.origin;
            }
    
            // Use cached event for resize/scroll events
            else if(!event || event && (event.type === 'resize' || event.type === 'scroll')) {
                event = cache.event;
            }
    
            // Otherwise, use the cached mouse coordinates if available
            else if(mouse && mouse.pageX) {
                event = mouse;
            }
    
            // Calculate body and container offset and take them into account below
            if(type !== 'static') { position = container.offset(); }
            if(doc.body.offsetWidth !== (window.innerWidth || doc.documentElement.clientWidth)) {
                offset = $(document.body).offset();
            }
    
            // Use event coordinates for position
            position = {
                left: event.pageX - position.left + (offset && offset.left || 0),
                top: event.pageY - position.top + (offset && offset.top || 0)
            };
    
            // Scroll events are a pain, some browsers
            if(adjust.mouse && isScroll && mouse) {
                position.left -= (mouse.scrollX || 0) - win.scrollLeft();
                position.top -= (mouse.scrollY || 0) - win.scrollTop();
            }
        }
    
        // Target wasn't mouse or absolute...
        else {
            // Check if event targetting is being used
            if(target === 'event') {
                if(event && event.target && event.type !== 'scroll' && event.type !== 'resize') {
                    cache.target = $(event.target);
                }
                else if(!event.target) {
                    cache.target = this.elements.target;
                }
            }
            else if(target !== 'event'){
                cache.target = $(target.jquery ? target : this.elements.target);
            }
            target = cache.target;
    
            // Parse the target into a jQuery object and make sure there's an element present
            target = $(target).eq(0);
            if(target.length === 0) { return this; }
    
            // Check if window or document is the target
            else if(target[0] === document || target[0] === window) {
                targetWidth = BROWSER.iOS ? window.innerWidth : target.width();
                targetHeight = BROWSER.iOS ? window.innerHeight : target.height();
    
                if(target[0] === window) {
                    position = {
                        top: (viewport || target).scrollTop(),
                        left: (viewport || target).scrollLeft()
                    };
                }
            }
    
            // Check if the target is an <AREA> element
            else if(PLUGINS.imagemap && target.is('area')) {
                pluginCalculations = PLUGINS.imagemap(this, target, at, PLUGINS.viewport ? method : FALSE);
            }
    
            // Check if the target is an SVG element
            else if(PLUGINS.svg && target && target[0].ownerSVGElement) {
                pluginCalculations = PLUGINS.svg(this, target, at, PLUGINS.viewport ? method : FALSE);
            }
    
            // Otherwise use regular jQuery methods
            else {
                targetWidth = target.outerWidth(FALSE);
                targetHeight = target.outerHeight(FALSE);
                position = target.offset();
            }
    
            // Parse returned plugin values into proper variables
            if(pluginCalculations) {
                targetWidth = pluginCalculations.width;
                targetHeight = pluginCalculations.height;
                offset = pluginCalculations.offset;
                position = pluginCalculations.position;
            }
    
            // Adjust position to take into account offset parents
            position = this.reposition.offset(target, position, container);
    
            // Adjust for position.fixed tooltips (and also iOS scroll bug in v3.2-4.0 & v4.3-4.3.2)
            if(BROWSER.iOS > 3.1 && BROWSER.iOS < 4.1 ||
                BROWSER.iOS >= 4.3 && BROWSER.iOS < 4.33 ||
                !BROWSER.iOS && type === 'fixed'
            ){
                position.left -= win.scrollLeft();
                position.top -= win.scrollTop();
            }
    
            // Adjust position relative to target
            if(!pluginCalculations || pluginCalculations && pluginCalculations.adjustable !== FALSE) {
                position.left += at.x === RIGHT ? targetWidth : at.x === CENTER ? targetWidth / 2 : 0;
                position.top += at.y === BOTTOM ? targetHeight : at.y === CENTER ? targetHeight / 2 : 0;
            }
        }
    
        // Adjust position relative to tooltip
        position.left += adjust.x + (my.x === RIGHT ? -tooltipWidth : my.x === CENTER ? -tooltipWidth / 2 : 0);
        position.top += adjust.y + (my.y === BOTTOM ? -tooltipHeight : my.y === CENTER ? -tooltipHeight / 2 : 0);
    
        // Use viewport adjustment plugin if enabled
        if(PLUGINS.viewport) {
            adjusted = position.adjusted = PLUGINS.viewport(
                this, position, posOptions, targetWidth, targetHeight, tooltipWidth, tooltipHeight
            );
    
            // Apply offsets supplied by positioning plugin (if used)
            if(offset && adjusted.left) { position.left += offset.left; }
            if(offset && adjusted.top) {  position.top += offset.top; }
    
            // Apply any new 'my' position
            if(adjusted.my) { this.position.my = adjusted.my; }
        }
    
        // Viewport adjustment is disabled, set values to zero
        else { position.adjusted = { left: 0, top: 0 }; }
    
        // Set tooltip position class if it's changed
        if(cache.posClass !== (newClass = this._createPosClass(this.position.my))) {
            cache.posClass = newClass;
            tooltip.removeClass(cache.posClass).addClass(newClass);
        }
    
        // tooltipmove event
        if(!this._trigger('move', [position, viewport.elem || viewport], event)) { return this; }
        delete position.adjusted;
    
        // If effect is disabled, target it mouse, no animation is defined or positioning gives NaN out, set CSS directly
        if(effect === FALSE || !visible || isNaN(position.left) || isNaN(position.top) || target === 'mouse' || !$.isFunction(posOptions.effect)) {
            tooltip.css(position);
        }
    
        // Use custom function if provided
        else if($.isFunction(posOptions.effect)) {
            posOptions.effect.call(tooltip, this, $.extend({}, position));
            tooltip.queue(function(next) {
                // Reset attributes to avoid cross-browser rendering bugs
                $(this).css({ opacity: '', height: '' });
                if(BROWSER.ie) { this.style.removeAttribute('filter'); }
    
                next();
            });
        }
    
        // Set positioning flag
        this.positioning = FALSE;
    
        return this;
    };
    
    // Custom (more correct for qTip!) offset calculator
    PROTOTYPE.reposition.offset = function(elem, pos, container) {
        if(!container[0]) { return pos; }
    
        var ownerDocument = $(elem[0].ownerDocument),
            quirks = !!BROWSER.ie && document.compatMode !== 'CSS1Compat',
            parent = container[0],
            scrolled, position, parentOffset, overflow;
    
        function scroll(e, i) {
            pos.left += i * e.scrollLeft();
            pos.top += i * e.scrollTop();
        }
    
        // Compensate for non-static containers offset
        do {
            if((position = $.css(parent, 'position')) !== 'static') {
                if(position === 'fixed') {
                    parentOffset = parent.getBoundingClientRect();
                    scroll(ownerDocument, -1);
                }
                else {
                    parentOffset = $(parent).position();
                    parentOffset.left += parseFloat($.css(parent, 'borderLeftWidth')) || 0;
                    parentOffset.top += parseFloat($.css(parent, 'borderTopWidth')) || 0;
                }
    
                pos.left -= parentOffset.left + (parseFloat($.css(parent, 'marginLeft')) || 0);
                pos.top -= parentOffset.top + (parseFloat($.css(parent, 'marginTop')) || 0);
    
                // If this is the first parent element with an overflow of "scroll" or "auto", store it
                if(!scrolled && (overflow = $.css(parent, 'overflow')) !== 'hidden' && overflow !== 'visible') { scrolled = $(parent); }
            }
        }
        while(parent = parent.offsetParent);
    
        // Compensate for containers scroll if it also has an offsetParent (or in IE quirks mode)
        if(scrolled && (scrolled[0] !== ownerDocument[0] || quirks)) {
            scroll(scrolled, 1);
        }
    
        return pos;
    };
    
    // Corner class
    var C = (CORNER = PROTOTYPE.reposition.Corner = function(corner, forceY) {
        corner = ('' + corner).replace(/([A-Z])/, ' $1').replace(/middle/gi, CENTER).toLowerCase();
        this.x = (corner.match(/left|right/i) || corner.match(/center/) || ['inherit'])[0].toLowerCase();
        this.y = (corner.match(/top|bottom|center/i) || ['inherit'])[0].toLowerCase();
        this.forceY = !!forceY;
    
        var f = corner.charAt(0);
        this.precedance = f === 't' || f === 'b' ? Y : X;
    }).prototype;
    
    C.invert = function(z, center) {
        this[z] = this[z] === LEFT ? RIGHT : this[z] === RIGHT ? LEFT : center || this[z];
    };
    
    C.string = function(join) {
        var x = this.x, y = this.y;
    
        var result = x !== y ?
            x === 'center' || y !== 'center' && (this.precedance === Y || this.forceY) ? 
                [y,x] : 
                [x,y] :
            [x];
    
        return join !== false ? result.join(' ') : result;
    };
    
    C.abbrev = function() {
        var result = this.string(false);
        return result[0].charAt(0) + (result[1] && result[1].charAt(0) || '');
    };
    
    C.clone = function() {
        return new CORNER( this.string(), this.forceY );
    };
    
    ;
    PROTOTYPE.toggle = function(state, event) {
        var cache = this.cache,
            options = this.options,
            tooltip = this.tooltip;
    
        // Try to prevent flickering when tooltip overlaps show element
        if(event) {
            if((/over|enter/).test(event.type) && cache.event && (/out|leave/).test(cache.event.type) &&
                options.show.target.add(event.target).length === options.show.target.length &&
                tooltip.has(event.relatedTarget).length) {
                return this;
            }
    
            // Cache event
            cache.event = $.event.fix(event);
        }
    
        // If we're currently waiting and we've just hidden... stop it
        this.waiting && !state && (this.hiddenDuringWait = TRUE);
    
        // Render the tooltip if showing and it isn't already
        if(!this.rendered) { return state ? this.render(1) : this; }
        else if(this.destroyed || this.disabled) { return this; }
    
        var type = state ? 'show' : 'hide',
            opts = this.options[type],
            posOptions = this.options.position,
            contentOptions = this.options.content,
            width = this.tooltip.css('width'),
            visible = this.tooltip.is(':visible'),
            animate = state || opts.target.length === 1,
            sameTarget = !event || opts.target.length < 2 || cache.target[0] === event.target,
            identicalState, allow, after;
    
        // Detect state if valid one isn't provided
        if((typeof state).search('boolean|number')) { state = !visible; }
    
        // Check if the tooltip is in an identical state to the new would-be state
        identicalState = !tooltip.is(':animated') && visible === state && sameTarget;
    
        // Fire tooltip(show/hide) event and check if destroyed
        allow = !identicalState ? !!this._trigger(type, [90]) : NULL;
    
        // Check to make sure the tooltip wasn't destroyed in the callback
        if(this.destroyed) { return this; }
    
        // If the user didn't stop the method prematurely and we're showing the tooltip, focus it
        if(allow !== FALSE && state) { this.focus(event); }
    
        // If the state hasn't changed or the user stopped it, return early
        if(!allow || identicalState) { return this; }
    
        // Set ARIA hidden attribute
        $.attr(tooltip[0], 'aria-hidden', !!!state);
    
        // Execute state specific properties
        if(state) {
            // Store show origin coordinates
            this.mouse && (cache.origin = $.event.fix(this.mouse));
    
            // Update tooltip content & title if it's a dynamic function
            if($.isFunction(contentOptions.text)) { this._updateContent(contentOptions.text, FALSE); }
            if($.isFunction(contentOptions.title)) { this._updateTitle(contentOptions.title, FALSE); }
    
            // Cache mousemove events for positioning purposes (if not already tracking)
            if(!trackingBound && posOptions.target === 'mouse' && posOptions.adjust.mouse) {
                $(document).bind('mousemove.'+NAMESPACE, this._storeMouse);
                trackingBound = TRUE;
            }
    
            // Update the tooltip position (set width first to prevent viewport/max-width issues)
            if(!width) { tooltip.css('width', tooltip.outerWidth(FALSE)); }
            this.reposition(event, arguments[2]);
            if(!width) { tooltip.css('width', ''); }
    
            // Hide other tooltips if tooltip is solo
            if(!!opts.solo) {
                (typeof opts.solo === 'string' ? $(opts.solo) : $(SELECTOR, opts.solo))
                    .not(tooltip).not(opts.target).qtip('hide', new $.Event('tooltipsolo'));
            }
        }
        else {
            // Clear show timer if we're hiding
            clearTimeout(this.timers.show);
    
            // Remove cached origin on hide
            delete cache.origin;
    
            // Remove mouse tracking event if not needed (all tracking qTips are hidden)
            if(trackingBound && !$(SELECTOR+'[tracking="true"]:visible', opts.solo).not(tooltip).length) {
                $(document).unbind('mousemove.'+NAMESPACE);
                trackingBound = FALSE;
            }
    
            // Blur the tooltip
            this.blur(event);
        }
    
        // Define post-animation, state specific properties
        after = $.proxy(function() {
            if(state) {
                // Prevent antialias from disappearing in IE by removing filter
                if(BROWSER.ie) { tooltip[0].style.removeAttribute('filter'); }
    
                // Remove overflow setting to prevent tip bugs
                tooltip.css('overflow', '');
    
                // Autofocus elements if enabled
                if('string' === typeof opts.autofocus) {
                    $(this.options.show.autofocus, tooltip).focus();
                }
    
                // If set, hide tooltip when inactive for delay period
                this.options.show.target.trigger('qtip-'+this.id+'-inactive');
            }
            else {
                // Reset CSS states
                tooltip.css({
                    display: '',
                    visibility: '',
                    opacity: '',
                    left: '',
                    top: ''
                });
            }
    
            // tooltipvisible/tooltiphidden events
            this._trigger(state ? 'visible' : 'hidden');
        }, this);
    
        // If no effect type is supplied, use a simple toggle
        if(opts.effect === FALSE || animate === FALSE) {
            tooltip[ type ]();
            after();
        }
    
        // Use custom function if provided
        else if($.isFunction(opts.effect)) {
            tooltip.stop(1, 1);
            opts.effect.call(tooltip, this);
            tooltip.queue('fx', function(n) {
                after(); n();
            });
        }
    
        // Use basic fade function by default
        else { tooltip.fadeTo(90, state ? 1 : 0, after); }
    
        // If inactive hide method is set, active it
        if(state) { opts.target.trigger('qtip-'+this.id+'-inactive'); }
    
        return this;
    };
    
    PROTOTYPE.show = function(event) { return this.toggle(TRUE, event); };
    
    PROTOTYPE.hide = function(event) { return this.toggle(FALSE, event); };
    ;PROTOTYPE.focus = function(event) {
        if(!this.rendered || this.destroyed) { return this; }
    
        var qtips = $(SELECTOR),
            tooltip = this.tooltip,
            curIndex = parseInt(tooltip[0].style.zIndex, 10),
            newIndex = QTIP.zindex + qtips.length;
    
        // Only update the z-index if it has changed and tooltip is not already focused
        if(!tooltip.hasClass(CLASS_FOCUS)) {
            // tooltipfocus event
            if(this._trigger('focus', [newIndex], event)) {
                // Only update z-index's if they've changed
                if(curIndex !== newIndex) {
                    // Reduce our z-index's and keep them properly ordered
                    qtips.each(function() {
                        if(this.style.zIndex > curIndex) {
                            this.style.zIndex = this.style.zIndex - 1;
                        }
                    });
    
                    // Fire blur event for focused tooltip
                    qtips.filter('.' + CLASS_FOCUS).qtip('blur', event);
                }
    
                // Set the new z-index
                tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;
            }
        }
    
        return this;
    };
    
    PROTOTYPE.blur = function(event) {
        if(!this.rendered || this.destroyed) { return this; }
    
        // Set focused status to FALSE
        this.tooltip.removeClass(CLASS_FOCUS);
    
        // tooltipblur event
        this._trigger('blur', [ this.tooltip.css('zIndex') ], event);
    
        return this;
    };
    ;PROTOTYPE.disable = function(state) {
        if(this.destroyed) { return this; }
    
        // If 'toggle' is passed, toggle the current state
        if(state === 'toggle') {
            state = !(this.rendered ? this.tooltip.hasClass(CLASS_DISABLED) : this.disabled);
        }
    
        // Disable if no state passed
        else if('boolean' !== typeof state) {
            state = TRUE;
        }
    
        if(this.rendered) {
            this.tooltip.toggleClass(CLASS_DISABLED, state)
                .attr('aria-disabled', state);
        }
    
        this.disabled = !!state;
    
        return this;
    };
    
    PROTOTYPE.enable = function() { return this.disable(FALSE); };
    ;PROTOTYPE._createButton = function()
    {
        var self = this,
            elements = this.elements,
            tooltip = elements.tooltip,
            button = this.options.content.button,
            isString = typeof button === 'string',
            close = isString ? button : 'Close tooltip';
    
        if(elements.button) { elements.button.remove(); }
    
        // Use custom button if one was supplied by user, else use default
        if(button.jquery) {
            elements.button = button;
        }
        else {
            elements.button = $('<a />', {
                'class': 'qtip-close ' + (this.options.style.widget ? '' : NAMESPACE+'-icon'),
                'title': close,
                'aria-label': close
            })
            .prepend(
                $('<span />', {
                    'class': 'ui-icon ui-icon-close',
                    'html': '&times;'
                })
            );
        }
    
        // Create button and setup attributes
        elements.button.appendTo(elements.titlebar || tooltip)
            .attr('role', 'button')
            .click(function(event) {
                if(!tooltip.hasClass(CLASS_DISABLED)) { self.hide(event); }
                return FALSE;
            });
    };
    
    PROTOTYPE._updateButton = function(button)
    {
        // Make sure tooltip is rendered and if not, return
        if(!this.rendered) { return FALSE; }
    
        var elem = this.elements.button;
        if(button) { this._createButton(); }
        else { elem.remove(); }
    };
    ;// Widget class creator
    function createWidgetClass(cls) {
        return WIDGET.concat('').join(cls ? '-'+cls+' ' : ' ');
    }
    
    // Widget class setter method
    PROTOTYPE._setWidget = function()
    {
        var on = this.options.style.widget,
            elements = this.elements,
            tooltip = elements.tooltip,
            disabled = tooltip.hasClass(CLASS_DISABLED);
    
        tooltip.removeClass(CLASS_DISABLED);
        CLASS_DISABLED = on ? 'ui-state-disabled' : 'qtip-disabled';
        tooltip.toggleClass(CLASS_DISABLED, disabled);
    
        tooltip.toggleClass('ui-helper-reset '+createWidgetClass(), on).toggleClass(CLASS_DEFAULT, this.options.style.def && !on);
    
        if(elements.content) {
            elements.content.toggleClass( createWidgetClass('content'), on);
        }
        if(elements.titlebar) {
            elements.titlebar.toggleClass( createWidgetClass('header'), on);
        }
        if(elements.button) {
            elements.button.toggleClass(NAMESPACE+'-icon', !on);
        }
    };
    ;function delay(callback, duration) {
        // If tooltip has displayed, start hide timer
        if(duration > 0) {
            return setTimeout(
                $.proxy(callback, this), duration
            );
        }
        else{ callback.call(this); }
    }
    
    function showMethod(event) {
        if(this.tooltip.hasClass(CLASS_DISABLED)) { return; }
    
        // Clear hide timers
        clearTimeout(this.timers.show);
        clearTimeout(this.timers.hide);
    
        // Start show timer
        this.timers.show = delay.call(this,
            function() { this.toggle(TRUE, event); },
            this.options.show.delay
        );
    }
    
    function hideMethod(event) {
        if(this.tooltip.hasClass(CLASS_DISABLED) || this.destroyed) { return; }
    
        // Check if new target was actually the tooltip element
        var relatedTarget = $(event.relatedTarget),
            ontoTooltip = relatedTarget.closest(SELECTOR)[0] === this.tooltip[0],
            ontoTarget = relatedTarget[0] === this.options.show.target[0];
    
        // Clear timers and stop animation queue
        clearTimeout(this.timers.show);
        clearTimeout(this.timers.hide);
    
        // Prevent hiding if tooltip is fixed and event target is the tooltip.
        // Or if mouse positioning is enabled and cursor momentarily overlaps
        if(this !== relatedTarget[0] &&
            (this.options.position.target === 'mouse' && ontoTooltip) ||
            this.options.hide.fixed && (
                (/mouse(out|leave|move)/).test(event.type) && (ontoTooltip || ontoTarget))
            )
        {
            /* eslint-disable no-empty */
            try {
                event.preventDefault();
                event.stopImmediatePropagation();
            } catch(e) {}
            /* eslint-enable no-empty */
    
            return;
        }
    
        // If tooltip has displayed, start hide timer
        this.timers.hide = delay.call(this,
            function() { this.toggle(FALSE, event); },
            this.options.hide.delay,
            this
        );
    }
    
    function inactiveMethod(event) {
        if(this.tooltip.hasClass(CLASS_DISABLED) || !this.options.hide.inactive) { return; }
    
        // Clear timer
        clearTimeout(this.timers.inactive);
    
        this.timers.inactive = delay.call(this,
            function(){ this.hide(event); },
            this.options.hide.inactive
        );
    }
    
    function repositionMethod(event) {
        if(this.rendered && this.tooltip[0].offsetWidth > 0) { this.reposition(event); }
    }
    
    // Store mouse coordinates
    PROTOTYPE._storeMouse = function(event) {
        (this.mouse = $.event.fix(event)).type = 'mousemove';
        return this;
    };
    
    // Bind events
    PROTOTYPE._bind = function(targets, events, method, suffix, context) {
        if(!targets || !method || !events.length) { return; }
        var ns = '.' + this._id + (suffix ? '-'+suffix : '');
        $(targets).bind(
            (events.split ? events : events.join(ns + ' ')) + ns,
            $.proxy(method, context || this)
        );
        return this;
    };
    PROTOTYPE._unbind = function(targets, suffix) {
        targets && $(targets).unbind('.' + this._id + (suffix ? '-'+suffix : ''));
        return this;
    };
    
    // Global delegation helper
    function delegate(selector, events, method) {
        $(document.body).delegate(selector,
            (events.split ? events : events.join('.'+NAMESPACE + ' ')) + '.'+NAMESPACE,
            function() {
                var api = QTIP.api[ $.attr(this, ATTR_ID) ];
                api && !api.disabled && method.apply(api, arguments);
            }
        );
    }
    // Event trigger
    PROTOTYPE._trigger = function(type, args, event) {
        var callback = new $.Event('tooltip'+type);
        callback.originalEvent = event && $.extend({}, event) || this.cache.event || NULL;
    
        this.triggering = type;
        this.tooltip.trigger(callback, [this].concat(args || []));
        this.triggering = FALSE;
    
        return !callback.isDefaultPrevented();
    };
    
    PROTOTYPE._bindEvents = function(showEvents, hideEvents, showTargets, hideTargets, showCallback, hideCallback) {
        // Get tasrgets that lye within both
        var similarTargets = showTargets.filter( hideTargets ).add( hideTargets.filter(showTargets) ),
            toggleEvents = [];
    
        // If hide and show targets are the same...
        if(similarTargets.length) {
    
            // Filter identical show/hide events
            $.each(hideEvents, function(i, type) {
                var showIndex = $.inArray(type, showEvents);
    
                // Both events are identical, remove from both hide and show events
                // and append to toggleEvents
                showIndex > -1 && toggleEvents.push( showEvents.splice( showIndex, 1 )[0] );
            });
    
            // Toggle events are special case of identical show/hide events, which happen in sequence
            if(toggleEvents.length) {
                // Bind toggle events to the similar targets
                this._bind(similarTargets, toggleEvents, function(event) {
                    var state = this.rendered ? this.tooltip[0].offsetWidth > 0 : false;
                    (state ? hideCallback : showCallback).call(this, event);
                });
    
                // Remove the similar targets from the regular show/hide bindings
                showTargets = showTargets.not(similarTargets);
                hideTargets = hideTargets.not(similarTargets);
            }
        }
    
        // Apply show/hide/toggle events
        this._bind(showTargets, showEvents, showCallback);
        this._bind(hideTargets, hideEvents, hideCallback);
    };
    
    PROTOTYPE._assignInitialEvents = function(event) {
        var options = this.options,
            showTarget = options.show.target,
            hideTarget = options.hide.target,
            showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
            hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];
    
        // Catch remove/removeqtip events on target element to destroy redundant tooltips
        this._bind(this.elements.target, ['remove', 'removeqtip'], function() {
            this.destroy(true);
        }, 'destroy');
    
        /*
         * Make sure hoverIntent functions properly by using mouseleave as a hide event if
         * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
         */
        if(/mouse(over|enter)/i.test(options.show.event) && !/mouse(out|leave)/i.test(options.hide.event)) {
            hideEvents.push('mouseleave');
        }
    
        /*
         * Also make sure initial mouse targetting works correctly by caching mousemove coords
         * on show targets before the tooltip has rendered. Also set onTarget when triggered to
         * keep mouse tracking working.
         */
        this._bind(showTarget, 'mousemove', function(moveEvent) {
            this._storeMouse(moveEvent);
            this.cache.onTarget = TRUE;
        });
    
        // Define hoverIntent function
        function hoverIntent(hoverEvent) {
            // Only continue if tooltip isn't disabled
            if(this.disabled || this.destroyed) { return FALSE; }
    
            // Cache the event data
            this.cache.event = hoverEvent && $.event.fix(hoverEvent);
            this.cache.target = hoverEvent && $(hoverEvent.target);
    
            // Start the event sequence
            clearTimeout(this.timers.show);
            this.timers.show = delay.call(this,
                function() { this.render(typeof hoverEvent === 'object' || options.show.ready); },
                options.prerender ? 0 : options.show.delay
            );
        }
    
        // Filter and bind events
        this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, hoverIntent, function() {
            if(!this.timers) { return FALSE; }
            clearTimeout(this.timers.show);
        });
    
        // Prerendering is enabled, create tooltip now
        if(options.show.ready || options.prerender) { hoverIntent.call(this, event); }
    };
    
    // Event assignment method
    PROTOTYPE._assignEvents = function() {
        var self = this,
            options = this.options,
            posOptions = options.position,
    
            tooltip = this.tooltip,
            showTarget = options.show.target,
            hideTarget = options.hide.target,
            containerTarget = posOptions.container,
            viewportTarget = posOptions.viewport,
            documentTarget = $(document),
            windowTarget = $(window),
    
            showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
            hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];
    
    
        // Assign passed event callbacks
        $.each(options.events, function(name, callback) {
            self._bind(tooltip, name === 'toggle' ? ['tooltipshow','tooltiphide'] : ['tooltip'+name], callback, null, tooltip);
        });
    
        // Hide tooltips when leaving current window/frame (but not select/option elements)
        if(/mouse(out|leave)/i.test(options.hide.event) && options.hide.leave === 'window') {
            this._bind(documentTarget, ['mouseout', 'blur'], function(event) {
                if(!/select|option/.test(event.target.nodeName) && !event.relatedTarget) {
                    this.hide(event);
                }
            });
        }
    
        // Enable hide.fixed by adding appropriate class
        if(options.hide.fixed) {
            hideTarget = hideTarget.add( tooltip.addClass(CLASS_FIXED) );
        }
    
        /*
         * Make sure hoverIntent functions properly by using mouseleave to clear show timer if
         * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
         */
        else if(/mouse(over|enter)/i.test(options.show.event)) {
            this._bind(hideTarget, 'mouseleave', function() {
                clearTimeout(this.timers.show);
            });
        }
    
        // Hide tooltip on document mousedown if unfocus events are enabled
        if(('' + options.hide.event).indexOf('unfocus') > -1) {
            this._bind(containerTarget.closest('html'), ['mousedown', 'touchstart'], function(event) {
                var elem = $(event.target),
                    enabled = this.rendered && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0,
                    isAncestor = elem.parents(SELECTOR).filter(this.tooltip[0]).length > 0;
    
                if(elem[0] !== this.target[0] && elem[0] !== this.tooltip[0] && !isAncestor &&
                    !this.target.has(elem[0]).length && enabled
                ) {
                    this.hide(event);
                }
            });
        }
    
        // Check if the tooltip hides when inactive
        if('number' === typeof options.hide.inactive) {
            // Bind inactive method to show target(s) as a custom event
            this._bind(showTarget, 'qtip-'+this.id+'-inactive', inactiveMethod, 'inactive');
    
            // Define events which reset the 'inactive' event handler
            this._bind(hideTarget.add(tooltip), QTIP.inactiveEvents, inactiveMethod);
        }
    
        // Filter and bind events
        this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, showMethod, hideMethod);
    
        // Mouse movement bindings
        this._bind(showTarget.add(tooltip), 'mousemove', function(event) {
            // Check if the tooltip hides when mouse is moved a certain distance
            if('number' === typeof options.hide.distance) {
                var origin = this.cache.origin || {},
                    limit = this.options.hide.distance,
                    abs = Math.abs;
    
                // Check if the movement has gone beyond the limit, and hide it if so
                if(abs(event.pageX - origin.pageX) >= limit || abs(event.pageY - origin.pageY) >= limit) {
                    this.hide(event);
                }
            }
    
            // Cache mousemove coords on show targets
            this._storeMouse(event);
        });
    
        // Mouse positioning events
        if(posOptions.target === 'mouse') {
            // If mouse adjustment is on...
            if(posOptions.adjust.mouse) {
                // Apply a mouseleave event so we don't get problems with overlapping
                if(options.hide.event) {
                    // Track if we're on the target or not
                    this._bind(showTarget, ['mouseenter', 'mouseleave'], function(event) {
                        if(!this.cache) {return FALSE; }
                        this.cache.onTarget = event.type === 'mouseenter';
                    });
                }
    
                // Update tooltip position on mousemove
                this._bind(documentTarget, 'mousemove', function(event) {
                    // Update the tooltip position only if the tooltip is visible and adjustment is enabled
                    if(this.rendered && this.cache.onTarget && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0) {
                        this.reposition(event);
                    }
                });
            }
        }
    
        // Adjust positions of the tooltip on window resize if enabled
        if(posOptions.adjust.resize || viewportTarget.length) {
            this._bind( $.event.special.resize ? viewportTarget : windowTarget, 'resize', repositionMethod );
        }
    
        // Adjust tooltip position on scroll of the window or viewport element if present
        if(posOptions.adjust.scroll) {
            this._bind( windowTarget.add(posOptions.container), 'scroll', repositionMethod );
        }
    };
    
    // Un-assignment method
    PROTOTYPE._unassignEvents = function() {
        var options = this.options,
            showTargets = options.show.target,
            hideTargets = options.hide.target,
            targets = $.grep([
                this.elements.target[0],
                this.rendered && this.tooltip[0],
                options.position.container[0],
                options.position.viewport[0],
                options.position.container.closest('html')[0], // unfocus
                window,
                document
            ], function(i) {
                return typeof i === 'object';
            });
    
        // Add show and hide targets if they're valid
        if(showTargets && showTargets.toArray) {
            targets = targets.concat(showTargets.toArray());
        }
        if(hideTargets && hideTargets.toArray) {
            targets = targets.concat(hideTargets.toArray());
        }
    
        // Unbind the events
        this._unbind(targets)
            ._unbind(targets, 'destroy')
            ._unbind(targets, 'inactive');
    };
    
    // Apply common event handlers using delegate (avoids excessive .bind calls!)
    $(function() {
        delegate(SELECTOR, ['mouseenter', 'mouseleave'], function(event) {
            var state = event.type === 'mouseenter',
                tooltip = $(event.currentTarget),
                target = $(event.relatedTarget || event.target),
                options = this.options;
    
            // On mouseenter...
            if(state) {
                // Focus the tooltip on mouseenter (z-index stacking)
                this.focus(event);
    
                // Clear hide timer on tooltip hover to prevent it from closing
                tooltip.hasClass(CLASS_FIXED) && !tooltip.hasClass(CLASS_DISABLED) && clearTimeout(this.timers.hide);
            }
    
            // On mouseleave...
            else {
                // When mouse tracking is enabled, hide when we leave the tooltip and not onto the show target (if a hide event is set)
                if(options.position.target === 'mouse' && options.position.adjust.mouse &&
                    options.hide.event && options.show.target && !target.closest(options.show.target[0]).length) {
                    this.hide(event);
                }
            }
    
            // Add hover class
            tooltip.toggleClass(CLASS_HOVER, state);
        });
    
        // Define events which reset the 'inactive' event handler
        delegate('['+ATTR_ID+']', INACTIVE_EVENTS, inactiveMethod);
    });
    ;// Initialization method
    function init(elem, id, opts) {
        var obj, posOptions, attr, config, title,
    
        // Setup element references
        docBody = $(document.body),
    
        // Use document body instead of document element if needed
        newTarget = elem[0] === document ? docBody : elem,
    
        // Grab metadata from element if plugin is present
        metadata = elem.metadata ? elem.metadata(opts.metadata) : NULL,
    
        // If metadata type if HTML5, grab 'name' from the object instead, or use the regular data object otherwise
        metadata5 = opts.metadata.type === 'html5' && metadata ? metadata[opts.metadata.name] : NULL,
    
        // Grab data from metadata.name (or data-qtipopts as fallback) using .data() method,
        html5 = elem.data(opts.metadata.name || 'qtipopts');
    
        // If we don't get an object returned attempt to parse it manualyl without parseJSON
        /* eslint-disable no-empty */
        try { html5 = typeof html5 === 'string' ? $.parseJSON(html5) : html5; }
        catch(e) {}
        /* eslint-enable no-empty */
    
        // Merge in and sanitize metadata
        config = $.extend(TRUE, {}, QTIP.defaults, opts,
            typeof html5 === 'object' ? sanitizeOptions(html5) : NULL,
            sanitizeOptions(metadata5 || metadata));
    
        // Re-grab our positioning options now we've merged our metadata and set id to passed value
        posOptions = config.position;
        config.id = id;
    
        // Setup missing content if none is detected
        if('boolean' === typeof config.content.text) {
            attr = elem.attr(config.content.attr);
    
            // Grab from supplied attribute if available
            if(config.content.attr !== FALSE && attr) { config.content.text = attr; }
    
            // No valid content was found, abort render
            else { return FALSE; }
        }
    
        // Setup target options
        if(!posOptions.container.length) { posOptions.container = docBody; }
        if(posOptions.target === FALSE) { posOptions.target = newTarget; }
        if(config.show.target === FALSE) { config.show.target = newTarget; }
        if(config.show.solo === TRUE) { config.show.solo = posOptions.container.closest('body'); }
        if(config.hide.target === FALSE) { config.hide.target = newTarget; }
        if(config.position.viewport === TRUE) { config.position.viewport = posOptions.container; }
    
        // Ensure we only use a single container
        posOptions.container = posOptions.container.eq(0);
    
        // Convert position corner values into x and y strings
        posOptions.at = new CORNER(posOptions.at, TRUE);
        posOptions.my = new CORNER(posOptions.my);
    
        // Destroy previous tooltip if overwrite is enabled, or skip element if not
        if(elem.data(NAMESPACE)) {
            if(config.overwrite) {
                elem.qtip('destroy', true);
            }
            else if(config.overwrite === FALSE) {
                return FALSE;
            }
        }
    
        // Add has-qtip attribute
        elem.attr(ATTR_HAS, id);
    
        // Remove title attribute and store it if present
        if(config.suppress && (title = elem.attr('title'))) {
            // Final attr call fixes event delegatiom and IE default tooltip showing problem
            elem.removeAttr('title').attr(oldtitle, title).attr('title', '');
        }
    
        // Initialize the tooltip and add API reference
        obj = new QTip(elem, config, id, !!attr);
        elem.data(NAMESPACE, obj);
    
        return obj;
    }
    
    // jQuery $.fn extension method
    QTIP = $.fn.qtip = function(options, notation, newValue)
    {
        var command = ('' + options).toLowerCase(), // Parse command
            returned = NULL,
            args = $.makeArray(arguments).slice(1),
            event = args[args.length - 1],
            opts = this[0] ? $.data(this[0], NAMESPACE) : NULL;
    
        // Check for API request
        if(!arguments.length && opts || command === 'api') {
            return opts;
        }
    
        // Execute API command if present
        else if('string' === typeof options) {
            this.each(function() {
                var api = $.data(this, NAMESPACE);
                if(!api) { return TRUE; }
    
                // Cache the event if possible
                if(event && event.timeStamp) { api.cache.event = event; }
    
                // Check for specific API commands
                if(notation && (command === 'option' || command === 'options')) {
                    if(newValue !== undefined || $.isPlainObject(notation)) {
                        api.set(notation, newValue);
                    }
                    else {
                        returned = api.get(notation);
                        return FALSE;
                    }
                }
    
                // Execute API command
                else if(api[command]) {
                    api[command].apply(api, args);
                }
            });
    
            return returned !== NULL ? returned : this;
        }
    
        // No API commands. validate provided options and setup qTips
        else if('object' === typeof options || !arguments.length) {
            // Sanitize options first
            opts = sanitizeOptions($.extend(TRUE, {}, options));
    
            return this.each(function(i) {
                var api, id;
    
                // Find next available ID, or use custom ID if provided
                id = $.isArray(opts.id) ? opts.id[i] : opts.id;
                id = !id || id === FALSE || id.length < 1 || QTIP.api[id] ? QTIP.nextid++ : id;
    
                // Initialize the qTip and re-grab newly sanitized options
                api = init($(this), id, opts);
                if(api === FALSE) { return TRUE; }
                else { QTIP.api[id] = api; }
    
                // Initialize plugins
                $.each(PLUGINS, function() {
                    if(this.initialize === 'initialize') { this(api); }
                });
    
                // Assign initial pre-render events
                api._assignInitialEvents(event);
            });
        }
    };
    
    // Expose class
    $.qtip = QTip;
    
    // Populated in render method
    QTIP.api = {};
    ;$.each({
        /* Allow other plugins to successfully retrieve the title of an element with a qTip applied */
        attr: function(attr, val) {
            if(this.length) {
                var self = this[0],
                    title = 'title',
                    api = $.data(self, 'qtip');
    
                if(attr === title && api && api.options && 'object' === typeof api && 'object' === typeof api.options && api.options.suppress) {
                    if(arguments.length < 2) {
                        return $.attr(self, oldtitle);
                    }
    
                    // If qTip is rendered and title was originally used as content, update it
                    if(api && api.options.content.attr === title && api.cache.attr) {
                        api.set('content.text', val);
                    }
    
                    // Use the regular attr method to set, then cache the result
                    return this.attr(oldtitle, val);
                }
            }
    
            return $.fn['attr'+replaceSuffix].apply(this, arguments);
        },
    
        /* Allow clone to correctly retrieve cached title attributes */
        clone: function(keepData) {
            // Clone our element using the real clone method
            var elems = $.fn['clone'+replaceSuffix].apply(this, arguments);
    
            // Grab all elements with an oldtitle set, and change it to regular title attribute, if keepData is false
            if(!keepData) {
                elems.filter('['+oldtitle+']').attr('title', function() {
                    return $.attr(this, oldtitle);
                })
                .removeAttr(oldtitle);
            }
    
            return elems;
        }
    }, function(name, func) {
        if(!func || $.fn[name+replaceSuffix]) { return TRUE; }
    
        var old = $.fn[name+replaceSuffix] = $.fn[name];
        $.fn[name] = function() {
            return func.apply(this, arguments) || old.apply(this, arguments);
        };
    });
    
    /* Fire off 'removeqtip' handler in $.cleanData if jQuery UI not present (it already does similar).
     * This snippet is taken directly from jQuery UI source code found here:
     *     http://code.jquery.com/ui/jquery-ui-git.js
     */
    if(!$.ui) {
        $['cleanData'+replaceSuffix] = $.cleanData;
        $.cleanData = function( elems ) {
            for(var i = 0, elem; (elem = $( elems[i] )).length; i++) {
                if(elem.attr(ATTR_HAS)) {
                    /* eslint-disable no-empty */
                    try { elem.triggerHandler('removeqtip'); }
                    catch( e ) {}
                    /* eslint-enable no-empty */
                }
            }
            $['cleanData'+replaceSuffix].apply(this, arguments);
        };
    }
    ;// qTip version
    QTIP.version = '3.0.3';
    
    // Base ID for all qTips
    QTIP.nextid = 0;
    
    // Inactive events array
    QTIP.inactiveEvents = INACTIVE_EVENTS;
    
    // Base z-index for all qTips
    QTIP.zindex = 15000;
    
    // Define configuration defaults
    QTIP.defaults = {
        prerender: FALSE,
        id: FALSE,
        overwrite: TRUE,
        suppress: TRUE,
        content: {
            text: TRUE,
            attr: 'title',
            title: FALSE,
            button: FALSE
        },
        position: {
            my: 'top left',
            at: 'bottom right',
            target: FALSE,
            container: FALSE,
            viewport: FALSE,
            adjust: {
                x: 0, y: 0,
                mouse: TRUE,
                scroll: TRUE,
                resize: TRUE,
                method: 'flipinvert flipinvert'
            },
            effect: function(api, pos) {
                $(this).animate(pos, {
                    duration: 200,
                    queue: FALSE
                });
            }
        },
        show: {
            target: FALSE,
            event: 'mouseenter',
            effect: TRUE,
            delay: 90,
            solo: FALSE,
            ready: FALSE,
            autofocus: FALSE
        },
        hide: {
            target: FALSE,
            event: 'mouseleave',
            effect: TRUE,
            delay: 0,
            fixed: FALSE,
            inactive: FALSE,
            leave: 'window',
            distance: FALSE
        },
        style: {
            classes: '',
            widget: FALSE,
            width: FALSE,
            height: FALSE,
            def: TRUE
        },
        events: {
            render: NULL,
            move: NULL,
            show: NULL,
            hide: NULL,
            toggle: NULL,
            visible: NULL,
            hidden: NULL,
            focus: NULL,
            blur: NULL
        }
    };
    ;var TIP,
    createVML,
    SCALE,
    PIXEL_RATIO,
    BACKING_STORE_RATIO,
    
    // Common CSS strings
    MARGIN = 'margin',
    BORDER = 'border',
    COLOR = 'color',
    BG_COLOR = 'background-color',
    TRANSPARENT = 'transparent',
    IMPORTANT = ' !important',
    
    // Check if the browser supports <canvas/> elements
    HASCANVAS = !!document.createElement('canvas').getContext,
    
    // Invalid colour values used in parseColours()
    INVALID = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i;
    
    // Camel-case method, taken from jQuery source
    // http://code.jquery.com/jquery-1.8.0.js
    function camel(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
    
    /*
     * Modified from Modernizr's testPropsAll()
     * http://modernizr.com/downloads/modernizr-latest.js
     */
    var cssProps = {}, cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'];
    function vendorCss(elem, prop) {
        var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
            props = (prop + ' ' + cssPrefixes.join(ucProp + ' ') + ucProp).split(' '),
            cur, val, i = 0;
    
        // If the property has already been mapped...
        if(cssProps[prop]) { return elem.css(cssProps[prop]); }
    
        while(cur = props[i++]) {
            if((val = elem.css(cur)) !== undefined) {
                cssProps[prop] = cur;
                return val;
            }
        }
    }
    
    // Parse a given elements CSS property into an int
    function intCss(elem, prop) {
        return Math.ceil(parseFloat(vendorCss(elem, prop)));
    }
    
    
    // VML creation (for IE only)
    if(!HASCANVAS) {
        createVML = function(tag, props, style) {
            return '<qtipvml:'+tag+' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" '+(props||'')+
                ' style="behavior: url(#default#VML); '+(style||'')+ '" />';
        };
    }
    
    // Canvas only definitions
    else {
        PIXEL_RATIO = window.devicePixelRatio || 1;
        BACKING_STORE_RATIO = (function() {
            var context = document.createElement('canvas').getContext('2d');
            return context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio ||
                    context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || 1;
        })();
        SCALE = PIXEL_RATIO / BACKING_STORE_RATIO;
    }
    
    
    function Tip(qtip, options) {
        this._ns = 'tip';
        this.options = options;
        this.offset = options.offset;
        this.size = [ options.width, options.height ];
    
        // Initialize
        this.qtip = qtip;
        this.init(qtip);
    }
    
    $.extend(Tip.prototype, {
        init: function(qtip) {
            var context, tip;
    
            // Create tip element and prepend to the tooltip
            tip = this.element = qtip.elements.tip = $('<div />', { 'class': NAMESPACE+'-tip' }).prependTo(qtip.tooltip);
    
            // Create tip drawing element(s)
            if(HASCANVAS) {
                // save() as soon as we create the canvas element so FF2 doesn't bork on our first restore()!
                context = $('<canvas />').appendTo(this.element)[0].getContext('2d');
    
                // Setup constant parameters
                context.lineJoin = 'miter';
                context.miterLimit = 100000;
                context.save();
            }
            else {
                context = createVML('shape', 'coordorigin="0,0"', 'position:absolute;');
                this.element.html(context + context);
    
                // Prevent mousing down on the tip since it causes problems with .live() handling in IE due to VML
                qtip._bind( $('*', tip).add(tip), ['click', 'mousedown'], function(event) { event.stopPropagation(); }, this._ns);
            }
    
            // Bind update events
            qtip._bind(qtip.tooltip, 'tooltipmove', this.reposition, this._ns, this);
    
            // Create it
            this.create();
        },
    
        _swapDimensions: function() {
            this.size[0] = this.options.height;
            this.size[1] = this.options.width;
        },
        _resetDimensions: function() {
            this.size[0] = this.options.width;
            this.size[1] = this.options.height;
        },
    
        _useTitle: function(corner) {
            var titlebar = this.qtip.elements.titlebar;
            return titlebar && (
                corner.y === TOP || corner.y === CENTER && this.element.position().top + this.size[1] / 2 + this.options.offset < titlebar.outerHeight(TRUE)
            );
        },
    
        _parseCorner: function(corner) {
            var my = this.qtip.options.position.my;
    
            // Detect corner and mimic properties
            if(corner === FALSE || my === FALSE) {
                corner = FALSE;
            }
            else if(corner === TRUE) {
                corner = new CORNER( my.string() );
            }
            else if(!corner.string) {
                corner = new CORNER(corner);
                corner.fixed = TRUE;
            }
    
            return corner;
        },
    
        _parseWidth: function(corner, side, use) {
            var elements = this.qtip.elements,
                prop = BORDER + camel(side) + 'Width';
    
            return (use ? intCss(use, prop) : 
                intCss(elements.content, prop) ||
                intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
                intCss(elements.tooltip, prop)
            ) || 0;
        },
    
        _parseRadius: function(corner) {
            var elements = this.qtip.elements,
                prop = BORDER + camel(corner.y) + camel(corner.x) + 'Radius';
    
            return BROWSER.ie < 9 ? 0 :
                intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
                intCss(elements.tooltip, prop) || 0;
        },
    
        _invalidColour: function(elem, prop, compare) {
            var val = elem.css(prop);
            return !val || compare && val === elem.css(compare) || INVALID.test(val) ? FALSE : val;
        },
    
        _parseColours: function(corner) {
            var elements = this.qtip.elements,
                tip = this.element.css('cssText', ''),
                borderSide = BORDER + camel(corner[ corner.precedance ]) + camel(COLOR),
                colorElem = this._useTitle(corner) && elements.titlebar || elements.content,
                css = this._invalidColour, color = [];
    
            // Attempt to detect the background colour from various elements, left-to-right precedance
            color[0] = css(tip, BG_COLOR) || css(colorElem, BG_COLOR) || css(elements.content, BG_COLOR) ||
                css(elements.tooltip, BG_COLOR) || tip.css(BG_COLOR);
    
            // Attempt to detect the correct border side colour from various elements, left-to-right precedance
            color[1] = css(tip, borderSide, COLOR) || css(colorElem, borderSide, COLOR) ||
                css(elements.content, borderSide, COLOR) || css(elements.tooltip, borderSide, COLOR) || elements.tooltip.css(borderSide);
    
            // Reset background and border colours
            $('*', tip).add(tip).css('cssText', BG_COLOR+':'+TRANSPARENT+IMPORTANT+';'+BORDER+':0'+IMPORTANT+';');
    
            return color;
        },
    
        _calculateSize: function(corner) {
            var y = corner.precedance === Y,
                width = this.options.width,
                height = this.options.height,
                isCenter = corner.abbrev() === 'c',
                base = (y ? width: height) * (isCenter ? 0.5 : 1),
                pow = Math.pow,
                round = Math.round,
                bigHyp, ratio, result,
    
            smallHyp = Math.sqrt( pow(base, 2) + pow(height, 2) ),
            hyp = [
                this.border / base * smallHyp,
                this.border / height * smallHyp
            ];
    
            hyp[2] = Math.sqrt( pow(hyp[0], 2) - pow(this.border, 2) );
            hyp[3] = Math.sqrt( pow(hyp[1], 2) - pow(this.border, 2) );
    
            bigHyp = smallHyp + hyp[2] + hyp[3] + (isCenter ? 0 : hyp[0]);
            ratio = bigHyp / smallHyp;
    
            result = [ round(ratio * width), round(ratio * height) ];
            return y ? result : result.reverse();
        },
    
        // Tip coordinates calculator
        _calculateTip: function(corner, size, scale) {
            scale = scale || 1;
            size = size || this.size;
    
            var width = size[0] * scale,
                height = size[1] * scale,
                width2 = Math.ceil(width / 2), height2 = Math.ceil(height / 2),
    
            // Define tip coordinates in terms of height and width values
            tips = {
                br:	[0,0,		width,height,	width,0],
                bl:	[0,0,		width,0,		0,height],
                tr:	[0,height,	width,0,		width,height],
                tl:	[0,0,		0,height,		width,height],
                tc:	[0,height,	width2,0,		width,height],
                bc:	[0,0,		width,0,		width2,height],
                rc:	[0,0,		width,height2,	0,height],
                lc:	[width,0,	width,height,	0,height2]
            };
    
            // Set common side shapes
            tips.lt = tips.br; tips.rt = tips.bl;
            tips.lb = tips.tr; tips.rb = tips.tl;
    
            return tips[ corner.abbrev() ];
        },
    
        // Tip coordinates drawer (canvas)
        _drawCoords: function(context, coords) {
            context.beginPath();
            context.moveTo(coords[0], coords[1]);
            context.lineTo(coords[2], coords[3]);
            context.lineTo(coords[4], coords[5]);
            context.closePath();
        },
    
        create: function() {
            // Determine tip corner
            var c = this.corner = (HASCANVAS || BROWSER.ie) && this._parseCorner(this.options.corner);
    
            // If we have a tip corner...
            this.enabled = !!this.corner && this.corner.abbrev() !== 'c';
            if(this.enabled) {
                // Cache it
                this.qtip.cache.corner = c.clone();
    
                // Create it
                this.update();
            }
    
            // Toggle tip element
            this.element.toggle(this.enabled);
    
            return this.corner;
        },
    
        update: function(corner, position) {
            if(!this.enabled) { return this; }
    
            var elements = this.qtip.elements,
                tip = this.element,
                inner = tip.children(),
                options = this.options,
                curSize = this.size,
                mimic = options.mimic,
                round = Math.round,
                color, precedance, context,
                coords, bigCoords, translate, newSize, border;
    
            // Re-determine tip if not already set
            if(!corner) { corner = this.qtip.cache.corner || this.corner; }
    
            // Use corner property if we detect an invalid mimic value
            if(mimic === FALSE) { mimic = corner; }
    
            // Otherwise inherit mimic properties from the corner object as necessary
            else {
                mimic = new CORNER(mimic);
                mimic.precedance = corner.precedance;
    
                if(mimic.x === 'inherit') { mimic.x = corner.x; }
                else if(mimic.y === 'inherit') { mimic.y = corner.y; }
                else if(mimic.x === mimic.y) {
                    mimic[ corner.precedance ] = corner[ corner.precedance ];
                }
            }
            precedance = mimic.precedance;
    
            // Ensure the tip width.height are relative to the tip position
            if(corner.precedance === X) { this._swapDimensions(); }
            else { this._resetDimensions(); }
    
            // Update our colours
            color = this.color = this._parseColours(corner);
    
            // Detect border width, taking into account colours
            if(color[1] !== TRANSPARENT) {
                // Grab border width
                border = this.border = this._parseWidth(corner, corner[corner.precedance]);
    
                // If border width isn't zero, use border color as fill if it's not invalid (1.0 style tips)
                if(options.border && border < 1 && !INVALID.test(color[1])) { color[0] = color[1]; }

                // Set border width (use detected border width if options.border is true)
                this.border = border = options.border !== TRUE ? options.border : border;
            }
    
            // Border colour was invalid, set border to zero
            else { this.border = border = 0; }
    
            // Determine tip size
            newSize = this.size = this._calculateSize(corner);
            tip.css({
                width: newSize[0],
                height: newSize[1],
                lineHeight: newSize[1]+'px'
            });
    
            // Calculate tip translation
            if(corner.precedance === Y) {
                translate = [
                    round(mimic.x === LEFT ? border : mimic.x === RIGHT ? newSize[0] - curSize[0] - border : (newSize[0] - curSize[0]) / 2),
                    round(mimic.y === TOP ? newSize[1] - curSize[1] : 0)
                ];
            }
            else {
                translate = [
                    round(mimic.x === LEFT ? newSize[0] - curSize[0] : 0),
                    round(mimic.y === TOP ? border : mimic.y === BOTTOM ? newSize[1] - curSize[1] - border : (newSize[1] - curSize[1]) / 2)
                ];
            }
    
            // Canvas drawing implementation
            if(HASCANVAS) {
                // Grab canvas context and clear/save it
                context = inner[0].getContext('2d');
                context.restore(); context.save();
                context.clearRect(0,0,6000,6000);
    
                // Calculate coordinates
                coords = this._calculateTip(mimic, curSize, SCALE);
                bigCoords = this._calculateTip(mimic, this.size, SCALE);
                // Set the canvas size using calculated size
                inner.attr(WIDTH, newSize[0] * SCALE).attr(HEIGHT, newSize[1] * SCALE);
                inner.css(WIDTH, newSize[0]).css(HEIGHT, newSize[1]);
    
                // Draw the outer-stroke tip
                this._drawCoords(context, bigCoords);
                context.fillStyle = color[1];
                context.fill();
                
                // Draw the actual tip
                context.translate(translate[0] * SCALE, translate[1] * SCALE);
                var newCoords = [
                    coords[0],
                    coords[1],
                    coords[2],
                    coords[3],
                    coords[4],
                    coords[5]
                ];
                if(this.corner.x == "right" && this.corner.y == "top" && this.corner.precedance == "x"){
                    newCoords = [
                        coords[0],
                        coords[1],
                        coords[2]-this.border,
                        coords[3],
                        coords[4],
                        coords[5]-this.border
                    ];
                }

                if(this.corner.x == "left" && this.corner.y == "top" && this.corner.precedance == "x"){
                    console.log(coords);
                    newCoords = [
                        coords[0],
                        coords[1],
                        coords[2],
                        coords[3]-this.border,
                        coords[4],
                        coords[5]
                    ];
                }
                if(this.corner.x == "left" && this.corner.y == "bottom" && this.corner.precedance == "x"){
                    console.log(coords);
                    newCoords = [
                        coords[0]+this.border,
                        coords[1],
                        coords[2],
                        coords[3]+this.border,
                        coords[4],
                        coords[5]
                    ];
                }
                /*
                if(this.corner.x == "right" && this.corner.y == "bottom"){
                    var newCoords = [
                        coords[0],
                        coords[1],
                        coords[2],
                        coords[3],
                        coords[4],
                        coords[5]+4
                    ];
                }
                */
                this._drawCoords(context, newCoords);
                context.fillStyle = color[0];
                context.fill();
            }
    
            // VML (IE Proprietary implementation)
            else {
                // Calculate coordinates
                coords = this._calculateTip(mimic);
    
                // Setup coordinates string
                coords = 'm' + coords[0] + ',' + coords[1] + ' l' + coords[2] +
                    ',' + coords[3] + ' ' + coords[4] + ',' + coords[5] + ' xe';
    
                // Setup VML-specific offset for pixel-perfection
                translate[2] = border && /^(r|b)/i.test(corner.string()) ?
                    BROWSER.ie === 8 ? 2 : 1 : 0;
    
                // Set initial CSS
                inner.css({
                    coordsize: newSize[0]+border + ' ' + newSize[1]+border,
                    antialias: ''+(mimic.string().indexOf(CENTER) > -1),
                    left: translate[0] - translate[2] * Number(precedance === X),
                    top: translate[1] - translate[2] * Number(precedance === Y),
                    width: newSize[0] + border,
                    height: newSize[1] + border
                })
                .each(function(i) {
                    var $this = $(this);
    
                    // Set shape specific attributes
                    $this[ $this.prop ? 'prop' : 'attr' ]({
                        coordsize: newSize[0]+border + ' ' + newSize[1]+border,
                        path: coords,
                        fillcolor: color[0],
                        filled: !!i,
                        stroked: !i
                    })
                    .toggle(!!(border || i));
    
                    // Check if border is enabled and add stroke element
                    !i && $this.html( createVML(
                        'stroke', 'weight="'+border*2+'px" color="'+color[1]+'" miterlimit="1000" joinstyle="miter"'
                    ) );
                });
            }
    
            // Opera bug #357 - Incorrect tip position
            // https://github.com/Craga89/qTip2/issues/367
            window.opera && setTimeout(function() {
                elements.tip.css({
                    display: 'inline-block',
                    visibility: 'visible'
                });
            }, 1);
    
            // Position if needed
            if(position !== FALSE) { this.calculate(corner, newSize); }
        },
    
        calculate: function(corner, size) {
            if(!this.enabled) { return FALSE; }
    
            var self = this,
                elements = this.qtip.elements,
                tip = this.element,
                userOffset = this.options.offset,
                position = {},
                precedance, corners;
    
            // Inherit corner if not provided
            corner = corner || this.corner;
            precedance = corner.precedance;
    
            // Determine which tip dimension to use for adjustment
            size = size || this._calculateSize(corner);
    
            // Setup corners and offset array
            corners = [ corner.x, corner.y ];
            if(precedance === X) { corners.reverse(); }
    
            // Calculate tip position
            $.each(corners, function(i, side) {
                var b, bc, br;
    
                if(side === CENTER) {
                    b = precedance === Y ? LEFT : TOP;
                    position[ b ] = '50%';
                    position[MARGIN+'-' + b] = -Math.round(size[ precedance === Y ? 0 : 1 ] / 2) + userOffset;
                }
                else {
                    b = self._parseWidth(corner, side, elements.tooltip);
                    bc = self._parseWidth(corner, side, elements.content);
                    br = self._parseRadius(corner);
    
                    position[ side ] = Math.max(-self.border, i ? bc : userOffset + (br > b ? br : -b));
                }
            });
    
            // Adjust for tip size
            position[ corner[precedance] ] -= size[ precedance === X ? 0 : 1 ];
    
            // Set and return new position
            tip.css({ margin: '', top: '', bottom: '', left: '', right: '' }).css(position);
            return position;
        },
    
        reposition: function(event, api, pos) {
            if(!this.enabled) { return; }
    
            var cache = api.cache,
                newCorner = this.corner.clone(),
                adjust = pos.adjusted,
                method = api.options.position.adjust.method.split(' '),
                horizontal = method[0],
                vertical = method[1] || method[0],
                shift = { left: FALSE, top: FALSE, x: 0, y: 0 },
                offset, css = {}, props;
    
            function shiftflip(direction, precedance, popposite, side, opposite) {
                // Horizontal - Shift or flip method
                if(direction === SHIFT && newCorner.precedance === precedance && adjust[side] && newCorner[popposite] !== CENTER) {
                    newCorner.precedance = newCorner.precedance === X ? Y : X;
                }
                else if(direction !== SHIFT && adjust[side]){
                    newCorner[precedance] = newCorner[precedance] === CENTER ?
                        adjust[side] > 0 ? side : opposite :
                        newCorner[precedance] === side ? opposite : side;
                }
            }
    
            function shiftonly(xy, side, opposite) {
                if(newCorner[xy] === CENTER) {
                    css[MARGIN+'-'+side] = shift[xy] = offset[MARGIN+'-'+side] - adjust[side];
                }
                else {
                    props = offset[opposite] !== undefined ?
                        [ adjust[side], -offset[side] ] : [ -adjust[side], offset[side] ];
    
                    if( (shift[xy] = Math.max(props[0], props[1])) > props[0] ) {
                        pos[side] -= adjust[side];
                        shift[side] = FALSE;
                    }
    
                    css[ offset[opposite] !== undefined ? opposite : side ] = shift[xy];
                }
            }
    
            // If our tip position isn't fixed e.g. doesn't adjust with viewport...
            if(this.corner.fixed !== TRUE) {
                // Perform shift/flip adjustments
                shiftflip(horizontal, X, Y, LEFT, RIGHT);
                shiftflip(vertical, Y, X, TOP, BOTTOM);
    
                // Update and redraw the tip if needed (check cached details of last drawn tip)
                if(newCorner.string() !== cache.corner.string() || cache.cornerTop !== adjust.top || cache.cornerLeft !== adjust.left) {
                    this.update(newCorner, FALSE);
                }
            }
    
            // Setup tip offset properties
            offset = this.calculate(newCorner);
    
            // Readjust offset object to make it left/top
            if(offset.right !== undefined) { offset.left = -offset.right; }
            if(offset.bottom !== undefined) { offset.top = -offset.bottom; }
            offset.user = this.offset;
    
            // Perform shift adjustments
            shift.left = horizontal === SHIFT && !!adjust.left;
            if(shift.left) {
                shiftonly(X, LEFT, RIGHT);
            }
            shift.top = vertical === SHIFT && !!adjust.top;
            if(shift.top) {
                shiftonly(Y, TOP, BOTTOM);
            }
    
            /*
            * If the tip is adjusted in both dimensions, or in a
            * direction that would cause it to be anywhere but the
            * outer border, hide it!
            */
            this.element.css(css).toggle(
                !(shift.x && shift.y || newCorner.x === CENTER && shift.y || newCorner.y === CENTER && shift.x)
            );
    
            // Adjust position to accomodate tip dimensions
            pos.left -= offset.left.charAt ? offset.user :
                horizontal !== SHIFT || shift.top || !shift.left && !shift.top ? offset.left + this.border : 0;
            pos.top -= offset.top.charAt ? offset.user :
                vertical !== SHIFT || shift.left || !shift.left && !shift.top ? offset.top + this.border : 0;
    
            // Cache details
            cache.cornerLeft = adjust.left; cache.cornerTop = adjust.top;
            cache.corner = newCorner.clone();
        },
    
        destroy: function() {
            // Unbind events
            this.qtip._unbind(this.qtip.tooltip, this._ns);
    
            // Remove the tip element(s)
            if(this.qtip.elements.tip) {
                this.qtip.elements.tip.find('*')
                    .remove().end().remove();
            }
        }
    });
    
    TIP = PLUGINS.tip = function(api) {
        return new Tip(api, api.options.style.tip);
    };
    
    // Initialize tip on render
    TIP.initialize = 'render';
    
    // Setup plugin sanitization options
    TIP.sanitize = function(options) {
        if(options.style && 'tip' in options.style) {
            var opts = options.style.tip;
            if(typeof opts !== 'object') { opts = options.style.tip = { corner: opts }; }
            if(!(/string|boolean/i).test(typeof opts.corner)) { opts.corner = TRUE; }
        }
    };
    
    // Add new option checks for the plugin
    CHECKS.tip = {
        '^position.my|style.tip.(corner|mimic|border)$': function() {
            // Make sure a tip can be drawn
            this.create();
    
            // Reposition the tooltip
            this.qtip.reposition();
        },
        '^style.tip.(height|width)$': function(obj) {
            // Re-set dimensions and redraw the tip
            this.size = [ obj.width, obj.height ];
            this.update();
    
            // Reposition the tooltip
            this.qtip.reposition();
        },
        '^content.title|style.(classes|widget)$': function() {
            this.update();
        }
    };
    
    // Extend original qTip defaults
    $.extend(TRUE, QTIP.defaults, {
        style: {
            tip: {
                corner: TRUE,
                mimic: FALSE,
                width: 6,
                height: 6,
                border: TRUE,
                offset: 0
            }
        }
    });
    ;var MODAL, OVERLAY,
        MODALCLASS = 'qtip-modal',
        MODALSELECTOR = '.'+MODALCLASS;
    
    OVERLAY = function()
    {
        var self = this,
            focusableElems = {},
            current,
            prevState,
            elem;
    
        // Modified code from jQuery UI 1.10.0 source
        // http://code.jquery.com/ui/1.10.0/jquery-ui.js
        function focusable(element) {
            // Use the defined focusable checker when possible
            if($.expr[':'].focusable) { return $.expr[':'].focusable; }
    
            var isTabIndexNotNaN = !isNaN($.attr(element, 'tabindex')),
                nodeName = element.nodeName && element.nodeName.toLowerCase(),
                map, mapName, img;
    
            if('area' === nodeName) {
                map = element.parentNode;
                mapName = map.name;
                if(!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
                    return false;
                }
                img = $('img[usemap=#' + mapName + ']')[0];
                return !!img && img.is(':visible');
            }
    
            return /input|select|textarea|button|object/.test( nodeName ) ?
                !element.disabled :
                'a' === nodeName ?
                    element.href || isTabIndexNotNaN :
                    isTabIndexNotNaN
            ;
        }
    
        // Focus inputs using cached focusable elements (see update())
        function focusInputs(blurElems) {
            // Blurring body element in IE causes window.open windows to unfocus!
            if(focusableElems.length < 1 && blurElems.length) { blurElems.not('body').blur(); }
    
            // Focus the inputs
            else { focusableElems.first().focus(); }
        }
    
        // Steal focus from elements outside tooltip
        function stealFocus(event) {
            if(!elem.is(':visible')) { return; }
    
            var target = $(event.target),
                tooltip = current.tooltip,
                container = target.closest(SELECTOR),
                targetOnTop;
    
            // Determine if input container target is above this
            targetOnTop = container.length < 1 ? FALSE :
                parseInt(container[0].style.zIndex, 10) > parseInt(tooltip[0].style.zIndex, 10);
    
            // If we're showing a modal, but focus has landed on an input below
            // this modal, divert focus to the first visible input in this modal
            // or if we can't find one... the tooltip itself
            if(!targetOnTop && target.closest(SELECTOR)[0] !== tooltip[0]) {
                focusInputs(target);
            }
        }
    
        $.extend(self, {
            init: function() {
                // Create document overlay
                elem = self.elem = $('<div />', {
                    id: 'qtip-overlay',
                    html: '<div></div>',
                    mousedown: function() { return FALSE; }
                })
                .hide();
    
                // Make sure we can't focus anything outside the tooltip
                $(document.body).bind('focusin'+MODALSELECTOR, stealFocus);
    
                // Apply keyboard "Escape key" close handler
                $(document).bind('keydown'+MODALSELECTOR, function(event) {
                    if(current && current.options.show.modal.escape && event.keyCode === 27) {
                        current.hide(event);
                    }
                });
    
                // Apply click handler for blur option
                elem.bind('click'+MODALSELECTOR, function(event) {
                    if(current && current.options.show.modal.blur) {
                        current.hide(event);
                    }
                });
    
                return self;
            },
    
            update: function(api) {
                // Update current API reference
                current = api;
    
                // Update focusable elements if enabled
                if(api.options.show.modal.stealfocus !== FALSE) {
                    focusableElems = api.tooltip.find('*').filter(function() {
                        return focusable(this);
                    });
                }
                else { focusableElems = []; }
            },
    
            toggle: function(api, state, duration) {
                var tooltip = api.tooltip,
                    options = api.options.show.modal,
                    effect = options.effect,
                    type = state ? 'show': 'hide',
                    visible = elem.is(':visible'),
                    visibleModals = $(MODALSELECTOR).filter(':visible:not(:animated)').not(tooltip);
    
                // Set active tooltip API reference
                self.update(api);
    
                // If the modal can steal the focus...
                // Blur the current item and focus anything in the modal we an
                if(state && options.stealfocus !== FALSE) {
                    focusInputs( $(':focus') );
                }
    
                // Toggle backdrop cursor style on show
                elem.toggleClass('blurs', options.blur);
    
                // Append to body on show
                if(state) {
                    elem.appendTo(document.body);
                }
    
                // Prevent modal from conflicting with show.solo, and don't hide backdrop is other modals are visible
                if(elem.is(':animated') && visible === state && prevState !== FALSE || !state && visibleModals.length) {
                    return self;
                }
    
                // Stop all animations
                elem.stop(TRUE, FALSE);
    
                // Use custom function if provided
                if($.isFunction(effect)) {
                    effect.call(elem, state);
                }
    
                // If no effect type is supplied, use a simple toggle
                else if(effect === FALSE) {
                    elem[ type ]();
                }
    
                // Use basic fade function
                else {
                    elem.fadeTo( parseInt(duration, 10) || 90, state ? 1 : 0, function() {
                        if(!state) { elem.hide(); }
                    });
                }
    
                // Reset position and detach from body on hide
                if(!state) {
                    elem.queue(function(next) {
                        elem.css({ left: '', top: '' });
                        if(!$(MODALSELECTOR).length) { elem.detach(); }
                        next();
                    });
                }
    
                // Cache the state
                prevState = state;
    
                // If the tooltip is destroyed, set reference to null
                if(current.destroyed) { current = NULL; }
    
                return self;
            }
        });
    
        self.init();
    };
    OVERLAY = new OVERLAY();
    
    function Modal(api, options) {
        this.options = options;
        this._ns = '-modal';
    
        this.qtip = api;
        this.init(api);
    }
    
    $.extend(Modal.prototype, {
        init: function(qtip) {
            var tooltip = qtip.tooltip;
    
            // If modal is disabled... return
            if(!this.options.on) { return this; }
    
            // Set overlay reference
            qtip.elements.overlay = OVERLAY.elem;
    
            // Add unique attribute so we can grab modal tooltips easily via a SELECTOR, and set z-index
            tooltip.addClass(MODALCLASS).css('z-index', QTIP.modal_zindex + $(MODALSELECTOR).length);
    
            // Apply our show/hide/focus modal events
            qtip._bind(tooltip, ['tooltipshow', 'tooltiphide'], function(event, api, duration) {
                var oEvent = event.originalEvent;
    
                // Make sure mouseout doesn't trigger a hide when showing the modal and mousing onto backdrop
                if(event.target === tooltip[0]) {
                    if(oEvent && event.type === 'tooltiphide' && /mouse(leave|enter)/.test(oEvent.type) && $(oEvent.relatedTarget).closest(OVERLAY.elem[0]).length) {
                        /* eslint-disable no-empty */
                        try { event.preventDefault(); }
                        catch(e) {}
                        /* eslint-enable no-empty */
                    }
                    else if(!oEvent || oEvent && oEvent.type !== 'tooltipsolo') {
                        this.toggle(event, event.type === 'tooltipshow', duration);
                    }
                }
            }, this._ns, this);
    
            // Adjust modal z-index on tooltip focus
            qtip._bind(tooltip, 'tooltipfocus', function(event, api) {
                // If focus was cancelled before it reached us, don't do anything
                if(event.isDefaultPrevented() || event.target !== tooltip[0]) { return; }
    
                var qtips = $(MODALSELECTOR),
    
                // Keep the modal's lower than other, regular qtips
                newIndex = QTIP.modal_zindex + qtips.length,
                curIndex = parseInt(tooltip[0].style.zIndex, 10);
    
                // Set overlay z-index
                OVERLAY.elem[0].style.zIndex = newIndex - 1;
    
                // Reduce modal z-index's and keep them properly ordered
                qtips.each(function() {
                    if(this.style.zIndex > curIndex) {
                        this.style.zIndex -= 1;
                    }
                });
    
                // Fire blur event for focused tooltip
                qtips.filter('.' + CLASS_FOCUS).qtip('blur', event.originalEvent);
    
                // Set the new z-index
                tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;
    
                // Set current
                OVERLAY.update(api);
    
                // Prevent default handling
                /* eslint-disable no-empty */
                try { event.preventDefault(); }
                catch(e) {}
                /* eslint-enable no-empty */
            }, this._ns, this);
    
            // Focus any other visible modals when this one hides
            qtip._bind(tooltip, 'tooltiphide', function(event) {
                if(event.target === tooltip[0]) {
                    $(MODALSELECTOR).filter(':visible').not(tooltip).last().qtip('focus', event);
                }
            }, this._ns, this);
        },
    
        toggle: function(event, state, duration) {
            // Make sure default event hasn't been prevented
            if(event && event.isDefaultPrevented()) { return this; }
    
            // Toggle it
            OVERLAY.toggle(this.qtip, !!state, duration);
        },
    
        destroy: function() {
            // Remove modal class
            this.qtip.tooltip.removeClass(MODALCLASS);
    
            // Remove bound events
            this.qtip._unbind(this.qtip.tooltip, this._ns);
    
            // Delete element reference
            OVERLAY.toggle(this.qtip, FALSE);
            delete this.qtip.elements.overlay;
        }
    });
    
    
    MODAL = PLUGINS.modal = function(api) {
        return new Modal(api, api.options.show.modal);
    };
    
    // Setup sanitiztion rules
    MODAL.sanitize = function(opts) {
        if(opts.show) {
            if(typeof opts.show.modal !== 'object') { opts.show.modal = { on: !!opts.show.modal }; }
            else if(typeof opts.show.modal.on === 'undefined') { opts.show.modal.on = TRUE; }
        }
    };
    
    // Base z-index for all modal tooltips (use qTip core z-index as a base)
    /* eslint-disable camelcase */
    QTIP.modal_zindex = QTIP.zindex - 200;
    /* eslint-enable camelcase */
    
    // Plugin needs to be initialized on render
    MODAL.initialize = 'render';
    
    // Setup option set checks
    CHECKS.modal = {
        '^show.modal.(on|blur)$': function() {
            // Initialise
            this.destroy();
            this.init();
    
            // Show the modal if not visible already and tooltip is visible
            this.qtip.elems.overlay.toggle(
                this.qtip.tooltip[0].offsetWidth > 0
            );
        }
    };
    
    // Extend original api defaults
    $.extend(TRUE, QTIP.defaults, {
        show: {
            modal: {
                on: FALSE,
                effect: TRUE,
                blur: TRUE,
                stealfocus: TRUE,
                escape: TRUE
            }
        }
    });
    ;PLUGINS.viewport = function(api, position, posOptions, targetWidth, targetHeight, elemWidth, elemHeight)
    {
        var target = posOptions.target,
            tooltip = api.elements.tooltip,
            my = posOptions.my,
            at = posOptions.at,
            adjust = posOptions.adjust,
            method = adjust.method.split(' '),
            methodX = method[0],
            methodY = method[1] || method[0],
            viewport = posOptions.viewport,
            container = posOptions.container,
            adjusted = { left: 0, top: 0 },
            fixed, newMy, containerOffset, containerStatic,
            viewportWidth, viewportHeight, viewportScroll, viewportOffset;
    
        // If viewport is not a jQuery element, or it's the window/document, or no adjustment method is used... return
        if(!viewport.jquery || target[0] === window || target[0] === document.body || adjust.method === 'none') {
            return adjusted;
        }
    
        // Cach container details
        containerOffset = container.offset() || adjusted;
        containerStatic = container.css('position') === 'static';
    
        // Cache our viewport details
        fixed = tooltip.css('position') === 'fixed';
        viewportWidth = viewport[0] === window ? viewport.width() : viewport.outerWidth(FALSE);
        viewportHeight = viewport[0] === window ? viewport.height() : viewport.outerHeight(FALSE);
        viewportScroll = { left: fixed ? 0 : viewport.scrollLeft(), top: fixed ? 0 : viewport.scrollTop() };
        viewportOffset = viewport.offset() || adjusted;
    
        // Generic calculation method
        function calculate(side, otherSide, type, adjustment, side1, side2, lengthName, targetLength, elemLength) {
            var initialPos = position[side1],
                mySide = my[side],
                atSide = at[side],
                isShift = type === SHIFT,
                myLength = mySide === side1 ? elemLength : mySide === side2 ? -elemLength : -elemLength / 2,
                atLength = atSide === side1 ? targetLength : atSide === side2 ? -targetLength : -targetLength / 2,
                sideOffset = viewportScroll[side1] + viewportOffset[side1] - (containerStatic ? 0 : containerOffset[side1]),
                overflow1 = sideOffset - initialPos,
                overflow2 = initialPos + elemLength - (lengthName === WIDTH ? viewportWidth : viewportHeight) - sideOffset,
                offset = myLength - (my.precedance === side || mySide === my[otherSide] ? atLength : 0) - (atSide === CENTER ? targetLength / 2 : 0);
    
            // shift
            if(isShift) {
                offset = (mySide === side1 ? 1 : -1) * myLength;
    
                // Adjust position but keep it within viewport dimensions
                position[side1] += overflow1 > 0 ? overflow1 : overflow2 > 0 ? -overflow2 : 0;
                position[side1] = Math.max(
                    -containerOffset[side1] + viewportOffset[side1],
                    initialPos - offset,
                    Math.min(
                        Math.max(
                            -containerOffset[side1] + viewportOffset[side1] + (lengthName === WIDTH ? viewportWidth : viewportHeight),
                            initialPos + offset
                        ),
                        position[side1],
    
                        // Make sure we don't adjust complete off the element when using 'center'
                        mySide === 'center' ? initialPos - myLength : 1E9
                    )
                );
    
            }
    
            // flip/flipinvert
            else {
                // Update adjustment amount depending on if using flipinvert or flip
                adjustment *= type === FLIPINVERT ? 2 : 0;
    
                // Check for overflow on the left/top
                if(overflow1 > 0 && (mySide !== side1 || overflow2 > 0)) {
                    position[side1] -= offset + adjustment;
                    newMy.invert(side, side1);
                }
    
                // Check for overflow on the bottom/right
                else if(overflow2 > 0 && (mySide !== side2 || overflow1 > 0)  ) {
                    position[side1] -= (mySide === CENTER ? -offset : offset) + adjustment;
                    newMy.invert(side, side2);
                }
    
                // Make sure we haven't made things worse with the adjustment and reset if so
                if(position[side1] < viewportScroll[side1] && -position[side1] > overflow2) {
                    position[side1] = initialPos; newMy = my.clone();
                }
            }
    
            return position[side1] - initialPos;
        }
    
        // Set newMy if using flip or flipinvert methods
        if(methodX !== 'shift' || methodY !== 'shift') { newMy = my.clone(); }
    
        // Adjust position based onviewport and adjustment options
        adjusted = {
            left: methodX !== 'none' ? calculate( X, Y, methodX, adjust.x, LEFT, RIGHT, WIDTH, targetWidth, elemWidth ) : 0,
            top: methodY !== 'none' ? calculate( Y, X, methodY, adjust.y, TOP, BOTTOM, HEIGHT, targetHeight, elemHeight ) : 0,
            my: newMy
        };
    
        return adjusted;
    };
    ;PLUGINS.polys = {
        // POLY area coordinate calculator
        //	Special thanks to Ed Cradock for helping out with this.
        //	Uses a binary search algorithm to find suitable coordinates.
        polygon: function(baseCoords, corner) {
            var result = {
                width: 0, height: 0,
                position: {
                    top: 1e10, right: 0,
                    bottom: 0, left: 1e10
                },
                adjustable: FALSE
            },
            i = 0, next,
            coords = [],
            compareX = 1, compareY = 1,
            realX = 0, realY = 0,
            newWidth, newHeight;
    
            // First pass, sanitize coords and determine outer edges
            i = baseCoords.length; 
            while(i--) {
                next = [ parseInt(baseCoords[--i], 10), parseInt(baseCoords[i+1], 10) ];
    
                if(next[0] > result.position.right){ result.position.right = next[0]; }
                if(next[0] < result.position.left){ result.position.left = next[0]; }
                if(next[1] > result.position.bottom){ result.position.bottom = next[1]; }
                if(next[1] < result.position.top){ result.position.top = next[1]; }
    
                coords.push(next);
            }
    
            // Calculate height and width from outer edges
            newWidth = result.width = Math.abs(result.position.right - result.position.left);
            newHeight = result.height = Math.abs(result.position.bottom - result.position.top);
    
            // If it's the center corner...
            if(corner.abbrev() === 'c') {
                result.position = {
                    left: result.position.left + result.width / 2,
                    top: result.position.top + result.height / 2
                };
            }
            else {
                // Second pass, use a binary search algorithm to locate most suitable coordinate
                while(newWidth > 0 && newHeight > 0 && compareX > 0 && compareY > 0)
                {
                    newWidth = Math.floor(newWidth / 2);
                    newHeight = Math.floor(newHeight / 2);
    
                    if(corner.x === LEFT){ compareX = newWidth; }
                    else if(corner.x === RIGHT){ compareX = result.width - newWidth; }
                    else{ compareX += Math.floor(newWidth / 2); }
    
                    if(corner.y === TOP){ compareY = newHeight; }
                    else if(corner.y === BOTTOM){ compareY = result.height - newHeight; }
                    else{ compareY += Math.floor(newHeight / 2); }
    
                    i = coords.length;
                    while(i--)
                    {
                        if(coords.length < 2){ break; }
    
                        realX = coords[i][0] - result.position.left;
                        realY = coords[i][1] - result.position.top;
    
                        if(
                            corner.x === LEFT && realX >= compareX ||
                            corner.x === RIGHT && realX <= compareX ||
                            corner.x === CENTER && (realX < compareX || realX > result.width - compareX) ||
                            corner.y === TOP && realY >= compareY ||
                            corner.y === BOTTOM && realY <= compareY ||
                            corner.y === CENTER && (realY < compareY || realY > result.height - compareY)) {
                            coords.splice(i, 1);
                        }
                    }
                }
                result.position = { left: coords[0][0], top: coords[0][1] };
            }
    
            return result;
        },
    
        rect: function(ax, ay, bx, by) {
            return {
                width: Math.abs(bx - ax),
                height: Math.abs(by - ay),
                position: {
                    left: Math.min(ax, bx),
                    top: Math.min(ay, by)
                }
            };
        },
    
        _angles: {
            tc: 3 / 2, tr: 7 / 4, tl: 5 / 4,
            bc: 1 / 2, br: 1 / 4, bl: 3 / 4,
            rc: 2, lc: 1, c: 0
        },
        ellipse: function(cx, cy, rx, ry, corner) {
            var c = PLUGINS.polys._angles[ corner.abbrev() ],
                rxc = c === 0 ? 0 : rx * Math.cos( c * Math.PI ),
                rys = ry * Math.sin( c * Math.PI );
    
            return {
                width: rx * 2 - Math.abs(rxc),
                height: ry * 2 - Math.abs(rys),
                position: {
                    left: cx + rxc,
                    top: cy + rys
                },
                adjustable: FALSE
            };
        },
        circle: function(cx, cy, r, corner) {
            return PLUGINS.polys.ellipse(cx, cy, r, r, corner);
        }
    };
    ;PLUGINS.svg = function(api, svg, corner)
    {
        var elem = svg[0],
            root = $(elem.ownerSVGElement),
            ownerDocument = elem.ownerDocument,
            strokeWidth2 = (parseInt(svg.css('stroke-width'), 10) || 0) / 2,
            frameOffset, mtx, transformed,
            len, next, i, points,
            result, position;
    
        // Ascend the parentNode chain until we find an element with getBBox()
        while(!elem.getBBox) { elem = elem.parentNode; }
        if(!elem.getBBox || !elem.parentNode) { return FALSE; }
    
        // Determine which shape calculation to use
        switch(elem.nodeName) {
            case 'ellipse':
            case 'circle':
                result = PLUGINS.polys.ellipse(
                    elem.cx.baseVal.value,
                    elem.cy.baseVal.value,
                    (elem.rx || elem.r).baseVal.value + strokeWidth2,
                    (elem.ry || elem.r).baseVal.value + strokeWidth2,
                    corner
                );
            break;
    
            case 'line':
            case 'polygon':
            case 'polyline':
                // Determine points object (line has none, so mimic using array)
                points = elem.points || [
                    { x: elem.x1.baseVal.value, y: elem.y1.baseVal.value },
                    { x: elem.x2.baseVal.value, y: elem.y2.baseVal.value }
                ];
    
                for(result = [], i = -1, len = points.numberOfItems || points.length; ++i < len;) {
                    next = points.getItem ? points.getItem(i) : points[i];
                    result.push.apply(result, [next.x, next.y]);
                }
    
                result = PLUGINS.polys.polygon(result, corner);
            break;
    
            // Unknown shape or rectangle? Use bounding box
            default:
                result = elem.getBBox();
                result = {
                    width: result.width,
                    height: result.height,
                    position: {
                        left: result.x,
                        top: result.y
                    }
                };
            break;
        }
    
        // Shortcut assignments
        position = result.position;
        root = root[0];
    
        // Convert position into a pixel value
        if(root.createSVGPoint) {
            mtx = elem.getScreenCTM();
            points = root.createSVGPoint();
    
            points.x = position.left;
            points.y = position.top;
            transformed = points.matrixTransform( mtx );
            position.left = transformed.x;
            position.top = transformed.y;
        }
    
        // Check the element is not in a child document, and if so, adjust for frame elements offset
        if(ownerDocument !== document && api.position.target !== 'mouse') {
            frameOffset = $((ownerDocument.defaultView || ownerDocument.parentWindow).frameElement).offset();
            if(frameOffset) {
                position.left += frameOffset.left;
                position.top += frameOffset.top;
            }
        }
    
        // Adjust by scroll offset of owner document
        ownerDocument = $(ownerDocument);
        position.left += ownerDocument.scrollLeft();
        position.top += ownerDocument.scrollTop();
    
        return result;
    };
    ;PLUGINS.imagemap = function(api, area, corner)
    {
        if(!area.jquery) { area = $(area); }
    
        var shape = (area.attr('shape') || 'rect').toLowerCase().replace('poly', 'polygon'),
            image = $('img[usemap="#'+area.parent('map').attr('name')+'"]'),
            coordsString = $.trim(area.attr('coords')),
            coordsArray = coordsString.replace(/,$/, '').split(','),
            imageOffset, coords, i, result, len;
    
        // If we can't find the image using the map...
        if(!image.length) { return FALSE; }
    
        // Pass coordinates string if polygon
        if(shape === 'polygon') {
            result = PLUGINS.polys.polygon(coordsArray, corner);
        }
    
        // Otherwise parse the coordinates and pass them as arguments
        else if(PLUGINS.polys[shape]) {
            for(i = -1, len = coordsArray.length, coords = []; ++i < len;) {
                coords.push( parseInt(coordsArray[i], 10) );
            }
    
            result = PLUGINS.polys[shape].apply(
                this, coords.concat(corner)
            );
        }
    
        // If no shapre calculation method was found, return false
        else { return FALSE; }
    
        // Make sure we account for padding and borders on the image
        imageOffset = image.offset();
        imageOffset.left += Math.ceil((image.outerWidth(FALSE) - image.width()) / 2);
        imageOffset.top += Math.ceil((image.outerHeight(FALSE) - image.height()) / 2);
    
        // Add image position to offset coordinates
        result.position.left += imageOffset.left;
        result.position.top += imageOffset.top;
    
        return result;
    };
    ;var IE6,
    
    /*
     * BGIFrame adaption (http://plugins.jquery.com/project/bgiframe)
     * Special thanks to Brandon Aaron
     */
    BGIFRAME = '<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';" ' +
        ' style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); ' +
            '-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';
    
    function Ie6(api) {
        this._ns = 'ie6';
    
        this.qtip = api;
        this.init(api);
    }
    
    $.extend(Ie6.prototype, {
        _scroll : function() {
            var overlay = this.qtip.elements.overlay;
            overlay && (overlay[0].style.top = $(window).scrollTop() + 'px');
        },
    
        init: function(qtip) {
            var tooltip = qtip.tooltip;
    
            // Create the BGIFrame element if needed
            if($('select, object').length < 1) {
                this.bgiframe = qtip.elements.bgiframe = $(BGIFRAME).appendTo(tooltip);
    
                // Update BGIFrame on tooltip move
                qtip._bind(tooltip, 'tooltipmove', this.adjustBGIFrame, this._ns, this);
            }
    
            // redraw() container for width/height calculations
            this.redrawContainer = $('<div/>', { id: NAMESPACE+'-rcontainer' })
                .appendTo(document.body);
    
            // Fixup modal plugin if present too
            if( qtip.elements.overlay && qtip.elements.overlay.addClass('qtipmodal-ie6fix') ) {
                qtip._bind(window, ['scroll', 'resize'], this._scroll, this._ns, this);
                qtip._bind(tooltip, ['tooltipshow'], this._scroll, this._ns, this);
            }
    
            // Set dimensions
            this.redraw();
        },
    
        adjustBGIFrame: function() {
            var tooltip = this.qtip.tooltip,
                dimensions = {
                    height: tooltip.outerHeight(FALSE),
                    width: tooltip.outerWidth(FALSE)
                },
                plugin = this.qtip.plugins.tip,
                tip = this.qtip.elements.tip,
                tipAdjust, offset;
    
            // Adjust border offset
            offset = parseInt(tooltip.css('borderLeftWidth'), 10) || 0;
            offset = { left: -offset, top: -offset };
    
            // Adjust for tips plugin
            if(plugin && tip) {
                tipAdjust = plugin.corner.precedance === 'x' ? [WIDTH, LEFT] : [HEIGHT, TOP];
                offset[ tipAdjust[1] ] -= tip[ tipAdjust[0] ]();
            }
    
            // Update bgiframe
            this.bgiframe.css(offset).css(dimensions);
        },
    
        // Max/min width simulator function
        redraw: function() {
            if(this.qtip.rendered < 1 || this.drawing) { return this; }
    
            var tooltip = this.qtip.tooltip,
                style = this.qtip.options.style,
                container = this.qtip.options.position.container,
                perc, width, max, min;
    
            // Set drawing flag
            this.qtip.drawing = 1;
    
            // If tooltip has a set height/width, just set it... like a boss!
            if(style.height) { tooltip.css(HEIGHT, style.height); }
            if(style.width) { tooltip.css(WIDTH, style.width); }
    
            // Simulate max/min width if not set width present...
            else {
                // Reset width and add fluid class
                tooltip.css(WIDTH, '').appendTo(this.redrawContainer);
    
                // Grab our tooltip width (add 1 if odd so we don't get wrapping problems.. huzzah!)
                width = tooltip.width();
                if(width % 2 < 1) { width += 1; }
    
                // Grab our max/min properties
                max = tooltip.css('maxWidth') || '';
                min = tooltip.css('minWidth') || '';
    
                // Parse into proper pixel values
                perc = (max + min).indexOf('%') > -1 ? container.width() / 100 : 0;
                max = (max.indexOf('%') > -1 ? perc : 1 * parseInt(max, 10)) || width;
                min = (min.indexOf('%') > -1 ? perc : 1 * parseInt(min, 10)) || 0;
    
                // Determine new dimension size based on max/min/current values
                width = max + min ? Math.min(Math.max(width, min), max) : width;
    
                // Set the newly calculated width and remvoe fluid class
                tooltip.css(WIDTH, Math.round(width)).appendTo(container);
            }
    
            // Set drawing flag
            this.drawing = 0;
    
            return this;
        },
    
        destroy: function() {
            // Remove iframe
            this.bgiframe && this.bgiframe.remove();
    
            // Remove bound events
            this.qtip._unbind([window, this.qtip.tooltip], this._ns);
        }
    });
    
    IE6 = PLUGINS.ie6 = function(api) {
        // Proceed only if the browser is IE6
        return BROWSER.ie === 6 ? new Ie6(api) : FALSE;
    };
    
    IE6.initialize = 'render';
    
    CHECKS.ie6 = {
        '^content|style$': function() {
            this.redraw();
        }
    };
    ;}));
    }( window, document ));
    
},{}],13:[function(require,module,exports){
function copy() {
    var id = this.getAttribute('data-index');
    
    // Get the value from hidden element with resource URL
    var copyText = document.querySelector( "#resource-url-" + id ).value;
    
    // Create a hidden input and set value to resource URL
    var tempInput = document.createElement("input");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = copyText;
    document.body.appendChild(tempInput);
    
    // Select hidden input value, copy and then remove it
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    console.log(id);

    // Temporarily display notification
    var notification = document.querySelector( "#resource__copy-notification-" + id );
    notification.classList.add( 'resource__copy-notification--active' );

    // Remove notification class
    setTimeout( function() {
        notification.classList.remove( 'resource__copy-notification--active' );
    }, 3000 );
}

var copyButtons = document.querySelectorAll('.js-resource-copy');

for ( var i = 0; i < copyButtons.length; i++ ) {
    copyButtons[i].addEventListener( 'click' , copy );
}
},{}],14:[function(require,module,exports){
// Add horizontal scroll to tables
function checkTable() {
	var tableWrappers = document.querySelectorAll('.table-wrapper');

	// If any tables have been set to responsive
	if ( tableWrappers ) {
		for (var i = 0; i < tableWrappers.length; i++) {
			var table = tableWrappers[i].querySelector('table');

			// Check for a table, in case the wrapper has been misused
			if ( table ) {
				if ( table.clientWidth > tableWrappers[i].clientWidth ) {
					tableWrappers[i].classList.add('table-wrapper--too-narrow');
				} else {
					tableWrappers[i].classList.remove('table-wrapper--too-narrow');
				}
			}

		}
	}
}

checkTable();

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var optimisedCheckTable = debounce(checkTable, 250); // Debounce for performance

// Fire on comparision modal load
var comparisonButton = document.querySelector( '.product-list-header__button .button' );
if ( comparisonButton ) {
	comparisonButton.addEventListener( 'click', function() {
		setTimeout( checkTable, 250 );
	});
}

window.addEventListener( 'resize', optimisedCheckTable );
},{}],15:[function(require,module,exports){
// A custom reset to avoid issues with slider values on reset
var resetForm = function() {
	$('.filter-block-reset').on( 'click' , function(e) {
		e.preventDefault();

		// Get current path
		var currentPath = window.location.pathname;

		// Last path character
		var lastPathCharacter = currentPath.substr( currentPath.length - 1, currentPath.length );

		// If last character is slash, strip it
		if ( lastPathCharacter === '/' ) {
			var targetPath = currentPath.slice(0, -1);
		} else {
			var targetPath = currentPath;
		}

		// Reload page, and scroll to filter target
		window.location = targetPath + '?scrollOffset=true&scrollTarget=filter-reset-target';
	});
}

$(document).ready( resetForm );

var hideEmptyTerms = function() {
	if ( document.querySelector('.dynamic-filter-block') ) {
		$('.dynamic-filter-block li').each(function() {
			// Remove everything with a blank string for a value
			$(this).find('li').each(function() {
				if ( $(this).find('input').val() == '' ) {
					$(this).remove();
				}
			});
			// Don't hide active options OR options which have an active child
			if ( ! $(this).hasClass('sf-option-active') && ! $(this).find('.sf-option-active').length ) {
				/**
				 * Search & Filter provides a data attribute for checkboxes, called `data-sf-count`, which tells us
				 * how many results each term has. If this is zero, we can remove the element.
				 * We need to remove, rather than hide, so that we can accurately hide the `h4` headers
				 * for filters with no terms at all.
				 */
				if( $(this).data('sfCount') === 0 ) {
					$(this).remove();
				}
			}
		});

		$('.dynamic-filter-block h4').each(function() {
			// Loop through each header and, if there are no terms for the filter, hide the header
			if ( $(this).next('ul').length ) {
				if ( $(this).next('ul').html().trim() == '' ) {
					$(this).parent().remove();
				}
			}
		});

		if ( $('.dynamic-filter-block li').length < 3 ) {
			$('.dynamic-filter-block').remove();
			$('.filter-list').removeClass('filter-list--active');
			$('.filtered-grid').addClass('grid--4col-1000');
		}
	}
}

$(document).ready( hideEmptyTerms );

// Function to handle visual toggle of nested checkboxes in Search & Filter
var initialiseFilterChildToggle = function() {

	// Add button before each child list
	$('.nested-filter-block .children').before('<a class="filter-child-toggle">+</a>');

	// Add click handler to button
	$('.filter-child-toggle').on('click', function(e) {
		e.preventDefault();
		$(this).next('.children').toggleClass('children--expanded');
		if ( $(this).html() === '+' ) {
			$(this).html('–');
		} else {
			$(this).html('+');
		}
	});

	// Open any lists with children selected
	$('.nested-filter-block .children').each(function() {
		var list = $(this);
		$(this).find('input').each(function() {
			if ( $(this).attr('checked') ) {
				list.addClass('children--expanded');
				list.prev('.filter-child-toggle').html('–');
			}
		})
	});

};

$(document).ready( initialiseFilterChildToggle );
$(document).ajaxComplete( initialiseFilterChildToggle ); // Run on ajaxComplete in case any settings which use AJAX are turned on

// Ensure Kitchen & Wet Rooms Max is selected
var selectKitchenWetRoomsMax = function() {
	$('.sf-field-post-meta-number_of_kitchen_and_wet_rooms .sf-range-max .sf-input-radio:last-child input').attr('checked', 'checked');
}
$(document).ready( selectKitchenWetRoomsMax );

},{}],16:[function(require,module,exports){
/**
 * Initialise Slick sliders
 */
$(document).ready(function() {

	// Main product image
	$('.product-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right"></i></button>',
		dots: false,
		swipe: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					dots: true,
					arrows: false,
					swipe: true
				}
			}
		]
	});

	// Nav thumbnails for main product image
	$('.product-slider-nav').slick({
		slidesToShow: 8,
		slidesToScroll: 1,
		asNavFor: '.product-slider',
		swipe: false,
		focusOnSelect: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right"></i></button>'
	});

	/**
	 * This block manually recreates broken `asNavFor` on `.product-slider`
	 * See: https://stackoverflow.com/questions/31382661/slick-slider-sync-situation
	 */
	$('.product-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
	  var inFocus = $('.product-slider .slick-current').attr('data-slick-index');
	  $('.product-slider-nav .slick-current').removeClass('slick-current');
	  $('.product-slider-nav .slick-slide[data-slick-index="' + inFocus + '"]').trigger('click');
	});

	// Compatible products on single product page
	$('.compatible-products-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right"></i></button>',
		dots: false,
		swipe: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					swipe: true,
					arrows: false,
					dots: true
				}
			}
		]
	});

	// Similar products on single product page
	$('.similar-products-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right"></i></button>',
		dots: false,
		swipe: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					swipe: true,
					arrows: false,
					dots: true
				}
			}
		]
	});

	// Slider for product categories in product archives
	$('.product-category-nav-slider').slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right"></i></button>',
		swipe: false,
		responsive: [
			{
				breakpoint: 1260,
				settings: {
					slidesToShow: 5
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 768,
				settings: 'unslick'
			}
		]
	});

});
},{}],17:[function(require,module,exports){
// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  // Also don't include modals
  // Also don't include skip to content link
  .not('[href="#"]')
  .not('[href="#0"]')
  .not('[data-modal]')
  .not('[href="#page"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 160 // Offset the scroll by 160px so content isn't flush with viewport or hidden under sticky nav
        }, 300, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          // $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            // $target.focus(); // Set focus again
          };
        });
      }
    }
  });

  // Get parameter from query string
function getUrlParameter(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

window.addEventListener('load', function() {
  if ( getUrlParameter('scrollOffset') == 'true' ) {
    var target = document.getElementById( getUrlParameter('scrollTarget') );
    var bodyRect = document.body.getBoundingClientRect();
    var elemRect = target.getBoundingClientRect();
    var offsetTop = elemRect.top - bodyRect.top;
    $('.content-toggle').removeClass('content-toggle--active');
    $('#' + getUrlParameter('scrollTarget') + ' .content-toggle').addClass('content-toggle--active');
    var headerAllowance = 85;
    if ( getUrlParameter( 'headerAllowance' ) !== null ) {
      var headerAllowance = getUrlParameter( 'headerAllowance' );
    }
    window.scrollTo(0, offsetTop - headerAllowance);
  }
})
},{}],18:[function(require,module,exports){
(function (global){
/* global TimelineLite TweenLite Power1 */
var THREE = (typeof window !== "undefined" ? window['THREE'] : typeof global !== "undefined" ? global['THREE'] : null);
const timing = require('./timing');
const timingRecorder ={};
THREE.PanControls = function (object, domElement) {
    domElement = (domElement !== undefined) ? domElement : document;

    // API
    this.soften = null;
    this.moving = false;
    this.enabled = true;
    this.firstrun = false;
    this.center = new THREE.Vector3();
    this.panSpeed = 0.001;
  
    this.timeline = new TimelineLite({
        onUpdate: function() {
            //timingRecorder[Math.floor(object.position.x)] = this.time();
        },
        onComplete:function() {
            this.restart();
        }});
    
    this.timeline.pause();

    this.velocity = 0;
    
    //-1180 - 820
    this.max = 820;
    this.min = -1200;
    const camera = {
        x : this.min,
    };

    const right = {
        x : this.max,
        ease:Power1.easeInOut,
        onUpdate() {
            object.position.x = camera.x;
        },
    };
    const left = {
        x : this.min,
        ease:Power1.easeInOut,
        onUpdate() {
            object.position.x = camera.x;
        },
    };
    
    this.timeline.add( TweenLite.to(camera, 28, right) );
    this.timeline.add( TweenLite.to(camera, 28, left) );
    
    
    // internals

    const that = this;

    
    

    const delta = new THREE.Vector3();

    const STATE = { NONE: - 1, PAN: 0 };
    let state = STATE.NONE;

    const {center} = this;
    const normalMatrix = new THREE.Matrix3();
    const pointer = new THREE.Vector2();
    const pointerOld = new THREE.Vector2();

    // events

    const changeEvent = { type: 'change' };
    let position = 0;
    let restartTimeout;

    this.play = function() {
        that.moving = true;
        that.timeline.play();
    }

    this.pause = function() {
        that.timeline.pause();
    }

    this.slowdown = function(){
        if(!that.timeline.paused()){
            that.timeline.pause();
            const camera = {
                x : object.position.x,
            };
            const direction = that.timeline.time() > 26 ? -25 : 25;
            let end = object.position.x + direction;
            if(end > that.max){
                end = that.max
            }
            if(end < that.min){
                end = that.min
            }
            const soft = {
                x : end,
                ease:Power1.easeOut,
                onUpdate() {
                    object.position.x = camera.x;
                },
            };
            that.soften = TweenLite.to(camera, 1, soft);
        }
    }

    this.resume = function(time = 6000, customtime = false) {
        if(restartTimeout){
            clearTimeout(restartTimeout);
        }
        
        restartTimeout= setTimeout(() => {
            if(state = STATE.NONE && that.enabled && this.firstrun){
                that.moving = true;
                let distance = 9999;
                let time = 0;
                if(customtime !== false){
                    time = timing["-1175"];
                } else {
                    Object.keys(timing).forEach((position) => {
                        const currentdistance = Math.abs(object.position.x - position);
                        if(currentdistance<distance){
                            distance = currentdistance;
                            time = timing[position];
                        }
                    });
                }
                that.timeline.time(time);
                that.timeline.play();
            }
        }, time);
    }

    this.pan = function (delta) {
        const distance = object.position.distanceTo(center);
        delta.multiplyScalar(distance * that.panSpeed);
        delta.applyMatrix3(normalMatrix.getNormalMatrix(object.matrix));

        if(object.position.x > this.max && delta.x > 0){
            this.velocity = 0;
            return;
        }
        if(object.position.x < this.min && delta.x < 0){
            this.velocity = 0;
            return;
        }
        this.velocity = delta.x;
        that.moving = true;
        object.position.add(delta);
        center.add(delta);

        position = (object.position.x + 1100) / 1920 * 26;

        that.dispatchEvent(changeEvent);
    };

    // mouse

    const onTouchStart = function(event) {
        if(that.soften){
            that.soften.kill();
        }
        if (that.enabled === false) return;

        const touches = event.changedTouches;
      
        if (touches.length > 0){
            that.timeline.pause();
            state = STATE.PAN;
            that.moving = true;

            domElement.parentNode.classList.add('panning');
            pointerOld.set(touches[0].clientX, touches[0].clientY);

            domElement.addEventListener('mousemove', onMouseMove, false);
            domElement.addEventListener('touchmove', onTouchMove, false);
            domElement.addEventListener('mouseup', onMouseUp, false);
            domElement.addEventListener('touchend', onMouseUp, false);
            domElement.addEventListener('touchcancel', onMouseUp, false);
            domElement.addEventListener('mouseout', onMouseUp, false);
            domElement.addEventListener('dblclick', onMouseUp, false);
        }
    };

    const onMouseDown = function(event) {
        if(that.soften){
            that.soften.kill();
        }
        if (that.enabled === false) return;

        if (event.button === 0) {
            that.timeline.pause();
            state = STATE.PAN;
            that.moving = true;
        }

        domElement.parentNode.classList.add('panning');

        pointerOld.set(event.clientX, event.clientY);

        domElement.addEventListener('mousemove', onMouseMove, false);
        domElement.addEventListener('touchmove', onTouchMove, false);
        domElement.addEventListener('mouseup', onMouseUp, false);
        domElement.addEventListener('touchend', onMouseUp, false);
        domElement.addEventListener('touchcancel', onMouseUp, false);
        domElement.addEventListener('mouseout', onMouseUp, false);
        domElement.addEventListener('dblclick', onMouseUp, false);
    };

    const onMouseMove = function(event) {
        if (that.enabled === false) return;

        pointer.set(event.clientX, event.clientY);

        const movementX = pointer.x - pointerOld.x;

        if (state === STATE.PAN) {
            that.pan(delta.set(- movementX, 0, 0));
        }

        pointerOld.set(event.clientX, event.clientY);
    };

    const onTouchMove = function(event) {
        if (that.enabled === false) return;

        const touches = event.changedTouches;
      
        if (touches.length > 0){
            pointer.set(touches[0].clientX, touches[0].clientY);

            const movementX = pointer.x - pointerOld.x;

            if (state === STATE.PAN) {
                that.pan(delta.set(- movementX, 0, 0));
            }

            pointerOld.set(touches[0].clientX, touches[0].clientY);
        }
    };

    const onMouseUp = function() {
        domElement.removeEventListener('mousemove', onMouseMove, false);
        domElement.removeEventListener('touchmove', onTouchMove, false);
        domElement.removeEventListener('mouseup', onMouseUp, false);
        domElement.removeEventListener('touchend', onMouseUp, false);
        domElement.removeEventListener('touchcancel', onMouseUp, false);
        domElement.removeEventListener('mouseout', onMouseUp, false);
        domElement.removeEventListener('dblclick', onMouseUp, false);
        domElement.parentNode.classList.remove('panning');
        
        if(that.velocity && that.velocity !== 0){
            const camera = {
                x : object.position.x,
            };
            let end = object.position.x + (that.velocity*10);
            if(end > that.max){
                end = that.max
            }
            if(end < that.min){
                end = that.min
            }
            const soft = {
                x : end,
                ease:Power1.easeOut,
                onUpdate() {
                    object.position.x = camera.x;
                },
            };
            that.soften = TweenLite.to(camera, 1, soft);
        }
        state = STATE.NONE;
        that.resume();
        /*setTimeout(() => {
            that.moving = false;
        },200);
        */
    };

    const contextmenu = function(event) {
        event.preventDefault();
    };

    this.dispose = function () {
        domElement.removeEventListener('contextmenu', contextmenu, false);
        domElement.removeEventListener('mousedown', onMouseDown, false);
        domElement.removeEventListener('touchstart', onTouchStart, false);

        domElement.removeEventListener('mousemove', onMouseMove, false);
        domElement.removeEventListener('touchmove', onTouchMove, false);
        domElement.removeEventListener('mouseup', onMouseUp, false);
        domElement.removeEventListener('touchend', onMouseUp, false);
        domElement.removeEventListener('touchcancel', onMouseUp, false);
        domElement.removeEventListener('mouseout', onMouseUp, false);
        domElement.removeEventListener('dblclick', onMouseUp, false);
    };

    domElement.addEventListener('contextmenu', contextmenu, false);
    domElement.addEventListener('mousedown', onMouseDown, false);
    domElement.addEventListener('touchstart', onTouchStart, false);
};

THREE.PanControls.prototype = Object.create(THREE.EventDispatcher.prototype);
THREE.PanControls.prototype.constructor = THREE.PanControls;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./timing":19}],19:[function(require,module,exports){
const timing = {
    "0":  15.390,
    "1":  15.396,
    "2":  15.405,
    "3":  15.415,
    "4":  15.419,
    "5":  15.428,
    "6":  15.436,
    "7":  15.445,
    "8":  15.452,
    "9":  15.461,
    "10":  15.465,
    "11":  15.470,
    "12":  15.478,
    "13":  15.487,
    "14":  15.493,
    "15":  15.502,
    "16":  15.509,
    "17":  15.518,
    "18":  15.532,
    "19":  15.538,
    "20":  15.541,
    "21":  15.553,
    "22":  15.558,
    "23":  15.568,
    "24":  15.576,
    "25":  15.585,
    "26":  15.592,
    "27":  15.600,
    "28":  15.606,
    "29":  15.615,
    "30":  15.624,
    "31":  15.633,
    "32":  15.637,
    "33":  15.646,
    "34":  15.655,
    "35":  15.663,
    "36":  15.668,
    "37":  15.675,
    "38":  15.684,
    "39":  15.696,
    "40":  15.698,
    "41":  15.708,
    "42":  15.716,
    "43":  15.726,
    "44":  15.73,
    "45":  15.743,
    "46":  15.745,
    "47":  15.753,
    "48":  15.767,
    "49":  15.771,
    "50":  15.780,
    "51":  15.788,
    "52":  15.797,
    "53":  15.806,
    "54":  15.814,
    "55":  15.818,
    "56":  15.827,
    "57":  15.838,
    "58":  15.847,
    "59":  15.854,
    "60":  15.859,
    "61":  15.868,
    "62":  15.877,
    "63":  15.884,
    "64":  15.889,
    "65":  15.896,
    "66":  15.904,
    "67":  15.913,
    "68":  15.921,
    "69":  15.927,
    "70":  15.936,
    "71":  15.943,
    "72":  15.952,
    "73":  15.967,
    "74":  15.975,
    "75":  15.984,
    "76":  15.990,
    "77":  15.999,
    "78":  16.006,
    "79":  16.016,
    "80":  16.023,
    "81":  16.032,
    "82":  16.040,
    "83":  16.044,
    "84":  16.056,
    "85":  16.064,
    "86":  16.069,
    "87":  16.073,
    "88":  16.088,
    "89":  16.094,
    "90":  16.103,
    "91":  16.112,
    "92":  16.121,
    "93":  16.130,
    "94":  16.133,
    "95":  16.142,
    "96":  16.151,
    "97":  16.160,
    "98":  16.168,
    "99":  16.177,
    "100":  16.186,
    "101":  16.193,
    "102":  16.202,
    "103":  16.210,
    "104":  16.216,
    "105":  16.224,
    "106":  16.232,
    "107":  16.244,
    "108":  16.252,
    "109":  16.258,
    "110":  16.267,
    "111":  16.275,
    "112":  16.285,
    "113":  16.293,
    "114":  16.302,
    "115":  16.306,
    "116":  16.315,
    "117":  16.323,
    "118":  16.332,
    "119":  16.341,
    "120":  16.35,
    "121":  16.359,
    "122":  16.366,
    "123":  16.375,
    "124":  16.384,
    "125":  16.392,
    "126":  16.395,
    "127":  16.409,
    "128":  16.416,
    "129":  16.427,
    "130":  16.433,
    "131":  16.445,
    "132":  16.451,
    "133":  16.46,
    "134":  16.465,
    "135":  16.472,
    "136":  16.482,
    "137":  16.490,
    "138":  16.499,
    "139":  16.505,
    "140":  16.519,
    "141":  16.525,
    "142":  16.537,
    "143":  16.543,
    "144":  16.553,
    "145":  16.561,
    "146":  16.570,
    "147":  16.576,
    "148":  16.585,
    "149":  16.592,
    "150":  16.601,
    "151":  16.609,
    "152":  16.618,
    "153":  16.627,
    "154":  16.636,
    "155":  16.645,
    "156":  16.654,
    "157":  16.660,
    "158":  16.668,
    "159":  16.674,
    "160":  16.690,
    "161":  16.697,
    "162":  16.707,
    "163":  16.716,
    "164":  16.722,
    "165":  16.731,
    "166":  16.736,
    "167":  16.743,
    "168":  16.755,
    "169":  16.762,
    "170":  16.773,
    "171":  16.779,
    "172":  16.788,
    "173":  16.799,
    "174":  16.803,
    "175":  16.814,
    "176":  16.823,
    "177":  16.832,
    "178":  16.839,
    "179":  16.847,
    "180":  16.863,
    "181":  16.871,
    "182":  16.880,
    "183":  16.887,
    "184":  16.895,
    "185":  16.904,
    "186":  16.910,
    "187":  16.918,
    "188":  16.927,
    "189":  16.942,
    "190":  16.951,
    "191":  16.957,
    "192":  16.966,
    "193":  16.976,
    "194":  16.979,
    "195":  16.990,
    "196":  17.002,
    "197":  17.012,
    "198":  17.022,
    "199":  17.031,
    "200":  17.038,
    "201":  17.047,
    "202":  17.055,
    "203":  17.064,
    "204":  17.073,
    "205":  17.077,
    "206":  17.086,
    "207":  17.101,
    "208":  17.106,
    "209":  17.116,
    "210":  17.124,
    "211":  17.133,
    "212":  17.142,
    "213":  17.151,
    "214":  17.159,
    "215":  17.172,
    "216":  17.181,
    "217":  17.189,
    "218":  17.198,
    "219":  17.207,
    "220":  17.216,
    "221":  17.223,
    "222":  17.235,
    "223":  17.244,
    "224":  17.253,
    "225":  17.261,
    "226":  17.270,
    "227":  17.279,
    "228":  17.288,
    "229":  17.296,
    "230":  17.305,
    "231":  17.317,
    "232":  17.324,
    "233":  17.333,
    "234":  17.342,
    "235":  17.350,
    "236":  17.356,
    "237":  17.371,
    "238":  17.376,
    "239":  17.387,
    "240":  17.398,
    "241":  17.406,
    "242":  17.416,
    "243":  17.424,
    "244":  17.430,
    "245":  17.443,
    "246":  17.451,
    "247":  17.463,
    "248":  17.469,
    "249":  17.481,
    "250":  17.487,
    "251":  17.499,
    "252":  17.505,
    "253":  17.517,
    "254":  17.525,
    "255":  17.537,
    "256":  17.543,
    "257":  17.555,
    "258":  17.561,
    "259":  17.574,
    "260":  17.579,
    "261":  17.592,
    "262":  17.6,
    "263":  17.612,
    "264":  17.618,
    "265":  17.630,
    "266":  17.637,
    "267":  17.65,
    "268":  17.659,
    "269":  17.666,
    "270":  17.674,
    "271":  17.686,
    "272":  17.695,
    "273":  17.704,
    "274":  17.713,
    "275":  17.722,
    "276":  17.731,
    "277":  17.741,
    "278":  17.752,
    "279":  17.759,
    "280":  17.770,
    "281":  17.779,
    "282":  17.788,
    "283":  17.796,
    "284":  17.808,
    "285":  17.815,
    "286":  17.827,
    "287":  17.832,
    "288":  17.845,
    "289":  17.857,
    "290":  17.865,
    "291":  17.877,
    "292":  17.886,
    "293":  17.889,
    "294":  17.904,
    "295":  17.915,
    "296":  17.924,
    "297":  17.933,
    "298":  17.940,
    "299":  17.945,
    "300":  17.960,
    "301":  17.970,
    "302":  17.979,
    "303":  17.993,
    "304":  18.002,
    "305":  18.009,
    "306":  18.019,
    "307":  18.028,
    "308":  18.041,
    "309":  18.049,
    "310":  18.058,
    "311":  18.070,
    "312":  18.079,
    "313":  18.088,
    "314":  18.094,
    "315":  18.103,
    "316":  18.115,
    "317":  18.124,
    "318":  18.134,
    "319":  18.148,
    "320":  18.153,
    "321":  18.168,
    "322":  18.177,
    "323":  18.186,
    "324":  18.195,
    "325":  18.204,
    "326":  18.216,
    "327":  18.225,
    "328":  18.237,
    "329":  18.247,
    "330":  18.255,
    "331":  18.264,
    "332":  18.278,
    "333":  18.287,
    "334":  18.296,
    "335":  18.305,
    "336":  18.317,
    "337":  18.326,
    "338":  18.335,
    "339":  18.344,
    "340":  18.357,
    "341":  18.366,
    "342":  18.375,
    "343":  18.383,
    "344":  18.398,
    "345":  18.407,
    "346":  18.416,
    "347":  18.428,
    "348":  18.437,
    "349":  18.439,
    "350":  18.457,
    "351":  18.464,
    "352":  18.476,
    "353":  18.490,
    "354":  18.492,
    "355":  18.502,
    "356":  18.520,
    "357":  18.529,
    "358":  18.538,
    "359":  18.546,
    "360":  18.559,
    "361":  18.567,
    "362":  18.579,
    "363":  18.591,
    "364":  18.597,
    "365":  18.609,
    "366":  18.622,
    "367":  18.630,
    "368":  18.642,
    "369":  18.654,
    "370":  18.660,
    "371":  18.672,
    "372":  18.686,
    "373":  18.692,
    "374":  18.704,
    "375":  18.716,
    "376":  18.722,
    "377":  18.734,
    "378":  18.747,
    "379":  18.753,
    "380":  18.766,
    "381":  18.779,
    "382":  18.791,
    "383":  18.8,
    "384":  18.811,
    "385":  18.817,
    "386":  18.832,
    "387":  18.839,
    "388":  18.853,
    "389":  18.860,
    "390":  18.874,
    "391":  18.883,
    "392":  18.895,
    "393":  18.898,
    "394":  18.912,
    "395":  18.924,
    "396":  18.930,
    "397":  18.943,
    "398":  18.955,
    "399":  18.963,
    "400":  18.979,
    "401":  18.990,
    "402":  19.003,
    "403":  19.012,
    "404":  19.022,
    "405":  19.035,
    "406":  19.043,
    "407":  19.050,
    "408":  19.067,
    "409":  19.074,
    "410":  19.082,
    "411":  19.098,
    "412":  19.112,
    "413":  19.121,
    "414":  19.133,
    "415":  19.142,
    "416":  19.154,
    "417":  19.163,
    "418":  19.177,
    "419":  19.186,
    "420":  19.198,
    "421":  19.207,
    "422":  19.214,
    "423":  19.231,
    "424":  19.238,
    "425":  19.255,
    "426":  19.259,
    "427":  19.267,
    "428":  19.281,
    "429":  19.296,
    "430":  19.311,
    "431":  19.32,
    "432":  19.332,
    "433":  19.341,
    "434":  19.354,
    "435":  19.362,
    "436":  19.371,
    "437":  19.387,
    "438":  19.395,
    "439":  19.404,
    "440":  19.416,
    "441":  19.431,
    "442":  19.445,
    "443":  19.454,
    "444":  19.467,
    "445":  19.476,
    "446":  19.485,
    "447":  19.502,
    "448":  19.511,
    "449":  19.525,
    "450":  19.532,
    "451":  19.546,
    "452":  19.558,
    "453":  19.570,
    "454":  19.579,
    "455":  19.592,
    "456":  19.606,
    "457":  19.615,
    "458":  19.627,
    "459":  19.637,
    "460":  19.651,
    "461":  19.660,
    "462":  19.674,
    "463":  19.686,
    "464":  19.695,
    "465":  19.707,
    "466":  19.720,
    "467":  19.732,
    "468":  19.746,
    "469":  19.755,
    "470":  19.767,
    "471":  19.779,
    "472":  19.793,
    "473":  19.805,
    "474":  19.811,
    "475":  19.820,
    "476":  19.833,
    "477":  19.851,
    "478":  19.865,
    "479":  19.871,
    "480":  19.883,
    "481":  19.895,
    "482":  19.907,
    "483":  19.919,
    "484":  19.933,
    "485":  19.945,
    "486":  19.957,
    "487":  19.969,
    "488":  19.981,
    "489":  19.993,
    "490":  20.005,
    "491":  20.017,
    "492":  20.029,
    "493":  20.041,
    "494":  20.053,
    "495":  20.065,
    "496":  20.077,
    "497":  20.091,
    "498":  20.097,
    "499":  20.116,
    "500":  20.127,
    "501":  20.139,
    "502":  20.154,
    "503":  20.166,
    "504":  20.18,
    "505":  20.192,
    "506":  20.204,
    "507":  20.213,
    "508":  20.226,
    "509":  20.240,
    "510":  20.252,
    "511":  20.264,
    "512":  20.273,
    "513":  20.293,
    "514":  20.303,
    "515":  20.311,
    "516":  20.323,
    "517":  20.341,
    "518":  20.356,
    "519":  20.368,
    "520":  20.380,
    "521":  20.387,
    "522":  20.404,
    "523":  20.419,
    "524":  20.428,
    "525":  20.442,
    "526":  20.454,
    "527":  20.467,
    "528":  20.484,
    "529":  20.497,
    "530":  20.511,
    "531":  20.523,
    "532":  20.537,
    "533":  20.549,
    "534":  20.562,
    "535":  20.576,
    "536":  20.588,
    "537":  20.600,
    "538":  20.615,
    "539":  20.627,
    "540":  20.636,
    "541":  20.647,
    "542":  20.668,
    "543":  20.679,
    "544":  20.684,
    "545":  20.707,
    "546":  20.716,
    "547":  20.729,
    "548":  20.743,
    "549":  20.755,
    "550":  20.769,
    "551":  20.782,
    "552":  20.796,
    "553":  20.808,
    "554":  20.821,
    "555":  20.835,
    "556":  20.848,
    "557":  20.868,
    "558":  20.881,
    "559":  20.895,
    "560":  20.907,
    "561":  20.921,
    "562":  20.933,
    "563":  20.946,
    "564":  20.96,
    "565":  20.975,
    "566":  20.993,
    "567":  21.005,
    "568":  21.019,
    "569":  21.032,
    "570":  21.046,
    "571":  21.058,
    "572":  21.070,
    "573":  21.089,
    "574":  21.103,
    "575":  21.115,
    "576":  21.127,
    "577":  21.145,
    "578":  21.157,
    "579":  21.171,
    "580":  21.183,
    "581":  21.198,
    "582":  21.217,
    "583":  21.228,
    "584":  21.237,
    "585":  21.259,
    "586":  21.273,
    "587":  21.288,
    "588":  21.300,
    "589":  21.318,
    "590":  21.329,
    "591":  21.347,
    "592":  21.359,
    "593":  21.377,
    "594":  21.389,
    "595":  21.403,
    "596":  21.419,
    "597":  21.431,
    "598":  21.448,
    "599":  21.461,
    "600":  21.478,
    "601":  21.493,
    "602":  21.509,
    "603":  21.523,
    "604":  21.535,
    "605":  21.553,
    "606":  21.57,
    "607":  21.585,
    "608":  21.595,
    "609":  21.612,
    "610":  21.627,
    "611":  21.645,
    "612":  21.654,
    "613":  21.666,
    "614":  21.686,
    "615":  21.704,
    "616":  21.722,
    "617":  21.735,
    "618":  21.752,
    "619":  21.764,
    "620":  21.779,
    "621":  21.794,
    "622":  21.811,
    "623":  21.82,
    "624":  21.842,
    "625":  21.859,
    "626":  21.877,
    "627":  21.889,
    "628":  21.906,
    "629":  21.922,
    "630":  21.940,
    "631":  21.957,
    "632":  21.972,
    "633":  21.987,
    "634":  22.000,
    "635":  22.023,
    "636":  22.038,
    "637":  22.055,
    "638":  22.071,
    "639":  22.085,
    "640":  22.100,
    "641":  22.116,
    "642":  22.139,
    "643":  22.154,
    "644":  22.169,
    "645":  22.186,
    "646":  22.201,
    "647":  22.216,
    "648":  22.231,
    "649":  22.255,
    "650":  22.272,
    "651":  22.287,
    "652":  22.302,
    "653":  22.318,
    "654":  22.341,
    "655":  22.356,
    "656":  22.365,
    "657":  22.384,
    "658":  22.395,
    "659":  22.424,
    "660":  22.443,
    "661":  22.461,
    "662":  22.476,
    "663":  22.494,
    "664":  22.511,
    "665":  22.529,
    "666":  22.550,
    "667":  22.567,
    "668":  22.585,
    "669":  22.601,
    "670":  22.618,
    "671":  22.636,
    "672":  22.656,
    "673":  22.677,
    "674":  22.687,
    "675":  22.711,
    "676":  22.728,
    "677":  22.734,
    "678":  22.762,
    "679":  22.782,
    "680":  22.802,
    "681":  22.821,
    "682":  22.841,
    "683":  22.862,
    "684":  22.877,
    "685":  22.898,
    "686":  22.918,
    "687":  22.936,
    "688":  22.954,
    "689":  22.972,
    "690":  22.996,
    "691":  23.011,
    "692":  23.026,
    "693":  23.052,
    "694":  23.067,
    "695":  23.091,
    "696":  23.106,
    "697":  23.130,
    "698":  23.147,
    "699":  23.171,
    "700":  23.186,
    "701":  23.202,
    "702":  23.228,
    "703":  23.247,
    "704":  23.272,
    "705":  23.287,
    "706":  23.302,
    "707":  23.320,
    "708":  23.356,
    "709":  23.378,
    "710":  23.395,
    "711":  23.416,
    "712":  23.439,
    "713":  23.463,
    "714":  23.484,
    "715":  23.506,
    "716":  23.529,
    "717":  23.549,
    "718":  23.571,
    "719":  23.586,
    "720":  23.610,
    "721":  23.633,
    "722":  23.657,
    "723":  23.680,
    "724":  23.704,
    "725":  23.717,
    "726":  23.746,
    "727":  23.770,
    "728":  23.796,
    "729":  23.817,
    "730":  23.844,
    "731":  23.865,
    "732":  23.889,
    "733":  23.913,
    "734":  23.937,
    "735":  23.958,
    "736":  23.985,
    "737":  24.008,
    "738":  24.032,
    "739":  24.058,
    "740":  24.080,
    "741":  24.106,
    "742":  24.131,
    "743":  24.157,
    "744":  24.183,
    "745":  24.208,
    "746":  24.235,
    "747":  24.261,
    "748":  24.287,
    "749":  24.311,
    "750":  24.338,
    "751":  24.365,
    "752":  24.391,
    "753":  24.416,
    "754":  24.442,
    "755":  24.475,
    "756":  24.500,
    "757":  24.531,
    "758":  24.556,
    "759":  24.576,
    "760":  24.610,
    "761":  24.641,
    "762":  24.671,
    "763":  24.702,
    "764":  24.728,
    "765":  24.761,
    "766":  24.791,
    "767":  24.820,
    "768":  24.844,
    "769":  24.881,
    "770":  24.913,
    "771":  24.943,
    "772":  24.978,
    "773":  25.008,
    "774":  25.038,
    "775":  25.074,
    "776":  25.106,
    "777":  25.137,
    "778":  25.177,
    "779":  25.213,
    "780":  25.246,
    "781":  25.279,
    "782":  25.318,
    "783":  25.354,
    "784":  25.392,
    "785":  25.425,
    "786":  25.464,
    "787":  25.505,
    "788":  25.532,
    "789":  25.586,
    "790":  25.624,
    "791":  25.665,
    "792":  25.708,
    "793":  25.747,
    "794":  25.793,
    "795":  25.838,
    "796":  25.884,
    "797":  25.930,
    "798":  25.975,
    "799":  26.026,
    "800":  26.077,
    "801":  26.128,
    "802":  26.18,
    "803":  26.232,
    "804":  26.284,
    "805":  26.344,
    "806":  26.401,
    "807":  26.464,
    "808":  26.538,
    "809":  26.603,
    "810":  26.677,
    "811":  26.749,
    "812":  26.826,
    "813":  26.913,
    "814":  27.014,
    "815": 27.110,
    "816":  27.232,
    "817":  27.371,
    "818":  27.555,
    "819":  27.996,
    "820": 28,
    "-1025":  5.843,
    "-1024":  5.859,
    "-1023":  5.875,
    "-1022":  5.890,
    "-1021":  5.906,
    "-1020":  5.922,
    "-1019":  5.939,
    "-1018":  5.948,
    "-1017":  5.970,
    "-1016":  5.991,
    "-1015":  6.003,
    "-1014":  6.020,
    "-1013":  6.038,
    "-1012":  6.055,
    "-1011":  6.068,
    "-1010":  6.086,
    "-1009":  6.103,
    "-1008":  6.116,
    "-1007":  6.134,
    "-1006":  6.150,
    "-1005":  6.163,
    "-1004":  6.180,
    "-1003":  6.198,
    "-1002":  6.210,
    "-1001":  6.224,
    "-1000":  6.242,
    "-999":  6.259,
    "-998":  6.270,
    "-997":  6.290,
    "-996":  6.299,
    "-995":  6.32,
    "-994":  6.336,
    "-993":  6.348,
    "-992":  6.361,
    "-991":  6.381,
    "-990":  6.393,
    "-989":  6.412,
    "-988":  6.425,
    "-987":  6.439,
    "-985":  6.471,
    "-984":  6.484,
    "-983":  6.497,
    "-982":  6.517,
    "-981":  6.530,
    "-980":  6.543,
    "-979":  6.556,
    "-978":  6.576,
    "-977":  6.590,
    "-976":  6.603,
    "-975":  6.616,
    "-974":  6.629,
    "-973":  6.643,
    "-972":  6.663,
    "-971":  6.677,
    "-970":  6.689,
    "-969":  6.707,
    "-968":  6.720,
    "-967":  6.733,
    "-966":  6.750,
    "-965":  6.763,
    "-964":  6.775,
    "-963":  6.794,
    "-962":  6.808,
    "-961":  6.82,
    "-960":  6.832,
    "-959":  6.851,
    "-958":  6.864,
    "-957":  6.876,
    "-956":  6.889,
    "-955":  6.908,
    "-954":  6.921,
    "-953":  6.933,
    "-952":  6.946,
    "-951":  6.964,
    "-950":  6.977,
    "-949":  6.991,
    "-948":  7.003,
    "-947":  7.015,
    "-946":  7.024,
    "-945":  7.035,
    "-944":  7.055,
    "-943":  7.074,
    "-942":  7.086,
    "-941":  7.099,
    "-940":  7.112,
    "-939":  7.129,
    "-938":  7.142,
    "-937":  7.155,
    "-936":  7.168,
    "-935":  7.181,
    "-934":  7.195,
    "-933":  7.206,
    "-932":  7.223,
    "-931":  7.236,
    "-930":  7.25,
    "-929":  7.262,
    "-928":  7.274,
    "-927":  7.288,
    "-926":  7.302,
    "-925":  7.317,
    "-924":  7.329,
    "-923":  7.334,
    "-922":  7.355,
    "-921":  7.365,
    "-920":  7.382,
    "-919":  7.396,
    "-918":  7.409,
    "-916":  7.436,
    "-915":  7.448,
    "-914":  7.461,
    "-913":  7.474,
    "-912":  7.487,
    "-911":  7.500,
    "-910":  7.509,
    "-909":  7.526,
    "-908":  7.539,
    "-907":  7.552,
    "-906":  7.565,
    "-905":  7.578,
    "-904":  7.589,
    "-903":  7.596,
    "-902":  7.614,
    "-901":  7.628,
    "-900":  7.635,
    "-899":  7.649,
    "-898":  7.662,
    "-897":  7.674,
    "-896":  7.687,
    "-895":  7.699,
    "-894":  7.711,
    "-893":  7.724,
    "-892":  7.736,
    "-891":  7.75,
    "-890":  7.762,
    "-889":  7.774,
    "-888":  7.787,
    "-887":  7.799,
    "-886":  7.811,
    "-885":  7.824,
    "-884":  7.838,
    "-883":  7.851,
    "-882":  7.864,
    "-881":  7.878,
    "-880":  7.890,
    "-879":  7.897,
    "-878":  7.916,
    "-877":  7.922,
    "-876":  7.936,
    "-875":  7.948,
    "-874":  7.961,
    "-873":  7.974,
    "-870":  8.012,
    "-869":  8.025,
    "-868":  8.037,
    "-867":  8.044,
    "-866":  8.058,
    "-865":  8.07,
    "-864":  8.081,
    "-863":  8.094,
    "-862":  8.107,
    "-861":  8.119,
    "-860":  8.131,
    "-859":  8.143,
    "-858":  8.156,
    "-857":  8.168,
    "-855":  8.193,
    "-854":  8.200,
    "-853":  8.213,
    "-852":  8.226,
    "-851":  8.238,
    "-850":  8.251,
    "-849":  8.263,
    "-848":  8.269,
    "-847":  8.282,
    "-846":  8.294,
    "-845":  8.308,
    "-844":  8.32,
    "-843":  8.332,
    "-842":  8.345,
    "-841":  8.352,
    "-840":  8.366,
    "-839":  8.378,
    "-838":  8.391,
    "-837":  8.402,
    "-836":  8.415,
    "-835":  8.421,
    "-834":  8.437,
    "-833":  8.448,
    "-832":  8.456,
    "-831":  8.464,
    "-830":  8.480,
    "-829":  8.495,
    "-828":  8.503,
    "-827":  8.517,
    "-826":  8.526,
    "-825":  8.54,
    "-824":  8.552,
    "-823":  8.561,
    "-822":  8.573,
    "-821":  8.585,
    "-820":  8.593,
    "-819":  8.608,
    "-818":  8.616,
    "-817":  8.631,
    "-816":  8.639,
    "-815":  8.646,
    "-814":  8.662,
    "-813":  8.671,
    "-812":  8.686,
    "-811":  8.695,
    "-810":  8.707,
    "-809":  8.716,
    "-808":  8.730,
    "-807":  8.744,
    "-806":  8.751,
    "-805":  8.760,
    "-804":  8.776,
    "-803":  8.783,
    "-802":  8.793,
    "-801":  8.805,
    "-800":  8.818,
    "-799":  8.828,
    "-798":  8.842,
    "-797":  8.850,
    "-796":  8.864,
    "-795":  8.875,
    "-794":  8.884,
    "-793":  8.891,
    "-792":  8.905,
    "-791":  8.913,
    "-790":  8.93,
    "-789":  8.939,
    "-788":  8.951,
    "-787":  8.959,
    "-786":  8.972,
    "-785":  8.982,
    "-784":  8.994,
    "-783":  9.003,
    "-782":  9.015,
    "-781":  9.023,
    "-780":  9.036,
    "-779":  9.046,
    "-778":  9.058,
    "-777":  9.067,
    "-776":  9.079,
    "-775":  9.088,
    "-774":  9.097,
    "-773":  9.108,
    "-772":  9.123,
    "-771":  9.131,
    "-770":  9.142,
    "-769":  9.155,
    "-768":  9.165,
    "-767":  9.174,
    "-766":  9.183,
    "-765":  9.196,
    "-764":  9.204,
    "-763":  9.217,
    "-762":  9.226,
    "-760":  9.244,
    "-759":  9.254,
    "-758":  9.267,
    "-757":  9.276,
    "-756":  9.29,
    "-755":  9.297,
    "-754":  9.309,
    "-753":  9.323,
    "-752":  9.331,
    "-751":  9.340,
    "-750":  9.354,
    "-749":  9.363,
    "-748":  9.372,
    "-747":  9.384,
    "-746":  9.392,
    "-745":  9.405,
    "-744":  9.415,
    "-743":  9.422,
    "-741":  9.442,
    "-740":  9.449,
    "-739":  9.465,
    "-738":  9.473,
    "-737":  9.482,
    "-736":  9.495,
    "-735":  9.504,
    "-734":  9.516,
    "-733":  9.526,
    "-732":  9.54,
    "-731":  9.549,
    "-730":  9.558,
    "-729":  9.567,
    "-727":  9.587,
    "-726":  9.596,
    "-725":  9.604,
    "-724":  9.619,
    "-723":  9.628,
    "-722":  9.634,
    "-721":  9.643,
    "-720":  9.659,
    "-719":  9.668,
    "-718":  9.675,
    "-717":  9.690,
    "-716":  9.699,
    "-715":  9.706,
    "-714":  9.715,
    "-713":  9.730,
    "-712":  9.738,
    "-711":  9.747,
    "-710":  9.754,
    "-709":  9.770,
    "-708":  9.778,
    "-707":  9.786,
    "-706":  9.793,
    "-705":  9.809,
    "-704":  9.817,
    "-703":  9.825,
    "-701":  9.841,
    "-700":  9.855,
    "-699":  9.866,
    "-698":  9.873,
    "-697":  9.881,
    "-696":  9.897,
    "-695":  9.905,
    "-694":  9.913,
    "-693":  9.922,
    "-692":  9.936,
    "-691":  9.948,
    "-690":  9.956,
    "-689":  9.966,
    "-688":  9.976,
    "-687":  9.985,
    "-686":  9.997,
    "-685":  10.006,
    "-684":  10.013,
    "-683":  10.021,
    "-682":  10.034,
    "-681":  10.043,
    "-680":  10.052,
    "-679":  10.061,
    "-678":  10.073,
    "-677":  10.081,
    "-676":  10.086,
    "-675":  10.102,
    "-674":  10.110,
    "-673":  10.117,
    "-672":  10.126,
    "-671":  10.134,
    "-670":  10.142,
    "-668":  10.168,
    "-667":  10.175,
    "-666":  10.186,
    "-665":  10.196,
    "-664":  10.207,
    "-663":  10.215,
    "-662":  10.222,
    "-661":  10.230,
    "-660":  10.238,
    "-659":  10.253,
    "-658":  10.262,
    "-657":  10.270,
    "-656":  10.283,
    "-655":  10.290,
    "-654":  10.300,
    "-653":  10.311,
    "-652":  10.32,
    "-651":  10.328,
    "-650":  10.336,
    "-649":  10.344,
    "-648":  10.357,
    "-647":  10.367,
    "-646":  10.376,
    "-645":  10.385,
    "-644":  10.393,
    "-643":  10.402,
    "-642":  10.410,
    "-641":  10.424,
    "-640":  10.433,
    "-639":  10.440,
    "-638":  10.449,
    "-637":  10.458,
    "-636":  10.466,
    "-635":  10.479,
    "-634":  10.488,
    "-633":  10.497,
    "-632":  10.506,
    "-631":  10.513,
    "-630":  10.522,
    "-629":  10.531,
    "-628":  10.54,
    "-627":  10.552,
    "-626":  10.559,
    "-625":  10.568,
    "-624":  10.576,
    "-623":  10.588,
    "-622":  10.598,
    "-621":  10.607,
    "-620":  10.616,
    "-619":  10.623,
    "-618":  10.632,
    "-617":  10.638,
    "-616":  10.651,
    "-615":  10.659,
    "-614":  10.671,
    "-613":  10.677,
    "-612":  10.689,
    "-611":  10.695,
    "-610":  10.708,
    "-608":  10.721,
    "-607":  10.729,
    "-606":  10.742,
    "-605":  10.745,
    "-604":  10.757,
    "-603":  10.770,
    "-602":  10.780,
    "-601":  10.79,
    "-600":  10.799,
    "-599":  10.806,
    "-598":  10.815,
    "-597":  10.823,
    "-596":  10.831,
    "-595":  10.840,
    "-593":  10.861,
    "-592":  10.866,
    "-591":  10.875,
    "-590":  10.886,
    "-589":  10.889,
    "-588":  10.901,
    "-587":  10.909,
    "-586":  10.921,
    "-585":  10.93,
    "-584":  10.939,
    "-583":  10.949,
    "-582":  10.958,
    "-581":  10.967,
    "-580":  10.976,
    "-579":  10.985,
    "-578":  10.994,
    "-577":  11.003,
    "-576":  11.011,
    "-575":  11.019,
    "-574":  11.028,
    "-573":  11.036,
    "-572":  11.041,
    "-571":  11.050,
    "-570":  11.058,
    "-569":  11.073,
    "-568":  11.081,
    "-567":  11.088,
    "-566":  11.097,
    "-565":  11.108,
    "-564":  11.113,
    "-563":  11.120,
    "-562":  11.132,
    "-561":  11.140,
    "-560":  11.148,
    "-559":  11.153,
    "-558":  11.168,
    "-557":  11.178,
    "-556":  11.186,
    "-555":  11.193,
    "-553":  11.212,
    "-551":  11.229,
    "-550":  11.238,
    "-549":  11.247,
    "-548":  11.256,
    "-547":  11.262,
    "-546":  11.272,
    "-545":  11.279,
    "-544":  11.284,
    "-542":  11.305,
    "-541":  11.315,
    "-540":  11.324,
    "-539":  11.332,
    "-538":  11.340,
    "-537":  11.350,
    "-536":  11.358,
    "-535":  11.367,
    "-534":  11.375,
    "-533":  11.384,
    "-532":  11.391,
    "-531":  11.399,
    "-530":  11.407,
    "-529":  11.416,
    "-528":  11.421,
    "-527":  11.430,
    "-526":  11.442,
    "-525":  11.451,
    "-524":  11.460,
    "-523":  11.469,
    "-522":  11.473,
    "-521":  11.486,
    "-520":  11.492,
    "-519":  11.503,
    "-518":  11.511,
    "-517":  11.519,
    "-516":  11.524,
    "-515":  11.532,
    "-514":  11.543,
    "-513":  11.553,
    "-512":  11.561,
    "-511":  11.567,
    "-510":  11.574,
    "-509":  11.584,
    "-508":  11.593,
    "-507":  11.602,
    "-505":  11.619,
    "-503":  11.636,
    "-501":  11.650,
    "-499":  11.668,
    "-498":  11.675,
    "-497":  11.683,
    "-496":  11.692,
    "-495":  11.702,
    "-494":  11.710,
    "-493":  11.720,
    "-492":  11.724,
    "-491":  11.735,
    "-490":  11.744,
    "-489":  11.750,
    "-487":  11.768,
    "-486":  11.777,
    "-485":  11.786,
    "-484":  11.790,
    "-483":  11.797,
    "-482":  11.806,
    "-481":  11.814,
    "-480":  11.821,
    "-479":  11.828,
    "-478":  11.843,
    "-477":  11.852,
    "-476":  11.860,
    "-475":  11.866,
    "-474":  11.876,
    "-473":  11.884,
    "-472":  11.890,
    "-471":  11.900,
    "-470":  11.908,
    "-469":  11.918,
    "-468":  11.922,
    "-467":  11.931,
    "-466":  11.939,
    "-465":  11.948,
    "-463":  11.965,
    "-461":  11.979,
    "-460":  11.986,
    "-459":  11.995,
    "-458":  12.004,
    "-457":  12.012,
    "-456":  12.021,
    "-455":  12.030,
    "-454":  12.038,
    "-453":  12.047,
    "-452":  12.055,
    "-451":  12.064,
    "-450":  12.072,
    "-449":  12.075,
    "-448":  12.083,
    "-447":  12.095,
    "-446":  12.099,
    "-445":  12.11,
    "-444":  12.116,
    "-443":  12.125,
    "-442":  12.132,
    "-441":  12.143,
    "-440":  12.150,
    "-439":  12.156,
    "-438":  12.165,
    "-437":  12.174,
    "-436":  12.183,
    "-435":  12.189,
    "-433":  12.205,
    "-432":  12.213,
    "-431":  12.222,
    "-430":  12.227,
    "-429":  12.235,
    "-428":  12.244,
    "-427":  12.253,
    "-426":  12.261,
    "-425":  12.269,
    "-424":  12.278,
    "-423":  12.286,
    "-422":  12.291,
    "-421":  12.300,
    "-420":  12.309,
    "-419":  12.317,
    "-418":  12.325,
    "-416":  12.335,
    "-415":  12.343,
    "-414":  12.352,
    "-413":  12.36,
    "-412":  12.369,
    "-411":  12.375,
    "-410":  12.384,
    "-409":  12.391,
    "-407":  12.406,
    "-405":  12.422,
    "-404":  12.431,
    "-403":  12.439,
    "-402":  12.448,
    "-401":  12.453,
    "-400":  12.460,
    "-399":  12.472,
    "-398":  12.480,
    "-397":  12.486,
    "-396":  12.497,
    "-395":  12.501,
    "-394":  12.506,
    "-393":  12.517,
    "-392":  12.525,
    "-391":  12.535,
    "-390":  12.540,
    "-389":  12.549,
    "-388":  12.558,
    "-387":  12.567,
    "-386":  12.571,
    "-385":  12.579,
    "-384":  12.588,
    "-383":  12.597,
    "-382":  12.601,
    "-381":  12.610,
    "-380":  12.619,
    "-379":  12.628,
    "-378":  12.636,
    "-377":  12.642,
    "-376":  12.652,
    "-375":  12.655,
    "-374":  12.665,
    "-373":  12.672,
    "-372":  12.681,
    "-371":  12.689,
    "-370":  12.698,
    "-369":  12.702,
    "-367":  12.718,
    "-366":  12.727,
    "-365":  12.735,
    "-363":  12.747,
    "-362":  12.753,
    "-361":  12.759,
    "-360":  12.768,
    "-359":  12.780,
    "-358":  12.782,
    "-357":  12.793,
    "-356":  12.800,
    "-353":  12.824,
    "-352":  12.832,
    "-350":  12.846,
    "-349":  12.856,
    "-348":  12.863,
    "-347":  12.871,
    "-346":  12.880,
    "-344":  12.892,
    "-343":  12.901,
    "-342":  12.910,
    "-341":  12.913,
    "-340":  12.922,
    "-339":  12.930,
    "-338":  12.936,
    "-337":  12.942,
    "-336":  12.951,
    "-335":  12.961,
    "-333":  12.974,
    "-331":  12.988,
    "-329":  13.008,
    "-327":  13.023,
    "-326":  13.027,
    "-324":  13.043,
    "-323":  13.052,
    "-322":  13.059,
    "-321":  13.064,
    "-320":  13.068,
    "-319":  13.079,
    "-318":  13.088,
    "-317":  13.097,
    "-316":  13.104,
    "-315":  13.109,
    "-314":  13.118,
    "-313":  13.127,
    "-312":  13.130,
    "-311":  13.139,
    "-310":  13.148,
    "-309":  13.151,
    "-306":  13.174,
    "-305":  13.183,
    "-304":  13.190,
    "-303":  13.198,
    "-302":  13.207,
    "-301":  13.213,
    "-300":  13.220,
    "-299":  13.229,
    "-298":  13.232,
    "-296":  13.249,
    "-295":  13.258,
    "-294":  13.262,
    "-293":  13.270,
    "-292":  13.279,
    "-291":  13.288,
    "-290":  13.291,
    "-289":  13.300,
    "-288":  13.305,
    "-287":  13.312,
    "-286":  13.323,
    "-285":  13.327,
    "-283":  13.34,
    "-281":  13.360,
    "-280":  13.366,
    "-279":  13.374,
    "-278":  13.380,
    "-277":  13.386,
    "-275":  13.404,
    "-273":  13.418,
    "-272":  13.424,
    "-271":  13.430,
    "-270":  13.437,
    "-269":  13.443,
    "-268":  13.451,
    "-267":  13.455,
    "-266":  13.469,
    "-265":  13.475,
    "-264":  13.481,
    "-263":  13.487,
    "-262":  13.493,
    "-261":  13.500,
    "-260":  13.510,
    "-258":  13.520,
    "-257":  13.532,
    "-256":  13.538,
    "-255":  13.549,
    "-254":  13.555,
    "-253":  13.561,
    "-252":  13.567,
    "-251":  13.576,
    "-250":  13.582,
    "-249":  13.591,
    "-248":  13.595,
    "-247":  13.604,
    "-246":  13.609,
    "-245":  13.618,
    "-243":  13.630,
    "-242":  13.639,
    "-240":  13.652,
    "-239":  13.661,
    "-237":  13.674,
    "-235":  13.687,
    "-234":  13.696,
    "-233":  13.704,
    "-232":  13.708,
    "-231":  13.717,
    "-230":  13.726,
    "-229":  13.729,
    "-228":  13.738,
    "-227":  13.747,
    "-226":  13.752,
    "-225":  13.761,
    "-224":  13.766,
    "-222":  13.776,
    "-221":  13.785,
    "-220":  13.796,
    "-219":  13.802,
    "-218":  13.807,
    "-217":  13.812,
    "-216":  13.821,
    "-215":  13.827,
    "-214":  13.832,
    "-213":  13.844,
    "-212":  13.847,
    "-211":  13.856,
    "-210":  13.863,
    "-209":  13.872,
    "-208":  13.880,
    "-207":  13.888,
    "-203":  13.916,
    "-202":  13.923,
    "-201":  13.924,
    "-199":  13.940,
    "-198":  13.949,
    "-197":  13.951,
    "-196":  13.958,
    "-194":  13.975,
    "-193":  13.985,
    "-192":  13.990,
    "-191":  13.999,
    "-189":  14.012,
    "-188":  14.017,
    "-187":  14.023,
    "-186":  14.032,
    "-184":  14.041,
    "-183":  14.049,
    "-182":  14.059,
    "-181":  14.068,
    "-180":  14.076,
    "-179":  14.083,
    "-177":  14.092,
    "-176":  14.101,
    "-175":  14.109,
    "-173":  14.124,
    "-172":  14.129,
    "-170":  14.142,
    "-169":  14.151,
    "-168":  14.157,
    "-167":  14.166,
    "-166":  14.171,
    "-165":  14.18,
    "-163":  14.193,
    "-162":  14.196,
    "-161":  14.204,
    "-160":  14.213,
    "-159":  14.219,
    "-157":  14.235,
    "-156":  14.243,
    "-155":  14.248,
    "-154":  14.256,
    "-152":  14.270,
    "-151":  14.279,
    "-150":  14.283,
    "-149":  14.293,
    "-148":  14.300,
    "-147":  14.305,
    "-146":  14.311,
    "-145":  14.32,
    "-144":  14.324,
    "-143":  14.333,
    "-142":  14.341,
    "-141":  14.350,
    "-140":  14.357,
    "-139":  14.361,
    "-138":  14.371,
    "-137":  14.375,
    "-136":  14.384,
    "-135":  14.392,
    "-134":  14.398,
    "-133":  14.407,
    "-132":  14.415,
    "-131":  14.421,
    "-130":  14.424,
    "-129":  14.430,
    "-128":  14.439,
    "-127":  14.446,
    "-126":  14.454,
    "-125":  14.461,
    "-124":  14.466,
    "-123":  14.475,
    "-122":  14.481,
    "-121":  14.490,
    "-120":  14.497,
    "-119":  14.508,
    "-118":  14.512,
    "-117":  14.521,
    "-116":  14.526,
    "-115":  14.530,
    "-114":  14.543,
    "-113":  14.549,
    "-112":  14.556,
    "-111":  14.558,
    "-110":  14.565,
    "-109":  14.573,
    "-108":  14.580,
    "-107":  14.592,
    "-106":  14.598,
    "-105":  14.607,
    "-104":  14.612,
    "-103":  14.621,
    "-102":  14.628,
    "-101":  14.633,
    "-100":  14.642,
    "-98":  14.655,
    "-97":  14.666,
    "-96":  14.671,
    "-95":  14.680,
    "-94":  14.686,
    "-93":  14.695,
    "-92":  14.702,
    "-91":  14.71,
    "-90":  14.715,
    "-89":  14.719,
    "-88":  14.725,
    "-87":  14.734,
    "-86":  14.746,
    "-85":  14.752,
    "-84":  14.761,
    "-82":  14.776,
    "-80":  14.791,
    "-79":  14.799,
    "-78":  14.802,
    "-77":  14.808,
    "-76":  14.817,
    "-74":  14.832,
    "-73":  14.839,
    "-72":  14.848,
    "-71":  14.857,
    "-70":  14.857,
    "-69":  14.865,
    "-68":  14.874,
    "-67":  14.881,
    "-66":  14.889,
    "-65":  14.896,
    "-64":  14.904,
    "-63":  14.913,
    "-62":  14.918,
    "-61":  14.925,
    "-60":  14.936,
    "-59":  14.943,
    "-58":  14.952,
    "-56":  14.969,
    "-55":  14.975,
    "-54":  14.983,
    "-52":  14.991,
    "-51":  15.000,
    "-50":  15.008,
    "-49":  15.017,
    "-48":  15.024,
    "-47":  15.033,
    "-46":  15.040,
    "-45":  15.043,
    "-44":  15.056,
    "-43":  15.061,
    "-42":  15.070,
    "-41":  15.079,
    "-40":  15.085,
    "-38":  15.100,
    "-37":  15.109,
    "-36":  15.117,
    "-35":  15.118,
    "-34":  15.127,
    "-33":  15.134,
    "-32":  15.142,
    "-31":  15.151,
    "-30":  15.158,
    "-29":  15.168,
    "-28":  15.177,
    "-27":  15.180,
    "-26":  15.189,
    "-25":  15.195,
    "-24":  15.204,
    "-23":  15.213,
    "-22":  15.222,
    "-21":  15.229,
    "-20":  15.238,
    "-18":  15.255,
    "-17":  15.261,
    "-16":  15.269,
    "-15":  15.276,
    "-14":  15.280,
    "-13":  15.290,
    "-12":  15.299,
    "-11":  15.306,
    "-10":  15.314,
    "-9":  15.320,
    "-8":  15.327,
    "-7":  15.336,
    "-6":  15.344,
    "-5":  15.353,
    "-4":  15.359,
    "-3":  15.368,
    "-1":  15.381,
    "-1200":  0,
    "-1199":  0.621,
    "-1198":  0.762,
    "-1197":  0.879,
    "-1196":  0.977,
    "-1195":  1.078,
    "-1194":  1.160,
    "-1193":  1.234,
    "-1192":  1.319,
    "-1191":  1.388,
    "-1190":  1.457,
    "-1189":  1.526,
    "-1188":  1.575,
    "-1187":  1.646,
    "-1186":  1.706,
    "-1185":  1.759,
    "-1184":  1.811,
    "-1183":  1.864,
    "-1182":  1.920,
    "-1181":  1.965,
    "-1180":  2.013,
    "-1179":  2.060,
    "-1178":  2.088,
    "-1177":  2.148,
    "-1176":  2.195,
    "-1175":  2.242,
    "-1174":  2.281,
    "-1173":  2.323,
    "-1172":  2.365,
    "-1171":  2.408,
    "-1170":  2.448,
    "-1169":  2.487,
    "-1168":  2.527,
    "-1167":  2.567,
    "-1166":  2.597,
    "-1165":  2.638,
    "-1164":  2.676,
    "-1163":  2.710,
    "-1162":  2.75,
    "-1161":  2.782,
    "-1160":  2.817,
    "-1159":  2.853,
    "-1158":  2.884,
    "-1157":  2.918,
    "-1156":  2.952,
    "-1155":  2.983,
    "-1154":  3.018,
    "-1153":  3.049,
    "-1152":  3.080,
    "-1151":  3.111,
    "-1150":  3.141,
    "-1149":  3.171,
    "-1148":  3.205,
    "-1147":  3.236,
    "-1146":  3.262,
    "-1145":  3.292,
    "-1144":  3.323,
    "-1143":  3.352,
    "-1142":  3.382,
    "-1141":  3.408,
    "-1140":  3.437,
    "-1139":  3.462,
    "-1138":  3.494,
    "-1137":  3.520,
    "-1136":  3.540,
    "-1135":  3.568,
    "-1134":  3.604,
    "-1133":  3.626,
    "-1132":  3.658,
    "-1131":  3.681,
    "-1130":  3.706,
    "-1129":  3.734,
    "-1128":  3.762,
    "-1127":  3.788,
    "-1126":  3.814,
    "-1125":  3.839,
    "-1124":  3.861,
    "-1123":  3.887,
    "-1122":  3.913,
    "-1121":  3.939,
    "-1120":  3.960,
    "-1119":  3.986,
    "-1118":  4.011,
    "-1117":  4.033,
    "-1116":  4.059,
    "-1115":  4.082,
    "-1114":  4.103,
    "-1113":  4.128,
    "-1112":  4.150,
    "-1111":  4.177,
    "-1110":  4.198,
    "-1109":  4.224,
    "-1108":  4.245,
    "-1107":  4.267,
    "-1106":  4.289,
    "-1105":  4.315,
    "-1104":  4.335,
    "-1103":  4.359,
    "-1102":  4.378,
    "-1101":  4.400,
    "-1100":  4.424,
    "-1099":  4.448,
    "-1098":  4.464,
    "-1097":  4.487,
    "-1096":  4.511,
    "-1095":  4.527,
    "-1094":  4.549,
    "-1093":  4.575,
    "-1092":  4.594,
    "-1091":  4.616,
    "-1090":  4.637,
    "-1089":  4.661,
    "-1088":  4.68,
    "-1087":  4.700,
    "-1086":  4.721,
    "-1085":  4.741,
    "-1084":  4.763,
    "-1083":  4.778,
    "-1082":  4.803,
    "-1081":  4.823,
    "-1080":  4.838,
    "-1079":  4.861,
    "-1078":  4.882,
    "-1077":  4.903,
    "-1076":  4.921,
    "-1075":  4.942,
    "-1074":  4.963,
    "-1073":  4.981,
    "-1072":  5.003,
    "-1071":  5.020,
    "-1070":  5.041,
    "-1069":  5.059,
    "-1068":  5.076,
    "-1067":  5.097,
    "-1066":  5.114,
    "-1065":  5.135,
    "-1064":  5.152,
    "-1063":  5.173,
    "-1062":  5.189,
    "-1061":  5.210,
    "-1060":  5.227,
    "-1059":  5.245,
    "-1058":  5.266,
    "-1057":  5.283,
    "-1056":  5.300,
    "-1055":  5.318,
    "-1054":  5.340,
    "-1053":  5.357,
    "-1052":  5.375,
    "-1051":  5.393,
    "-1050":  5.410,
    "-1049":  5.427,
    "-1048":  5.445,
    "-1047":  5.464,
    "-1046":  5.481,
    "-1045":  5.5,
    "-1044":  5.516,
    "-1043":  5.533,
    "-1042":  5.550,
    "-1041":  5.571,
    "-1040":  5.583,
    "-1039":  5.603,
    "-1038":  5.620,
    "-1037":  5.640,
    "-1036":  5.653,
    "-1035":  5.660,
    "-1034":  5.68,
    "-1033":  5.701,
    "-1032":  5.719,
    "-1031":  5.736,
    "-1030":  5.753,
    "-1029":  5.770,
    "-1028":  5.786,
    "-1027":  5.803,
    "-1026":  5.82,
    "-986":  6.458,
    "-917":  7.422,
    "-872":  7.987,
    "-871": 8,
    "-856":  8.181,
    "-761":  9.229,
    "-742":  9.433,
    "-728":  9.576,
    "-702":  9.834,
    "-609":  10.714,
    "-594":  10.852,
    "-554":  11.202,
    "-552":  11.220,
    "-543":  11.296,
    "-506":  11.610,
    "-504":  11.628,
    "-502":  11.641,
    "-500":  11.658,
    "-488":  11.759,
    "-464":  11.957,
    "-462":  11.974,
    "-417":  12.327,
    "-408":  12.399,
    "-406":  12.415,
    "-368":  12.710,
    "-364":  12.739,
    "-355":  12.811,
    "-354":  12.815,
    "-351":  12.841,
    "-345":  12.884,
    "-334":  12.970,
    "-330":  12.997,
    "-328":  13.008,
    "-325":  13.038,
    "-308":  13.160,
    "-307":  13.168,
    "-297":  13.241,
    "-282":  13.353,
    "-276":  13.392,
    "-274":  13.410,
    "-259":  13.517,
    "-244":  13.625,
    "-241":  13.648,
    "-238":  13.666,
    "-236":  13.683,
    "-205":  13.896,
    "-204":  13.907,
    "-200":  13.933,
    "-195":  13.969,
    "-190":  14.003,
    "-185":  14.040,
    "-178":  14.085,
    "-174":  14.118,
    "-171":  14.134,
    "-164":  14.184,
    "-99":  14.651,
    "-83":  14.767,
    "-75":  14.823,
    "-57":  14.96,
    "-53":  14.984,
    "-39":  15.094,
    "-19":  15.246,
    "-669":  10.156,
    "-434":  12.196,
    "-332":  12.981,
    "-284":  13.336,
    "-206":  13.889,
    "-158":  14.228,
    "-153":  14.261,
    "-81":  14.782,
};


module.exports = timing;
},{}],20:[function(require,module,exports){
/*!
 * headroom.js v0.7.0 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

!function(a,b){"use strict";function c(a){this.callback=a,this.ticking=!1}function d(b){return b&&"undefined"!=typeof a&&(b===a||b.nodeType)}function e(a){if(arguments.length<=0)throw new Error("Missing arguments in extend function");var b,c,f=a||{};for(c=1;c<arguments.length;c++){var g=arguments[c]||{};for(b in g)f[b]="object"!=typeof f[b]||d(f[b])?f[b]||g[b]:e(f[b],g[b])}return f}function f(a){return a===Object(a)?a:{down:a,up:a}}function g(a,b){b=e(b,g.options),this.lastKnownScrollY=0,this.elem=a,this.debouncer=new c(this.update.bind(this)),this.tolerance=f(b.tolerance),this.classes=b.classes,this.offset=b.offset,this.scroller=b.scroller,this.initialised=!1,this.onPin=b.onPin,this.onUnpin=b.onUnpin,this.onTop=b.onTop,this.onNotTop=b.onNotTop}var h={bind:!!function(){}.bind,classList:"classList"in b.documentElement,rAF:!!(a.requestAnimationFrame||a.webkitRequestAnimationFrame||a.mozRequestAnimationFrame)};a.requestAnimationFrame=a.requestAnimationFrame||a.webkitRequestAnimationFrame||a.mozRequestAnimationFrame,c.prototype={constructor:c,update:function(){this.callback&&this.callback(),this.ticking=!1},requestTick:function(){this.ticking||(requestAnimationFrame(this.rafCallback||(this.rafCallback=this.update.bind(this))),this.ticking=!0)},handleEvent:function(){this.requestTick()}},g.prototype={constructor:g,init:function(){return g.cutsTheMustard?(this.elem.classList.add(this.classes.initial),setTimeout(this.attachEvent.bind(this),100),this):void 0},destroy:function(){var a=this.classes;this.initialised=!1,this.elem.classList.remove(a.unpinned,a.pinned,a.top,a.initial),this.scroller.removeEventListener("scroll",this.debouncer,!1)},attachEvent:function(){this.initialised||(this.lastKnownScrollY=this.getScrollY(),this.initialised=!0,this.scroller.addEventListener("scroll",this.debouncer,!1),this.debouncer.handleEvent())},unpin:function(){var a=this.elem.classList,b=this.classes;(a.contains(b.pinned)||!a.contains(b.unpinned))&&(a.add(b.unpinned),a.remove(b.pinned),this.onUnpin&&this.onUnpin.call(this))},pin:function(){var a=this.elem.classList,b=this.classes;a.contains(b.unpinned)&&(a.remove(b.unpinned),a.add(b.pinned),this.onPin&&this.onPin.call(this))},top:function(){var a=this.elem.classList,b=this.classes;a.contains(b.top)||(a.add(b.top),a.remove(b.notTop),this.onTop&&this.onTop.call(this))},notTop:function(){var a=this.elem.classList,b=this.classes;a.contains(b.notTop)||(a.add(b.notTop),a.remove(b.top),this.onNotTop&&this.onNotTop.call(this))},getScrollY:function(){return void 0!==this.scroller.pageYOffset?this.scroller.pageYOffset:void 0!==this.scroller.scrollTop?this.scroller.scrollTop:(b.documentElement||b.body.parentNode||b.body).scrollTop},getViewportHeight:function(){return a.innerHeight||b.documentElement.clientHeight||b.body.clientHeight},getDocumentHeight:function(){var a=b.body,c=b.documentElement;return Math.max(a.scrollHeight,c.scrollHeight,a.offsetHeight,c.offsetHeight,a.clientHeight,c.clientHeight)},getElementHeight:function(a){return Math.max(a.scrollHeight,a.offsetHeight,a.clientHeight)},getScrollerHeight:function(){return this.scroller===a||this.scroller===b.body?this.getDocumentHeight():this.getElementHeight(this.scroller)},isOutOfBounds:function(a){var b=0>a,c=a+this.getViewportHeight()>this.getScrollerHeight();return b||c},toleranceExceeded:function(a,b){return Math.abs(a-this.lastKnownScrollY)>=this.tolerance[b]},shouldUnpin:function(a,b){var c=a>this.lastKnownScrollY,d=a>=this.offset;return c&&d&&b},shouldPin:function(a,b){var c=a<this.lastKnownScrollY,d=a<=this.offset;return c&&b||d},update:function(){var a=this.getScrollY(),b=a>this.lastKnownScrollY?"down":"up",c=this.toleranceExceeded(a,b);this.isOutOfBounds(a)||(a<=this.offset?this.top():this.notTop(),this.shouldUnpin(a,c)?this.unpin():this.shouldPin(a,c)&&this.pin(),this.lastKnownScrollY=a)}},g.options={tolerance:{up:0,down:0},offset:0,scroller:a,classes:{pinned:"headroom--pinned",unpinned:"headroom--unpinned",top:"headroom--top",notTop:"headroom--not-top",initial:"headroom"}},g.cutsTheMustard="undefined"!=typeof h&&h.rAF&&h.bind&&h.classList,a.Headroom=g}(window,document);

/*!
 * headroom.js v0.7.0 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

!function(a){a&&(a.fn.headroom=function(b){return this.each(function(){var c=a(this),d=c.data("headroom"),e="object"==typeof b&&b;e=a.extend(!0,{},Headroom.options,e),d||(d=new Headroom(this,e),d.init(),c.data("headroom",d)),"string"==typeof b&&d[b]()})},a("[data-headroom]").each(function(){var b=a(this);b.headroom(b.data())}))}(window.Zepto||window.jQuery);

},{}],21:[function(require,module,exports){
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-canvas-touchevents-webgl-setclasses !*/
 !function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in d)if(d.hasOwnProperty(l)){if(e=[],n=d[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,d,c="modernizr",p=i("div"),v=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:c+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+c,(v.fake?v:p).appendChild(a),v.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=c,v.fake&&(v.style.background="",v.style.overflow="hidden",d=u.style.overflow,u.style.overflow="hidden",u.appendChild(v)),l=t(p,e),v.fake?(v.parentNode.removeChild(v),u.style.overflow=d,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],d=[],c={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){d.push({name:e,fn:n,options:t})},addAsyncTest:function(e){d.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=c,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase();Modernizr.addTest("webgl",function(){var n=i("canvas"),t="probablySupportsContext"in n?"probablySupportsContext":"supportsContext";return t in n?n[t]("webgl")||n[t]("experimental-webgl"):"WebGLRenderingContext"in e});var v=c._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];c._prefixes=v,Modernizr.addTest("canvas",function(){var e=i("canvas");return!(!e.getContext||!e.getContext("2d"))});var h=c.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",v.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");h(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete c.addTest,delete c.addAsyncTest;for(var m=0;m<Modernizr._q.length;m++)Modernizr._q[m]();e.Modernizr=Modernizr}(window,document);
},{}],22:[function(require,module,exports){
/**
 * dat-gui JavaScript Controller Library
 * http://code.google.com/p/dat-gui
 *
 * Copyright 2011 Data Arts Team, Google Creative Lab
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.dat = {})));
}(this, (function (exports) { 'use strict';

function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);

  return css;
}

function colorToString (color, forceCSSHex) {
  var colorFormat = color.__state.conversionName.toString();
  var r = Math.round(color.r);
  var g = Math.round(color.g);
  var b = Math.round(color.b);
  var a = color.a;
  var h = Math.round(color.h);
  var s = color.s.toFixed(1);
  var v = color.v.toFixed(1);
  if (forceCSSHex || colorFormat === 'THREE_CHAR_HEX' || colorFormat === 'SIX_CHAR_HEX') {
    var str = color.hex.toString(16);
    while (str.length < 6) {
      str = '0' + str;
    }
    return '#' + str;
  } else if (colorFormat === 'CSS_RGB') {
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  } else if (colorFormat === 'CSS_RGBA') {
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
  } else if (colorFormat === 'HEX') {
    return '0x' + color.hex.toString(16);
  } else if (colorFormat === 'RGB_ARRAY') {
    return '[' + r + ',' + g + ',' + b + ']';
  } else if (colorFormat === 'RGBA_ARRAY') {
    return '[' + r + ',' + g + ',' + b + ',' + a + ']';
  } else if (colorFormat === 'RGB_OBJ') {
    return '{r:' + r + ',g:' + g + ',b:' + b + '}';
  } else if (colorFormat === 'RGBA_OBJ') {
    return '{r:' + r + ',g:' + g + ',b:' + b + ',a:' + a + '}';
  } else if (colorFormat === 'HSV_OBJ') {
    return '{h:' + h + ',s:' + s + ',v:' + v + '}';
  } else if (colorFormat === 'HSVA_OBJ') {
    return '{h:' + h + ',s:' + s + ',v:' + v + ',a:' + a + '}';
  }
  return 'unknown format';
}

var ARR_EACH = Array.prototype.forEach;
var ARR_SLICE = Array.prototype.slice;
var Common = {
  BREAK: {},
  extend: function extend(target) {
    this.each(ARR_SLICE.call(arguments, 1), function (obj) {
      var keys = this.isObject(obj) ? Object.keys(obj) : [];
      keys.forEach(function (key) {
        if (!this.isUndefined(obj[key])) {
          target[key] = obj[key];
        }
      }.bind(this));
    }, this);
    return target;
  },
  defaults: function defaults(target) {
    this.each(ARR_SLICE.call(arguments, 1), function (obj) {
      var keys = this.isObject(obj) ? Object.keys(obj) : [];
      keys.forEach(function (key) {
        if (this.isUndefined(target[key])) {
          target[key] = obj[key];
        }
      }.bind(this));
    }, this);
    return target;
  },
  compose: function compose() {
    var toCall = ARR_SLICE.call(arguments);
    return function () {
      var args = ARR_SLICE.call(arguments);
      for (var i = toCall.length - 1; i >= 0; i--) {
        args = [toCall[i].apply(this, args)];
      }
      return args[0];
    };
  },
  each: function each(obj, itr, scope) {
    if (!obj) {
      return;
    }
    if (ARR_EACH && obj.forEach && obj.forEach === ARR_EACH) {
      obj.forEach(itr, scope);
    } else if (obj.length === obj.length + 0) {
      var key = void 0;
      var l = void 0;
      for (key = 0, l = obj.length; key < l; key++) {
        if (key in obj && itr.call(scope, obj[key], key) === this.BREAK) {
          return;
        }
      }
    } else {
      for (var _key in obj) {
        if (itr.call(scope, obj[_key], _key) === this.BREAK) {
          return;
        }
      }
    }
  },
  defer: function defer(fnc) {
    setTimeout(fnc, 0);
  },
  debounce: function debounce(func, threshold, callImmediately) {
    var timeout = void 0;
    return function () {
      var obj = this;
      var args = arguments;
      function delayed() {
        timeout = null;
        if (!callImmediately) func.apply(obj, args);
      }
      var callNow = callImmediately || !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(delayed, threshold);
      if (callNow) {
        func.apply(obj, args);
      }
    };
  },
  toArray: function toArray(obj) {
    if (obj.toArray) return obj.toArray();
    return ARR_SLICE.call(obj);
  },
  isUndefined: function isUndefined(obj) {
    return obj === undefined;
  },
  isNull: function isNull(obj) {
    return obj === null;
  },
  isNaN: function (_isNaN) {
    function isNaN(_x) {
      return _isNaN.apply(this, arguments);
    }
    isNaN.toString = function () {
      return _isNaN.toString();
    };
    return isNaN;
  }(function (obj) {
    return isNaN(obj);
  }),
  isArray: Array.isArray || function (obj) {
    return obj.constructor === Array;
  },
  isObject: function isObject(obj) {
    return obj === Object(obj);
  },
  isNumber: function isNumber(obj) {
    return obj === obj + 0;
  },
  isString: function isString(obj) {
    return obj === obj + '';
  },
  isBoolean: function isBoolean(obj) {
    return obj === false || obj === true;
  },
  isFunction: function isFunction(obj) {
    return obj instanceof Function;
  }
};

var INTERPRETATIONS = [
{
  litmus: Common.isString,
  conversions: {
    THREE_CHAR_HEX: {
      read: function read(original) {
        var test = original.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
        if (test === null) {
          return false;
        }
        return {
          space: 'HEX',
          hex: parseInt('0x' + test[1].toString() + test[1].toString() + test[2].toString() + test[2].toString() + test[3].toString() + test[3].toString(), 0)
        };
      },
      write: colorToString
    },
    SIX_CHAR_HEX: {
      read: function read(original) {
        var test = original.match(/^#([A-F0-9]{6})$/i);
        if (test === null) {
          return false;
        }
        return {
          space: 'HEX',
          hex: parseInt('0x' + test[1].toString(), 0)
        };
      },
      write: colorToString
    },
    CSS_RGB: {
      read: function read(original) {
        var test = original.match(/^rgb\(\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*\)/);
        if (test === null) {
          return false;
        }
        return {
          space: 'RGB',
          r: parseFloat(test[1]),
          g: parseFloat(test[2]),
          b: parseFloat(test[3])
        };
      },
      write: colorToString
    },
    CSS_RGBA: {
      read: function read(original) {
        var test = original.match(/^rgba\(\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*\)/);
        if (test === null) {
          return false;
        }
        return {
          space: 'RGB',
          r: parseFloat(test[1]),
          g: parseFloat(test[2]),
          b: parseFloat(test[3]),
          a: parseFloat(test[4])
        };
      },
      write: colorToString
    }
  }
},
{
  litmus: Common.isNumber,
  conversions: {
    HEX: {
      read: function read(original) {
        return {
          space: 'HEX',
          hex: original,
          conversionName: 'HEX'
        };
      },
      write: function write(color) {
        return color.hex;
      }
    }
  }
},
{
  litmus: Common.isArray,
  conversions: {
    RGB_ARRAY: {
      read: function read(original) {
        if (original.length !== 3) {
          return false;
        }
        return {
          space: 'RGB',
          r: original[0],
          g: original[1],
          b: original[2]
        };
      },
      write: function write(color) {
        return [color.r, color.g, color.b];
      }
    },
    RGBA_ARRAY: {
      read: function read(original) {
        if (original.length !== 4) return false;
        return {
          space: 'RGB',
          r: original[0],
          g: original[1],
          b: original[2],
          a: original[3]
        };
      },
      write: function write(color) {
        return [color.r, color.g, color.b, color.a];
      }
    }
  }
},
{
  litmus: Common.isObject,
  conversions: {
    RGBA_OBJ: {
      read: function read(original) {
        if (Common.isNumber(original.r) && Common.isNumber(original.g) && Common.isNumber(original.b) && Common.isNumber(original.a)) {
          return {
            space: 'RGB',
            r: original.r,
            g: original.g,
            b: original.b,
            a: original.a
          };
        }
        return false;
      },
      write: function write(color) {
        return {
          r: color.r,
          g: color.g,
          b: color.b,
          a: color.a
        };
      }
    },
    RGB_OBJ: {
      read: function read(original) {
        if (Common.isNumber(original.r) && Common.isNumber(original.g) && Common.isNumber(original.b)) {
          return {
            space: 'RGB',
            r: original.r,
            g: original.g,
            b: original.b
          };
        }
        return false;
      },
      write: function write(color) {
        return {
          r: color.r,
          g: color.g,
          b: color.b
        };
      }
    },
    HSVA_OBJ: {
      read: function read(original) {
        if (Common.isNumber(original.h) && Common.isNumber(original.s) && Common.isNumber(original.v) && Common.isNumber(original.a)) {
          return {
            space: 'HSV',
            h: original.h,
            s: original.s,
            v: original.v,
            a: original.a
          };
        }
        return false;
      },
      write: function write(color) {
        return {
          h: color.h,
          s: color.s,
          v: color.v,
          a: color.a
        };
      }
    },
    HSV_OBJ: {
      read: function read(original) {
        if (Common.isNumber(original.h) && Common.isNumber(original.s) && Common.isNumber(original.v)) {
          return {
            space: 'HSV',
            h: original.h,
            s: original.s,
            v: original.v
          };
        }
        return false;
      },
      write: function write(color) {
        return {
          h: color.h,
          s: color.s,
          v: color.v
        };
      }
    }
  }
}];
var result = void 0;
var toReturn = void 0;
var interpret = function interpret() {
  toReturn = false;
  var original = arguments.length > 1 ? Common.toArray(arguments) : arguments[0];
  Common.each(INTERPRETATIONS, function (family) {
    if (family.litmus(original)) {
      Common.each(family.conversions, function (conversion, conversionName) {
        result = conversion.read(original);
        if (toReturn === false && result !== false) {
          toReturn = result;
          result.conversionName = conversionName;
          result.conversion = conversion;
          return Common.BREAK;
        }
      });
      return Common.BREAK;
    }
  });
  return toReturn;
};

var tmpComponent = void 0;
var ColorMath = {
  hsv_to_rgb: function hsv_to_rgb(h, s, v) {
    var hi = Math.floor(h / 60) % 6;
    var f = h / 60 - Math.floor(h / 60);
    var p = v * (1.0 - s);
    var q = v * (1.0 - f * s);
    var t = v * (1.0 - (1.0 - f) * s);
    var c = [[v, t, p], [q, v, p], [p, v, t], [p, q, v], [t, p, v], [v, p, q]][hi];
    return {
      r: c[0] * 255,
      g: c[1] * 255,
      b: c[2] * 255
    };
  },
  rgb_to_hsv: function rgb_to_hsv(r, g, b) {
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h = void 0;
    var s = void 0;
    if (max !== 0) {
      s = delta / max;
    } else {
      return {
        h: NaN,
        s: 0,
        v: 0
      };
    }
    if (r === max) {
      h = (g - b) / delta;
    } else if (g === max) {
      h = 2 + (b - r) / delta;
    } else {
      h = 4 + (r - g) / delta;
    }
    h /= 6;
    if (h < 0) {
      h += 1;
    }
    return {
      h: h * 360,
      s: s,
      v: max / 255
    };
  },
  rgb_to_hex: function rgb_to_hex(r, g, b) {
    var hex = this.hex_with_component(0, 2, r);
    hex = this.hex_with_component(hex, 1, g);
    hex = this.hex_with_component(hex, 0, b);
    return hex;
  },
  component_from_hex: function component_from_hex(hex, componentIndex) {
    return hex >> componentIndex * 8 & 0xFF;
  },
  hex_with_component: function hex_with_component(hex, componentIndex, value) {
    return value << (tmpComponent = componentIndex * 8) | hex & ~(0xFF << tmpComponent);
  }
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Color = function () {
  function Color() {
    classCallCheck(this, Color);
    this.__state = interpret.apply(this, arguments);
    if (this.__state === false) {
      throw new Error('Failed to interpret color arguments');
    }
    this.__state.a = this.__state.a || 1;
  }
  createClass(Color, [{
    key: 'toString',
    value: function toString() {
      return colorToString(this);
    }
  }, {
    key: 'toHexString',
    value: function toHexString() {
      return colorToString(this, true);
    }
  }, {
    key: 'toOriginal',
    value: function toOriginal() {
      return this.__state.conversion.write(this);
    }
  }]);
  return Color;
}();
function defineRGBComponent(target, component, componentHexIndex) {
  Object.defineProperty(target, component, {
    get: function get$$1() {
      if (this.__state.space === 'RGB') {
        return this.__state[component];
      }
      Color.recalculateRGB(this, component, componentHexIndex);
      return this.__state[component];
    },
    set: function set$$1(v) {
      if (this.__state.space !== 'RGB') {
        Color.recalculateRGB(this, component, componentHexIndex);
        this.__state.space = 'RGB';
      }
      this.__state[component] = v;
    }
  });
}
function defineHSVComponent(target, component) {
  Object.defineProperty(target, component, {
    get: function get$$1() {
      if (this.__state.space === 'HSV') {
        return this.__state[component];
      }
      Color.recalculateHSV(this);
      return this.__state[component];
    },
    set: function set$$1(v) {
      if (this.__state.space !== 'HSV') {
        Color.recalculateHSV(this);
        this.__state.space = 'HSV';
      }
      this.__state[component] = v;
    }
  });
}
Color.recalculateRGB = function (color, component, componentHexIndex) {
  if (color.__state.space === 'HEX') {
    color.__state[component] = ColorMath.component_from_hex(color.__state.hex, componentHexIndex);
  } else if (color.__state.space === 'HSV') {
    Common.extend(color.__state, ColorMath.hsv_to_rgb(color.__state.h, color.__state.s, color.__state.v));
  } else {
    throw new Error('Corrupted color state');
  }
};
Color.recalculateHSV = function (color) {
  var result = ColorMath.rgb_to_hsv(color.r, color.g, color.b);
  Common.extend(color.__state, {
    s: result.s,
    v: result.v
  });
  if (!Common.isNaN(result.h)) {
    color.__state.h = result.h;
  } else if (Common.isUndefined(color.__state.h)) {
    color.__state.h = 0;
  }
};
Color.COMPONENTS = ['r', 'g', 'b', 'h', 's', 'v', 'hex', 'a'];
defineRGBComponent(Color.prototype, 'r', 2);
defineRGBComponent(Color.prototype, 'g', 1);
defineRGBComponent(Color.prototype, 'b', 0);
defineHSVComponent(Color.prototype, 'h');
defineHSVComponent(Color.prototype, 's');
defineHSVComponent(Color.prototype, 'v');
Object.defineProperty(Color.prototype, 'a', {
  get: function get$$1() {
    return this.__state.a;
  },
  set: function set$$1(v) {
    this.__state.a = v;
  }
});
Object.defineProperty(Color.prototype, 'hex', {
  get: function get$$1() {
    if (this.__state.space !== 'HEX') {
      this.__state.hex = ColorMath.rgb_to_hex(this.r, this.g, this.b);
      this.__state.space = 'HEX';
    }
    return this.__state.hex;
  },
  set: function set$$1(v) {
    this.__state.space = 'HEX';
    this.__state.hex = v;
  }
});

var Controller = function () {
  function Controller(object, property) {
    classCallCheck(this, Controller);
    this.initialValue = object[property];
    this.domElement = document.createElement('div');
    this.object = object;
    this.property = property;
    this.__onChange = undefined;
    this.__onFinishChange = undefined;
  }
  createClass(Controller, [{
    key: 'onChange',
    value: function onChange(fnc) {
      this.__onChange = fnc;
      return this;
    }
  }, {
    key: 'onFinishChange',
    value: function onFinishChange(fnc) {
      this.__onFinishChange = fnc;
      return this;
    }
  }, {
    key: 'setValue',
    value: function setValue(newValue) {
      this.object[this.property] = newValue;
      if (this.__onChange) {
        this.__onChange.call(this, newValue);
      }
      this.updateDisplay();
      return this;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.object[this.property];
    }
  }, {
    key: 'updateDisplay',
    value: function updateDisplay() {
      return this;
    }
  }, {
    key: 'isModified',
    value: function isModified() {
      return this.initialValue !== this.getValue();
    }
  }]);
  return Controller;
}();

var EVENT_MAP = {
  HTMLEvents: ['change'],
  MouseEvents: ['click', 'mousemove', 'mousedown', 'mouseup', 'mouseover'],
  KeyboardEvents: ['keydown']
};
var EVENT_MAP_INV = {};
Common.each(EVENT_MAP, function (v, k) {
  Common.each(v, function (e) {
    EVENT_MAP_INV[e] = k;
  });
});
var CSS_VALUE_PIXELS = /(\d+(\.\d+)?)px/;
function cssValueToPixels(val) {
  if (val === '0' || Common.isUndefined(val)) {
    return 0;
  }
  var match = val.match(CSS_VALUE_PIXELS);
  if (!Common.isNull(match)) {
    return parseFloat(match[1]);
  }
  return 0;
}
var dom = {
  makeSelectable: function makeSelectable(elem, selectable) {
    if (elem === undefined || elem.style === undefined) return;
    elem.onselectstart = selectable ? function () {
      return false;
    } : function () {};
    elem.style.MozUserSelect = selectable ? 'auto' : 'none';
    elem.style.KhtmlUserSelect = selectable ? 'auto' : 'none';
    elem.unselectable = selectable ? 'on' : 'off';
  },
  makeFullscreen: function makeFullscreen(elem, hor, vert) {
    var vertical = vert;
    var horizontal = hor;
    if (Common.isUndefined(horizontal)) {
      horizontal = true;
    }
    if (Common.isUndefined(vertical)) {
      vertical = true;
    }
    elem.style.position = 'absolute';
    if (horizontal) {
      elem.style.left = 0;
      elem.style.right = 0;
    }
    if (vertical) {
      elem.style.top = 0;
      elem.style.bottom = 0;
    }
  },
  fakeEvent: function fakeEvent(elem, eventType, pars, aux) {
    var params = pars || {};
    var className = EVENT_MAP_INV[eventType];
    if (!className) {
      throw new Error('Event type ' + eventType + ' not supported.');
    }
    var evt = document.createEvent(className);
    switch (className) {
      case 'MouseEvents':
        {
          var clientX = params.x || params.clientX || 0;
          var clientY = params.y || params.clientY || 0;
          evt.initMouseEvent(eventType, params.bubbles || false, params.cancelable || true, window, params.clickCount || 1, 0,
          0,
          clientX,
          clientY,
          false, false, false, false, 0, null);
          break;
        }
      case 'KeyboardEvents':
        {
          var init = evt.initKeyboardEvent || evt.initKeyEvent;
          Common.defaults(params, {
            cancelable: true,
            ctrlKey: false,
            altKey: false,
            shiftKey: false,
            metaKey: false,
            keyCode: undefined,
            charCode: undefined
          });
          init(eventType, params.bubbles || false, params.cancelable, window, params.ctrlKey, params.altKey, params.shiftKey, params.metaKey, params.keyCode, params.charCode);
          break;
        }
      default:
        {
          evt.initEvent(eventType, params.bubbles || false, params.cancelable || true);
          break;
        }
    }
    Common.defaults(evt, aux);
    elem.dispatchEvent(evt);
  },
  bind: function bind(elem, event, func, newBool) {
    var bool = newBool || false;
    if (elem.addEventListener) {
      elem.addEventListener(event, func, bool);
    } else if (elem.attachEvent) {
      elem.attachEvent('on' + event, func);
    }
    return dom;
  },
  unbind: function unbind(elem, event, func, newBool) {
    var bool = newBool || false;
    if (elem.removeEventListener) {
      elem.removeEventListener(event, func, bool);
    } else if (elem.detachEvent) {
      elem.detachEvent('on' + event, func);
    }
    return dom;
  },
  addClass: function addClass(elem, className) {
    if (elem.className === undefined) {
      elem.className = className;
    } else if (elem.className !== className) {
      var classes = elem.className.split(/ +/);
      if (classes.indexOf(className) === -1) {
        classes.push(className);
        elem.className = classes.join(' ').replace(/^\s+/, '').replace(/\s+$/, '');
      }
    }
    return dom;
  },
  removeClass: function removeClass(elem, className) {
    if (className) {
      if (elem.className === className) {
        elem.removeAttribute('class');
      } else {
        var classes = elem.className.split(/ +/);
        var index = classes.indexOf(className);
        if (index !== -1) {
          classes.splice(index, 1);
          elem.className = classes.join(' ');
        }
      }
    } else {
      elem.className = undefined;
    }
    return dom;
  },
  hasClass: function hasClass(elem, className) {
    return new RegExp('(?:^|\\s+)' + className + '(?:\\s+|$)').test(elem.className) || false;
  },
  getWidth: function getWidth(elem) {
    var style = getComputedStyle(elem);
    return cssValueToPixels(style['border-left-width']) + cssValueToPixels(style['border-right-width']) + cssValueToPixels(style['padding-left']) + cssValueToPixels(style['padding-right']) + cssValueToPixels(style.width);
  },
  getHeight: function getHeight(elem) {
    var style = getComputedStyle(elem);
    return cssValueToPixels(style['border-top-width']) + cssValueToPixels(style['border-bottom-width']) + cssValueToPixels(style['padding-top']) + cssValueToPixels(style['padding-bottom']) + cssValueToPixels(style.height);
  },
  getOffset: function getOffset(el) {
    var elem = el;
    var offset = { left: 0, top: 0 };
    if (elem.offsetParent) {
      do {
        offset.left += elem.offsetLeft;
        offset.top += elem.offsetTop;
        elem = elem.offsetParent;
      } while (elem);
    }
    return offset;
  },
  isActive: function isActive(elem) {
    return elem === document.activeElement && (elem.type || elem.href);
  }
};

var BooleanController = function (_Controller) {
  inherits(BooleanController, _Controller);
  function BooleanController(object, property) {
    classCallCheck(this, BooleanController);
    var _this2 = possibleConstructorReturn(this, (BooleanController.__proto__ || Object.getPrototypeOf(BooleanController)).call(this, object, property));
    var _this = _this2;
    _this2.__prev = _this2.getValue();
    _this2.__checkbox = document.createElement('input');
    _this2.__checkbox.setAttribute('type', 'checkbox');
    function onChange() {
      _this.setValue(!_this.__prev);
    }
    dom.bind(_this2.__checkbox, 'change', onChange, false);
    _this2.domElement.appendChild(_this2.__checkbox);
    _this2.updateDisplay();
    return _this2;
  }
  createClass(BooleanController, [{
    key: 'setValue',
    value: function setValue(v) {
      var toReturn = get(BooleanController.prototype.__proto__ || Object.getPrototypeOf(BooleanController.prototype), 'setValue', this).call(this, v);
      if (this.__onFinishChange) {
        this.__onFinishChange.call(this, this.getValue());
      }
      this.__prev = this.getValue();
      return toReturn;
    }
  }, {
    key: 'updateDisplay',
    value: function updateDisplay() {
      if (this.getValue() === true) {
        this.__checkbox.setAttribute('checked', 'checked');
        this.__checkbox.checked = true;
        this.__prev = true;
      } else {
        this.__checkbox.checked = false;
        this.__prev = false;
      }
      return get(BooleanController.prototype.__proto__ || Object.getPrototypeOf(BooleanController.prototype), 'updateDisplay', this).call(this);
    }
  }]);
  return BooleanController;
}(Controller);

var OptionController = function (_Controller) {
  inherits(OptionController, _Controller);
  function OptionController(object, property, opts) {
    classCallCheck(this, OptionController);
    var _this2 = possibleConstructorReturn(this, (OptionController.__proto__ || Object.getPrototypeOf(OptionController)).call(this, object, property));
    var options = opts;
    var _this = _this2;
    _this2.__select = document.createElement('select');
    if (Common.isArray(options)) {
      var map = {};
      Common.each(options, function (element) {
        map[element] = element;
      });
      options = map;
    }
    Common.each(options, function (value, key) {
      var opt = document.createElement('option');
      opt.innerHTML = key;
      opt.setAttribute('value', value);
      _this.__select.appendChild(opt);
    });
    _this2.updateDisplay();
    dom.bind(_this2.__select, 'change', function () {
      var desiredValue = this.options[this.selectedIndex].value;
      _this.setValue(desiredValue);
    });
    _this2.domElement.appendChild(_this2.__select);
    return _this2;
  }
  createClass(OptionController, [{
    key: 'setValue',
    value: function setValue(v) {
      var toReturn = get(OptionController.prototype.__proto__ || Object.getPrototypeOf(OptionController.prototype), 'setValue', this).call(this, v);
      if (this.__onFinishChange) {
        this.__onFinishChange.call(this, this.getValue());
      }
      return toReturn;
    }
  }, {
    key: 'updateDisplay',
    value: function updateDisplay() {
      if (dom.isActive(this.__select)) return this;
      this.__select.value = this.getValue();
      return get(OptionController.prototype.__proto__ || Object.getPrototypeOf(OptionController.prototype), 'updateDisplay', this).call(this);
    }
  }]);
  return OptionController;
}(Controller);

var StringController = function (_Controller) {
  inherits(StringController, _Controller);
  function StringController(object, property) {
    classCallCheck(this, StringController);
    var _this2 = possibleConstructorReturn(this, (StringController.__proto__ || Object.getPrototypeOf(StringController)).call(this, object, property));
    var _this = _this2;
    function onChange() {
      _this.setValue(_this.__input.value);
    }
    function onBlur() {
      if (_this.__onFinishChange) {
        _this.__onFinishChange.call(_this, _this.getValue());
      }
    }
    _this2.__input = document.createElement('input');
    _this2.__input.setAttribute('type', 'text');
    dom.bind(_this2.__input, 'keyup', onChange);
    dom.bind(_this2.__input, 'change', onChange);
    dom.bind(_this2.__input, 'blur', onBlur);
    dom.bind(_this2.__input, 'keydown', function (e) {
      if (e.keyCode === 13) {
        this.blur();
      }
    });
    _this2.updateDisplay();
    _this2.domElement.appendChild(_this2.__input);
    return _this2;
  }
  createClass(StringController, [{
    key: 'updateDisplay',
    value: function updateDisplay() {
      if (!dom.isActive(this.__input)) {
        this.__input.value = this.getValue();
      }
      return get(StringController.prototype.__proto__ || Object.getPrototypeOf(StringController.prototype), 'updateDisplay', this).call(this);
    }
  }]);
  return StringController;
}(Controller);

function numDecimals(x) {
  var _x = x.toString();
  if (_x.indexOf('.') > -1) {
    return _x.length - _x.indexOf('.') - 1;
  }
  return 0;
}
var NumberController = function (_Controller) {
  inherits(NumberController, _Controller);
  function NumberController(object, property, params) {
    classCallCheck(this, NumberController);
    var _this = possibleConstructorReturn(this, (NumberController.__proto__ || Object.getPrototypeOf(NumberController)).call(this, object, property));
    var _params = params || {};
    _this.__min = _params.min;
    _this.__max = _params.max;
    _this.__step = _params.step;
    if (Common.isUndefined(_this.__step)) {
      if (_this.initialValue === 0) {
        _this.__impliedStep = 1;
      } else {
        _this.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(_this.initialValue)) / Math.LN10)) / 10;
      }
    } else {
      _this.__impliedStep = _this.__step;
    }
    _this.__precision = numDecimals(_this.__impliedStep);
    return _this;
  }
  createClass(NumberController, [{
    key: 'setValue',
    value: function setValue(v) {
      var _v = v;
      if (this.__min !== undefined && _v < this.__min) {
        _v = this.__min;
      } else if (this.__max !== undefined && _v > this.__max) {
        _v = this.__max;
      }
      if (this.__step !== undefined && _v % this.__step !== 0) {
        _v = Math.round(_v / this.__step) * this.__step;
      }
      return get(NumberController.prototype.__proto__ || Object.getPrototypeOf(NumberController.prototype), 'setValue', this).call(this, _v);
    }
  }, {
    key: 'min',
    value: function min(minValue) {
      this.__min = minValue;
      return this;
    }
  }, {
    key: 'max',
    value: function max(maxValue) {
      this.__max = maxValue;
      return this;
    }
  }, {
    key: 'step',
    value: function step(stepValue) {
      this.__step = stepValue;
      this.__impliedStep = stepValue;
      this.__precision = numDecimals(stepValue);
      return this;
    }
  }]);
  return NumberController;
}(Controller);

function roundToDecimal(value, decimals) {
  var tenTo = Math.pow(10, decimals);
  return Math.round(value * tenTo) / tenTo;
}
var NumberControllerBox = function (_NumberController) {
  inherits(NumberControllerBox, _NumberController);
  function NumberControllerBox(object, property, params) {
    classCallCheck(this, NumberControllerBox);
    var _this2 = possibleConstructorReturn(this, (NumberControllerBox.__proto__ || Object.getPrototypeOf(NumberControllerBox)).call(this, object, property, params));
    _this2.__truncationSuspended = false;
    var _this = _this2;
    var prevY = void 0;
    function onChange() {
      var attempted = parseFloat(_this.__input.value);
      if (!Common.isNaN(attempted)) {
        _this.setValue(attempted);
      }
    }
    function onFinish() {
      if (_this.__onFinishChange) {
        _this.__onFinishChange.call(_this, _this.getValue());
      }
    }
    function onBlur() {
      onFinish();
    }
    function onMouseDrag(e) {
      var diff = prevY - e.clientY;
      _this.setValue(_this.getValue() + diff * _this.__impliedStep);
      prevY = e.clientY;
    }
    function onMouseUp() {
      dom.unbind(window, 'mousemove', onMouseDrag);
      dom.unbind(window, 'mouseup', onMouseUp);
      onFinish();
    }
    function onMouseDown(e) {
      dom.bind(window, 'mousemove', onMouseDrag);
      dom.bind(window, 'mouseup', onMouseUp);
      prevY = e.clientY;
    }
    _this2.__input = document.createElement('input');
    _this2.__input.setAttribute('type', 'text');
    dom.bind(_this2.__input, 'change', onChange);
    dom.bind(_this2.__input, 'blur', onBlur);
    dom.bind(_this2.__input, 'mousedown', onMouseDown);
    dom.bind(_this2.__input, 'keydown', function (e) {
      if (e.keyCode === 13) {
        _this.__truncationSuspended = true;
        this.blur();
        _this.__truncationSuspended = false;
        onFinish();
      }
    });
    _this2.updateDisplay();
    _this2.domElement.appendChild(_this2.__input);
    return _this2;
  }
  createClass(NumberControllerBox, [{
    key: 'updateDisplay',
    value: function updateDisplay() {
      this.__input.value = this.__truncationSuspended ? this.getValue() : roundToDecimal(this.getValue(), this.__precision);
      return get(NumberControllerBox.prototype.__proto__ || Object.getPrototypeOf(NumberControllerBox.prototype), 'updateDisplay', this).call(this);
    }
  }]);
  return NumberControllerBox;
}(NumberController);

function map(v, i1, i2, o1, o2) {
  return o1 + (o2 - o1) * ((v - i1) / (i2 - i1));
}
var NumberControllerSlider = function (_NumberController) {
  inherits(NumberControllerSlider, _NumberController);
  function NumberControllerSlider(object, property, min, max, step) {
    classCallCheck(this, NumberControllerSlider);
    var _this2 = possibleConstructorReturn(this, (NumberControllerSlider.__proto__ || Object.getPrototypeOf(NumberControllerSlider)).call(this, object, property, { min: min, max: max, step: step }));
    var _this = _this2;
    _this2.__background = document.createElement('div');
    _this2.__foreground = document.createElement('div');
    dom.bind(_this2.__background, 'mousedown', onMouseDown);
    dom.bind(_this2.__background, 'touchstart', onTouchStart);
    dom.addClass(_this2.__background, 'slider');
    dom.addClass(_this2.__foreground, 'slider-fg');
    function onMouseDown(e) {
      document.activeElement.blur();
      dom.bind(window, 'mousemove', onMouseDrag);
      dom.bind(window, 'mouseup', onMouseUp);
      onMouseDrag(e);
    }
    function onMouseDrag(e) {
      e.preventDefault();
      var bgRect = _this.__background.getBoundingClientRect();
      _this.setValue(map(e.clientX, bgRect.left, bgRect.right, _this.__min, _this.__max));
      return false;
    }
    function onMouseUp() {
      dom.unbind(window, 'mousemove', onMouseDrag);
      dom.unbind(window, 'mouseup', onMouseUp);
      if (_this.__onFinishChange) {
        _this.__onFinishChange.call(_this, _this.getValue());
      }
    }
    function onTouchStart(e) {
      if (e.touches.length !== 1) {
        return;
      }
      dom.bind(window, 'touchmove', onTouchMove);
      dom.bind(window, 'touchend', onTouchEnd);
      onTouchMove(e);
    }
    function onTouchMove(e) {
      var clientX = e.touches[0].clientX;
      var bgRect = _this.__background.getBoundingClientRect();
      _this.setValue(map(clientX, bgRect.left, bgRect.right, _this.__min, _this.__max));
    }
    function onTouchEnd() {
      dom.unbind(window, 'touchmove', onTouchMove);
      dom.unbind(window, 'touchend', onTouchEnd);
      if (_this.__onFinishChange) {
        _this.__onFinishChange.call(_this, _this.getValue());
      }
    }
    _this2.updateDisplay();
    _this2.__background.appendChild(_this2.__foreground);
    _this2.domElement.appendChild(_this2.__background);
    return _this2;
  }
  createClass(NumberControllerSlider, [{
    key: 'updateDisplay',
    value: function updateDisplay() {
      var pct = (this.getValue() - this.__min) / (this.__max - this.__min);
      this.__foreground.style.width = pct * 100 + '%';
      return get(NumberControllerSlider.prototype.__proto__ || Object.getPrototypeOf(NumberControllerSlider.prototype), 'updateDisplay', this).call(this);
    }
  }]);
  return NumberControllerSlider;
}(NumberController);

var FunctionController = function (_Controller) {
  inherits(FunctionController, _Controller);
  function FunctionController(object, property, text) {
    classCallCheck(this, FunctionController);
    var _this2 = possibleConstructorReturn(this, (FunctionController.__proto__ || Object.getPrototypeOf(FunctionController)).call(this, object, property));
    var _this = _this2;
    _this2.__button = document.createElement('div');
    _this2.__button.innerHTML = text === undefined ? 'Fire' : text;
    dom.bind(_this2.__button, 'click', function (e) {
      e.preventDefault();
      _this.fire();
      return false;
    });
    dom.addClass(_this2.__button, 'button');
    _this2.domElement.appendChild(_this2.__button);
    return _this2;
  }
  createClass(FunctionController, [{
    key: 'fire',
    value: function fire() {
      if (this.__onChange) {
        this.__onChange.call(this);
      }
      this.getValue().call(this.object);
      if (this.__onFinishChange) {
        this.__onFinishChange.call(this, this.getValue());
      }
    }
  }]);
  return FunctionController;
}(Controller);

var ColorController = function (_Controller) {
  inherits(ColorController, _Controller);
  function ColorController(object, property) {
    classCallCheck(this, ColorController);
    var _this2 = possibleConstructorReturn(this, (ColorController.__proto__ || Object.getPrototypeOf(ColorController)).call(this, object, property));
    _this2.__color = new Color(_this2.getValue());
    _this2.__temp = new Color(0);
    var _this = _this2;
    _this2.domElement = document.createElement('div');
    dom.makeSelectable(_this2.domElement, false);
    _this2.__selector = document.createElement('div');
    _this2.__selector.className = 'selector';
    _this2.__saturation_field = document.createElement('div');
    _this2.__saturation_field.className = 'saturation-field';
    _this2.__field_knob = document.createElement('div');
    _this2.__field_knob.className = 'field-knob';
    _this2.__field_knob_border = '2px solid ';
    _this2.__hue_knob = document.createElement('div');
    _this2.__hue_knob.className = 'hue-knob';
    _this2.__hue_field = document.createElement('div');
    _this2.__hue_field.className = 'hue-field';
    _this2.__input = document.createElement('input');
    _this2.__input.type = 'text';
    _this2.__input_textShadow = '0 1px 1px ';
    dom.bind(_this2.__input, 'keydown', function (e) {
      if (e.keyCode === 13) {
        onBlur.call(this);
      }
    });
    dom.bind(_this2.__input, 'blur', onBlur);
    dom.bind(_this2.__selector, 'mousedown', function ()        {
      dom.addClass(this, 'drag').bind(window, 'mouseup', function ()        {
        dom.removeClass(_this.__selector, 'drag');
      });
    });
    dom.bind(_this2.__selector, 'touchstart', function ()        {
      dom.addClass(this, 'drag').bind(window, 'touchend', function ()        {
        dom.removeClass(_this.__selector, 'drag');
      });
    });
    var valueField = document.createElement('div');
    Common.extend(_this2.__selector.style, {
      width: '122px',
      height: '102px',
      padding: '3px',
      backgroundColor: '#222',
      boxShadow: '0px 1px 3px rgba(0,0,0,0.3)'
    });
    Common.extend(_this2.__field_knob.style, {
      position: 'absolute',
      width: '12px',
      height: '12px',
      border: _this2.__field_knob_border + (_this2.__color.v < 0.5 ? '#fff' : '#000'),
      boxShadow: '0px 1px 3px rgba(0,0,0,0.5)',
      borderRadius: '12px',
      zIndex: 1
    });
    Common.extend(_this2.__hue_knob.style, {
      position: 'absolute',
      width: '15px',
      height: '2px',
      borderRight: '4px solid #fff',
      zIndex: 1
    });
    Common.extend(_this2.__saturation_field.style, {
      width: '100px',
      height: '100px',
      border: '1px solid #555',
      marginRight: '3px',
      display: 'inline-block',
      cursor: 'pointer'
    });
    Common.extend(valueField.style, {
      width: '100%',
      height: '100%',
      background: 'none'
    });
    linearGradient(valueField, 'top', 'rgba(0,0,0,0)', '#000');
    Common.extend(_this2.__hue_field.style, {
      width: '15px',
      height: '100px',
      border: '1px solid #555',
      cursor: 'ns-resize',
      position: 'absolute',
      top: '3px',
      right: '3px'
    });
    hueGradient(_this2.__hue_field);
    Common.extend(_this2.__input.style, {
      outline: 'none',
      textAlign: 'center',
      color: '#fff',
      border: 0,
      fontWeight: 'bold',
      textShadow: _this2.__input_textShadow + 'rgba(0,0,0,0.7)'
    });
    dom.bind(_this2.__saturation_field, 'mousedown', fieldDown);
    dom.bind(_this2.__saturation_field, 'touchstart', fieldDown);
    dom.bind(_this2.__field_knob, 'mousedown', fieldDown);
    dom.bind(_this2.__field_knob, 'touchstart', fieldDown);
    dom.bind(_this2.__hue_field, 'mousedown', fieldDownH);
    dom.bind(_this2.__hue_field, 'touchstart', fieldDownH);
    function fieldDown(e) {
      setSV(e);
      dom.bind(window, 'mousemove', setSV);
      dom.bind(window, 'touchmove', setSV);
      dom.bind(window, 'mouseup', fieldUpSV);
      dom.bind(window, 'touchend', fieldUpSV);
    }
    function fieldDownH(e) {
      setH(e);
      dom.bind(window, 'mousemove', setH);
      dom.bind(window, 'touchmove', setH);
      dom.bind(window, 'mouseup', fieldUpH);
      dom.bind(window, 'touchend', fieldUpH);
    }
    function fieldUpSV() {
      dom.unbind(window, 'mousemove', setSV);
      dom.unbind(window, 'touchmove', setSV);
      dom.unbind(window, 'mouseup', fieldUpSV);
      dom.unbind(window, 'touchend', fieldUpSV);
      onFinish();
    }
    function fieldUpH() {
      dom.unbind(window, 'mousemove', setH);
      dom.unbind(window, 'touchmove', setH);
      dom.unbind(window, 'mouseup', fieldUpH);
      dom.unbind(window, 'touchend', fieldUpH);
      onFinish();
    }
    function onBlur() {
      var i = interpret(this.value);
      if (i !== false) {
        _this.__color.__state = i;
        _this.setValue(_this.__color.toOriginal());
      } else {
        this.value = _this.__color.toString();
      }
    }
    function onFinish() {
      if (_this.__onFinishChange) {
        _this.__onFinishChange.call(_this, _this.__color.toOriginal());
      }
    }
    _this2.__saturation_field.appendChild(valueField);
    _this2.__selector.appendChild(_this2.__field_knob);
    _this2.__selector.appendChild(_this2.__saturation_field);
    _this2.__selector.appendChild(_this2.__hue_field);
    _this2.__hue_field.appendChild(_this2.__hue_knob);
    _this2.domElement.appendChild(_this2.__input);
    _this2.domElement.appendChild(_this2.__selector);
    _this2.updateDisplay();
    function setSV(e) {
      if (e.type.indexOf('touch') === -1) {
        e.preventDefault();
      }
      var fieldRect = _this.__saturation_field.getBoundingClientRect();
      var _ref = e.touches && e.touches[0] || e,
          clientX = _ref.clientX,
          clientY = _ref.clientY;
      var s = (clientX - fieldRect.left) / (fieldRect.right - fieldRect.left);
      var v = 1 - (clientY - fieldRect.top) / (fieldRect.bottom - fieldRect.top);
      if (v > 1) {
        v = 1;
      } else if (v < 0) {
        v = 0;
      }
      if (s > 1) {
        s = 1;
      } else if (s < 0) {
        s = 0;
      }
      _this.__color.v = v;
      _this.__color.s = s;
      _this.setValue(_this.__color.toOriginal());
      return false;
    }
    function setH(e) {
      if (e.type.indexOf('touch') === -1) {
        e.preventDefault();
      }
      var fieldRect = _this.__hue_field.getBoundingClientRect();
      var _ref2 = e.touches && e.touches[0] || e,
          clientY = _ref2.clientY;
      var h = 1 - (clientY - fieldRect.top) / (fieldRect.bottom - fieldRect.top);
      if (h > 1) {
        h = 1;
      } else if (h < 0) {
        h = 0;
      }
      _this.__color.h = h * 360;
      _this.setValue(_this.__color.toOriginal());
      return false;
    }
    return _this2;
  }
  createClass(ColorController, [{
    key: 'updateDisplay',
    value: function updateDisplay() {
      var i = interpret(this.getValue());
      if (i !== false) {
        var mismatch = false;
        Common.each(Color.COMPONENTS, function (component) {
          if (!Common.isUndefined(i[component]) && !Common.isUndefined(this.__color.__state[component]) && i[component] !== this.__color.__state[component]) {
            mismatch = true;
            return {};
          }
        }, this);
        if (mismatch) {
          Common.extend(this.__color.__state, i);
        }
      }
      Common.extend(this.__temp.__state, this.__color.__state);
      this.__temp.a = 1;
      var flip = this.__color.v < 0.5 || this.__color.s > 0.5 ? 255 : 0;
      var _flip = 255 - flip;
      Common.extend(this.__field_knob.style, {
        marginLeft: 100 * this.__color.s - 7 + 'px',
        marginTop: 100 * (1 - this.__color.v) - 7 + 'px',
        backgroundColor: this.__temp.toHexString(),
        border: this.__field_knob_border + 'rgb(' + flip + ',' + flip + ',' + flip + ')'
      });
      this.__hue_knob.style.marginTop = (1 - this.__color.h / 360) * 100 + 'px';
      this.__temp.s = 1;
      this.__temp.v = 1;
      linearGradient(this.__saturation_field, 'left', '#fff', this.__temp.toHexString());
      this.__input.value = this.__color.toString();
      Common.extend(this.__input.style, {
        backgroundColor: this.__color.toHexString(),
        color: 'rgb(' + flip + ',' + flip + ',' + flip + ')',
        textShadow: this.__input_textShadow + 'rgba(' + _flip + ',' + _flip + ',' + _flip + ',.7)'
      });
    }
  }]);
  return ColorController;
}(Controller);
var vendors = ['-moz-', '-o-', '-webkit-', '-ms-', ''];
function linearGradient(elem, x, a, b) {
  elem.style.background = '';
  Common.each(vendors, function (vendor) {
    elem.style.cssText += 'background: ' + vendor + 'linear-gradient(' + x + ', ' + a + ' 0%, ' + b + ' 100%); ';
  });
}
function hueGradient(elem) {
  elem.style.background = '';
  elem.style.cssText += 'background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);';
  elem.style.cssText += 'background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
  elem.style.cssText += 'background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
  elem.style.cssText += 'background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
  elem.style.cssText += 'background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
}

var css = {
  load: function load(url, indoc) {
    var doc = indoc || document;
    var link = doc.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = url;
    doc.getElementsByTagName('head')[0].appendChild(link);
  },
  inject: function inject(cssContent, indoc) {
    var doc = indoc || document;
    var injected = document.createElement('style');
    injected.type = 'text/css';
    injected.innerHTML = cssContent;
    var head = doc.getElementsByTagName('head')[0];
    try {
      head.appendChild(injected);
    } catch (e) {
    }
  }
};

var saveDialogContents = "<div id=\"dg-save\" class=\"dg dialogue\">\n\n  Here's the new load parameter for your <code>GUI</code>'s constructor:\n\n  <textarea id=\"dg-new-constructor\"></textarea>\n\n  <div id=\"dg-save-locally\">\n\n    <input id=\"dg-local-storage\" type=\"checkbox\"/> Automatically save\n    values to <code>localStorage</code> on exit.\n\n    <div id=\"dg-local-explain\">The values saved to <code>localStorage</code> will\n      override those passed to <code>dat.GUI</code>'s constructor. This makes it\n      easier to work incrementally, but <code>localStorage</code> is fragile,\n      and your friends may not see the same values you do.\n\n    </div>\n\n  </div>\n\n</div>";

var ControllerFactory = function ControllerFactory(object, property) {
  var initialValue = object[property];
  if (Common.isArray(arguments[2]) || Common.isObject(arguments[2])) {
    return new OptionController(object, property, arguments[2]);
  }
  if (Common.isNumber(initialValue)) {
    if (Common.isNumber(arguments[2]) && Common.isNumber(arguments[3])) {
      if (Common.isNumber(arguments[4])) {
        return new NumberControllerSlider(object, property, arguments[2], arguments[3], arguments[4]);
      }
      return new NumberControllerSlider(object, property, arguments[2], arguments[3]);
    }
    if (Common.isNumber(arguments[4])) {
      return new NumberControllerBox(object, property, { min: arguments[2], max: arguments[3], step: arguments[4] });
    }
    return new NumberControllerBox(object, property, { min: arguments[2], max: arguments[3] });
  }
  if (Common.isString(initialValue)) {
    return new StringController(object, property);
  }
  if (Common.isFunction(initialValue)) {
    return new FunctionController(object, property, '');
  }
  if (Common.isBoolean(initialValue)) {
    return new BooleanController(object, property);
  }
  return null;
};

function requestAnimationFrame(callback) {
  setTimeout(callback, 1000 / 60);
}
var requestAnimationFrame$1 = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || requestAnimationFrame;

var CenteredDiv = function () {
  function CenteredDiv() {
    classCallCheck(this, CenteredDiv);
    this.backgroundElement = document.createElement('div');
    Common.extend(this.backgroundElement.style, {
      backgroundColor: 'rgba(0,0,0,0.8)',
      top: 0,
      left: 0,
      display: 'none',
      zIndex: '1000',
      opacity: 0,
      WebkitTransition: 'opacity 0.2s linear',
      transition: 'opacity 0.2s linear'
    });
    dom.makeFullscreen(this.backgroundElement);
    this.backgroundElement.style.position = 'fixed';
    this.domElement = document.createElement('div');
    Common.extend(this.domElement.style, {
      position: 'fixed',
      display: 'none',
      zIndex: '1001',
      opacity: 0,
      WebkitTransition: '-webkit-transform 0.2s ease-out, opacity 0.2s linear',
      transition: 'transform 0.2s ease-out, opacity 0.2s linear'
    });
    document.body.appendChild(this.backgroundElement);
    document.body.appendChild(this.domElement);
    var _this = this;
    dom.bind(this.backgroundElement, 'click', function () {
      _this.hide();
    });
  }
  createClass(CenteredDiv, [{
    key: 'show',
    value: function show() {
      var _this = this;
      this.backgroundElement.style.display = 'block';
      this.domElement.style.display = 'block';
      this.domElement.style.opacity = 0;
      this.domElement.style.webkitTransform = 'scale(1.1)';
      this.layout();
      Common.defer(function () {
        _this.backgroundElement.style.opacity = 1;
        _this.domElement.style.opacity = 1;
        _this.domElement.style.webkitTransform = 'scale(1)';
      });
    }
  }, {
    key: 'hide',
    value: function hide() {
      var _this = this;
      var hide = function hide() {
        _this.domElement.style.display = 'none';
        _this.backgroundElement.style.display = 'none';
        dom.unbind(_this.domElement, 'webkitTransitionEnd', hide);
        dom.unbind(_this.domElement, 'transitionend', hide);
        dom.unbind(_this.domElement, 'oTransitionEnd', hide);
      };
      dom.bind(this.domElement, 'webkitTransitionEnd', hide);
      dom.bind(this.domElement, 'transitionend', hide);
      dom.bind(this.domElement, 'oTransitionEnd', hide);
      this.backgroundElement.style.opacity = 0;
      this.domElement.style.opacity = 0;
      this.domElement.style.webkitTransform = 'scale(1.1)';
    }
  }, {
    key: 'layout',
    value: function layout() {
      this.domElement.style.left = window.innerWidth / 2 - dom.getWidth(this.domElement) / 2 + 'px';
      this.domElement.style.top = window.innerHeight / 2 - dom.getHeight(this.domElement) / 2 + 'px';
    }
  }]);
  return CenteredDiv;
}();

var styleSheet = ___$insertStyle(".dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1 !important}.dg.main:hover .close-button,.dg.main .close-button.drag{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear;border:0;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button.close-top{position:relative}.dg.main .close-button.close-bottom{position:absolute}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-y:visible}.dg.a.has-save>ul.close-top{margin-top:0}.dg.a.has-save>ul.close-bottom{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{top:0;z-index:1002}.dg.a .save-row.close-top{position:relative}.dg.a .save-row.close-bottom{position:fixed}.dg li{-webkit-transition:height .1s ease-out;-o-transition:height .1s ease-out;-moz-transition:height .1s ease-out;transition:height .1s ease-out;-webkit-transition:overflow .1s linear;-o-transition:overflow .1s linear;-moz-transition:overflow .1s linear;transition:overflow .1s linear}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid rgba(0,0,0,0)}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px;overflow:hidden}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .c{float:left;width:60%;position:relative}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:7px}.dg .c select{margin-top:5px}.dg .cr.function,.dg .cr.function .property-name,.dg .cr.function *,.dg .cr.boolean,.dg .cr.boolean *{cursor:pointer}.dg .cr.color{overflow:visible}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0px 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco, monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px 'Lucida Grande', sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px 4px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid rgba(255,255,255,0.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2FA1D6}.dg .cr.number input[type=text]{color:#2FA1D6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.function:hover,.dg .cr.boolean:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2FA1D6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}\n");

css.inject(styleSheet);
var CSS_NAMESPACE = 'dg';
var HIDE_KEY_CODE = 72;
var CLOSE_BUTTON_HEIGHT = 20;
var DEFAULT_DEFAULT_PRESET_NAME = 'Default';
var SUPPORTS_LOCAL_STORAGE = function () {
  try {
    return !!window.localStorage;
  } catch (e) {
    return false;
  }
}();
var SAVE_DIALOGUE = void 0;
var autoPlaceVirgin = true;
var autoPlaceContainer = void 0;
var hide = false;
var hideableGuis = [];
var GUI = function GUI(pars) {
  var _this = this;
  var params = pars || {};
  this.domElement = document.createElement('div');
  this.__ul = document.createElement('ul');
  this.domElement.appendChild(this.__ul);
  dom.addClass(this.domElement, CSS_NAMESPACE);
  this.__folders = {};
  this.__controllers = [];
  this.__rememberedObjects = [];
  this.__rememberedObjectIndecesToControllers = [];
  this.__listening = [];
  params = Common.defaults(params, {
    closeOnTop: false,
    autoPlace: true,
    width: GUI.DEFAULT_WIDTH
  });
  params = Common.defaults(params, {
    resizable: params.autoPlace,
    hideable: params.autoPlace
  });
  if (!Common.isUndefined(params.load)) {
    if (params.preset) {
      params.load.preset = params.preset;
    }
  } else {
    params.load = { preset: DEFAULT_DEFAULT_PRESET_NAME };
  }
  if (Common.isUndefined(params.parent) && params.hideable) {
    hideableGuis.push(this);
  }
  params.resizable = Common.isUndefined(params.parent) && params.resizable;
  if (params.autoPlace && Common.isUndefined(params.scrollable)) {
    params.scrollable = true;
  }
  var useLocalStorage = SUPPORTS_LOCAL_STORAGE && localStorage.getItem(getLocalStorageHash(this, 'isLocal')) === 'true';
  var saveToLocalStorage = void 0;
  var titleRow = void 0;
  Object.defineProperties(this,
  {
    parent: {
      get: function get$$1() {
        return params.parent;
      }
    },
    scrollable: {
      get: function get$$1() {
        return params.scrollable;
      }
    },
    autoPlace: {
      get: function get$$1() {
        return params.autoPlace;
      }
    },
    closeOnTop: {
      get: function get$$1() {
        return params.closeOnTop;
      }
    },
    preset: {
      get: function get$$1() {
        if (_this.parent) {
          return _this.getRoot().preset;
        }
        return params.load.preset;
      },
      set: function set$$1(v) {
        if (_this.parent) {
          _this.getRoot().preset = v;
        } else {
          params.load.preset = v;
        }
        setPresetSelectIndex(this);
        _this.revert();
      }
    },
    width: {
      get: function get$$1() {
        return params.width;
      },
      set: function set$$1(v) {
        params.width = v;
        setWidth(_this, v);
      }
    },
    name: {
      get: function get$$1() {
        return params.name;
      },
      set: function set$$1(v) {
        params.name = v;
        if (titleRow) {
          titleRow.innerHTML = params.name;
        }
      }
    },
    closed: {
      get: function get$$1() {
        return params.closed;
      },
      set: function set$$1(v) {
        params.closed = v;
        if (params.closed) {
          dom.addClass(_this.__ul, GUI.CLASS_CLOSED);
        } else {
          dom.removeClass(_this.__ul, GUI.CLASS_CLOSED);
        }
        this.onResize();
        if (_this.__closeButton) {
          _this.__closeButton.innerHTML = v ? GUI.TEXT_OPEN : GUI.TEXT_CLOSED;
        }
      }
    },
    load: {
      get: function get$$1() {
        return params.load;
      }
    },
    useLocalStorage: {
      get: function get$$1() {
        return useLocalStorage;
      },
      set: function set$$1(bool) {
        if (SUPPORTS_LOCAL_STORAGE) {
          useLocalStorage = bool;
          if (bool) {
            dom.bind(window, 'unload', saveToLocalStorage);
          } else {
            dom.unbind(window, 'unload', saveToLocalStorage);
          }
          localStorage.setItem(getLocalStorageHash(_this, 'isLocal'), bool);
        }
      }
    }
  });
  if (Common.isUndefined(params.parent)) {
    this.closed = params.closed || false;
    dom.addClass(this.domElement, GUI.CLASS_MAIN);
    dom.makeSelectable(this.domElement, false);
    if (SUPPORTS_LOCAL_STORAGE) {
      if (useLocalStorage) {
        _this.useLocalStorage = true;
        var savedGui = localStorage.getItem(getLocalStorageHash(this, 'gui'));
        if (savedGui) {
          params.load = JSON.parse(savedGui);
        }
      }
    }
    this.__closeButton = document.createElement('div');
    this.__closeButton.innerHTML = GUI.TEXT_CLOSED;
    dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_BUTTON);
    if (params.closeOnTop) {
      dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_TOP);
      this.domElement.insertBefore(this.__closeButton, this.domElement.childNodes[0]);
    } else {
      dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_BOTTOM);
      this.domElement.appendChild(this.__closeButton);
    }
    dom.bind(this.__closeButton, 'click', function () {
      _this.closed = !_this.closed;
    });
  } else {
    if (params.closed === undefined) {
      params.closed = true;
    }
    var titleRowName = document.createTextNode(params.name);
    dom.addClass(titleRowName, 'controller-name');
    titleRow = addRow(_this, titleRowName);
    var onClickTitle = function onClickTitle(e) {
      e.preventDefault();
      _this.closed = !_this.closed;
      return false;
    };
    dom.addClass(this.__ul, GUI.CLASS_CLOSED);
    dom.addClass(titleRow, 'title');
    dom.bind(titleRow, 'click', onClickTitle);
    if (!params.closed) {
      this.closed = false;
    }
  }
  if (params.autoPlace) {
    if (Common.isUndefined(params.parent)) {
      if (autoPlaceVirgin) {
        autoPlaceContainer = document.createElement('div');
        dom.addClass(autoPlaceContainer, CSS_NAMESPACE);
        dom.addClass(autoPlaceContainer, GUI.CLASS_AUTO_PLACE_CONTAINER);
        document.body.appendChild(autoPlaceContainer);
        autoPlaceVirgin = false;
      }
      autoPlaceContainer.appendChild(this.domElement);
      dom.addClass(this.domElement, GUI.CLASS_AUTO_PLACE);
    }
    if (!this.parent) {
      setWidth(_this, params.width);
    }
  }
  this.__resizeHandler = function () {
    _this.onResizeDebounced();
  };
  dom.bind(window, 'resize', this.__resizeHandler);
  dom.bind(this.__ul, 'webkitTransitionEnd', this.__resizeHandler);
  dom.bind(this.__ul, 'transitionend', this.__resizeHandler);
  dom.bind(this.__ul, 'oTransitionEnd', this.__resizeHandler);
  this.onResize();
  if (params.resizable) {
    addResizeHandle(this);
  }
  saveToLocalStorage = function saveToLocalStorage() {
    if (SUPPORTS_LOCAL_STORAGE && localStorage.getItem(getLocalStorageHash(_this, 'isLocal')) === 'true') {
      localStorage.setItem(getLocalStorageHash(_this, 'gui'), JSON.stringify(_this.getSaveObject()));
    }
  };
  this.saveToLocalStorageIfPossible = saveToLocalStorage;
  function resetWidth() {
    var root = _this.getRoot();
    root.width += 1;
    Common.defer(function () {
      root.width -= 1;
    });
  }
  if (!params.parent) {
    resetWidth();
  }
};
GUI.toggleHide = function () {
  hide = !hide;
  Common.each(hideableGuis, function (gui) {
    gui.domElement.style.display = hide ? 'none' : '';
  });
};
GUI.CLASS_AUTO_PLACE = 'a';
GUI.CLASS_AUTO_PLACE_CONTAINER = 'ac';
GUI.CLASS_MAIN = 'main';
GUI.CLASS_CONTROLLER_ROW = 'cr';
GUI.CLASS_TOO_TALL = 'taller-than-window';
GUI.CLASS_CLOSED = 'closed';
GUI.CLASS_CLOSE_BUTTON = 'close-button';
GUI.CLASS_CLOSE_TOP = 'close-top';
GUI.CLASS_CLOSE_BOTTOM = 'close-bottom';
GUI.CLASS_DRAG = 'drag';
GUI.DEFAULT_WIDTH = 245;
GUI.TEXT_CLOSED = 'Close Controls';
GUI.TEXT_OPEN = 'Open Controls';
GUI._keydownHandler = function (e) {
  if (document.activeElement.type !== 'text' && (e.which === HIDE_KEY_CODE || e.keyCode === HIDE_KEY_CODE)) {
    GUI.toggleHide();
  }
};
dom.bind(window, 'keydown', GUI._keydownHandler, false);
Common.extend(GUI.prototype,
{
  add: function add(object, property) {
    return _add(this, object, property, {
      factoryArgs: Array.prototype.slice.call(arguments, 2)
    });
  },
  addColor: function addColor(object, property) {
    return _add(this, object, property, {
      color: true
    });
  },
  remove: function remove(controller) {
    this.__ul.removeChild(controller.__li);
    this.__controllers.splice(this.__controllers.indexOf(controller), 1);
    var _this = this;
    Common.defer(function () {
      _this.onResize();
    });
  },
  destroy: function destroy() {
    if (this.parent) {
      throw new Error('Only the root GUI should be removed with .destroy(). ' + 'For subfolders, use gui.removeFolder(folder) instead.');
    }
    if (this.autoPlace) {
      autoPlaceContainer.removeChild(this.domElement);
    }
    var _this = this;
    Common.each(this.__folders, function (subfolder) {
      _this.removeFolder(subfolder);
    });
    dom.unbind(window, 'keydown', GUI._keydownHandler, false);
    removeListeners(this);
  },
  addFolder: function addFolder(name) {
    if (this.__folders[name] !== undefined) {
      throw new Error('You already have a folder in this GUI by the' + ' name "' + name + '"');
    }
    var newGuiParams = { name: name, parent: this };
    newGuiParams.autoPlace = this.autoPlace;
    if (this.load &&
    this.load.folders &&
    this.load.folders[name]) {
      newGuiParams.closed = this.load.folders[name].closed;
      newGuiParams.load = this.load.folders[name];
    }
    var gui = new GUI(newGuiParams);
    this.__folders[name] = gui;
    var li = addRow(this, gui.domElement);
    dom.addClass(li, 'folder');
    return gui;
  },
  removeFolder: function removeFolder(folder) {
    this.__ul.removeChild(folder.domElement.parentElement);
    delete this.__folders[folder.name];
    if (this.load &&
    this.load.folders &&
    this.load.folders[folder.name]) {
      delete this.load.folders[folder.name];
    }
    removeListeners(folder);
    var _this = this;
    Common.each(folder.__folders, function (subfolder) {
      folder.removeFolder(subfolder);
    });
    Common.defer(function () {
      _this.onResize();
    });
  },
  open: function open() {
    this.closed = false;
  },
  close: function close() {
    this.closed = true;
  },
  hide: function hide() {
    this.domElement.style.display = 'none';
  },
  show: function show() {
    this.domElement.style.display = '';
  },
  onResize: function onResize() {
    var root = this.getRoot();
    if (root.scrollable) {
      var top = dom.getOffset(root.__ul).top;
      var h = 0;
      Common.each(root.__ul.childNodes, function (node) {
        if (!(root.autoPlace && node === root.__save_row)) {
          h += dom.getHeight(node);
        }
      });
      if (window.innerHeight - top - CLOSE_BUTTON_HEIGHT < h) {
        dom.addClass(root.domElement, GUI.CLASS_TOO_TALL);
        root.__ul.style.height = window.innerHeight - top - CLOSE_BUTTON_HEIGHT + 'px';
      } else {
        dom.removeClass(root.domElement, GUI.CLASS_TOO_TALL);
        root.__ul.style.height = 'auto';
      }
    }
    if (root.__resize_handle) {
      Common.defer(function () {
        root.__resize_handle.style.height = root.__ul.offsetHeight + 'px';
      });
    }
    if (root.__closeButton) {
      root.__closeButton.style.width = root.width + 'px';
    }
  },
  onResizeDebounced: Common.debounce(function () {
    this.onResize();
  }, 50),
  remember: function remember() {
    if (Common.isUndefined(SAVE_DIALOGUE)) {
      SAVE_DIALOGUE = new CenteredDiv();
      SAVE_DIALOGUE.domElement.innerHTML = saveDialogContents;
    }
    if (this.parent) {
      throw new Error('You can only call remember on a top level GUI.');
    }
    var _this = this;
    Common.each(Array.prototype.slice.call(arguments), function (object) {
      if (_this.__rememberedObjects.length === 0) {
        addSaveMenu(_this);
      }
      if (_this.__rememberedObjects.indexOf(object) === -1) {
        _this.__rememberedObjects.push(object);
      }
    });
    if (this.autoPlace) {
      setWidth(this, this.width);
    }
  },
  getRoot: function getRoot() {
    var gui = this;
    while (gui.parent) {
      gui = gui.parent;
    }
    return gui;
  },
  getSaveObject: function getSaveObject() {
    var toReturn = this.load;
    toReturn.closed = this.closed;
    if (this.__rememberedObjects.length > 0) {
      toReturn.preset = this.preset;
      if (!toReturn.remembered) {
        toReturn.remembered = {};
      }
      toReturn.remembered[this.preset] = getCurrentPreset(this);
    }
    toReturn.folders = {};
    Common.each(this.__folders, function (element, key) {
      toReturn.folders[key] = element.getSaveObject();
    });
    return toReturn;
  },
  save: function save() {
    if (!this.load.remembered) {
      this.load.remembered = {};
    }
    this.load.remembered[this.preset] = getCurrentPreset(this);
    markPresetModified(this, false);
    this.saveToLocalStorageIfPossible();
  },
  saveAs: function saveAs(presetName) {
    if (!this.load.remembered) {
      this.load.remembered = {};
      this.load.remembered[DEFAULT_DEFAULT_PRESET_NAME] = getCurrentPreset(this, true);
    }
    this.load.remembered[presetName] = getCurrentPreset(this);
    this.preset = presetName;
    addPresetOption(this, presetName, true);
    this.saveToLocalStorageIfPossible();
  },
  revert: function revert(gui) {
    Common.each(this.__controllers, function (controller) {
      if (!this.getRoot().load.remembered) {
        controller.setValue(controller.initialValue);
      } else {
        recallSavedValue(gui || this.getRoot(), controller);
      }
      if (controller.__onFinishChange) {
        controller.__onFinishChange.call(controller, controller.getValue());
      }
    }, this);
    Common.each(this.__folders, function (folder) {
      folder.revert(folder);
    });
    if (!gui) {
      markPresetModified(this.getRoot(), false);
    }
  },
  listen: function listen(controller) {
    var init = this.__listening.length === 0;
    this.__listening.push(controller);
    if (init) {
      updateDisplays(this.__listening);
    }
  },
  updateDisplay: function updateDisplay() {
    Common.each(this.__controllers, function (controller) {
      controller.updateDisplay();
    });
    Common.each(this.__folders, function (folder) {
      folder.updateDisplay();
    });
  }
});
function addRow(gui, newDom, liBefore) {
  var li = document.createElement('li');
  if (newDom) {
    li.appendChild(newDom);
  }
  if (liBefore) {
    gui.__ul.insertBefore(li, liBefore);
  } else {
    gui.__ul.appendChild(li);
  }
  gui.onResize();
  return li;
}
function removeListeners(gui) {
  dom.unbind(window, 'resize', gui.__resizeHandler);
  if (gui.saveToLocalStorageIfPossible) {
    dom.unbind(window, 'unload', gui.saveToLocalStorageIfPossible);
  }
}
function markPresetModified(gui, modified) {
  var opt = gui.__preset_select[gui.__preset_select.selectedIndex];
  if (modified) {
    opt.innerHTML = opt.value + '*';
  } else {
    opt.innerHTML = opt.value;
  }
}
function augmentController(gui, li, controller) {
  controller.__li = li;
  controller.__gui = gui;
  Common.extend(controller,                                   {
    options: function options(_options) {
      if (arguments.length > 1) {
        var nextSibling = controller.__li.nextElementSibling;
        controller.remove();
        return _add(gui, controller.object, controller.property, {
          before: nextSibling,
          factoryArgs: [Common.toArray(arguments)]
        });
      }
      if (Common.isArray(_options) || Common.isObject(_options)) {
        var _nextSibling = controller.__li.nextElementSibling;
        controller.remove();
        return _add(gui, controller.object, controller.property, {
          before: _nextSibling,
          factoryArgs: [_options]
        });
      }
    },
    name: function name(_name) {
      controller.__li.firstElementChild.firstElementChild.innerHTML = _name;
      return controller;
    },
    listen: function listen() {
      controller.__gui.listen(controller);
      return controller;
    },
    remove: function remove() {
      controller.__gui.remove(controller);
      return controller;
    }
  });
  if (controller instanceof NumberControllerSlider) {
    var box = new NumberControllerBox(controller.object, controller.property, { min: controller.__min, max: controller.__max, step: controller.__step });
    Common.each(['updateDisplay', 'onChange', 'onFinishChange', 'step', 'min', 'max'], function (method) {
      var pc = controller[method];
      var pb = box[method];
      controller[method] = box[method] = function () {
        var args = Array.prototype.slice.call(arguments);
        pb.apply(box, args);
        return pc.apply(controller, args);
      };
    });
    dom.addClass(li, 'has-slider');
    controller.domElement.insertBefore(box.domElement, controller.domElement.firstElementChild);
  } else if (controller instanceof NumberControllerBox) {
    var r = function r(returned) {
      if (Common.isNumber(controller.__min) && Common.isNumber(controller.__max)) {
        var oldName = controller.__li.firstElementChild.firstElementChild.innerHTML;
        var wasListening = controller.__gui.__listening.indexOf(controller) > -1;
        controller.remove();
        var newController = _add(gui, controller.object, controller.property, {
          before: controller.__li.nextElementSibling,
          factoryArgs: [controller.__min, controller.__max, controller.__step]
        });
        newController.name(oldName);
        if (wasListening) newController.listen();
        return newController;
      }
      return returned;
    };
    controller.min = Common.compose(r, controller.min);
    controller.max = Common.compose(r, controller.max);
  } else if (controller instanceof BooleanController) {
    dom.bind(li, 'click', function () {
      dom.fakeEvent(controller.__checkbox, 'click');
    });
    dom.bind(controller.__checkbox, 'click', function (e) {
      e.stopPropagation();
    });
  } else if (controller instanceof FunctionController) {
    dom.bind(li, 'click', function () {
      dom.fakeEvent(controller.__button, 'click');
    });
    dom.bind(li, 'mouseover', function () {
      dom.addClass(controller.__button, 'hover');
    });
    dom.bind(li, 'mouseout', function () {
      dom.removeClass(controller.__button, 'hover');
    });
  } else if (controller instanceof ColorController) {
    dom.addClass(li, 'color');
    controller.updateDisplay = Common.compose(function (val) {
      li.style.borderLeftColor = controller.__color.toString();
      return val;
    }, controller.updateDisplay);
    controller.updateDisplay();
  }
  controller.setValue = Common.compose(function (val) {
    if (gui.getRoot().__preset_select && controller.isModified()) {
      markPresetModified(gui.getRoot(), true);
    }
    return val;
  }, controller.setValue);
}
function recallSavedValue(gui, controller) {
  var root = gui.getRoot();
  var matchedIndex = root.__rememberedObjects.indexOf(controller.object);
  if (matchedIndex !== -1) {
    var controllerMap = root.__rememberedObjectIndecesToControllers[matchedIndex];
    if (controllerMap === undefined) {
      controllerMap = {};
      root.__rememberedObjectIndecesToControllers[matchedIndex] = controllerMap;
    }
    controllerMap[controller.property] = controller;
    if (root.load && root.load.remembered) {
      var presetMap = root.load.remembered;
      var preset = void 0;
      if (presetMap[gui.preset]) {
        preset = presetMap[gui.preset];
      } else if (presetMap[DEFAULT_DEFAULT_PRESET_NAME]) {
        preset = presetMap[DEFAULT_DEFAULT_PRESET_NAME];
      } else {
        return;
      }
      if (preset[matchedIndex] && preset[matchedIndex][controller.property] !== undefined) {
        var value = preset[matchedIndex][controller.property];
        controller.initialValue = value;
        controller.setValue(value);
      }
    }
  }
}
function _add(gui, object, property, params) {
  if (object[property] === undefined) {
    throw new Error('Object "' + object + '" has no property "' + property + '"');
  }
  var controller = void 0;
  if (params.color) {
    controller = new ColorController(object, property);
  } else {
    var factoryArgs = [object, property].concat(params.factoryArgs);
    controller = ControllerFactory.apply(gui, factoryArgs);
  }
  if (params.before instanceof Controller) {
    params.before = params.before.__li;
  }
  recallSavedValue(gui, controller);
  dom.addClass(controller.domElement, 'c');
  var name = document.createElement('span');
  dom.addClass(name, 'property-name');
  name.innerHTML = controller.property;
  var container = document.createElement('div');
  container.appendChild(name);
  container.appendChild(controller.domElement);
  var li = addRow(gui, container, params.before);
  dom.addClass(li, GUI.CLASS_CONTROLLER_ROW);
  if (controller instanceof ColorController) {
    dom.addClass(li, 'color');
  } else {
    dom.addClass(li, _typeof(controller.getValue()));
  }
  augmentController(gui, li, controller);
  gui.__controllers.push(controller);
  return controller;
}
function getLocalStorageHash(gui, key) {
  return document.location.href + '.' + key;
}
function addPresetOption(gui, name, setSelected) {
  var opt = document.createElement('option');
  opt.innerHTML = name;
  opt.value = name;
  gui.__preset_select.appendChild(opt);
  if (setSelected) {
    gui.__preset_select.selectedIndex = gui.__preset_select.length - 1;
  }
}
function showHideExplain(gui, explain) {
  explain.style.display = gui.useLocalStorage ? 'block' : 'none';
}
function addSaveMenu(gui) {
  var div = gui.__save_row = document.createElement('li');
  dom.addClass(gui.domElement, 'has-save');
  gui.__ul.insertBefore(div, gui.__ul.firstChild);
  dom.addClass(div, 'save-row');
  var gears = document.createElement('span');
  gears.innerHTML = '&nbsp;';
  dom.addClass(gears, 'button gears');
  var button = document.createElement('span');
  button.innerHTML = 'Save';
  dom.addClass(button, 'button');
  dom.addClass(button, 'save');
  var button2 = document.createElement('span');
  button2.innerHTML = 'New';
  dom.addClass(button2, 'button');
  dom.addClass(button2, 'save-as');
  var button3 = document.createElement('span');
  button3.innerHTML = 'Revert';
  dom.addClass(button3, 'button');
  dom.addClass(button3, 'revert');
  var select = gui.__preset_select = document.createElement('select');
  if (gui.load && gui.load.remembered) {
    Common.each(gui.load.remembered, function (value, key) {
      addPresetOption(gui, key, key === gui.preset);
    });
  } else {
    addPresetOption(gui, DEFAULT_DEFAULT_PRESET_NAME, false);
  }
  dom.bind(select, 'change', function () {
    for (var index = 0; index < gui.__preset_select.length; index++) {
      gui.__preset_select[index].innerHTML = gui.__preset_select[index].value;
    }
    gui.preset = this.value;
  });
  div.appendChild(select);
  div.appendChild(gears);
  div.appendChild(button);
  div.appendChild(button2);
  div.appendChild(button3);
  if (SUPPORTS_LOCAL_STORAGE) {
    var explain = document.getElementById('dg-local-explain');
    var localStorageCheckBox = document.getElementById('dg-local-storage');
    var saveLocally = document.getElementById('dg-save-locally');
    saveLocally.style.display = 'block';
    if (localStorage.getItem(getLocalStorageHash(gui, 'isLocal')) === 'true') {
      localStorageCheckBox.setAttribute('checked', 'checked');
    }
    showHideExplain(gui, explain);
    dom.bind(localStorageCheckBox, 'change', function () {
      gui.useLocalStorage = !gui.useLocalStorage;
      showHideExplain(gui, explain);
    });
  }
  var newConstructorTextArea = document.getElementById('dg-new-constructor');
  dom.bind(newConstructorTextArea, 'keydown', function (e) {
    if (e.metaKey && (e.which === 67 || e.keyCode === 67)) {
      SAVE_DIALOGUE.hide();
    }
  });
  dom.bind(gears, 'click', function () {
    newConstructorTextArea.innerHTML = JSON.stringify(gui.getSaveObject(), undefined, 2);
    SAVE_DIALOGUE.show();
    newConstructorTextArea.focus();
    newConstructorTextArea.select();
  });
  dom.bind(button, 'click', function () {
    gui.save();
  });
  dom.bind(button2, 'click', function () {
    var presetName = prompt('Enter a new preset name.');
    if (presetName) {
      gui.saveAs(presetName);
    }
  });
  dom.bind(button3, 'click', function () {
    gui.revert();
  });
}
function addResizeHandle(gui) {
  var pmouseX = void 0;
  gui.__resize_handle = document.createElement('div');
  Common.extend(gui.__resize_handle.style, {
    width: '6px',
    marginLeft: '-3px',
    height: '200px',
    cursor: 'ew-resize',
    position: 'absolute'
  });
  function drag(e) {
    e.preventDefault();
    gui.width += pmouseX - e.clientX;
    gui.onResize();
    pmouseX = e.clientX;
    return false;
  }
  function dragStop() {
    dom.removeClass(gui.__closeButton, GUI.CLASS_DRAG);
    dom.unbind(window, 'mousemove', drag);
    dom.unbind(window, 'mouseup', dragStop);
  }
  function dragStart(e) {
    e.preventDefault();
    pmouseX = e.clientX;
    dom.addClass(gui.__closeButton, GUI.CLASS_DRAG);
    dom.bind(window, 'mousemove', drag);
    dom.bind(window, 'mouseup', dragStop);
    return false;
  }
  dom.bind(gui.__resize_handle, 'mousedown', dragStart);
  dom.bind(gui.__closeButton, 'mousedown', dragStart);
  gui.domElement.insertBefore(gui.__resize_handle, gui.domElement.firstElementChild);
}
function setWidth(gui, w) {
  gui.domElement.style.width = w + 'px';
  if (gui.__save_row && gui.autoPlace) {
    gui.__save_row.style.width = w + 'px';
  }
  if (gui.__closeButton) {
    gui.__closeButton.style.width = w + 'px';
  }
}
function getCurrentPreset(gui, useInitialValues) {
  var toReturn = {};
  Common.each(gui.__rememberedObjects, function (val, index) {
    var savedValues = {};
    var controllerMap = gui.__rememberedObjectIndecesToControllers[index];
    Common.each(controllerMap, function (controller, property) {
      savedValues[property] = useInitialValues ? controller.initialValue : controller.getValue();
    });
    toReturn[index] = savedValues;
  });
  return toReturn;
}
function setPresetSelectIndex(gui) {
  for (var index = 0; index < gui.__preset_select.length; index++) {
    if (gui.__preset_select[index].value === gui.preset) {
      gui.__preset_select.selectedIndex = index;
    }
  }
}
function updateDisplays(controllerArray) {
  if (controllerArray.length !== 0) {
    requestAnimationFrame$1.call(window, function () {
      updateDisplays(controllerArray);
    });
  }
  Common.each(controllerArray, function (c) {
    c.updateDisplay();
  });
}

var color = {
  Color: Color,
  math: ColorMath,
  interpret: interpret
};
var controllers = {
  Controller: Controller,
  BooleanController: BooleanController,
  OptionController: OptionController,
  StringController: StringController,
  NumberController: NumberController,
  NumberControllerBox: NumberControllerBox,
  NumberControllerSlider: NumberControllerSlider,
  FunctionController: FunctionController,
  ColorController: ColorController
};
var dom$1 = { dom: dom };
var gui = { GUI: GUI };
var GUI$1 = GUI;
var index = {
  color: color,
  controllers: controllers,
  dom: dom$1,
  gui: gui,
  GUI: GUI$1
};

exports.color = color;
exports.controllers = controllers;
exports.dom = dom$1;
exports.gui = gui;
exports.GUI = GUI$1;
exports['default'] = index;

Object.defineProperty(exports, '__esModule', { value: true });

})));


},{}],23:[function(require,module,exports){
!function(){"use strict";if("undefined"!=typeof window){var e=window.navigator.userAgent.match(/Edge\/(\d{2})\./),n=!!e&&16<=parseInt(e[1],10);if(!("objectFit"in document.documentElement.style!=!1)||n){var o=function(e){var t=e.parentNode;!function(e){var t=window.getComputedStyle(e,null),i=t.getPropertyValue("position"),n=t.getPropertyValue("overflow"),o=t.getPropertyValue("display");i&&"static"!==i||(e.style.position="relative"),"hidden"!==n&&(e.style.overflow="hidden"),o&&"inline"!==o||(e.style.display="block"),0===e.clientHeight&&(e.style.height="100%"),-1===e.className.indexOf("object-fit-polyfill")&&(e.className=e.className+" object-fit-polyfill")}(t),function(e){var t=window.getComputedStyle(e,null),i={"max-width":"none","max-height":"none","min-width":"0px","min-height":"0px",top:"auto",right:"auto",bottom:"auto",left:"auto","margin-top":"0px","margin-right":"0px","margin-bottom":"0px","margin-left":"0px"};for(var n in i)t.getPropertyValue(n)!==i[n]&&(e.style[n]=i[n])}(e),e.style.position="absolute",e.style.height="100%",e.style.width="auto",e.clientWidth>t.clientWidth?(e.style.top="0",e.style.marginTop="0",e.style.left="50%",e.style.marginLeft=e.clientWidth/-2+"px"):(e.style.width="100%",e.style.height="auto",e.style.left="0",e.style.marginLeft="0",e.style.top="50%",e.style.marginTop=e.clientHeight/-2+"px")},t=function(e){if(void 0===e||e instanceof Event)e=document.querySelectorAll("[data-object-fit]");else if(e&&e.nodeName)e=[e];else{if("object"!=typeof e||!e.length||!e[0].nodeName)return!1;e=e}for(var t=0;t<e.length;t++)if(e[t].nodeName){var i=e[t].nodeName.toLowerCase();if("img"===i){if(n)continue;e[t].complete?o(e[t]):e[t].addEventListener("load",function(){o(this)})}else"video"===i?0<e[t].readyState?o(e[t]):e[t].addEventListener("loadedmetadata",function(){o(this)}):o(e[t])}return!0};"loading"===document.readyState?document.addEventListener("DOMContentLoaded",t):t(),window.addEventListener("resize",t),window.objectFitPolyfill=t}else window.objectFitPolyfill=function(){return!1}}}();
},{}],24:[function(require,module,exports){
/*!
* svg.js - A lightweight library for manipulating and animating SVG.
* @version 2.7.1
* https://svgdotjs.github.io/
*
* @copyright Wout Fierens <wout@mick-wout.com>
* @license MIT
*
* BUILT: Fri Nov 30 2018 10:01:55 GMT+0100 (GMT+01:00)
*/;
(function(root, factory) {
  /* istanbul ignore next */
  if (typeof define === 'function' && define.amd) {
    define(function(){
      return factory(root, root.document)
    })
  } else if (typeof exports === 'object') {
    module.exports = root.document ? factory(root, root.document) : function(w){ return factory(w, w.document) }
  } else {
    root.SVG = factory(root, root.document)
  }
}(typeof window !== "undefined" ? window : this, function(window, document) {

// Find global reference - uses 'this' by default when available,
// falls back to 'window' otherwise (for bundlers like Webpack)
var globalRef = (typeof this !== "undefined") ? this : window;

// The main wrapping element
var SVG = globalRef.SVG = function(element) {
  if (SVG.supported) {
    element = new SVG.Doc(element)

    if(!SVG.parser.draw)
      SVG.prepare()

    return element
  }
}

// Default namespaces
SVG.ns    = 'http://www.w3.org/2000/svg'
SVG.xmlns = 'http://www.w3.org/2000/xmlns/'
SVG.xlink = 'http://www.w3.org/1999/xlink'
SVG.svgjs = 'http://svgjs.com/svgjs'

// Svg support test
SVG.supported = (function() {
  return !! document.createElementNS &&
         !! document.createElementNS(SVG.ns,'svg').createSVGRect
})()

// Don't bother to continue if SVG is not supported
if (!SVG.supported) return false

// Element id sequence
SVG.did  = 1000

// Get next named element id
SVG.eid = function(name) {
  return 'Svgjs' + capitalize(name) + (SVG.did++)
}

// Method for element creation
SVG.create = function(name) {
  // create element
  var element = document.createElementNS(this.ns, name)

  // apply unique id
  element.setAttribute('id', this.eid(name))

  return element
}

// Method for extending objects
SVG.extend = function() {
  var modules, methods, key, i

  // Get list of modules
  modules = [].slice.call(arguments)

  // Get object with extensions
  methods = modules.pop()

  for (i = modules.length - 1; i >= 0; i--)
    if (modules[i])
      for (key in methods)
        modules[i].prototype[key] = methods[key]

  // Make sure SVG.Set inherits any newly added methods
  if (SVG.Set && SVG.Set.inherit)
    SVG.Set.inherit()
}

// Invent new element
SVG.invent = function(config) {
  // Create element initializer
  var initializer = typeof config.create == 'function' ?
    config.create :
    function() {
      this.constructor.call(this, SVG.create(config.create))
    }

  // Inherit prototype
  if (config.inherit)
    initializer.prototype = new config.inherit

  // Extend with methods
  if (config.extend)
    SVG.extend(initializer, config.extend)

  // Attach construct method to parent
  if (config.construct)
    SVG.extend(config.parent || SVG.Container, config.construct)

  return initializer
}

// Adopt existing svg elements
SVG.adopt = function(node) {
  // check for presence of node
  if (!node) return null

  // make sure a node isn't already adopted
  if (node.instance) return node.instance

  // initialize variables
  var element

  // adopt with element-specific settings
  if (node.nodeName == 'svg')
    element = node.parentNode instanceof window.SVGElement ? new SVG.Nested : new SVG.Doc
  else if (node.nodeName == 'linearGradient')
    element = new SVG.Gradient('linear')
  else if (node.nodeName == 'radialGradient')
    element = new SVG.Gradient('radial')
  else if (SVG[capitalize(node.nodeName)])
    element = new SVG[capitalize(node.nodeName)]
  else
    element = new SVG.Element(node)

  // ensure references
  element.type  = node.nodeName
  element.node  = node
  node.instance = element

  // SVG.Class specific preparations
  if (element instanceof SVG.Doc)
    element.namespace().defs()

  // pull svgjs data from the dom (getAttributeNS doesn't work in html5)
  element.setData(JSON.parse(node.getAttribute('svgjs:data')) || {})

  return element
}

// Initialize parsing element
SVG.prepare = function() {
  // Select document body and create invisible svg element
  var body = document.getElementsByTagName('body')[0]
    , draw = (body ? new SVG.Doc(body) : SVG.adopt(document.documentElement).nested()).size(2, 0)

  // Create parser object
  SVG.parser = {
    body: body || document.documentElement
  , draw: draw.style('opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden').attr('focusable', 'false').node
  , poly: draw.polyline().node
  , path: draw.path().node
  , native: SVG.create('svg')
  }
}

SVG.parser = {
  native: SVG.create('svg')
}

document.addEventListener('DOMContentLoaded', function() {
  if(!SVG.parser.draw)
    SVG.prepare()
}, false)

// Storage for regular expressions
SVG.regex = {
  // Parse unit value
  numberAndUnit:    /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i

  // Parse hex value
, hex:              /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i

  // Parse rgb value
, rgb:              /rgb\((\d+),(\d+),(\d+)\)/

  // Parse reference id
, reference:        /#([a-z0-9\-_]+)/i

  // splits a transformation chain
, transforms:       /\)\s*,?\s*/

  // Whitespace
, whitespace:       /\s/g

  // Test hex value
, isHex:            /^#[a-f0-9]{3,6}$/i

  // Test rgb value
, isRgb:            /^rgb\(/

  // Test css declaration
, isCss:            /[^:]+:[^;]+;?/

  // Test for blank string
, isBlank:          /^(\s+)?$/

  // Test for numeric string
, isNumber:         /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i

  // Test for percent value
, isPercent:        /^-?[\d\.]+%$/

  // Test for image url
, isImage:          /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i

  // split at whitespace and comma
, delimiter:        /[\s,]+/

  // The following regex are used to parse the d attribute of a path

  // Matches all hyphens which are not after an exponent
, hyphen:           /([^e])\-/gi

  // Replaces and tests for all path letters
, pathLetters:      /[MLHVCSQTAZ]/gi

  // yes we need this one, too
, isPathLetter:     /[MLHVCSQTAZ]/i

  // matches 0.154.23.45
, numbersWithDots:  /((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi

  // matches .
, dots:             /\./g
}

SVG.utils = {
  // Map function
  map: function(array, block) {
    var i
      , il = array.length
      , result = []

    for (i = 0; i < il; i++)
      result.push(block(array[i]))

    return result
  }

  // Filter function
, filter: function(array, block) {
    var i
      , il = array.length
      , result = []

    for (i = 0; i < il; i++)
      if (block(array[i]))
        result.push(array[i])

    return result
  }

  // Degrees to radians
, radians: function(d) {
    return d % 360 * Math.PI / 180
  }

  // Radians to degrees
, degrees: function(r) {
    return r * 180 / Math.PI % 360
  }

, filterSVGElements: function(nodes) {
    return this.filter( nodes, function(el) { return el instanceof window.SVGElement })
  }

}

SVG.defaults = {
  // Default attribute values
  attrs: {
    // fill and stroke
    'fill-opacity':     1
  , 'stroke-opacity':   1
  , 'stroke-width':     0
  , 'stroke-linejoin':  'miter'
  , 'stroke-linecap':   'butt'
  , fill:               '#000000'
  , stroke:             '#000000'
  , opacity:            1
    // position
  , x:                  0
  , y:                  0
  , cx:                 0
  , cy:                 0
    // size
  , width:              0
  , height:             0
    // radius
  , r:                  0
  , rx:                 0
  , ry:                 0
    // gradient
  , offset:             0
  , 'stop-opacity':     1
  , 'stop-color':       '#000000'
    // text
  , 'font-size':        16
  , 'font-family':      'Helvetica, Arial, sans-serif'
  , 'text-anchor':      'start'
  }

}
// Module for color convertions
SVG.Color = function(color) {
  var match

  // initialize defaults
  this.r = 0
  this.g = 0
  this.b = 0

  if(!color) return

  // parse color
  if (typeof color === 'string') {
    if (SVG.regex.isRgb.test(color)) {
      // get rgb values
      match = SVG.regex.rgb.exec(color.replace(SVG.regex.whitespace,''))

      // parse numeric values
      this.r = parseInt(match[1])
      this.g = parseInt(match[2])
      this.b = parseInt(match[3])

    } else if (SVG.regex.isHex.test(color)) {
      // get hex values
      match = SVG.regex.hex.exec(fullHex(color))

      // parse numeric values
      this.r = parseInt(match[1], 16)
      this.g = parseInt(match[2], 16)
      this.b = parseInt(match[3], 16)

    }

  } else if (typeof color === 'object') {
    this.r = color.r
    this.g = color.g
    this.b = color.b

  }

}

SVG.extend(SVG.Color, {
  // Default to hex conversion
  toString: function() {
    return this.toHex()
  }
  // Build hex value
, toHex: function() {
    return '#'
      + compToHex(this.r)
      + compToHex(this.g)
      + compToHex(this.b)
  }
  // Build rgb value
, toRgb: function() {
    return 'rgb(' + [this.r, this.g, this.b].join() + ')'
  }
  // Calculate true brightness
, brightness: function() {
    return (this.r / 255 * 0.30)
         + (this.g / 255 * 0.59)
         + (this.b / 255 * 0.11)
  }
  // Make color morphable
, morph: function(color) {
    this.destination = new SVG.Color(color)

    return this
  }
  // Get morphed color at given position
, at: function(pos) {
    // make sure a destination is defined
    if (!this.destination) return this

    // normalise pos
    pos = pos < 0 ? 0 : pos > 1 ? 1 : pos

    // generate morphed color
    return new SVG.Color({
      r: ~~(this.r + (this.destination.r - this.r) * pos)
    , g: ~~(this.g + (this.destination.g - this.g) * pos)
    , b: ~~(this.b + (this.destination.b - this.b) * pos)
    })
  }

})

// Testers

// Test if given value is a color string
SVG.Color.test = function(color) {
  color += ''
  return SVG.regex.isHex.test(color)
      || SVG.regex.isRgb.test(color)
}

// Test if given value is a rgb object
SVG.Color.isRgb = function(color) {
  return color && typeof color.r == 'number'
               && typeof color.g == 'number'
               && typeof color.b == 'number'
}

// Test if given value is a color
SVG.Color.isColor = function(color) {
  return SVG.Color.isRgb(color) || SVG.Color.test(color)
}
// Module for array conversion
SVG.Array = function(array, fallback) {
  array = (array || []).valueOf()

  // if array is empty and fallback is provided, use fallback
  if (array.length == 0 && fallback)
    array = fallback.valueOf()

  // parse array
  this.value = this.parse(array)
}

SVG.extend(SVG.Array, {
  // Make array morphable
  morph: function(array) {
    this.destination = this.parse(array)

    // normalize length of arrays
    if (this.value.length != this.destination.length) {
      var lastValue       = this.value[this.value.length - 1]
        , lastDestination = this.destination[this.destination.length - 1]

      while(this.value.length > this.destination.length)
        this.destination.push(lastDestination)
      while(this.value.length < this.destination.length)
        this.value.push(lastValue)
    }

    return this
  }
  // Clean up any duplicate points
, settle: function() {
    // find all unique values
    for (var i = 0, il = this.value.length, seen = []; i < il; i++)
      if (seen.indexOf(this.value[i]) == -1)
        seen.push(this.value[i])

    // set new value
    return this.value = seen
  }
  // Get morphed array at given position
, at: function(pos) {
    // make sure a destination is defined
    if (!this.destination) return this

    // generate morphed array
    for (var i = 0, il = this.value.length, array = []; i < il; i++)
      array.push(this.value[i] + (this.destination[i] - this.value[i]) * pos)

    return new SVG.Array(array)
  }
  // Convert array to string
, toString: function() {
    return this.value.join(' ')
  }
  // Real value
, valueOf: function() {
    return this.value
  }
  // Parse whitespace separated string
, parse: function(array) {
    array = array.valueOf()

    // if already is an array, no need to parse it
    if (Array.isArray(array)) return array

    return this.split(array)
  }
  // Strip unnecessary whitespace
, split: function(string) {
    return string.trim().split(SVG.regex.delimiter).map(parseFloat)
  }
  // Reverse array
, reverse: function() {
    this.value.reverse()

    return this
  }
, clone: function() {
    var clone = new this.constructor()
    clone.value = array_clone(this.value)
    return clone
  }
})
// Poly points array
SVG.PointArray = function(array, fallback) {
  SVG.Array.call(this, array, fallback || [[0,0]])
}

// Inherit from SVG.Array
SVG.PointArray.prototype = new SVG.Array
SVG.PointArray.prototype.constructor = SVG.PointArray

SVG.extend(SVG.PointArray, {
  // Convert array to string
  toString: function() {
    // convert to a poly point string
    for (var i = 0, il = this.value.length, array = []; i < il; i++)
      array.push(this.value[i].join(','))

    return array.join(' ')
  }
  // Convert array to line object
, toLine: function() {
    return {
      x1: this.value[0][0]
    , y1: this.value[0][1]
    , x2: this.value[1][0]
    , y2: this.value[1][1]
    }
  }
  // Get morphed array at given position
, at: function(pos) {
    // make sure a destination is defined
    if (!this.destination) return this

    // generate morphed point string
    for (var i = 0, il = this.value.length, array = []; i < il; i++)
      array.push([
        this.value[i][0] + (this.destination[i][0] - this.value[i][0]) * pos
      , this.value[i][1] + (this.destination[i][1] - this.value[i][1]) * pos
      ])

    return new SVG.PointArray(array)
  }
  // Parse point string and flat array
, parse: function(array) {
    var points = []

    array = array.valueOf()

    // if it is an array
    if (Array.isArray(array)) {
      // and it is not flat, there is no need to parse it
      if(Array.isArray(array[0])) {
        // make sure to use a clone
        return array.map(function (el) { return el.slice() })
      } else if (array[0].x != null){
        // allow point objects to be passed
        return array.map(function (el) { return [el.x, el.y] })
      }
    } else { // Else, it is considered as a string
      // parse points
      array = array.trim().split(SVG.regex.delimiter).map(parseFloat)
    }

    // validate points - https://svgwg.org/svg2-draft/shapes.html#DataTypePoints
    // Odd number of coordinates is an error. In such cases, drop the last odd coordinate.
    if (array.length % 2 !== 0) array.pop()

    // wrap points in two-tuples and parse points as floats
    for(var i = 0, len = array.length; i < len; i = i + 2)
      points.push([ array[i], array[i+1] ])

    return points
  }
  // Move point string
, move: function(x, y) {
    var box = this.bbox()

    // get relative offset
    x -= box.x
    y -= box.y

    // move every point
    if (!isNaN(x) && !isNaN(y))
      for (var i = this.value.length - 1; i >= 0; i--)
        this.value[i] = [this.value[i][0] + x, this.value[i][1] + y]

    return this
  }
  // Resize poly string
, size: function(width, height) {
    var i, box = this.bbox()

    // recalculate position of all points according to new size
    for (i = this.value.length - 1; i >= 0; i--) {
      if(box.width) this.value[i][0] = ((this.value[i][0] - box.x) * width)  / box.width  + box.x
      if(box.height) this.value[i][1] = ((this.value[i][1] - box.y) * height) / box.height + box.y
    }

    return this
  }
  // Get bounding box of points
, bbox: function() {
    SVG.parser.poly.setAttribute('points', this.toString())

    return SVG.parser.poly.getBBox()
  }
})

var pathHandlers = {
  M: function(c, p, p0) {
    p.x = p0.x = c[0]
    p.y = p0.y = c[1]

    return ['M', p.x, p.y]
  },
  L: function(c, p) {
    p.x = c[0]
    p.y = c[1]
    return ['L', c[0], c[1]]
  },
  H: function(c, p) {
    p.x = c[0]
    return ['H', c[0]]
  },
  V: function(c, p) {
    p.y = c[0]
    return ['V', c[0]]
  },
  C: function(c, p) {
    p.x = c[4]
    p.y = c[5]
    return ['C', c[0], c[1], c[2], c[3], c[4], c[5]]
  },
  S: function(c, p) {
    p.x = c[2]
    p.y = c[3]
    return ['S', c[0], c[1], c[2], c[3]]
  },
  Q: function(c, p) {
    p.x = c[2]
    p.y = c[3]
    return ['Q', c[0], c[1], c[2], c[3]]
  },
  T: function(c, p) {
    p.x = c[0]
    p.y = c[1]
    return ['T', c[0], c[1]]
  },
  Z: function(c, p, p0) {
    p.x = p0.x
    p.y = p0.y
    return ['Z']
  },
  A: function(c, p) {
    p.x = c[5]
    p.y = c[6]
    return ['A', c[0], c[1], c[2], c[3], c[4], c[5], c[6]]
  }
}

var mlhvqtcsa = 'mlhvqtcsaz'.split('')

for(var i = 0, il = mlhvqtcsa.length; i < il; ++i){
  pathHandlers[mlhvqtcsa[i]] = (function(i){
    return function(c, p, p0) {
      if(i == 'H') c[0] = c[0] + p.x
      else if(i == 'V') c[0] = c[0] + p.y
      else if(i == 'A'){
        c[5] = c[5] + p.x,
        c[6] = c[6] + p.y
      }
      else
        for(var j = 0, jl = c.length; j < jl; ++j) {
          c[j] = c[j] + (j%2 ? p.y : p.x)
        }

      return pathHandlers[i](c, p, p0)
    }
  })(mlhvqtcsa[i].toUpperCase())
}

// Path points array
SVG.PathArray = function(array, fallback) {
  SVG.Array.call(this, array, fallback || [['M', 0, 0]])
}

// Inherit from SVG.Array
SVG.PathArray.prototype = new SVG.Array
SVG.PathArray.prototype.constructor = SVG.PathArray

SVG.extend(SVG.PathArray, {
  // Convert array to string
  toString: function() {
    return arrayToString(this.value)
  }
  // Move path string
, move: function(x, y) {
    // get bounding box of current situation
    var box = this.bbox()

    // get relative offset
    x -= box.x
    y -= box.y

    if (!isNaN(x) && !isNaN(y)) {
      // move every point
      for (var l, i = this.value.length - 1; i >= 0; i--) {
        l = this.value[i][0]

        if (l == 'M' || l == 'L' || l == 'T')  {
          this.value[i][1] += x
          this.value[i][2] += y

        } else if (l == 'H')  {
          this.value[i][1] += x

        } else if (l == 'V')  {
          this.value[i][1] += y

        } else if (l == 'C' || l == 'S' || l == 'Q')  {
          this.value[i][1] += x
          this.value[i][2] += y
          this.value[i][3] += x
          this.value[i][4] += y

          if (l == 'C')  {
            this.value[i][5] += x
            this.value[i][6] += y
          }

        } else if (l == 'A')  {
          this.value[i][6] += x
          this.value[i][7] += y
        }

      }
    }

    return this
  }
  // Resize path string
, size: function(width, height) {
    // get bounding box of current situation
    var i, l, box = this.bbox()

    // recalculate position of all points according to new size
    for (i = this.value.length - 1; i >= 0; i--) {
      l = this.value[i][0]

      if (l == 'M' || l == 'L' || l == 'T')  {
        this.value[i][1] = ((this.value[i][1] - box.x) * width)  / box.width  + box.x
        this.value[i][2] = ((this.value[i][2] - box.y) * height) / box.height + box.y

      } else if (l == 'H')  {
        this.value[i][1] = ((this.value[i][1] - box.x) * width)  / box.width  + box.x

      } else if (l == 'V')  {
        this.value[i][1] = ((this.value[i][1] - box.y) * height) / box.height + box.y

      } else if (l == 'C' || l == 'S' || l == 'Q')  {
        this.value[i][1] = ((this.value[i][1] - box.x) * width)  / box.width  + box.x
        this.value[i][2] = ((this.value[i][2] - box.y) * height) / box.height + box.y
        this.value[i][3] = ((this.value[i][3] - box.x) * width)  / box.width  + box.x
        this.value[i][4] = ((this.value[i][4] - box.y) * height) / box.height + box.y

        if (l == 'C')  {
          this.value[i][5] = ((this.value[i][5] - box.x) * width)  / box.width  + box.x
          this.value[i][6] = ((this.value[i][6] - box.y) * height) / box.height + box.y
        }

      } else if (l == 'A')  {
        // resize radii
        this.value[i][1] = (this.value[i][1] * width)  / box.width
        this.value[i][2] = (this.value[i][2] * height) / box.height

        // move position values
        this.value[i][6] = ((this.value[i][6] - box.x) * width)  / box.width  + box.x
        this.value[i][7] = ((this.value[i][7] - box.y) * height) / box.height + box.y
      }

    }

    return this
  }
  // Test if the passed path array use the same path data commands as this path array
, equalCommands: function(pathArray) {
    var i, il, equalCommands

    pathArray = new SVG.PathArray(pathArray)

    equalCommands = this.value.length === pathArray.value.length
    for(i = 0, il = this.value.length; equalCommands && i < il; i++) {
      equalCommands = this.value[i][0] === pathArray.value[i][0]
    }

    return equalCommands
  }
  // Make path array morphable
, morph: function(pathArray) {
    pathArray = new SVG.PathArray(pathArray)

    if(this.equalCommands(pathArray)) {
      this.destination = pathArray
    } else {
      this.destination = null
    }

    return this
  }
  // Get morphed path array at given position
, at: function(pos) {
    // make sure a destination is defined
    if (!this.destination) return this

    var sourceArray = this.value
      , destinationArray = this.destination.value
      , array = [], pathArray = new SVG.PathArray()
      , i, il, j, jl

    // Animate has specified in the SVG spec
    // See: https://www.w3.org/TR/SVG11/paths.html#PathElement
    for (i = 0, il = sourceArray.length; i < il; i++) {
      array[i] = [sourceArray[i][0]]
      for(j = 1, jl = sourceArray[i].length; j < jl; j++) {
        array[i][j] = sourceArray[i][j] + (destinationArray[i][j] - sourceArray[i][j]) * pos
      }
      // For the two flags of the elliptical arc command, the SVG spec say:
      // Flags and booleans are interpolated as fractions between zero and one, with any non-zero value considered to be a value of one/true
      // Elliptical arc command as an array followed by corresponding indexes:
      // ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
      //   0    1   2        3                 4             5      6  7
      if(array[i][0] === 'A') {
        array[i][4] = +(array[i][4] != 0)
        array[i][5] = +(array[i][5] != 0)
      }
    }

    // Directly modify the value of a path array, this is done this way for performance
    pathArray.value = array
    return pathArray
  }
  // Absolutize and parse path to array
, parse: function(array) {
    // if it's already a patharray, no need to parse it
    if (array instanceof SVG.PathArray) return array.valueOf()

    // prepare for parsing
    var i, x0, y0, s, seg, arr
      , x = 0
      , y = 0
      , paramCnt = { 'M':2, 'L':2, 'H':1, 'V':1, 'C':6, 'S':4, 'Q':4, 'T':2, 'A':7, 'Z':0 }

    if(typeof array == 'string'){

      array = array
        .replace(SVG.regex.numbersWithDots, pathRegReplace) // convert 45.123.123 to 45.123 .123
        .replace(SVG.regex.pathLetters, ' $& ') // put some room between letters and numbers
        .replace(SVG.regex.hyphen, '$1 -')      // add space before hyphen
        .trim()                                 // trim
        .split(SVG.regex.delimiter)   // split into array

    }else{
      array = array.reduce(function(prev, curr){
        return [].concat.call(prev, curr)
      }, [])
    }

    // array now is an array containing all parts of a path e.g. ['M', '0', '0', 'L', '30', '30' ...]
    var arr = []
      , p = new SVG.Point()
      , p0 = new SVG.Point()
      , index = 0
      , len = array.length

    do{
      // Test if we have a path letter
      if(SVG.regex.isPathLetter.test(array[index])){
        s = array[index]
        ++index
      // If last letter was a move command and we got no new, it defaults to [L]ine
      }else if(s == 'M'){
        s = 'L'
      }else if(s == 'm'){
        s = 'l'
      }

      arr.push(pathHandlers[s].call(null,
          array.slice(index, (index = index + paramCnt[s.toUpperCase()])).map(parseFloat),
          p, p0
        )
      )

    }while(len > index)

    return arr

  }
  // Get bounding box of path
, bbox: function() {
    SVG.parser.path.setAttribute('d', this.toString())

    return SVG.parser.path.getBBox()
  }

})

// Module for unit convertions
SVG.Number = SVG.invent({
  // Initialize
  create: function(value, unit) {
    // initialize defaults
    this.value = 0
    this.unit  = unit || ''

    // parse value
    if (typeof value === 'number') {
      // ensure a valid numeric value
      this.value = isNaN(value) ? 0 : !isFinite(value) ? (value < 0 ? -3.4e+38 : +3.4e+38) : value

    } else if (typeof value === 'string') {
      unit = value.match(SVG.regex.numberAndUnit)

      if (unit) {
        // make value numeric
        this.value = parseFloat(unit[1])

        // normalize
        if (unit[5] == '%')
          this.value /= 100
        else if (unit[5] == 's')
          this.value *= 1000

        // store unit
        this.unit = unit[5]
      }

    } else {
      if (value instanceof SVG.Number) {
        this.value = value.valueOf()
        this.unit  = value.unit
      }
    }

  }
  // Add methods
, extend: {
    // Stringalize
    toString: function() {
      return (
        this.unit == '%' ?
          ~~(this.value * 1e8) / 1e6:
        this.unit == 's' ?
          this.value / 1e3 :
          this.value
      ) + this.unit
    }
  , toJSON: function() {
      return this.toString()
    }
  , // Convert to primitive
    valueOf: function() {
      return this.value
    }
    // Add number
  , plus: function(number) {
      number = new SVG.Number(number)
      return new SVG.Number(this + number, this.unit || number.unit)
    }
    // Subtract number
  , minus: function(number) {
      number = new SVG.Number(number)
      return new SVG.Number(this - number, this.unit || number.unit)
    }
    // Multiply number
  , times: function(number) {
      number = new SVG.Number(number)
      return new SVG.Number(this * number, this.unit || number.unit)
    }
    // Divide number
  , divide: function(number) {
      number = new SVG.Number(number)
      return new SVG.Number(this / number, this.unit || number.unit)
    }
    // Convert to different unit
  , to: function(unit) {
      var number = new SVG.Number(this)

      if (typeof unit === 'string')
        number.unit = unit

      return number
    }
    // Make number morphable
  , morph: function(number) {
      this.destination = new SVG.Number(number)

      if(number.relative) {
        this.destination.value += this.value
      }

      return this
    }
    // Get morphed number at given position
  , at: function(pos) {
      // Make sure a destination is defined
      if (!this.destination) return this

      // Generate new morphed number
      return new SVG.Number(this.destination)
          .minus(this)
          .times(pos)
          .plus(this)
    }

  }
})


SVG.Element = SVG.invent({
  // Initialize node
  create: function(node) {
    // make stroke value accessible dynamically
    this._stroke = SVG.defaults.attrs.stroke
    this._event = null
    this._events = {}

    // initialize data object
    this.dom = {}

    // create circular reference
    if (this.node = node) {
      this.type = node.nodeName
      this.node.instance = this
      this._events = node._events || {}

      // store current attribute value
      this._stroke = node.getAttribute('stroke') || this._stroke
    }
  }

  // Add class methods
, extend: {
    // Move over x-axis
    x: function(x) {
      return this.attr('x', x)
    }
    // Move over y-axis
  , y: function(y) {
      return this.attr('y', y)
    }
    // Move by center over x-axis
  , cx: function(x) {
      return x == null ? this.x() + this.width() / 2 : this.x(x - this.width() / 2)
    }
    // Move by center over y-axis
  , cy: function(y) {
      return y == null ? this.y() + this.height() / 2 : this.y(y - this.height() / 2)
    }
    // Move element to given x and y values
  , move: function(x, y) {
      return this.x(x).y(y)
    }
    // Move element by its center
  , center: function(x, y) {
      return this.cx(x).cy(y)
    }
    // Set width of element
  , width: function(width) {
      return this.attr('width', width)
    }
    // Set height of element
  , height: function(height) {
      return this.attr('height', height)
    }
    // Set element size to given width and height
  , size: function(width, height) {
      var p = proportionalSize(this, width, height)

      return this
        .width(new SVG.Number(p.width))
        .height(new SVG.Number(p.height))
    }
    // Clone element
  , clone: function(parent) {
      // write dom data to the dom so the clone can pickup the data
      this.writeDataToDom()

      // clone element and assign new id
      var clone = assignNewId(this.node.cloneNode(true))

      // insert the clone in the given parent or after myself
      if(parent) parent.add(clone)
      else this.after(clone)

      return clone
    }
    // Remove element
  , remove: function() {
      if (this.parent())
        this.parent().removeElement(this)

      return this
    }
    // Replace element
  , replace: function(element) {
      this.after(element).remove()

      return element
    }
    // Add element to given container and return self
  , addTo: function(parent) {
      return parent.put(this)
    }
    // Add element to given container and return container
  , putIn: function(parent) {
      return parent.add(this)
    }
    // Get / set id
  , id: function(id) {
      return this.attr('id', id)
    }
    // Checks whether the given point inside the bounding box of the element
  , inside: function(x, y) {
      var box = this.bbox()

      return x > box.x
          && y > box.y
          && x < box.x + box.width
          && y < box.y + box.height
    }
    // Show element
  , show: function() {
      return this.style('display', '')
    }
    // Hide element
  , hide: function() {
      return this.style('display', 'none')
    }
    // Is element visible?
  , visible: function() {
      return this.style('display') != 'none'
    }
    // Return id on string conversion
  , toString: function() {
      return this.attr('id')
    }
    // Return array of classes on the node
  , classes: function() {
      var attr = this.attr('class')

      return attr == null ? [] : attr.trim().split(SVG.regex.delimiter)
    }
    // Return true if class exists on the node, false otherwise
  , hasClass: function(name) {
      return this.classes().indexOf(name) != -1
    }
    // Add class to the node
  , addClass: function(name) {
      if (!this.hasClass(name)) {
        var array = this.classes()
        array.push(name)
        this.attr('class', array.join(' '))
      }

      return this
    }
    // Remove class from the node
  , removeClass: function(name) {
      if (this.hasClass(name)) {
        this.attr('class', this.classes().filter(function(c) {
          return c != name
        }).join(' '))
      }

      return this
    }
    // Toggle the presence of a class on the node
  , toggleClass: function(name) {
      return this.hasClass(name) ? this.removeClass(name) : this.addClass(name)
    }
    // Get referenced element form attribute value
  , reference: function(attr) {
      return SVG.get(this.attr(attr))
    }
    // Returns the parent element instance
  , parent: function(type) {
      var parent = this

      // check for parent
      if(!parent.node.parentNode) return null

      // get parent element
      parent = SVG.adopt(parent.node.parentNode)

      if(!type) return parent

      // loop trough ancestors if type is given
      while(parent && parent.node instanceof window.SVGElement){
        if(typeof type === 'string' ? parent.matches(type) : parent instanceof type) return parent
        if(!parent.node.parentNode || parent.node.parentNode.nodeName == '#document' || parent.node.parentNode.nodeName == '#document-fragment') return null // #759, #720
        parent = SVG.adopt(parent.node.parentNode)
      }
    }
    // Get parent document
  , doc: function() {
      return this instanceof SVG.Doc ? this : this.parent(SVG.Doc)
    }
    // return array of all ancestors of given type up to the root svg
  , parents: function(type) {
      var parents = [], parent = this

      do{
        parent = parent.parent(type)
        if(!parent || !parent.node) break

        parents.push(parent)
      } while(parent.parent)

      return parents
    }
    // matches the element vs a css selector
  , matches: function(selector){
      return matches(this.node, selector)
    }
    // Returns the svg node to call native svg methods on it
  , native: function() {
      return this.node
    }
    // Import raw svg
  , svg: function(svg) {
      // create temporary holder
      var well = document.createElement('svg')

      // act as a setter if svg is given
      if (svg && this instanceof SVG.Parent) {
        // dump raw svg
        well.innerHTML = '<svg>' + svg.replace(/\n/, '').replace(/<([\w:-]+)([^<]+?)\/>/g, '<$1$2></$1>') + '</svg>'

        // transplant nodes
        for (var i = 0, il = well.firstChild.childNodes.length; i < il; i++)
          this.node.appendChild(well.firstChild.firstChild)

      // otherwise act as a getter
      } else {
        // create a wrapping svg element in case of partial content
        well.appendChild(svg = document.createElement('svg'))

        // write svgjs data to the dom
        this.writeDataToDom()

        // insert a copy of this node
        svg.appendChild(this.node.cloneNode(true))

        // return target element
        return well.innerHTML.replace(/^<svg>/, '').replace(/<\/svg>$/, '')
      }

      return this
    }
  // write svgjs data to the dom
  , writeDataToDom: function() {

      // dump variables recursively
      if(this.each || this.lines){
        var fn = this.each ? this : this.lines();
        fn.each(function(){
          this.writeDataToDom()
        })
      }

      // remove previously set data
      this.node.removeAttribute('svgjs:data')

      if(Object.keys(this.dom).length)
        this.node.setAttribute('svgjs:data', JSON.stringify(this.dom)) // see #428

      return this
    }
  // set given data to the elements data property
  , setData: function(o){
      this.dom = o
      return this
    }
  , is: function(obj){
      return is(this, obj)
    }
  }
})

SVG.easing = {
  '-': function(pos){return pos}
, '<>':function(pos){return -Math.cos(pos * Math.PI) / 2 + 0.5}
, '>': function(pos){return  Math.sin(pos * Math.PI / 2)}
, '<': function(pos){return -Math.cos(pos * Math.PI / 2) + 1}
}

SVG.morph = function(pos){
  return function(from, to) {
    return new SVG.MorphObj(from, to).at(pos)
  }
}

SVG.Situation = SVG.invent({

  create: function(o){
    this.init = false
    this.reversed = false
    this.reversing = false

    this.duration = new SVG.Number(o.duration).valueOf()
    this.delay = new SVG.Number(o.delay).valueOf()

    this.start = +new Date() + this.delay
    this.finish = this.start + this.duration
    this.ease = o.ease

    // this.loop is incremented from 0 to this.loops
    // it is also incremented when in an infinite loop (when this.loops is true)
    this.loop = 0
    this.loops = false

    this.animations = {
      // functionToCall: [list of morphable objects]
      // e.g. move: [SVG.Number, SVG.Number]
    }

    this.attrs = {
      // holds all attributes which are not represented from a function svg.js provides
      // e.g. someAttr: SVG.Number
    }

    this.styles = {
      // holds all styles which should be animated
      // e.g. fill-color: SVG.Color
    }

    this.transforms = [
      // holds all transformations as transformation objects
      // e.g. [SVG.Rotate, SVG.Translate, SVG.Matrix]
    ]

    this.once = {
      // functions to fire at a specific position
      // e.g. "0.5": function foo(){}
    }

  }

})


SVG.FX = SVG.invent({

  create: function(element) {
    this._target = element
    this.situations = []
    this.active = false
    this.situation = null
    this.paused = false
    this.lastPos = 0
    this.pos = 0
    // The absolute position of an animation is its position in the context of its complete duration (including delay and loops)
    // When performing a delay, absPos is below 0 and when performing a loop, its value is above 1
    this.absPos = 0
    this._speed = 1
  }

, extend: {

    /**
     * sets or returns the target of this animation
     * @param o object || number In case of Object it holds all parameters. In case of number its the duration of the animation
     * @param ease function || string Function which should be used for easing or easing keyword
     * @param delay Number indicating the delay before the animation starts
     * @return target || this
     */
    animate: function(o, ease, delay){

      if(typeof o == 'object'){
        ease = o.ease
        delay = o.delay
        o = o.duration
      }

      var situation = new SVG.Situation({
        duration: o || 1000,
        delay: delay || 0,
        ease: SVG.easing[ease || '-'] || ease
      })

      this.queue(situation)

      return this
    }

    /**
     * sets a delay before the next element of the queue is called
     * @param delay Duration of delay in milliseconds
     * @return this.target()
     */
  , delay: function(delay){
      // The delay is performed by an empty situation with its duration
      // attribute set to the duration of the delay
      var situation = new SVG.Situation({
        duration: delay,
        delay: 0,
        ease: SVG.easing['-']
      })

      return this.queue(situation)
    }

    /**
     * sets or returns the target of this animation
     * @param null || target SVG.Element which should be set as new target
     * @return target || this
     */
  , target: function(target){
      if(target && target instanceof SVG.Element){
        this._target = target
        return this
      }

      return this._target
    }

    // returns the absolute position at a given time
  , timeToAbsPos: function(timestamp){
      return (timestamp - this.situation.start) / (this.situation.duration/this._speed)
    }

    // returns the timestamp from a given absolute positon
  , absPosToTime: function(absPos){
      return this.situation.duration/this._speed * absPos + this.situation.start
    }

    // starts the animationloop
  , startAnimFrame: function(){
      this.stopAnimFrame()
      this.animationFrame = window.requestAnimationFrame(function(){ this.step() }.bind(this))
    }

    // cancels the animationframe
  , stopAnimFrame: function(){
      window.cancelAnimationFrame(this.animationFrame)
    }

    // kicks off the animation - only does something when the queue is currently not active and at least one situation is set
  , start: function(){
      // dont start if already started
      if(!this.active && this.situation){
        this.active = true
        this.startCurrent()
      }

      return this
    }

    // start the current situation
  , startCurrent: function(){
      this.situation.start = +new Date + this.situation.delay/this._speed
      this.situation.finish = this.situation.start + this.situation.duration/this._speed
      return this.initAnimations().step()
    }

    /**
     * adds a function / Situation to the animation queue
     * @param fn function / situation to add
     * @return this
     */
  , queue: function(fn){
      if(typeof fn == 'function' || fn instanceof SVG.Situation)
        this.situations.push(fn)

      if(!this.situation) this.situation = this.situations.shift()

      return this
    }

    /**
     * pulls next element from the queue and execute it
     * @return this
     */
  , dequeue: function(){
      // stop current animation
      this.stop()

      // get next animation from queue
      this.situation = this.situations.shift()

      if(this.situation){
        if(this.situation instanceof SVG.Situation) {
          this.start()
        } else {
          // If it is not a SVG.Situation, then it is a function, we execute it
          this.situation.call(this)
        }
      }

      return this
    }

    // updates all animations to the current state of the element
    // this is important when one property could be changed from another property
  , initAnimations: function() {
      var i, j, source
      var s = this.situation

      if(s.init) return this

      for(i in s.animations){
        source = this.target()[i]()

        if(!Array.isArray(source)) {
          source = [source]
        }

        if(!Array.isArray(s.animations[i])) {
          s.animations[i] = [s.animations[i]]
        }

        //if(s.animations[i].length > source.length) {
        //  source.concat = source.concat(s.animations[i].slice(source.length, s.animations[i].length))
        //}

        for(j = source.length; j--;) {
          // The condition is because some methods return a normal number instead
          // of a SVG.Number
          if(s.animations[i][j] instanceof SVG.Number)
            source[j] = new SVG.Number(source[j])

          s.animations[i][j] = source[j].morph(s.animations[i][j])
        }
      }

      for(i in s.attrs){
        s.attrs[i] = new SVG.MorphObj(this.target().attr(i), s.attrs[i])
      }

      for(i in s.styles){
        s.styles[i] = new SVG.MorphObj(this.target().style(i), s.styles[i])
      }

      s.initialTransformation = this.target().matrixify()

      s.init = true
      return this
    }
  , clearQueue: function(){
      this.situations = []
      return this
    }
  , clearCurrent: function(){
      this.situation = null
      return this
    }
    /** stops the animation immediately
     * @param jumpToEnd A Boolean indicating whether to complete the current animation immediately.
     * @param clearQueue A Boolean indicating whether to remove queued animation as well.
     * @return this
     */
  , stop: function(jumpToEnd, clearQueue){
      var active = this.active
      this.active = false

      if(clearQueue){
        this.clearQueue()
      }

      if(jumpToEnd && this.situation){
        // initialize the situation if it was not
        !active && this.startCurrent()
        this.atEnd()
      }

      this.stopAnimFrame()

      return this.clearCurrent()
    }

    /** resets the element to the state where the current element has started
     * @return this
     */
  , reset: function(){
      if(this.situation){
        var temp = this.situation
        this.stop()
        this.situation = temp
        this.atStart()
      }
      return this
    }

    // Stop the currently-running animation, remove all queued animations, and complete all animations for the element.
  , finish: function(){

      this.stop(true, false)

      while(this.dequeue().situation && this.stop(true, false));

      this.clearQueue().clearCurrent()

      return this
    }

    // set the internal animation pointer at the start position, before any loops, and updates the visualisation
  , atStart: function() {
      return this.at(0, true)
    }

    // set the internal animation pointer at the end position, after all the loops, and updates the visualisation
  , atEnd: function() {
      if (this.situation.loops === true) {
        // If in a infinite loop, we end the current iteration
        this.situation.loops = this.situation.loop + 1
      }

      if(typeof this.situation.loops == 'number') {
        // If performing a finite number of loops, we go after all the loops
        return this.at(this.situation.loops, true)
      } else {
        // If no loops, we just go at the end
        return this.at(1, true)
      }
    }

    // set the internal animation pointer to the specified position and updates the visualisation
    // if isAbsPos is true, pos is treated as an absolute position
  , at: function(pos, isAbsPos){
      var durDivSpd = this.situation.duration/this._speed

      this.absPos = pos
      // If pos is not an absolute position, we convert it into one
      if (!isAbsPos) {
        if (this.situation.reversed) this.absPos = 1 - this.absPos
        this.absPos += this.situation.loop
      }

      this.situation.start = +new Date - this.absPos * durDivSpd
      this.situation.finish = this.situation.start + durDivSpd

      return this.step(true)
    }

    /**
     * sets or returns the speed of the animations
     * @param speed null || Number The new speed of the animations
     * @return Number || this
     */
  , speed: function(speed){
      if (speed === 0) return this.pause()

      if (speed) {
        this._speed = speed
        // We use an absolute position here so that speed can affect the delay before the animation
        return this.at(this.absPos, true)
      } else return this._speed
    }

    // Make loopable
  , loop: function(times, reverse) {
      var c = this.last()

      // store total loops
      c.loops = (times != null) ? times : true
      c.loop = 0

      if(reverse) c.reversing = true
      return this
    }

    // pauses the animation
  , pause: function(){
      this.paused = true
      this.stopAnimFrame()

      return this
    }

    // unpause the animation
  , play: function(){
      if(!this.paused) return this
      this.paused = false
      // We use an absolute position here so that the delay before the animation can be paused
      return this.at(this.absPos, true)
    }

    /**
     * toggle or set the direction of the animation
     * true sets direction to backwards while false sets it to forwards
     * @param reversed Boolean indicating whether to reverse the animation or not (default: toggle the reverse status)
     * @return this
     */
  , reverse: function(reversed){
      var c = this.last()

      if(typeof reversed == 'undefined') c.reversed = !c.reversed
      else c.reversed = reversed

      return this
    }


    /**
     * returns a float from 0-1 indicating the progress of the current animation
     * @param eased Boolean indicating whether the returned position should be eased or not
     * @return number
     */
  , progress: function(easeIt){
      return easeIt ? this.situation.ease(this.pos) : this.pos
    }

    /**
     * adds a callback function which is called when the current animation is finished
     * @param fn Function which should be executed as callback
     * @return number
     */
  , after: function(fn){
      var c = this.last()
        , wrapper = function wrapper(e){
            if(e.detail.situation == c){
              fn.call(this, c)
              this.off('finished.fx', wrapper) // prevent memory leak
            }
          }

      this.target().on('finished.fx', wrapper)

      return this._callStart()
    }

    // adds a callback which is called whenever one animation step is performed
  , during: function(fn){
      var c = this.last()
        , wrapper = function(e){
            if(e.detail.situation == c){
              fn.call(this, e.detail.pos, SVG.morph(e.detail.pos), e.detail.eased, c)
            }
          }

      // see above
      this.target().off('during.fx', wrapper).on('during.fx', wrapper)

      this.after(function(){
        this.off('during.fx', wrapper)
      })

      return this._callStart()
    }

    // calls after ALL animations in the queue are finished
  , afterAll: function(fn){
      var wrapper = function wrapper(e){
            fn.call(this)
            this.off('allfinished.fx', wrapper)
          }

      // see above
      this.target().off('allfinished.fx', wrapper).on('allfinished.fx', wrapper)

      return this._callStart()
    }

    // calls on every animation step for all animations
  , duringAll: function(fn){
      var wrapper = function(e){
            fn.call(this, e.detail.pos, SVG.morph(e.detail.pos), e.detail.eased, e.detail.situation)
          }

      this.target().off('during.fx', wrapper).on('during.fx', wrapper)

      this.afterAll(function(){
        this.off('during.fx', wrapper)
      })

      return this._callStart()
    }

  , last: function(){
      return this.situations.length ? this.situations[this.situations.length-1] : this.situation
    }

    // adds one property to the animations
  , add: function(method, args, type){
      this.last()[type || 'animations'][method] = args
      return this._callStart()
    }

    /** perform one step of the animation
     *  @param ignoreTime Boolean indicating whether to ignore time and use position directly or recalculate position based on time
     *  @return this
     */
  , step: function(ignoreTime){

      // convert current time to an absolute position
      if(!ignoreTime) this.absPos = this.timeToAbsPos(+new Date)

      // This part convert an absolute position to a position
      if(this.situation.loops !== false) {
        var absPos, absPosInt, lastLoop

        // If the absolute position is below 0, we just treat it as if it was 0
        absPos = Math.max(this.absPos, 0)
        absPosInt = Math.floor(absPos)

        if(this.situation.loops === true || absPosInt < this.situation.loops) {
          this.pos = absPos - absPosInt
          lastLoop = this.situation.loop
          this.situation.loop = absPosInt
        } else {
          this.absPos = this.situation.loops
          this.pos = 1
          // The -1 here is because we don't want to toggle reversed when all the loops have been completed
          lastLoop = this.situation.loop - 1
          this.situation.loop = this.situation.loops
        }

        if(this.situation.reversing) {
          // Toggle reversed if an odd number of loops as occured since the last call of step
          this.situation.reversed = this.situation.reversed != Boolean((this.situation.loop - lastLoop) % 2)
        }

      } else {
        // If there are no loop, the absolute position must not be above 1
        this.absPos = Math.min(this.absPos, 1)
        this.pos = this.absPos
      }

      // while the absolute position can be below 0, the position must not be below 0
      if(this.pos < 0) this.pos = 0

      if(this.situation.reversed) this.pos = 1 - this.pos


      // apply easing
      var eased = this.situation.ease(this.pos)

      // call once-callbacks
      for(var i in this.situation.once){
        if(i > this.lastPos && i <= eased){
          this.situation.once[i].call(this.target(), this.pos, eased)
          delete this.situation.once[i]
        }
      }

      // fire during callback with position, eased position and current situation as parameter
      if(this.active) this.target().fire('during', {pos: this.pos, eased: eased, fx: this, situation: this.situation})

      // the user may call stop or finish in the during callback
      // so make sure that we still have a valid situation
      if(!this.situation){
        return this
      }

      // apply the actual animation to every property
      this.eachAt()

      // do final code when situation is finished
      if((this.pos == 1 && !this.situation.reversed) || (this.situation.reversed && this.pos == 0)){

        // stop animation callback
        this.stopAnimFrame()

        // fire finished callback with current situation as parameter
        this.target().fire('finished', {fx:this, situation: this.situation})

        if(!this.situations.length){
          this.target().fire('allfinished')

          // Recheck the length since the user may call animate in the afterAll callback
          if(!this.situations.length){
            this.target().off('.fx') // there shouldnt be any binding left, but to make sure...
            this.active = false
          }
        }

        // start next animation
        if(this.active) this.dequeue()
        else this.clearCurrent()

      }else if(!this.paused && this.active){
        // we continue animating when we are not at the end
        this.startAnimFrame()
      }

      // save last eased position for once callback triggering
      this.lastPos = eased
      return this

    }

    // calculates the step for every property and calls block with it
  , eachAt: function(){
      var i, len, at, self = this, target = this.target(), s = this.situation

      // apply animations which can be called trough a method
      for(i in s.animations){

        at = [].concat(s.animations[i]).map(function(el){
          return typeof el !== 'string' && el.at ? el.at(s.ease(self.pos), self.pos) : el
        })

        target[i].apply(target, at)

      }

      // apply animation which has to be applied with attr()
      for(i in s.attrs){

        at = [i].concat(s.attrs[i]).map(function(el){
          return typeof el !== 'string' && el.at ? el.at(s.ease(self.pos), self.pos) : el
        })

        target.attr.apply(target, at)

      }

      // apply animation which has to be applied with style()
      for(i in s.styles){

        at = [i].concat(s.styles[i]).map(function(el){
          return typeof el !== 'string' && el.at ? el.at(s.ease(self.pos), self.pos) : el
        })

        target.style.apply(target, at)

      }

      // animate initialTransformation which has to be chained
      if(s.transforms.length){

        // get initial initialTransformation
        at = s.initialTransformation
        for(i = 0, len = s.transforms.length; i < len; i++){

          // get next transformation in chain
          var a = s.transforms[i]

          // multiply matrix directly
          if(a instanceof SVG.Matrix){

            if(a.relative){
              at = at.multiply(new SVG.Matrix().morph(a).at(s.ease(this.pos)))
            }else{
              at = at.morph(a).at(s.ease(this.pos))
            }
            continue
          }

          // when transformation is absolute we have to reset the needed transformation first
          if(!a.relative)
            a.undo(at.extract())

          // and reapply it after
          at = at.multiply(a.at(s.ease(this.pos)))

        }

        // set new matrix on element
        target.matrix(at)
      }

      return this

    }


    // adds an once-callback which is called at a specific position and never again
  , once: function(pos, fn, isEased){
      var c = this.last()
      if(!isEased) pos = c.ease(pos)

      c.once[pos] = fn

      return this
    }

  , _callStart: function() {
      setTimeout(function(){this.start()}.bind(this), 0)
      return this
    }

  }

, parent: SVG.Element

  // Add method to parent elements
, construct: {
    // Get fx module or create a new one, then animate with given duration and ease
    animate: function(o, ease, delay) {
      return (this.fx || (this.fx = new SVG.FX(this))).animate(o, ease, delay)
    }
  , delay: function(delay){
      return (this.fx || (this.fx = new SVG.FX(this))).delay(delay)
    }
  , stop: function(jumpToEnd, clearQueue) {
      if (this.fx)
        this.fx.stop(jumpToEnd, clearQueue)

      return this
    }
  , finish: function() {
      if (this.fx)
        this.fx.finish()

      return this
    }
    // Pause current animation
  , pause: function() {
      if (this.fx)
        this.fx.pause()

      return this
    }
    // Play paused current animation
  , play: function() {
      if (this.fx)
        this.fx.play()

      return this
    }
    // Set/Get the speed of the animations
  , speed: function(speed) {
      if (this.fx)
        if (speed == null)
          return this.fx.speed()
        else
          this.fx.speed(speed)

      return this
    }
  }

})

// MorphObj is used whenever no morphable object is given
SVG.MorphObj = SVG.invent({

  create: function(from, to){
    // prepare color for morphing
    if(SVG.Color.isColor(to)) return new SVG.Color(from).morph(to)
    // check if we have a list of values
    if(SVG.regex.delimiter.test(from)) {
      // prepare path for morphing
      if(SVG.regex.pathLetters.test(from)) return new SVG.PathArray(from).morph(to)
      // prepare value list for morphing
      else return new SVG.Array(from).morph(to)
    }
    // prepare number for morphing
    if(SVG.regex.numberAndUnit.test(to)) return new SVG.Number(from).morph(to)

    // prepare for plain morphing
    this.value = from
    this.destination = to
  }

, extend: {
    at: function(pos, real){
      return real < 1 ? this.value : this.destination
    },

    valueOf: function(){
      return this.value
    }
  }

})

SVG.extend(SVG.FX, {
  // Add animatable attributes
  attr: function(a, v, relative) {
    // apply attributes individually
    if (typeof a == 'object') {
      for (var key in a)
        this.attr(key, a[key])

    } else {
      this.add(a, v, 'attrs')
    }

    return this
  }
  // Add animatable styles
, style: function(s, v) {
    if (typeof s == 'object')
      for (var key in s)
        this.style(key, s[key])

    else
      this.add(s, v, 'styles')

    return this
  }
  // Animatable x-axis
, x: function(x, relative) {
    if(this.target() instanceof SVG.G){
      this.transform({x:x}, relative)
      return this
    }

    var num = new SVG.Number(x)
    num.relative = relative
    return this.add('x', num)
  }
  // Animatable y-axis
, y: function(y, relative) {
    if(this.target() instanceof SVG.G){
      this.transform({y:y}, relative)
      return this
    }

    var num = new SVG.Number(y)
    num.relative = relative
    return this.add('y', num)
  }
  // Animatable center x-axis
, cx: function(x) {
    return this.add('cx', new SVG.Number(x))
  }
  // Animatable center y-axis
, cy: function(y) {
    return this.add('cy', new SVG.Number(y))
  }
  // Add animatable move
, move: function(x, y) {
    return this.x(x).y(y)
  }
  // Add animatable center
, center: function(x, y) {
    return this.cx(x).cy(y)
  }
  // Add animatable size
, size: function(width, height) {
    if (this.target() instanceof SVG.Text) {
      // animate font size for Text elements
      this.attr('font-size', width)

    } else {
      // animate bbox based size for all other elements
      var box

      if(!width || !height){
        box = this.target().bbox()
      }

      if(!width){
        width = box.width / box.height  * height
      }

      if(!height){
        height = box.height / box.width  * width
      }

      this.add('width' , new SVG.Number(width))
          .add('height', new SVG.Number(height))

    }

    return this
  }
  // Add animatable width
, width: function(width) {
    return this.add('width', new SVG.Number(width))
  }
  // Add animatable height
, height: function(height) {
    return this.add('height', new SVG.Number(height))
  }
  // Add animatable plot
, plot: function(a, b, c, d) {
    // Lines can be plotted with 4 arguments
    if(arguments.length == 4) {
      return this.plot([a, b, c, d])
    }

    return this.add('plot', new (this.target().morphArray)(a))
  }
  // Add leading method
, leading: function(value) {
    return this.target().leading ?
      this.add('leading', new SVG.Number(value)) :
      this
  }
  // Add animatable viewbox
, viewbox: function(x, y, width, height) {
    if (this.target() instanceof SVG.Container) {
      this.add('viewbox', new SVG.ViewBox(x, y, width, height))
    }

    return this
  }
, update: function(o) {
    if (this.target() instanceof SVG.Stop) {
      if (typeof o == 'number' || o instanceof SVG.Number) {
        return this.update({
          offset:  arguments[0]
        , color:   arguments[1]
        , opacity: arguments[2]
        })
      }

      if (o.opacity != null) this.attr('stop-opacity', o.opacity)
      if (o.color   != null) this.attr('stop-color', o.color)
      if (o.offset  != null) this.attr('offset', o.offset)
    }

    return this
  }
})

SVG.Box = SVG.invent({
  create: function(x, y, width, height) {
    if (typeof x == 'object' && !(x instanceof SVG.Element)) {
      // chromes getBoundingClientRect has no x and y property
      return SVG.Box.call(this, x.left != null ? x.left : x.x , x.top != null ? x.top : x.y, x.width, x.height)
    } else if (arguments.length == 4) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    }

    // add center, right, bottom...
    fullBox(this)
  }
, extend: {
    // Merge rect box with another, return a new instance
    merge: function(box) {
      var b = new this.constructor()

      // merge boxes
      b.x      = Math.min(this.x, box.x)
      b.y      = Math.min(this.y, box.y)
      b.width  = Math.max(this.x + this.width,  box.x + box.width)  - b.x
      b.height = Math.max(this.y + this.height, box.y + box.height) - b.y

      return fullBox(b)
    }

  , transform: function(m) {
      var xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, p, bbox

      var pts = [
        new SVG.Point(this.x, this.y),
        new SVG.Point(this.x2, this.y),
        new SVG.Point(this.x, this.y2),
        new SVG.Point(this.x2, this.y2)
      ]

      pts.forEach(function(p) {
        p = p.transform(m)
        xMin = Math.min(xMin,p.x)
        xMax = Math.max(xMax,p.x)
        yMin = Math.min(yMin,p.y)
        yMax = Math.max(yMax,p.y)
      })

      bbox = new this.constructor()
      bbox.x = xMin
      bbox.width = xMax-xMin
      bbox.y = yMin
      bbox.height = yMax-yMin

      fullBox(bbox)

      return bbox
    }
  }
})

SVG.BBox = SVG.invent({
  // Initialize
  create: function(element) {
    SVG.Box.apply(this, [].slice.call(arguments))

    // get values if element is given
    if (element instanceof SVG.Element) {
      var box

      // yes this is ugly, but Firefox can be a pain when it comes to elements that are not yet rendered
      try {

        if (!document.documentElement.contains){
          // This is IE - it does not support contains() for top-level SVGs
          var topParent = element.node
          while (topParent.parentNode){
            topParent = topParent.parentNode
          }
          if (topParent != document) throw new Exception('Element not in the dom')
        } else {
          // the element is NOT in the dom, throw error
          if(!document.documentElement.contains(element.node)) throw new Exception('Element not in the dom')
        }

        // find native bbox
        box = element.node.getBBox()
      } catch(e) {
        if(element instanceof SVG.Shape){
          var clone = element.clone(SVG.parser.draw.instance).show()
          box = clone.node.getBBox()
          clone.remove()
        }else{
          box = {
            x:      element.node.clientLeft
          , y:      element.node.clientTop
          , width:  element.node.clientWidth
          , height: element.node.clientHeight
          }
        }
      }

      SVG.Box.call(this, box)
    }

  }

  // Define ancestor
, inherit: SVG.Box

  // Define Parent
, parent: SVG.Element

  // Constructor
, construct: {
    // Get bounding box
    bbox: function() {
      return new SVG.BBox(this)
    }
  }

})

SVG.BBox.prototype.constructor = SVG.BBox


SVG.extend(SVG.Element, {
  tbox: function(){
    console.warn('Use of TBox is deprecated and mapped to RBox. Use .rbox() instead.')
    return this.rbox(this.doc())
  }
})

SVG.RBox = SVG.invent({
  // Initialize
  create: function(element) {
    SVG.Box.apply(this, [].slice.call(arguments))

    if (element instanceof SVG.Element) {
      SVG.Box.call(this, element.node.getBoundingClientRect())
    }
  }

, inherit: SVG.Box

  // define Parent
, parent: SVG.Element

, extend: {
    addOffset: function() {
      // offset by window scroll position, because getBoundingClientRect changes when window is scrolled
      this.x += window.pageXOffset
      this.y += window.pageYOffset
      return this
    }
  }

  // Constructor
, construct: {
    // Get rect box
    rbox: function(el) {
      if (el) return new SVG.RBox(this).transform(el.screenCTM().inverse())
      return new SVG.RBox(this).addOffset()
    }
  }

})

SVG.RBox.prototype.constructor = SVG.RBox

SVG.Matrix = SVG.invent({
  // Initialize
  create: function(source) {
    var i, base = arrayToMatrix([1, 0, 0, 1, 0, 0])

    // ensure source as object
    source = source instanceof SVG.Element ?
      source.matrixify() :
    typeof source === 'string' ?
      arrayToMatrix(source.split(SVG.regex.delimiter).map(parseFloat)) :
    arguments.length == 6 ?
      arrayToMatrix([].slice.call(arguments)) :
    Array.isArray(source) ?
      arrayToMatrix(source) :
    typeof source === 'object' ?
      source : base

    // merge source
    for (i = abcdef.length - 1; i >= 0; --i)
      this[abcdef[i]] = source[abcdef[i]] != null ?
        source[abcdef[i]] : base[abcdef[i]]
  }

  // Add methods
, extend: {
    // Extract individual transformations
    extract: function() {
      // find delta transform points
      var px    = deltaTransformPoint(this, 0, 1)
        , py    = deltaTransformPoint(this, 1, 0)
        , skewX = 180 / Math.PI * Math.atan2(px.y, px.x) - 90

      return {
        // translation
        x:        this.e
      , y:        this.f
      , transformedX:(this.e * Math.cos(skewX * Math.PI / 180) + this.f * Math.sin(skewX * Math.PI / 180)) / Math.sqrt(this.a * this.a + this.b * this.b)
      , transformedY:(this.f * Math.cos(skewX * Math.PI / 180) + this.e * Math.sin(-skewX * Math.PI / 180)) / Math.sqrt(this.c * this.c + this.d * this.d)
        // skew
      , skewX:    -skewX
      , skewY:    180 / Math.PI * Math.atan2(py.y, py.x)
        // scale
      , scaleX:   Math.sqrt(this.a * this.a + this.b * this.b)
      , scaleY:   Math.sqrt(this.c * this.c + this.d * this.d)
        // rotation
      , rotation: skewX
      , a: this.a
      , b: this.b
      , c: this.c
      , d: this.d
      , e: this.e
      , f: this.f
      , matrix: new SVG.Matrix(this)
      }
    }
    // Clone matrix
  , clone: function() {
      return new SVG.Matrix(this)
    }
    // Morph one matrix into another
  , morph: function(matrix) {
      // store new destination
      this.destination = new SVG.Matrix(matrix)

      return this
    }
    // Get morphed matrix at a given position
  , at: function(pos) {
      // make sure a destination is defined
      if (!this.destination) return this

      // calculate morphed matrix at a given position
      var matrix = new SVG.Matrix({
        a: this.a + (this.destination.a - this.a) * pos
      , b: this.b + (this.destination.b - this.b) * pos
      , c: this.c + (this.destination.c - this.c) * pos
      , d: this.d + (this.destination.d - this.d) * pos
      , e: this.e + (this.destination.e - this.e) * pos
      , f: this.f + (this.destination.f - this.f) * pos
      })

      return matrix
    }
    // Multiplies by given matrix
  , multiply: function(matrix) {
      return new SVG.Matrix(this.native().multiply(parseMatrix(matrix).native()))
    }
    // Inverses matrix
  , inverse: function() {
      return new SVG.Matrix(this.native().inverse())
    }
    // Translate matrix
  , translate: function(x, y) {
      return new SVG.Matrix(this.native().translate(x || 0, y || 0))
    }
    // Scale matrix
  , scale: function(x, y, cx, cy) {
      // support uniformal scale
      if (arguments.length == 1) {
        y = x
      } else if (arguments.length == 3) {
        cy = cx
        cx = y
        y = x
      }

      return this.around(cx, cy, new SVG.Matrix(x, 0, 0, y, 0, 0))
    }
    // Rotate matrix
  , rotate: function(r, cx, cy) {
      // convert degrees to radians
      r = SVG.utils.radians(r)

      return this.around(cx, cy, new SVG.Matrix(Math.cos(r), Math.sin(r), -Math.sin(r), Math.cos(r), 0, 0))
    }
    // Flip matrix on x or y, at a given offset
  , flip: function(a, o) {
      return a == 'x' ?
          this.scale(-1, 1, o, 0) :
        a == 'y' ?
          this.scale(1, -1, 0, o) :
          this.scale(-1, -1, a, o != null ? o : a)
    }
    // Skew
  , skew: function(x, y, cx, cy) {
      // support uniformal skew
      if (arguments.length == 1) {
        y = x
      } else if (arguments.length == 3) {
        cy = cx
        cx = y
        y = x
      }

      // convert degrees to radians
      x = SVG.utils.radians(x)
      y = SVG.utils.radians(y)

      return this.around(cx, cy, new SVG.Matrix(1, Math.tan(y), Math.tan(x), 1, 0, 0))
    }
    // SkewX
  , skewX: function(x, cx, cy) {
      return this.skew(x, 0, cx, cy)
    }
    // SkewY
  , skewY: function(y, cx, cy) {
      return this.skew(0, y, cx, cy)
    }
    // Transform around a center point
  , around: function(cx, cy, matrix) {
      return this
        .multiply(new SVG.Matrix(1, 0, 0, 1, cx || 0, cy || 0))
        .multiply(matrix)
        .multiply(new SVG.Matrix(1, 0, 0, 1, -cx || 0, -cy || 0))
    }
    // Convert to native SVGMatrix
  , native: function() {
      // create new matrix
      var matrix = SVG.parser.native.createSVGMatrix()

      // update with current values
      for (var i = abcdef.length - 1; i >= 0; i--)
        matrix[abcdef[i]] = this[abcdef[i]]

      return matrix
    }
    // Convert matrix to string
  , toString: function() {
      // Construct the matrix directly, avoid values that are too small
      return 'matrix(' + float32String(this.a) + ',' + float32String(this.b)
        + ',' + float32String(this.c) + ',' + float32String(this.d)
        + ',' + float32String(this.e) + ',' + float32String(this.f)
        + ')'
    }
  }

  // Define parent
, parent: SVG.Element

  // Add parent method
, construct: {
    // Get current matrix
    ctm: function() {
      return new SVG.Matrix(this.node.getCTM())
    },
    // Get current screen matrix
    screenCTM: function() {
      /* https://bugzilla.mozilla.org/show_bug.cgi?id=1344537
         This is needed because FF does not return the transformation matrix
         for the inner coordinate system when getScreenCTM() is called on nested svgs.
         However all other Browsers do that */
      if(this instanceof SVG.Nested) {
        var rect = this.rect(1,1)
        var m = rect.node.getScreenCTM()
        rect.remove()
        return new SVG.Matrix(m)
      }
      return new SVG.Matrix(this.node.getScreenCTM())
    }

  }

})

SVG.Point = SVG.invent({
  // Initialize
  create: function(x,y) {
    var i, source, base = {x:0, y:0}

    // ensure source as object
    source = Array.isArray(x) ?
      {x:x[0], y:x[1]} :
    typeof x === 'object' ?
      {x:x.x, y:x.y} :
    x != null ?
      {x:x, y:(y != null ? y : x)} : base // If y has no value, then x is used has its value

    // merge source
    this.x = source.x
    this.y = source.y
  }

  // Add methods
, extend: {
    // Clone point
    clone: function() {
      return new SVG.Point(this)
    }
    // Morph one point into another
  , morph: function(x, y) {
      // store new destination
      this.destination = new SVG.Point(x, y)

      return this
    }
    // Get morphed point at a given position
  , at: function(pos) {
      // make sure a destination is defined
      if (!this.destination) return this

      // calculate morphed matrix at a given position
      var point = new SVG.Point({
        x: this.x + (this.destination.x - this.x) * pos
      , y: this.y + (this.destination.y - this.y) * pos
      })

      return point
    }
    // Convert to native SVGPoint
  , native: function() {
      // create new point
      var point = SVG.parser.native.createSVGPoint()

      // update with current values
      point.x = this.x
      point.y = this.y

      return point
    }
    // transform point with matrix
  , transform: function(matrix) {
      return new SVG.Point(this.native().matrixTransform(matrix.native()))
    }

  }

})

SVG.extend(SVG.Element, {

  // Get point
  point: function(x, y) {
    return new SVG.Point(x,y).transform(this.screenCTM().inverse());
  }

})

SVG.extend(SVG.Element, {
  // Set svg element attribute
  attr: function(a, v, n) {
    // act as full getter
    if (a == null) {
      // get an object of attributes
      a = {}
      v = this.node.attributes
      for (n = v.length - 1; n >= 0; n--)
        a[v[n].nodeName] = SVG.regex.isNumber.test(v[n].nodeValue) ? parseFloat(v[n].nodeValue) : v[n].nodeValue

      return a

    } else if (typeof a == 'object') {
      // apply every attribute individually if an object is passed
      for (v in a) this.attr(v, a[v])

    } else if (v === null) {
        // remove value
        this.node.removeAttribute(a)

    } else if (v == null) {
      // act as a getter if the first and only argument is not an object
      v = this.node.getAttribute(a)
      return v == null ?
        SVG.defaults.attrs[a] :
      SVG.regex.isNumber.test(v) ?
        parseFloat(v) : v

    } else {
      // BUG FIX: some browsers will render a stroke if a color is given even though stroke width is 0
      if (a == 'stroke-width')
        this.attr('stroke', parseFloat(v) > 0 ? this._stroke : null)
      else if (a == 'stroke')
        this._stroke = v

      // convert image fill and stroke to patterns
      if (a == 'fill' || a == 'stroke') {
        if (SVG.regex.isImage.test(v))
          v = this.doc().defs().image(v, 0, 0)

        if (v instanceof SVG.Image)
          v = this.doc().defs().pattern(0, 0, function() {
            this.add(v)
          })
      }

      // ensure correct numeric values (also accepts NaN and Infinity)
      if (typeof v === 'number')
        v = new SVG.Number(v)

      // ensure full hex color
      else if (SVG.Color.isColor(v))
        v = new SVG.Color(v)

      // parse array values
      else if (Array.isArray(v))
        v = new SVG.Array(v)

      // if the passed attribute is leading...
      if (a == 'leading') {
        // ... call the leading method instead
        if (this.leading)
          this.leading(v)
      } else {
        // set given attribute on node
        typeof n === 'string' ?
          this.node.setAttributeNS(n, a, v.toString()) :
          this.node.setAttribute(a, v.toString())
      }

      // rebuild if required
      if (this.rebuild && (a == 'font-size' || a == 'x'))
        this.rebuild(a, v)
    }

    return this
  }
})
SVG.extend(SVG.Element, {
  // Add transformations
  transform: function(o, relative) {
    // get target in case of the fx module, otherwise reference this
    var target = this
      , matrix, bbox

    // act as a getter
    if (typeof o !== 'object') {
      // get current matrix
      matrix = new SVG.Matrix(target).extract()

      return typeof o === 'string' ? matrix[o] : matrix
    }

    // get current matrix
    matrix = new SVG.Matrix(target)

    // ensure relative flag
    relative = !!relative || !!o.relative

    // act on matrix
    if (o.a != null) {
      matrix = relative ?
        // relative
        matrix.multiply(new SVG.Matrix(o)) :
        // absolute
        new SVG.Matrix(o)

    // act on rotation
    } else if (o.rotation != null) {
      // ensure centre point
      ensureCentre(o, target)

      // apply transformation
      matrix = relative ?
        // relative
        matrix.rotate(o.rotation, o.cx, o.cy) :
        // absolute
        matrix.rotate(o.rotation - matrix.extract().rotation, o.cx, o.cy)

    // act on scale
    } else if (o.scale != null || o.scaleX != null || o.scaleY != null) {
      // ensure centre point
      ensureCentre(o, target)

      // ensure scale values on both axes
      o.scaleX = o.scale != null ? o.scale : o.scaleX != null ? o.scaleX : 1
      o.scaleY = o.scale != null ? o.scale : o.scaleY != null ? o.scaleY : 1

      if (!relative) {
        // absolute; multiply inversed values
        var e = matrix.extract()
        o.scaleX = o.scaleX * 1 / e.scaleX
        o.scaleY = o.scaleY * 1 / e.scaleY
      }

      matrix = matrix.scale(o.scaleX, o.scaleY, o.cx, o.cy)

    // act on skew
    } else if (o.skew != null || o.skewX != null || o.skewY != null) {
      // ensure centre point
      ensureCentre(o, target)

      // ensure skew values on both axes
      o.skewX = o.skew != null ? o.skew : o.skewX != null ? o.skewX : 0
      o.skewY = o.skew != null ? o.skew : o.skewY != null ? o.skewY : 0

      if (!relative) {
        // absolute; reset skew values
        var e = matrix.extract()
        matrix = matrix.multiply(new SVG.Matrix().skew(e.skewX, e.skewY, o.cx, o.cy).inverse())
      }

      matrix = matrix.skew(o.skewX, o.skewY, o.cx, o.cy)

    // act on flip
    } else if (o.flip) {
      if(o.flip == 'x' || o.flip == 'y') {
        o.offset = o.offset == null ? target.bbox()['c' + o.flip] : o.offset
      } else {
        if(o.offset == null) {
          bbox = target.bbox()
          o.flip = bbox.cx
          o.offset = bbox.cy
        } else {
          o.flip = o.offset
        }
      }

      matrix = new SVG.Matrix().flip(o.flip, o.offset)

    // act on translate
    } else if (o.x != null || o.y != null) {
      if (relative) {
        // relative
        matrix = matrix.translate(o.x, o.y)
      } else {
        // absolute
        if (o.x != null) matrix.e = o.x
        if (o.y != null) matrix.f = o.y
      }
    }

    return this.attr('transform', matrix)
  }
})

SVG.extend(SVG.FX, {
  transform: function(o, relative) {
    // get target in case of the fx module, otherwise reference this
    var target = this.target()
      , matrix, bbox

    // act as a getter
    if (typeof o !== 'object') {
      // get current matrix
      matrix = new SVG.Matrix(target).extract()

      return typeof o === 'string' ? matrix[o] : matrix
    }

    // ensure relative flag
    relative = !!relative || !!o.relative

    // act on matrix
    if (o.a != null) {
      matrix = new SVG.Matrix(o)

    // act on rotation
    } else if (o.rotation != null) {
      // ensure centre point
      ensureCentre(o, target)

      // apply transformation
      matrix = new SVG.Rotate(o.rotation, o.cx, o.cy)

    // act on scale
    } else if (o.scale != null || o.scaleX != null || o.scaleY != null) {
      // ensure centre point
      ensureCentre(o, target)

      // ensure scale values on both axes
      o.scaleX = o.scale != null ? o.scale : o.scaleX != null ? o.scaleX : 1
      o.scaleY = o.scale != null ? o.scale : o.scaleY != null ? o.scaleY : 1

      matrix = new SVG.Scale(o.scaleX, o.scaleY, o.cx, o.cy)

    // act on skew
    } else if (o.skewX != null || o.skewY != null) {
      // ensure centre point
      ensureCentre(o, target)

      // ensure skew values on both axes
      o.skewX = o.skewX != null ? o.skewX : 0
      o.skewY = o.skewY != null ? o.skewY : 0

      matrix = new SVG.Skew(o.skewX, o.skewY, o.cx, o.cy)

    // act on flip
    } else if (o.flip) {
      if(o.flip == 'x' || o.flip == 'y') {
        o.offset = o.offset == null ? target.bbox()['c' + o.flip] : o.offset
      } else {
        if(o.offset == null) {
          bbox = target.bbox()
          o.flip = bbox.cx
          o.offset = bbox.cy
        } else {
          o.flip = o.offset
        }
      }

      matrix = new SVG.Matrix().flip(o.flip, o.offset)

    // act on translate
    } else if (o.x != null || o.y != null) {
      matrix = new SVG.Translate(o.x, o.y)
    }

    if(!matrix) return this

    matrix.relative = relative

    this.last().transforms.push(matrix)

    return this._callStart()
  }
})

SVG.extend(SVG.Element, {
  // Reset all transformations
  untransform: function() {
    return this.attr('transform', null)
  },
  // merge the whole transformation chain into one matrix and returns it
  matrixify: function() {

    var matrix = (this.attr('transform') || '')
      // split transformations
      .split(SVG.regex.transforms).slice(0,-1).map(function(str){
        // generate key => value pairs
        var kv = str.trim().split('(')
        return [kv[0], kv[1].split(SVG.regex.delimiter).map(function(str){ return parseFloat(str) })]
      })
      // merge every transformation into one matrix
      .reduce(function(matrix, transform){

        if(transform[0] == 'matrix') return matrix.multiply(arrayToMatrix(transform[1]))
        return matrix[transform[0]].apply(matrix, transform[1])

      }, new SVG.Matrix())

    return matrix
  },
  // add an element to another parent without changing the visual representation on the screen
  toParent: function(parent) {
    if(this == parent) return this
    var ctm = this.screenCTM()
    var pCtm = parent.screenCTM().inverse()

    this.addTo(parent).untransform().transform(pCtm.multiply(ctm))

    return this
  },
  // same as above with parent equals root-svg
  toDoc: function() {
    return this.toParent(this.doc())
  }

})

SVG.Transformation = SVG.invent({

  create: function(source, inversed){

    if(arguments.length > 1 && typeof inversed != 'boolean'){
      return this.constructor.call(this, [].slice.call(arguments))
    }

    if(Array.isArray(source)){
      for(var i = 0, len = this.arguments.length; i < len; ++i){
        this[this.arguments[i]] = source[i]
      }
    } else if(typeof source == 'object'){
      for(var i = 0, len = this.arguments.length; i < len; ++i){
        this[this.arguments[i]] = source[this.arguments[i]]
      }
    }

    this.inversed = false

    if(inversed === true){
      this.inversed = true
    }

  }

, extend: {

    arguments: []
  , method: ''

  , at: function(pos){

      var params = []

      for(var i = 0, len = this.arguments.length; i < len; ++i){
        params.push(this[this.arguments[i]])
      }

      var m = this._undo || new SVG.Matrix()

      m = new SVG.Matrix().morph(SVG.Matrix.prototype[this.method].apply(m, params)).at(pos)

      return this.inversed ? m.inverse() : m

    }

  , undo: function(o){
      for(var i = 0, len = this.arguments.length; i < len; ++i){
        o[this.arguments[i]] = typeof this[this.arguments[i]] == 'undefined' ? 0 : o[this.arguments[i]]
      }

      // The method SVG.Matrix.extract which was used before calling this
      // method to obtain a value for the parameter o doesn't return a cx and
      // a cy so we use the ones that were provided to this object at its creation
      o.cx = this.cx
      o.cy = this.cy

      this._undo = new SVG[capitalize(this.method)](o, true).at(1)

      return this
    }

  }

})

SVG.Translate = SVG.invent({

  parent: SVG.Matrix
, inherit: SVG.Transformation

, create: function(source, inversed){
    this.constructor.apply(this, [].slice.call(arguments))
  }

, extend: {
    arguments: ['transformedX', 'transformedY']
  , method: 'translate'
  }

})

SVG.Rotate = SVG.invent({

  parent: SVG.Matrix
, inherit: SVG.Transformation

, create: function(source, inversed){
    this.constructor.apply(this, [].slice.call(arguments))
  }

, extend: {
    arguments: ['rotation', 'cx', 'cy']
  , method: 'rotate'
  , at: function(pos){
      var m = new SVG.Matrix().rotate(new SVG.Number().morph(this.rotation - (this._undo ? this._undo.rotation : 0)).at(pos), this.cx, this.cy)
      return this.inversed ? m.inverse() : m
    }
  , undo: function(o){
      this._undo = o
      return this
    }
  }

})

SVG.Scale = SVG.invent({

  parent: SVG.Matrix
, inherit: SVG.Transformation

, create: function(source, inversed){
    this.constructor.apply(this, [].slice.call(arguments))
  }

, extend: {
    arguments: ['scaleX', 'scaleY', 'cx', 'cy']
  , method: 'scale'
  }

})

SVG.Skew = SVG.invent({

  parent: SVG.Matrix
, inherit: SVG.Transformation

, create: function(source, inversed){
    this.constructor.apply(this, [].slice.call(arguments))
  }

, extend: {
    arguments: ['skewX', 'skewY', 'cx', 'cy']
  , method: 'skew'
  }

})

SVG.extend(SVG.Element, {
  // Dynamic style generator
  style: function(s, v) {
    if (arguments.length == 0) {
      // get full style
      return this.node.style.cssText || ''

    } else if (arguments.length < 2) {
      // apply every style individually if an object is passed
      if (typeof s == 'object') {
        for (v in s) this.style(v, s[v])

      } else if (SVG.regex.isCss.test(s)) {
        // parse css string
        s = s.split(/\s*;\s*/)
          // filter out suffix ; and stuff like ;;
          .filter(function(e) { return !!e })
          .map(function(e){ return e.split(/\s*:\s*/) })

        // apply every definition individually
        while (v = s.pop()) {
          this.style(v[0], v[1])
        }
      } else {
        // act as a getter if the first and only argument is not an object
        return this.node.style[camelCase(s)]
      }

    } else {
      this.node.style[camelCase(s)] = v === null || SVG.regex.isBlank.test(v) ? '' : v
    }

    return this
  }
})
SVG.Parent = SVG.invent({
  // Initialize node
  create: function(element) {
    this.constructor.call(this, element)
  }

  // Inherit from
, inherit: SVG.Element

  // Add class methods
, extend: {
    // Returns all child elements
    children: function() {
      return SVG.utils.map(SVG.utils.filterSVGElements(this.node.childNodes), function(node) {
        return SVG.adopt(node)
      })
    }
    // Add given element at a position
  , add: function(element, i) {
      if (i == null)
        this.node.appendChild(element.node)
      else if (element.node != this.node.childNodes[i])
        this.node.insertBefore(element.node, this.node.childNodes[i])

      return this
    }
    // Basically does the same as `add()` but returns the added element instead
  , put: function(element, i) {
      this.add(element, i)
      return element
    }
    // Checks if the given element is a child
  , has: function(element) {
      return this.index(element) >= 0
    }
    // Gets index of given element
  , index: function(element) {
      return [].slice.call(this.node.childNodes).indexOf(element.node)
    }
    // Get a element at the given index
  , get: function(i) {
      return SVG.adopt(this.node.childNodes[i])
    }
    // Get first child
  , first: function() {
      return this.get(0)
    }
    // Get the last child
  , last: function() {
      return this.get(this.node.childNodes.length - 1)
    }
    // Iterates over all children and invokes a given block
  , each: function(block, deep) {
      var i, il
        , children = this.children()

      for (i = 0, il = children.length; i < il; i++) {
        if (children[i] instanceof SVG.Element)
          block.apply(children[i], [i, children])

        if (deep && (children[i] instanceof SVG.Container))
          children[i].each(block, deep)
      }

      return this
    }
    // Remove a given child
  , removeElement: function(element) {
      this.node.removeChild(element.node)

      return this
    }
    // Remove all elements in this container
  , clear: function() {
      // remove children
      while(this.node.hasChildNodes())
        this.node.removeChild(this.node.lastChild)

      // remove defs reference
      delete this._defs

      return this
    }
  , // Get defs
    defs: function() {
      return this.doc().defs()
    }
  }

})

SVG.extend(SVG.Parent, {

  ungroup: function(parent, depth) {
    if(depth === 0 || this instanceof SVG.Defs || this.node == SVG.parser.draw) return this

    parent = parent || (this instanceof SVG.Doc ? this : this.parent(SVG.Parent))
    depth = depth || Infinity

    this.each(function(){
      if(this instanceof SVG.Defs) return this
      if(this instanceof SVG.Parent) return this.ungroup(parent, depth-1)
      return this.toParent(parent)
    })

    this.node.firstChild || this.remove()

    return this
  },

  flatten: function(parent, depth) {
    return this.ungroup(parent, depth)
  }

})
SVG.Container = SVG.invent({
  // Initialize node
  create: function(element) {
    this.constructor.call(this, element)
  }

  // Inherit from
, inherit: SVG.Parent

})

SVG.ViewBox = SVG.invent({

  create: function(source) {
    var i, base = [0, 0, 0, 0]

    var x, y, width, height, box, view, we, he
      , wm   = 1 // width multiplier
      , hm   = 1 // height multiplier
      , reg  = /[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?/gi

    if(source instanceof SVG.Element){

      we = source
      he = source
      view = (source.attr('viewBox') || '').match(reg)
      box = source.bbox

      // get dimensions of current node
      width  = new SVG.Number(source.width())
      height = new SVG.Number(source.height())

      // find nearest non-percentual dimensions
      while (width.unit == '%') {
        wm *= width.value
        width = new SVG.Number(we instanceof SVG.Doc ? we.parent().offsetWidth : we.parent().width())
        we = we.parent()
      }
      while (height.unit == '%') {
        hm *= height.value
        height = new SVG.Number(he instanceof SVG.Doc ? he.parent().offsetHeight : he.parent().height())
        he = he.parent()
      }

      // ensure defaults
      this.x      = 0
      this.y      = 0
      this.width  = width  * wm
      this.height = height * hm
      this.zoom   = 1

      if (view) {
        // get width and height from viewbox
        x      = parseFloat(view[0])
        y      = parseFloat(view[1])
        width  = parseFloat(view[2])
        height = parseFloat(view[3])

        // calculate zoom accoring to viewbox
        this.zoom = ((this.width / this.height) > (width / height)) ?
          this.height / height :
          this.width  / width

        // calculate real pixel dimensions on parent SVG.Doc element
        this.x      = x
        this.y      = y
        this.width  = width
        this.height = height

      }

    }else{

      // ensure source as object
      source = typeof source === 'string' ?
        source.match(reg).map(function(el){ return parseFloat(el) }) :
      Array.isArray(source) ?
        source :
      typeof source == 'object' ?
        [source.x, source.y, source.width, source.height] :
      arguments.length == 4 ?
        [].slice.call(arguments) :
        base

      this.x = source[0]
      this.y = source[1]
      this.width = source[2]
      this.height = source[3]
    }


  }

, extend: {

    toString: function() {
      return this.x + ' ' + this.y + ' ' + this.width + ' ' + this.height
    }
  , morph: function(x, y, width, height){
      this.destination = new SVG.ViewBox(x, y, width, height)
      return this
    }

  , at: function(pos) {

      if(!this.destination) return this

      return new SVG.ViewBox([
          this.x + (this.destination.x - this.x) * pos
        , this.y + (this.destination.y - this.y) * pos
        , this.width + (this.destination.width - this.width) * pos
        , this.height + (this.destination.height - this.height) * pos
      ])

    }

  }

  // Define parent
, parent: SVG.Container

  // Add parent method
, construct: {

    // get/set viewbox
    viewbox: function(x, y, width, height) {
      if (arguments.length == 0)
        // act as a getter if there are no arguments
        return new SVG.ViewBox(this)

      // otherwise act as a setter
      return this.attr('viewBox', new SVG.ViewBox(x, y, width, height))
    }

  }

})
// Add events to elements

;[ 'click',
  'dblclick',
  'mousedown',
  'mouseup',
  'mouseover',
  'mouseout',
  'mousemove',
  'mouseenter',
  'mouseleave',
  'touchstart',
  'touchmove',
  'touchleave',
  'touchend',
  'touchcancel' ].forEach(function (event) {
    // add event to SVG.Element
    SVG.Element.prototype[event] = function (f) {
      // bind event to element rather than element node
      if (f == null) {
        SVG.off(this, event)
      } else {
        SVG.on(this, event, f)
      }
      return this
    }
  })

SVG.listenerId = 0

// Add event binder in the SVG namespace
SVG.on = function (node, events, listener, binding, options) {
  var l = listener.bind(binding || node)
  var n = node instanceof SVG.Element ? node.node : node

  // ensure instance object for nodes which are not adopted
  n.instance = n.instance || {_events: {}}

  var bag = n.instance._events

  // add id to listener
  if (!listener._svgjsListenerId) { listener._svgjsListenerId = ++SVG.listenerId }

  events.split(SVG.regex.delimiter).forEach(function (event) {
    var ev = event.split('.')[0]
    var ns = event.split('.')[1] || '*'

    // ensure valid object
    bag[ev] = bag[ev] || {}
    bag[ev][ns] = bag[ev][ns] || {}

    // reference listener
    bag[ev][ns][listener._svgjsListenerId] = l

    // add listener
    n.addEventListener(ev, l, options || false)
  })
}

// Add event unbinder in the SVG namespace
SVG.off = function (node, events, listener, options) {
  var n = node instanceof SVG.Element ? node.node : node
  if (!n.instance) return

  // listener can be a function or a number
  if (typeof listener === 'function') {
    listener = listener._svgjsListenerId
    if (!listener) return
  }

  var bag = n.instance._events

  ;(events || '').split(SVG.regex.delimiter).forEach(function (event) {
    var ev = event && event.split('.')[0]
    var ns = event && event.split('.')[1]
    var namespace, l

    if (listener) {
      // remove listener reference
      if (bag[ev] && bag[ev][ns || '*']) {
        // removeListener
        n.removeEventListener(ev, bag[ev][ns || '*'][listener], options || false)

        delete bag[ev][ns || '*'][listener]
      }
    } else if (ev && ns) {
      // remove all listeners for a namespaced event
      if (bag[ev] && bag[ev][ns]) {
        for (l in bag[ev][ns]) { SVG.off(n, [ev, ns].join('.'), l) }

        delete bag[ev][ns]
      }
    } else if (ns) {
      // remove all listeners for a specific namespace
      for (event in bag) {
        for (namespace in bag[event]) {
          if (ns === namespace) { SVG.off(n, [event, ns].join('.')) }
        }
      }
    } else if (ev) {
      // remove all listeners for the event
      if (bag[ev]) {
        for (namespace in bag[ev]) { SVG.off(n, [ev, namespace].join('.')) }

        delete bag[ev]
      }
    } else {
      // remove all listeners on a given node
      for (event in bag) { SVG.off(n, event) }

      n.instance._events = {}
    }
  })
}

SVG.extend(SVG.Element, {
  // Bind given event to listener
  on: function (event, listener, binding, options) {
    SVG.on(this, event, listener, binding, options)
    return this
  },
  // Unbind event from listener
  off: function (event, listener) {
    SVG.off(this.node, event, listener)
    return this
  },
  fire: function (event, data) {
    // Dispatch event
    if (event instanceof window.Event) {
      this.node.dispatchEvent(event)
    } else {
      this.node.dispatchEvent(event = new SVG.CustomEvent(event, {detail: data, cancelable: true}))
    }
    this._event = event
    return this
  },
  event: function() {
    return this._event
  }
})


SVG.Defs = SVG.invent({
  // Initialize node
  create: 'defs'

  // Inherit from
, inherit: SVG.Container

})
SVG.G = SVG.invent({
  // Initialize node
  create: 'g'

  // Inherit from
, inherit: SVG.Container

  // Add class methods
, extend: {
    // Move over x-axis
    x: function(x) {
      return x == null ? this.transform('x') : this.transform({ x: x - this.x() }, true)
    }
    // Move over y-axis
  , y: function(y) {
      return y == null ? this.transform('y') : this.transform({ y: y - this.y() }, true)
    }
    // Move by center over x-axis
  , cx: function(x) {
      return x == null ? this.gbox().cx : this.x(x - this.gbox().width / 2)
    }
    // Move by center over y-axis
  , cy: function(y) {
      return y == null ? this.gbox().cy : this.y(y - this.gbox().height / 2)
    }
  , gbox: function() {

      var bbox  = this.bbox()
        , trans = this.transform()

      bbox.x  += trans.x
      bbox.x2 += trans.x
      bbox.cx += trans.x

      bbox.y  += trans.y
      bbox.y2 += trans.y
      bbox.cy += trans.y

      return bbox
    }
  }

  // Add parent method
, construct: {
    // Create a group element
    group: function() {
      return this.put(new SVG.G)
    }
  }
})

SVG.Doc = SVG.invent({
  // Initialize node
  create: function(element) {
    if (element) {
      // ensure the presence of a dom element
      element = typeof element == 'string' ?
        document.getElementById(element) :
        element

      // If the target is an svg element, use that element as the main wrapper.
      // This allows svg.js to work with svg documents as well.
      if (element.nodeName == 'svg') {
        this.constructor.call(this, element)
      } else {
        this.constructor.call(this, SVG.create('svg'))
        element.appendChild(this.node)
        this.size('100%', '100%')
      }

      // set svg element attributes and ensure defs node
      this.namespace().defs()
    }
  }

  // Inherit from
, inherit: SVG.Container

  // Add class methods
, extend: {
    // Add namespaces
    namespace: function() {
      return this
        .attr({ xmlns: SVG.ns, version: '1.1' })
        .attr('xmlns:xlink', SVG.xlink, SVG.xmlns)
        .attr('xmlns:svgjs', SVG.svgjs, SVG.xmlns)
    }
    // Creates and returns defs element
  , defs: function() {
      if (!this._defs) {
        var defs

        // Find or create a defs element in this instance
        if (defs = this.node.getElementsByTagName('defs')[0])
          this._defs = SVG.adopt(defs)
        else
          this._defs = new SVG.Defs

        // Make sure the defs node is at the end of the stack
        this.node.appendChild(this._defs.node)
      }

      return this._defs
    }
    // custom parent method
  , parent: function() {
      if(!this.node.parentNode || this.node.parentNode.nodeName == '#document' || this.node.parentNode.nodeName == '#document-fragment') return null
      return this.node.parentNode
    }
    // Fix for possible sub-pixel offset. See:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=608812
  , spof: function() {
      var pos = this.node.getScreenCTM()

      if (pos)
        this
          .style('left', (-pos.e % 1) + 'px')
          .style('top',  (-pos.f % 1) + 'px')

      return this
    }

      // Removes the doc from the DOM
  , remove: function() {
      if(this.parent()) {
        this.parent().removeChild(this.node)
      }

      return this
    }
  , clear: function() {
      // remove children
      while(this.node.hasChildNodes())
        this.node.removeChild(this.node.lastChild)

      // remove defs reference
      delete this._defs

      // add back parser
      if(!SVG.parser.draw.parentNode)
        this.node.appendChild(SVG.parser.draw)

      return this
    }
  , clone: function (parent) {
      // write dom data to the dom so the clone can pickup the data
      this.writeDataToDom()

      // get reference to node
      var node = this.node

      // clone element and assign new id
      var clone = assignNewId(node.cloneNode(true))

      // insert the clone in the given parent or after myself
      if(parent) {
        (parent.node || parent).appendChild(clone.node)
      } else {
        node.parentNode.insertBefore(clone.node, node.nextSibling)
      }

      return clone
    }
  }

})

// ### This module adds backward / forward functionality to elements.

//
SVG.extend(SVG.Element, {
  // Get all siblings, including myself
  siblings: function() {
    return this.parent().children()
  }
  // Get the curent position siblings
, position: function() {
    return this.parent().index(this)
  }
  // Get the next element (will return null if there is none)
, next: function() {
    return this.siblings()[this.position() + 1]
  }
  // Get the next element (will return null if there is none)
, previous: function() {
    return this.siblings()[this.position() - 1]
  }
  // Send given element one step forward
, forward: function() {
    var i = this.position() + 1
      , p = this.parent()

    // move node one step forward
    p.removeElement(this).add(this, i)

    // make sure defs node is always at the top
    if (p instanceof SVG.Doc)
      p.node.appendChild(p.defs().node)

    return this
  }
  // Send given element one step backward
, backward: function() {
    var i = this.position()

    if (i > 0)
      this.parent().removeElement(this).add(this, i - 1)

    return this
  }
  // Send given element all the way to the front
, front: function() {
    var p = this.parent()

    // Move node forward
    p.node.appendChild(this.node)

    // Make sure defs node is always at the top
    if (p instanceof SVG.Doc)
      p.node.appendChild(p.defs().node)

    return this
  }
  // Send given element all the way to the back
, back: function() {
    if (this.position() > 0)
      this.parent().removeElement(this).add(this, 0)

    return this
  }
  // Inserts a given element before the targeted element
, before: function(element) {
    element.remove()

    var i = this.position()

    this.parent().add(element, i)

    return this
  }
  // Insters a given element after the targeted element
, after: function(element) {
    element.remove()

    var i = this.position()

    this.parent().add(element, i + 1)

    return this
  }

})
SVG.Mask = SVG.invent({
  // Initialize node
  create: function() {
    this.constructor.call(this, SVG.create('mask'))

    // keep references to masked elements
    this.targets = []
  }

  // Inherit from
, inherit: SVG.Container

  // Add class methods
, extend: {
    // Unmask all masked elements and remove itself
    remove: function() {
      // unmask all targets
      for (var i = this.targets.length - 1; i >= 0; i--)
        if (this.targets[i])
          this.targets[i].unmask()
      this.targets = []

      // remove mask from parent
      SVG.Element.prototype.remove.call(this)

      return this
    }
  }

  // Add parent method
, construct: {
    // Create masking element
    mask: function() {
      return this.defs().put(new SVG.Mask)
    }
  }
})


SVG.extend(SVG.Element, {
  // Distribute mask to svg element
  maskWith: function(element) {
    // use given mask or create a new one
    this.masker = element instanceof SVG.Mask ? element : this.parent().mask().add(element)

    // store reverence on self in mask
    this.masker.targets.push(this)

    // apply mask
    return this.attr('mask', 'url("#' + this.masker.attr('id') + '")')
  }
  // Unmask element
, unmask: function() {
    delete this.masker
    return this.attr('mask', null)
  }

})

SVG.ClipPath = SVG.invent({
  // Initialize node
  create: function() {
    this.constructor.call(this, SVG.create('clipPath'))

    // keep references to clipped elements
    this.targets = []
  }

  // Inherit from
, inherit: SVG.Container

  // Add class methods
, extend: {
    // Unclip all clipped elements and remove itself
    remove: function() {
      // unclip all targets
      for (var i = this.targets.length - 1; i >= 0; i--)
        if (this.targets[i])
          this.targets[i].unclip()
      this.targets = []

      // remove clipPath from parent
      this.parent().removeElement(this)

      return this
    }
  }

  // Add parent method
, construct: {
    // Create clipping element
    clip: function() {
      return this.defs().put(new SVG.ClipPath)
    }
  }
})

//
SVG.extend(SVG.Element, {
  // Distribute clipPath to svg element
  clipWith: function(element) {
    // use given clip or create a new one
    this.clipper = element instanceof SVG.ClipPath ? element : this.parent().clip().add(element)

    // store reverence on self in mask
    this.clipper.targets.push(this)

    // apply mask
    return this.attr('clip-path', 'url("#' + this.clipper.attr('id') + '")')
  }
  // Unclip element
, unclip: function() {
    delete this.clipper
    return this.attr('clip-path', null)
  }

})
SVG.Gradient = SVG.invent({
  // Initialize node
  create: function(type) {
    this.constructor.call(this, SVG.create(type + 'Gradient'))

    // store type
    this.type = type
  }

  // Inherit from
, inherit: SVG.Container

  // Add class methods
, extend: {
    // Add a color stop
    at: function(offset, color, opacity) {
      return this.put(new SVG.Stop).update(offset, color, opacity)
    }
    // Update gradient
  , update: function(block) {
      // remove all stops
      this.clear()

      // invoke passed block
      if (typeof block == 'function')
        block.call(this, this)

      return this
    }
    // Return the fill id
  , fill: function() {
      return 'url(#' + this.id() + ')'
    }
    // Alias string convertion to fill
  , toString: function() {
      return this.fill()
    }
    // custom attr to handle transform
  , attr: function(a, b, c) {
      if(a == 'transform') a = 'gradientTransform'
      return SVG.Container.prototype.attr.call(this, a, b, c)
    }
  }

  // Add parent method
, construct: {
    // Create gradient element in defs
    gradient: function(type, block) {
      return this.defs().gradient(type, block)
    }
  }
})

// Add animatable methods to both gradient and fx module
SVG.extend(SVG.Gradient, SVG.FX, {
  // From position
  from: function(x, y) {
    return (this._target || this).type == 'radial' ?
      this.attr({ fx: new SVG.Number(x), fy: new SVG.Number(y) }) :
      this.attr({ x1: new SVG.Number(x), y1: new SVG.Number(y) })
  }
  // To position
, to: function(x, y) {
    return (this._target || this).type == 'radial' ?
      this.attr({ cx: new SVG.Number(x), cy: new SVG.Number(y) }) :
      this.attr({ x2: new SVG.Number(x), y2: new SVG.Number(y) })
  }
})

// Base gradient generation
SVG.extend(SVG.Defs, {
  // define gradient
  gradient: function(type, block) {
    return this.put(new SVG.Gradient(type)).update(block)
  }

})

SVG.Stop = SVG.invent({
  // Initialize node
  create: 'stop'

  // Inherit from
, inherit: SVG.Element

  // Add class methods
, extend: {
    // add color stops
    update: function(o) {
      if (typeof o == 'number' || o instanceof SVG.Number) {
        o = {
          offset:  arguments[0]
        , color:   arguments[1]
        , opacity: arguments[2]
        }
      }

      // set attributes
      if (o.opacity != null) this.attr('stop-opacity', o.opacity)
      if (o.color   != null) this.attr('stop-color', o.color)
      if (o.offset  != null) this.attr('offset', new SVG.Number(o.offset))

      return this
    }
  }

})

SVG.Pattern = SVG.invent({
  // Initialize node
  create: 'pattern'

  // Inherit from
, inherit: SVG.Container

  // Add class methods
, extend: {
    // Return the fill id
    fill: function() {
      return 'url(#' + this.id() + ')'
    }
    // Update pattern by rebuilding
  , update: function(block) {
      // remove content
      this.clear()

      // invoke passed block
      if (typeof block == 'function')
        block.call(this, this)

      return this
    }
    // Alias string convertion to fill
  , toString: function() {
      return this.fill()
    }
    // custom attr to handle transform
  , attr: function(a, b, c) {
      if(a == 'transform') a = 'patternTransform'
      return SVG.Container.prototype.attr.call(this, a, b, c)
    }

  }

  // Add parent method
, construct: {
    // Create pattern element in defs
    pattern: function(width, height, block) {
      return this.defs().pattern(width, height, block)
    }
  }
})

SVG.extend(SVG.Defs, {
  // Define gradient
  pattern: function(width, height, block) {
    return this.put(new SVG.Pattern).update(block).attr({
      x:            0
    , y:            0
    , width:        width
    , height:       height
    , patternUnits: 'userSpaceOnUse'
    })
  }

})
SVG.Shape = SVG.invent({
  // Initialize node
  create: function(element) {
    this.constructor.call(this, element)
  }

  // Inherit from
, inherit: SVG.Element

})

SVG.Bare = SVG.invent({
  // Initialize
  create: function(element, inherit) {
    // construct element
    this.constructor.call(this, SVG.create(element))

    // inherit custom methods
    if (inherit)
      for (var method in inherit.prototype)
        if (typeof inherit.prototype[method] === 'function')
          this[method] = inherit.prototype[method]
  }

  // Inherit from
, inherit: SVG.Element

  // Add methods
, extend: {
    // Insert some plain text
    words: function(text) {
      // remove contents
      while (this.node.hasChildNodes())
        this.node.removeChild(this.node.lastChild)

      // create text node
      this.node.appendChild(document.createTextNode(text))

      return this
    }
  }
})


SVG.extend(SVG.Parent, {
  // Create an element that is not described by SVG.js
  element: function(element, inherit) {
    return this.put(new SVG.Bare(element, inherit))
  }
})

SVG.Symbol = SVG.invent({
  // Initialize node
  create: 'symbol'

  // Inherit from
, inherit: SVG.Container

, construct: {
    // create symbol
    symbol: function() {
      return this.put(new SVG.Symbol)
    }
  }
})

SVG.Use = SVG.invent({
  // Initialize node
  create: 'use'

  // Inherit from
, inherit: SVG.Shape

  // Add class methods
, extend: {
    // Use element as a reference
    element: function(element, file) {
      // Set lined element
      return this.attr('href', (file || '') + '#' + element, SVG.xlink)
    }
  }

  // Add parent method
, construct: {
    // Create a use element
    use: function(element, file) {
      return this.put(new SVG.Use).element(element, file)
    }
  }
})
SVG.Rect = SVG.invent({
  // Initialize node
  create: 'rect'

  // Inherit from
, inherit: SVG.Shape

  // Add parent method
, construct: {
    // Create a rect element
    rect: function(width, height) {
      return this.put(new SVG.Rect()).size(width, height)
    }
  }
})
SVG.Circle = SVG.invent({
  // Initialize node
  create: 'circle'

  // Inherit from
, inherit: SVG.Shape

  // Add parent method
, construct: {
    // Create circle element, based on ellipse
    circle: function(size) {
      return this.put(new SVG.Circle).rx(new SVG.Number(size).divide(2)).move(0, 0)
    }
  }
})

SVG.extend(SVG.Circle, SVG.FX, {
  // Radius x value
  rx: function(rx) {
    return this.attr('r', rx)
  }
  // Alias radius x value
, ry: function(ry) {
    return this.rx(ry)
  }
})

SVG.Ellipse = SVG.invent({
  // Initialize node
  create: 'ellipse'

  // Inherit from
, inherit: SVG.Shape

  // Add parent method
, construct: {
    // Create an ellipse
    ellipse: function(width, height) {
      return this.put(new SVG.Ellipse).size(width, height).move(0, 0)
    }
  }
})

SVG.extend(SVG.Ellipse, SVG.Rect, SVG.FX, {
  // Radius x value
  rx: function(rx) {
    return this.attr('rx', rx)
  }
  // Radius y value
, ry: function(ry) {
    return this.attr('ry', ry)
  }
})

// Add common method
SVG.extend(SVG.Circle, SVG.Ellipse, {
    // Move over x-axis
    x: function(x) {
      return x == null ? this.cx() - this.rx() : this.cx(x + this.rx())
    }
    // Move over y-axis
  , y: function(y) {
      return y == null ? this.cy() - this.ry() : this.cy(y + this.ry())
    }
    // Move by center over x-axis
  , cx: function(x) {
      return x == null ? this.attr('cx') : this.attr('cx', x)
    }
    // Move by center over y-axis
  , cy: function(y) {
      return y == null ? this.attr('cy') : this.attr('cy', y)
    }
    // Set width of element
  , width: function(width) {
      return width == null ? this.rx() * 2 : this.rx(new SVG.Number(width).divide(2))
    }
    // Set height of element
  , height: function(height) {
      return height == null ? this.ry() * 2 : this.ry(new SVG.Number(height).divide(2))
    }
    // Custom size function
  , size: function(width, height) {
      var p = proportionalSize(this, width, height)

      return this
        .rx(new SVG.Number(p.width).divide(2))
        .ry(new SVG.Number(p.height).divide(2))
    }
})
SVG.Line = SVG.invent({
  // Initialize node
  create: 'line'

  // Inherit from
, inherit: SVG.Shape

  // Add class methods
, extend: {
    // Get array
    array: function() {
      return new SVG.PointArray([
        [ this.attr('x1'), this.attr('y1') ]
      , [ this.attr('x2'), this.attr('y2') ]
      ])
    }
    // Overwrite native plot() method
  , plot: function(x1, y1, x2, y2) {
      if (x1 == null)
        return this.array()
      else if (typeof y1 !== 'undefined')
        x1 = { x1: x1, y1: y1, x2: x2, y2: y2 }
      else
        x1 = new SVG.PointArray(x1).toLine()

      return this.attr(x1)
    }
    // Move by left top corner
  , move: function(x, y) {
      return this.attr(this.array().move(x, y).toLine())
    }
    // Set element size to given width and height
  , size: function(width, height) {
      var p = proportionalSize(this, width, height)

      return this.attr(this.array().size(p.width, p.height).toLine())
    }
  }

  // Add parent method
, construct: {
    // Create a line element
    line: function(x1, y1, x2, y2) {
      // make sure plot is called as a setter
      // x1 is not necessarily a number, it can also be an array, a string and a SVG.PointArray
      return SVG.Line.prototype.plot.apply(
        this.put(new SVG.Line)
      , x1 != null ? [x1, y1, x2, y2] : [0, 0, 0, 0]
      )
    }
  }
})

SVG.Polyline = SVG.invent({
  // Initialize node
  create: 'polyline'

  // Inherit from
, inherit: SVG.Shape

  // Add parent method
, construct: {
    // Create a wrapped polyline element
    polyline: function(p) {
      // make sure plot is called as a setter
      return this.put(new SVG.Polyline).plot(p || new SVG.PointArray)
    }
  }
})

SVG.Polygon = SVG.invent({
  // Initialize node
  create: 'polygon'

  // Inherit from
, inherit: SVG.Shape

  // Add parent method
, construct: {
    // Create a wrapped polygon element
    polygon: function(p) {
      // make sure plot is called as a setter
      return this.put(new SVG.Polygon).plot(p || new SVG.PointArray)
    }
  }
})

// Add polygon-specific functions
SVG.extend(SVG.Polyline, SVG.Polygon, {
  // Get array
  array: function() {
    return this._array || (this._array = new SVG.PointArray(this.attr('points')))
  }
  // Plot new path
, plot: function(p) {
    return (p == null) ?
      this.array() :
      this.clear().attr('points', typeof p == 'string' ? p : (this._array = new SVG.PointArray(p)))
  }
  // Clear array cache
, clear: function() {
    delete this._array
    return this
  }
  // Move by left top corner
, move: function(x, y) {
    return this.attr('points', this.array().move(x, y))
  }
  // Set element size to given width and height
, size: function(width, height) {
    var p = proportionalSize(this, width, height)

    return this.attr('points', this.array().size(p.width, p.height))
  }

})

// unify all point to point elements
SVG.extend(SVG.Line, SVG.Polyline, SVG.Polygon, {
  // Define morphable array
  morphArray:  SVG.PointArray
  // Move by left top corner over x-axis
, x: function(x) {
    return x == null ? this.bbox().x : this.move(x, this.bbox().y)
  }
  // Move by left top corner over y-axis
, y: function(y) {
    return y == null ? this.bbox().y : this.move(this.bbox().x, y)
  }
  // Set width of element
, width: function(width) {
    var b = this.bbox()

    return width == null ? b.width : this.size(width, b.height)
  }
  // Set height of element
, height: function(height) {
    var b = this.bbox()

    return height == null ? b.height : this.size(b.width, height)
  }
})
SVG.Path = SVG.invent({
  // Initialize node
  create: 'path'

  // Inherit from
, inherit: SVG.Shape

  // Add class methods
, extend: {
    // Define morphable array
    morphArray:  SVG.PathArray
    // Get array
  , array: function() {
      return this._array || (this._array = new SVG.PathArray(this.attr('d')))
    }
    // Plot new path
  , plot: function(d) {
      return (d == null) ?
        this.array() :
        this.clear().attr('d', typeof d == 'string' ? d : (this._array = new SVG.PathArray(d)))
    }
    // Clear array cache
  , clear: function() {
      delete this._array
      return this
    }
    // Move by left top corner
  , move: function(x, y) {
      return this.attr('d', this.array().move(x, y))
    }
    // Move by left top corner over x-axis
  , x: function(x) {
      return x == null ? this.bbox().x : this.move(x, this.bbox().y)
    }
    // Move by left top corner over y-axis
  , y: function(y) {
      return y == null ? this.bbox().y : this.move(this.bbox().x, y)
    }
    // Set element size to given width and height
  , size: function(width, height) {
      var p = proportionalSize(this, width, height)

      return this.attr('d', this.array().size(p.width, p.height))
    }
    // Set width of element
  , width: function(width) {
      return width == null ? this.bbox().width : this.size(width, this.bbox().height)
    }
    // Set height of element
  , height: function(height) {
      return height == null ? this.bbox().height : this.size(this.bbox().width, height)
    }

  }

  // Add parent method
, construct: {
    // Create a wrapped path element
    path: function(d) {
      // make sure plot is called as a setter
      return this.put(new SVG.Path).plot(d || new SVG.PathArray)
    }
  }
})

SVG.Image = SVG.invent({
  // Initialize node
  create: 'image'

  // Inherit from
, inherit: SVG.Shape

  // Add class methods
, extend: {
    // (re)load image
    load: function(url) {
      if (!url) return this

      var self = this
        , img  = new window.Image()

      // preload image
      SVG.on(img, 'load', function() {
        SVG.off(img)

        var p = self.parent(SVG.Pattern)

        if(p === null) return

        // ensure image size
        if (self.width() == 0 && self.height() == 0)
          self.size(img.width, img.height)

        // ensure pattern size if not set
        if (p && p.width() == 0 && p.height() == 0)
          p.size(self.width(), self.height())

        // callback
        if (typeof self._loaded === 'function')
          self._loaded.call(self, {
            width:  img.width
          , height: img.height
          , ratio:  img.width / img.height
          , url:    url
          })
      })

      SVG.on(img, 'error', function(e){
        SVG.off(img)

        if (typeof self._error === 'function'){
            self._error.call(self, e)
        }
      })

      return this.attr('href', (img.src = this.src = url), SVG.xlink)
    }
    // Add loaded callback
  , loaded: function(loaded) {
      this._loaded = loaded
      return this
    }

  , error: function(error) {
      this._error = error
      return this
    }
  }

  // Add parent method
, construct: {
    // create image element, load image and set its size
    image: function(source, width, height) {
      return this.put(new SVG.Image).load(source).size(width || 0, height || width || 0)
    }
  }

})
SVG.Text = SVG.invent({
  // Initialize node
  create: function() {
    this.constructor.call(this, SVG.create('text'))

    this.dom.leading = new SVG.Number(1.3)    // store leading value for rebuilding
    this._rebuild = true                      // enable automatic updating of dy values
    this._build   = false                     // disable build mode for adding multiple lines

    // set default font
    this.attr('font-family', SVG.defaults.attrs['font-family'])
  }

  // Inherit from
, inherit: SVG.Shape

  // Add class methods
, extend: {
    // Move over x-axis
    x: function(x) {
      // act as getter
      if (x == null)
        return this.attr('x')

      return this.attr('x', x)
    }
    // Move over y-axis
  , y: function(y) {
      var oy = this.attr('y')
        , o  = typeof oy === 'number' ? oy - this.bbox().y : 0

      // act as getter
      if (y == null)
        return typeof oy === 'number' ? oy - o : oy

      return this.attr('y', typeof y.valueOf() === 'number' ? y + o : y)
    }
    // Move center over x-axis
  , cx: function(x) {
      return x == null ? this.bbox().cx : this.x(x - this.bbox().width / 2)
    }
    // Move center over y-axis
  , cy: function(y) {
      return y == null ? this.bbox().cy : this.y(y - this.bbox().height / 2)
    }
    // Set the text content
  , text: function(text) {
      // act as getter
      if (typeof text === 'undefined'){
        var text = ''
        var children = this.node.childNodes
        for(var i = 0, len = children.length; i < len; ++i){

          // add newline if its not the first child and newLined is set to true
          if(i != 0 && children[i].nodeType != 3 && SVG.adopt(children[i]).dom.newLined == true){
            text += '\n'
          }

          // add content of this node
          text += children[i].textContent
        }

        return text
      }

      // remove existing content
      this.clear().build(true)

      if (typeof text === 'function') {
        // call block
        text.call(this, this)

      } else {
        // store text and make sure text is not blank
        text = text.split('\n')

        // build new lines
        for (var i = 0, il = text.length; i < il; i++)
          this.tspan(text[i]).newLine()
      }

      // disable build mode and rebuild lines
      return this.build(false).rebuild()
    }
    // Set font size
  , size: function(size) {
      return this.attr('font-size', size).rebuild()
    }
    // Set / get leading
  , leading: function(value) {
      // act as getter
      if (value == null)
        return this.dom.leading

      // act as setter
      this.dom.leading = new SVG.Number(value)

      return this.rebuild()
    }
    // Get all the first level lines
  , lines: function() {
      var node = (this.textPath && this.textPath() || this).node

      // filter tspans and map them to SVG.js instances
      var lines = SVG.utils.map(SVG.utils.filterSVGElements(node.childNodes), function(el){
        return SVG.adopt(el)
      })

      // return an instance of SVG.set
      return new SVG.Set(lines)
    }
    // Rebuild appearance type
  , rebuild: function(rebuild) {
      // store new rebuild flag if given
      if (typeof rebuild == 'boolean')
        this._rebuild = rebuild

      // define position of all lines
      if (this._rebuild) {
        var self = this
          , blankLineOffset = 0
          , dy = this.dom.leading * new SVG.Number(this.attr('font-size'))

        this.lines().each(function() {
          if (this.dom.newLined) {
            if (!self.textPath())
              this.attr('x', self.attr('x'))
            if(this.text() == '\n') {
              blankLineOffset += dy
            }else{
              this.attr('dy', dy + blankLineOffset)
              blankLineOffset = 0
            }
          }
        })

        this.fire('rebuild')
      }

      return this
    }
    // Enable / disable build mode
  , build: function(build) {
      this._build = !!build
      return this
    }
    // overwrite method from parent to set data properly
  , setData: function(o){
      this.dom = o
      this.dom.leading = new SVG.Number(o.leading || 1.3)
      return this
    }
  }

  // Add parent method
, construct: {
    // Create text element
    text: function(text) {
      return this.put(new SVG.Text).text(text)
    }
    // Create plain text element
  , plain: function(text) {
      return this.put(new SVG.Text).plain(text)
    }
  }

})

SVG.Tspan = SVG.invent({
  // Initialize node
  create: 'tspan'

  // Inherit from
, inherit: SVG.Shape

  // Add class methods
, extend: {
    // Set text content
    text: function(text) {
      if(text == null) return this.node.textContent + (this.dom.newLined ? '\n' : '')

      typeof text === 'function' ? text.call(this, this) : this.plain(text)

      return this
    }
    // Shortcut dx
  , dx: function(dx) {
      return this.attr('dx', dx)
    }
    // Shortcut dy
  , dy: function(dy) {
      return this.attr('dy', dy)
    }
    // Create new line
  , newLine: function() {
      // fetch text parent
      var t = this.parent(SVG.Text)

      // mark new line
      this.dom.newLined = true

      // apply new hy¡n
      return this.dy(t.dom.leading * t.attr('font-size')).attr('x', t.x())
    }
  }

})

SVG.extend(SVG.Text, SVG.Tspan, {
  // Create plain text node
  plain: function(text) {
    // clear if build mode is disabled
    if (this._build === false)
      this.clear()

    // create text node
    this.node.appendChild(document.createTextNode(text))

    return this
  }
  // Create a tspan
, tspan: function(text) {
    var node  = (this.textPath && this.textPath() || this).node
      , tspan = new SVG.Tspan

    // clear if build mode is disabled
    if (this._build === false)
      this.clear()

    // add new tspan
    node.appendChild(tspan.node)

    return tspan.text(text)
  }
  // Clear all lines
, clear: function() {
    var node = (this.textPath && this.textPath() || this).node

    // remove existing child nodes
    while (node.hasChildNodes())
      node.removeChild(node.lastChild)

    return this
  }
  // Get length of text element
, length: function() {
    return this.node.getComputedTextLength()
  }
})

SVG.TextPath = SVG.invent({
  // Initialize node
  create: 'textPath'

  // Inherit from
, inherit: SVG.Parent

  // Define parent class
, parent: SVG.Text

  // Add parent method
, construct: {
    morphArray: SVG.PathArray
    // Create path for text to run on
  , path: function(d) {
      // create textPath element
      var path  = new SVG.TextPath
        , track = this.doc().defs().path(d)

      // move lines to textpath
      while (this.node.hasChildNodes())
        path.node.appendChild(this.node.firstChild)

      // add textPath element as child node
      this.node.appendChild(path.node)

      // link textPath to path and add content
      path.attr('href', '#' + track, SVG.xlink)

      return this
    }
    // return the array of the path track element
  , array: function() {
      var track = this.track()

      return track ? track.array() : null
    }
    // Plot path if any
  , plot: function(d) {
      var track = this.track()
        , pathArray = null

      if (track) {
        pathArray = track.plot(d)
      }

      return (d == null) ? pathArray : this
    }
    // Get the path track element
  , track: function() {
      var path = this.textPath()

      if (path)
        return path.reference('href')
    }
    // Get the textPath child
  , textPath: function() {
      if (this.node.firstChild && this.node.firstChild.nodeName == 'textPath')
        return SVG.adopt(this.node.firstChild)
    }
  }
})

SVG.Nested = SVG.invent({
  // Initialize node
  create: function() {
    this.constructor.call(this, SVG.create('svg'))

    this.style('overflow', 'visible')
  }

  // Inherit from
, inherit: SVG.Container

  // Add parent method
, construct: {
    // Create nested svg document
    nested: function() {
      return this.put(new SVG.Nested)
    }
  }
})
SVG.A = SVG.invent({
  // Initialize node
  create: 'a'

  // Inherit from
, inherit: SVG.Container

  // Add class methods
, extend: {
    // Link url
    to: function(url) {
      return this.attr('href', url, SVG.xlink)
    }
    // Link show attribute
  , show: function(target) {
      return this.attr('show', target, SVG.xlink)
    }
    // Link target attribute
  , target: function(target) {
      return this.attr('target', target)
    }
  }

  // Add parent method
, construct: {
    // Create a hyperlink element
    link: function(url) {
      return this.put(new SVG.A).to(url)
    }
  }
})

SVG.extend(SVG.Element, {
  // Create a hyperlink element
  linkTo: function(url) {
    var link = new SVG.A

    if (typeof url == 'function')
      url.call(link, link)
    else
      link.to(url)

    return this.parent().put(link).put(this)
  }

})
SVG.Marker = SVG.invent({
  // Initialize node
  create: 'marker'

  // Inherit from
, inherit: SVG.Container

  // Add class methods
, extend: {
    // Set width of element
    width: function(width) {
      return this.attr('markerWidth', width)
    }
    // Set height of element
  , height: function(height) {
      return this.attr('markerHeight', height)
    }
    // Set marker refX and refY
  , ref: function(x, y) {
      return this.attr('refX', x).attr('refY', y)
    }
    // Update marker
  , update: function(block) {
      // remove all content
      this.clear()

      // invoke passed block
      if (typeof block == 'function')
        block.call(this, this)

      return this
    }
    // Return the fill id
  , toString: function() {
      return 'url(#' + this.id() + ')'
    }
  }

  // Add parent method
, construct: {
    marker: function(width, height, block) {
      // Create marker element in defs
      return this.defs().marker(width, height, block)
    }
  }

})

SVG.extend(SVG.Defs, {
  // Create marker
  marker: function(width, height, block) {
    // Set default viewbox to match the width and height, set ref to cx and cy and set orient to auto
    return this.put(new SVG.Marker)
      .size(width, height)
      .ref(width / 2, height / 2)
      .viewbox(0, 0, width, height)
      .attr('orient', 'auto')
      .update(block)
  }

})

SVG.extend(SVG.Line, SVG.Polyline, SVG.Polygon, SVG.Path, {
  // Create and attach markers
  marker: function(marker, width, height, block) {
    var attr = ['marker']

    // Build attribute name
    if (marker != 'all') attr.push(marker)
    attr = attr.join('-')

    // Set marker attribute
    marker = arguments[1] instanceof SVG.Marker ?
      arguments[1] :
      this.doc().marker(width, height, block)

    return this.attr(attr, marker)
  }

})
// Define list of available attributes for stroke and fill
var sugar = {
  stroke: ['color', 'width', 'opacity', 'linecap', 'linejoin', 'miterlimit', 'dasharray', 'dashoffset']
, fill:   ['color', 'opacity', 'rule']
, prefix: function(t, a) {
    return a == 'color' ? t : t + '-' + a
  }
}

// Add sugar for fill and stroke
;['fill', 'stroke'].forEach(function(m) {
  var i, extension = {}

  extension[m] = function(o) {
    if (typeof o == 'undefined')
      return this
    if (typeof o == 'string' || SVG.Color.isRgb(o) || (o && typeof o.fill === 'function'))
      this.attr(m, o)

    else
      // set all attributes from sugar.fill and sugar.stroke list
      for (i = sugar[m].length - 1; i >= 0; i--)
        if (o[sugar[m][i]] != null)
          this.attr(sugar.prefix(m, sugar[m][i]), o[sugar[m][i]])

    return this
  }

  SVG.extend(SVG.Element, SVG.FX, extension)

})

SVG.extend(SVG.Element, SVG.FX, {
  // Map rotation to transform
  rotate: function(d, cx, cy) {
    return this.transform({ rotation: d, cx: cx, cy: cy })
  }
  // Map skew to transform
, skew: function(x, y, cx, cy) {
    return arguments.length == 1  || arguments.length == 3 ?
      this.transform({ skew: x, cx: y, cy: cx }) :
      this.transform({ skewX: x, skewY: y, cx: cx, cy: cy })
  }
  // Map scale to transform
, scale: function(x, y, cx, cy) {
    return arguments.length == 1  || arguments.length == 3 ?
      this.transform({ scale: x, cx: y, cy: cx }) :
      this.transform({ scaleX: x, scaleY: y, cx: cx, cy: cy })
  }
  // Map translate to transform
, translate: function(x, y) {
    return this.transform({ x: x, y: y })
  }
  // Map flip to transform
, flip: function(a, o) {
    o = typeof a == 'number' ? a : o
    return this.transform({ flip: a || 'both', offset: o })
  }
  // Map matrix to transform
, matrix: function(m) {
    return this.attr('transform', new SVG.Matrix(arguments.length == 6 ? [].slice.call(arguments) : m))
  }
  // Opacity
, opacity: function(value) {
    return this.attr('opacity', value)
  }
  // Relative move over x axis
, dx: function(x) {
    return this.x(new SVG.Number(x).plus(this instanceof SVG.FX ? 0 : this.x()), true)
  }
  // Relative move over y axis
, dy: function(y) {
    return this.y(new SVG.Number(y).plus(this instanceof SVG.FX ? 0 : this.y()), true)
  }
  // Relative move over x and y axes
, dmove: function(x, y) {
    return this.dx(x).dy(y)
  }
})

SVG.extend(SVG.Rect, SVG.Ellipse, SVG.Circle, SVG.Gradient, SVG.FX, {
  // Add x and y radius
  radius: function(x, y) {
    var type = (this._target || this).type;
    return type == 'radial' || type == 'circle' ?
      this.attr('r', new SVG.Number(x)) :
      this.rx(x).ry(y == null ? x : y)
  }
})

SVG.extend(SVG.Path, {
  // Get path length
  length: function() {
    return this.node.getTotalLength()
  }
  // Get point at length
, pointAt: function(length) {
    return this.node.getPointAtLength(length)
  }
})

SVG.extend(SVG.Parent, SVG.Text, SVG.Tspan, SVG.FX, {
  // Set font
  font: function(a, v) {
    if (typeof a == 'object') {
      for (v in a) this.font(v, a[v])
    }

    return a == 'leading' ?
        this.leading(v) :
      a == 'anchor' ?
        this.attr('text-anchor', v) :
      a == 'size' || a == 'family' || a == 'weight' || a == 'stretch' || a == 'variant' || a == 'style' ?
        this.attr('font-'+ a, v) :
        this.attr(a, v)
  }
})

SVG.Set = SVG.invent({
  // Initialize
  create: function(members) {
    if (members instanceof SVG.Set) {
      this.members = members.members.slice()
    } else {
      Array.isArray(members) ? this.members = members : this.clear()
    }
  }

  // Add class methods
, extend: {
    // Add element to set
    add: function() {
      var i, il, elements = [].slice.call(arguments)

      for (i = 0, il = elements.length; i < il; i++)
        this.members.push(elements[i])

      return this
    }
    // Remove element from set
  , remove: function(element) {
      var i = this.index(element)

      // remove given child
      if (i > -1)
        this.members.splice(i, 1)

      return this
    }
    // Iterate over all members
  , each: function(block) {
      for (var i = 0, il = this.members.length; i < il; i++)
        block.apply(this.members[i], [i, this.members])

      return this
    }
    // Restore to defaults
  , clear: function() {
      // initialize store
      this.members = []

      return this
    }
    // Get the length of a set
  , length: function() {
      return this.members.length
    }
    // Checks if a given element is present in set
  , has: function(element) {
      return this.index(element) >= 0
    }
    // retuns index of given element in set
  , index: function(element) {
      return this.members.indexOf(element)
    }
    // Get member at given index
  , get: function(i) {
      return this.members[i]
    }
    // Get first member
  , first: function() {
      return this.get(0)
    }
    // Get last member
  , last: function() {
      return this.get(this.members.length - 1)
    }
    // Default value
  , valueOf: function() {
      return this.members
    }
    // Get the bounding box of all members included or empty box if set has no items
  , bbox: function(){
      // return an empty box of there are no members
      if (this.members.length == 0)
        return new SVG.RBox()

      // get the first rbox and update the target bbox
      var rbox = this.members[0].rbox(this.members[0].doc())

      this.each(function() {
        // user rbox for correct position and visual representation
        rbox = rbox.merge(this.rbox(this.doc()))
      })

      return rbox
    }
  }

  // Add parent method
, construct: {
    // Create a new set
    set: function(members) {
      return new SVG.Set(members)
    }
  }
})

SVG.FX.Set = SVG.invent({
  // Initialize node
  create: function(set) {
    // store reference to set
    this.set = set
  }

})

// Alias methods
SVG.Set.inherit = function() {
  var m
    , methods = []

  // gather shape methods
  for(var m in SVG.Shape.prototype)
    if (typeof SVG.Shape.prototype[m] == 'function' && typeof SVG.Set.prototype[m] != 'function')
      methods.push(m)

  // apply shape aliasses
  methods.forEach(function(method) {
    SVG.Set.prototype[method] = function() {
      for (var i = 0, il = this.members.length; i < il; i++)
        if (this.members[i] && typeof this.members[i][method] == 'function')
          this.members[i][method].apply(this.members[i], arguments)

      return method == 'animate' ? (this.fx || (this.fx = new SVG.FX.Set(this))) : this
    }
  })

  // clear methods for the next round
  methods = []

  // gather fx methods
  for(var m in SVG.FX.prototype)
    if (typeof SVG.FX.prototype[m] == 'function' && typeof SVG.FX.Set.prototype[m] != 'function')
      methods.push(m)

  // apply fx aliasses
  methods.forEach(function(method) {
    SVG.FX.Set.prototype[method] = function() {
      for (var i = 0, il = this.set.members.length; i < il; i++)
        this.set.members[i].fx[method].apply(this.set.members[i].fx, arguments)

      return this
    }
  })
}


SVG.extend(SVG.Element, {
  // Store data values on svg nodes
  data: function(a, v, r) {
    if (typeof a == 'object') {
      for (v in a)
        this.data(v, a[v])

    } else if (arguments.length < 2) {
      try {
        return JSON.parse(this.attr('data-' + a))
      } catch(e) {
        return this.attr('data-' + a)
      }

    } else {
      this.attr(
        'data-' + a
      , v === null ?
          null :
        r === true || typeof v === 'string' || typeof v === 'number' ?
          v :
          JSON.stringify(v)
      )
    }

    return this
  }
})
SVG.extend(SVG.Element, {
  // Remember arbitrary data
  remember: function(k, v) {
    // remember every item in an object individually
    if (typeof arguments[0] == 'object')
      for (var v in k)
        this.remember(v, k[v])

    // retrieve memory
    else if (arguments.length == 1)
      return this.memory()[k]

    // store memory
    else
      this.memory()[k] = v

    return this
  }

  // Erase a given memory
, forget: function() {
    if (arguments.length == 0)
      this._memory = {}
    else
      for (var i = arguments.length - 1; i >= 0; i--)
        delete this.memory()[arguments[i]]

    return this
  }

  // Initialize or return local memory object
, memory: function() {
    return this._memory || (this._memory = {})
  }

})
// Method for getting an element by id
SVG.get = function(id) {
  var node = document.getElementById(idFromReference(id) || id)
  return SVG.adopt(node)
}

// Select elements by query string
SVG.select = function(query, parent) {
  return new SVG.Set(
    SVG.utils.map((parent || document).querySelectorAll(query), function(node) {
      return SVG.adopt(node)
    })
  )
}

SVG.extend(SVG.Parent, {
  // Scoped select method
  select: function(query) {
    return SVG.select(query, this.node)
  }

})
function pathRegReplace(a, b, c, d) {
  return c + d.replace(SVG.regex.dots, ' .')
}

// creates deep clone of array
function array_clone(arr){
  var clone = arr.slice(0)
  for(var i = clone.length; i--;){
    if(Array.isArray(clone[i])){
      clone[i] = array_clone(clone[i])
    }
  }
  return clone
}

// tests if a given element is instance of an object
function is(el, obj){
  return el instanceof obj
}

// tests if a given selector matches an element
function matches(el, selector) {
  return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
}

// Convert dash-separated-string to camelCase
function camelCase(s) {
  return s.toLowerCase().replace(/-(.)/g, function(m, g) {
    return g.toUpperCase()
  })
}

// Capitalize first letter of a string
function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

// Ensure to six-based hex
function fullHex(hex) {
  return hex.length == 4 ?
    [ '#',
      hex.substring(1, 2), hex.substring(1, 2)
    , hex.substring(2, 3), hex.substring(2, 3)
    , hex.substring(3, 4), hex.substring(3, 4)
    ].join('') : hex
}

// Component to hex value
function compToHex(comp) {
  var hex = comp.toString(16)
  return hex.length == 1 ? '0' + hex : hex
}

// Calculate proportional width and height values when necessary
function proportionalSize(element, width, height) {
  if (width == null || height == null) {
    var box = element.bbox()

    if (width == null)
      width = box.width / box.height * height
    else if (height == null)
      height = box.height / box.width * width
  }

  return {
    width:  width
  , height: height
  }
}

// Delta transform point
function deltaTransformPoint(matrix, x, y) {
  return {
    x: x * matrix.a + y * matrix.c + 0
  , y: x * matrix.b + y * matrix.d + 0
  }
}

// Map matrix array to object
function arrayToMatrix(a) {
  return { a: a[0], b: a[1], c: a[2], d: a[3], e: a[4], f: a[5] }
}

// Parse matrix if required
function parseMatrix(matrix) {
  if (!(matrix instanceof SVG.Matrix))
    matrix = new SVG.Matrix(matrix)

  return matrix
}

// Add centre point to transform object
function ensureCentre(o, target) {
  o.cx = o.cx == null ? target.bbox().cx : o.cx
  o.cy = o.cy == null ? target.bbox().cy : o.cy
}

// PathArray Helpers
function arrayToString(a) {
  for (var i = 0, il = a.length, s = ''; i < il; i++) {
    s += a[i][0]

    if (a[i][1] != null) {
      s += a[i][1]

      if (a[i][2] != null) {
        s += ' '
        s += a[i][2]

        if (a[i][3] != null) {
          s += ' '
          s += a[i][3]
          s += ' '
          s += a[i][4]

          if (a[i][5] != null) {
            s += ' '
            s += a[i][5]
            s += ' '
            s += a[i][6]

            if (a[i][7] != null) {
              s += ' '
              s += a[i][7]
            }
          }
        }
      }
    }
  }

  return s + ' '
}

// Deep new id assignment
function assignNewId(node) {
  // do the same for SVG child nodes as well
  for (var i = node.childNodes.length - 1; i >= 0; i--)
    if (node.childNodes[i] instanceof window.SVGElement)
      assignNewId(node.childNodes[i])

  return SVG.adopt(node).id(SVG.eid(node.nodeName))
}

// Add more bounding box properties
function fullBox(b) {
  if (b.x == null) {
    b.x      = 0
    b.y      = 0
    b.width  = 0
    b.height = 0
  }

  b.w  = b.width
  b.h  = b.height
  b.x2 = b.x + b.width
  b.y2 = b.y + b.height
  b.cx = b.x + b.width / 2
  b.cy = b.y + b.height / 2

  return b
}

// Get id from reference string
function idFromReference(url) {
  var m = (url || '').toString().match(SVG.regex.reference)

  if (m) return m[1]
}

// If values like 1e-88 are passed, this is not a valid 32 bit float,
// but in those cases, we are so close to 0 that 0 works well!
function float32String(v) {
  return Math.abs(v) > 1e-37 ? v : 0
}

// Create matrix array for looping
var abcdef = 'abcdef'.split('')

// Add CustomEvent to IE9 and IE10
if (typeof window.CustomEvent !== 'function') {
  // Code from: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent
  var CustomEventPoly = function(event, options) {
    options = options || { bubbles: false, cancelable: false, detail: undefined }
    var e = document.createEvent('CustomEvent')
    e.initCustomEvent(event, options.bubbles, options.cancelable, options.detail)
    return e
  }

  CustomEventPoly.prototype = window.Event.prototype

  SVG.CustomEvent = CustomEventPoly
} else {
  SVG.CustomEvent = window.CustomEvent
}

// requestAnimationFrame / cancelAnimationFrame Polyfill with fallback based on Paul Irish
(function(w) {
  var lastTime = 0
  var vendors = ['moz', 'webkit']

  for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    w.requestAnimationFrame = w[vendors[x] + 'RequestAnimationFrame']
    w.cancelAnimationFrame  = w[vendors[x] + 'CancelAnimationFrame'] ||
                              w[vendors[x] + 'CancelRequestAnimationFrame']
  }

  w.requestAnimationFrame = w.requestAnimationFrame ||
    function(callback) {
      var currTime = new Date().getTime()
      var timeToCall = Math.max(0, 16 - (currTime - lastTime))

      var id = w.setTimeout(function() {
        callback(currTime + timeToCall)
      }, timeToCall)

      lastTime = currTime + timeToCall
      return id
    }

  w.cancelAnimationFrame = w.cancelAnimationFrame || w.clearTimeout;

}(window))

return SVG

}));
},{}],25:[function(require,module,exports){
/**
 * Loads a Wavefront .mtl file specifying materials
 *
 * @author angelxuanchang
 */

THREE.MTLLoader = function ( manager ) {

	THREE.Loader.call( this, manager );

};

THREE.MTLLoader.prototype = Object.assign( Object.create( THREE.Loader.prototype ), {

	constructor: THREE.MTLLoader,

	/**
	 * Loads and parses a MTL asset from a URL.
	 *
	 * @param {String} url - URL to the MTL file.
	 * @param {Function} [onLoad] - Callback invoked with the loaded object.
	 * @param {Function} [onProgress] - Callback for download progress.
	 * @param {Function} [onError] - Callback for download errors.
	 *
	 * @see setPath setResourcePath
	 *
	 * @note In order for relative texture references to resolve correctly
	 * you must call setResourcePath() explicitly prior to load.
	 */
	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var path = ( this.path === '' ) ? THREE.LoaderUtils.extractUrlBase( url ) : this.path;

		var loader = new THREE.FileLoader( this.manager );
		loader.setPath( this.path );
		loader.load( url, function ( text ) {

			onLoad( scope.parse( text, path ) );

		}, onProgress, onError );

	},

	setMaterialOptions: function ( value ) {

		this.materialOptions = value;
		return this;

	},

	/**
	 * Parses a MTL file.
	 *
	 * @param {String} text - Content of MTL file
	 * @return {THREE.MTLLoader.MaterialCreator}
	 *
	 * @see setPath setResourcePath
	 *
	 * @note In order for relative texture references to resolve correctly
	 * you must call setResourcePath() explicitly prior to parse.
	 */
	parse: function ( text, path ) {

		var lines = text.split( '\n' );
		var info = {};
		var delimiter_pattern = /\s+/;
		var materialsInfo = {};

		for ( var i = 0; i < lines.length; i ++ ) {

			var line = lines[ i ];
			line = line.trim();

			if ( line.length === 0 || line.charAt( 0 ) === '#' ) {

				// Blank line or comment ignore
				continue;

			}

			var pos = line.indexOf( ' ' );

			var key = ( pos >= 0 ) ? line.substring( 0, pos ) : line;
			key = key.toLowerCase();

			var value = ( pos >= 0 ) ? line.substring( pos + 1 ) : '';
			value = value.trim();

			if ( key === 'newmtl' ) {

				// New material

				info = { name: value };
				materialsInfo[ value ] = info;

			} else {

				if ( key === 'ka' || key === 'kd' || key === 'ks' || key === 'ke' ) {

					var ss = value.split( delimiter_pattern, 3 );
					info[ key ] = [ parseFloat( ss[ 0 ] ), parseFloat( ss[ 1 ] ), parseFloat( ss[ 2 ] ) ];

				} else {

					info[ key ] = value;

				}

			}

		}

		var materialCreator = new THREE.MTLLoader.MaterialCreator( this.resourcePath || path, this.materialOptions );
		materialCreator.setCrossOrigin( this.crossOrigin );
		materialCreator.setManager( this.manager );
		materialCreator.setMaterials( materialsInfo );
		return materialCreator;

	}

} );

/**
 * Create a new THREE-MTLLoader.MaterialCreator
 * @param baseUrl - Url relative to which textures are loaded
 * @param options - Set of options on how to construct the materials
 *                  side: Which side to apply the material
 *                        THREE.FrontSide (default), THREE.BackSide, THREE.DoubleSide
 *                  wrap: What type of wrapping to apply for textures
 *                        THREE.RepeatWrapping (default), THREE.ClampToEdgeWrapping, THREE.MirroredRepeatWrapping
 *                  normalizeRGB: RGBs need to be normalized to 0-1 from 0-255
 *                                Default: false, assumed to be already normalized
 *                  ignoreZeroRGBs: Ignore values of RGBs (Ka,Kd,Ks) that are all 0's
 *                                  Default: false
 * @constructor
 */

THREE.MTLLoader.MaterialCreator = function ( baseUrl, options ) {

	this.baseUrl = baseUrl || '';
	this.options = options;
	this.materialsInfo = {};
	this.materials = {};
	this.materialsArray = [];
	this.nameLookup = {};

	this.side = ( this.options && this.options.side ) ? this.options.side : THREE.FrontSide;
	this.wrap = ( this.options && this.options.wrap ) ? this.options.wrap : THREE.RepeatWrapping;

};

THREE.MTLLoader.MaterialCreator.prototype = {

	constructor: THREE.MTLLoader.MaterialCreator,

	crossOrigin: 'anonymous',

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;
		return this;

	},

	setManager: function ( value ) {

		this.manager = value;

	},

	setMaterials: function ( materialsInfo ) {

		this.materialsInfo = this.convert( materialsInfo );
		this.materials = {};
		this.materialsArray = [];
		this.nameLookup = {};

	},

	convert: function ( materialsInfo ) {

		if ( ! this.options ) return materialsInfo;

		var converted = {};

		for ( var mn in materialsInfo ) {

			// Convert materials info into normalized form based on options

			var mat = materialsInfo[ mn ];

			var covmat = {};

			converted[ mn ] = covmat;

			for ( var prop in mat ) {

				var save = true;
				var value = mat[ prop ];
				var lprop = prop.toLowerCase();

				switch ( lprop ) {

					case 'kd':
					case 'ka':
					case 'ks':

						// Diffuse color (color under white light) using RGB values

						if ( this.options && this.options.normalizeRGB ) {

							value = [ value[ 0 ] / 255, value[ 1 ] / 255, value[ 2 ] / 255 ];

						}

						if ( this.options && this.options.ignoreZeroRGBs ) {

							if ( value[ 0 ] === 0 && value[ 1 ] === 0 && value[ 2 ] === 0 ) {

								// ignore

								save = false;

							}

						}

						break;

					default:

						break;

				}

				if ( save ) {

					covmat[ lprop ] = value;

				}

			}

		}

		return converted;

	},

	preload: function () {

		for ( var mn in this.materialsInfo ) {

			this.create( mn );

		}

	},

	getIndex: function ( materialName ) {

		return this.nameLookup[ materialName ];

	},

	getAsArray: function () {

		var index = 0;

		for ( var mn in this.materialsInfo ) {

			this.materialsArray[ index ] = this.create( mn );
			this.nameLookup[ mn ] = index;
			index ++;

		}

		return this.materialsArray;

	},

	create: function ( materialName ) {

		if ( this.materials[ materialName ] === undefined ) {

			this.createMaterial_( materialName );

		}

		return this.materials[ materialName ];

	},

	createMaterial_: function ( materialName ) {

		// Create material

		var scope = this;
		var mat = this.materialsInfo[ materialName ];
		var params = {

			name: materialName,
			side: this.side

		};

		function resolveURL( baseUrl, url ) {

			if ( typeof url !== 'string' || url === '' )
				return '';

			// Absolute URL
			if ( /^https?:\/\//i.test( url ) ) return url;

			return baseUrl + url;

		}

		function setMapForType( mapType, value ) {

			if ( params[ mapType ] ) return; // Keep the first encountered texture

			var texParams = scope.getTextureParams( value, params );
			var map = scope.loadTexture( resolveURL( scope.baseUrl, texParams.url ) );

			map.repeat.copy( texParams.scale );
			map.offset.copy( texParams.offset );

			map.wrapS = scope.wrap;
			map.wrapT = scope.wrap;

			params[ mapType ] = map;

		}

		for ( var prop in mat ) {

			var value = mat[ prop ];
			var n;

			if ( value === '' ) continue;

			switch ( prop.toLowerCase() ) {

				// Ns is material specular exponent

				case 'kd':

					// Diffuse color (color under white light) using RGB values

					params.color = new THREE.Color().fromArray( value );

					break;

				case 'ks':

					// Specular color (color when light is reflected from shiny surface) using RGB values
					params.specular = new THREE.Color().fromArray( value );

					break;

				case 'ke':

					// Emissive using RGB values
					params.emissive = new THREE.Color().fromArray( value );

					break;

				case 'map_kd':

					// Diffuse texture map

					setMapForType( "map", value );

					break;

				case 'map_ks':

					// Specular map

					setMapForType( "specularMap", value );

					break;

				case 'map_ke':

					// Emissive map

					setMapForType( "emissiveMap", value );

					break;

				case 'norm':

					setMapForType( "normalMap", value );

					break;

				case 'map_bump':
				case 'bump':

					// Bump texture map

					setMapForType( "bumpMap", value );

					break;

				case 'map_d':

					// Alpha map

					setMapForType( "alphaMap", value );
					params.transparent = true;

					break;

				case 'ns':

					// The specular exponent (defines the focus of the specular highlight)
					// A high exponent results in a tight, concentrated highlight. Ns values normally range from 0 to 1000.

					params.shininess = parseFloat( value );

					break;

				case 'd':
					n = parseFloat( value );

					if ( n < 1 ) {

						params.opacity = n;
						params.transparent = true;

					}

					break;

				case 'tr':
					n = parseFloat( value );

					if ( this.options && this.options.invertTrProperty ) n = 1 - n;

					if ( n > 0 ) {

						params.opacity = 1 - n;
						params.transparent = true;

					}

					break;

				default:
					break;

			}

		}

		this.materials[ materialName ] = new THREE.MeshPhongMaterial( params );
		return this.materials[ materialName ];

	},

	getTextureParams: function ( value, matParams ) {

		var texParams = {

			scale: new THREE.Vector2( 1, 1 ),
			offset: new THREE.Vector2( 0, 0 )

		 };

		var items = value.split( /\s+/ );
		var pos;

		pos = items.indexOf( '-bm' );

		if ( pos >= 0 ) {

			matParams.bumpScale = parseFloat( items[ pos + 1 ] );
			items.splice( pos, 2 );

		}

		pos = items.indexOf( '-s' );

		if ( pos >= 0 ) {

			texParams.scale.set( parseFloat( items[ pos + 1 ] ), parseFloat( items[ pos + 2 ] ) );
			items.splice( pos, 4 ); // we expect 3 parameters here!

		}

		pos = items.indexOf( '-o' );

		if ( pos >= 0 ) {

			texParams.offset.set( parseFloat( items[ pos + 1 ] ), parseFloat( items[ pos + 2 ] ) );
			items.splice( pos, 4 ); // we expect 3 parameters here!

		}

		texParams.url = items.join( ' ' ).trim();
		return texParams;

	},

	loadTexture: function ( url, mapping, onLoad, onProgress, onError ) {

		var texture;
		var manager = ( this.manager !== undefined ) ? this.manager : THREE.DefaultLoadingManager;
		var loader = manager.getHandler( url );

		if ( loader === null ) {

			loader = new THREE.TextureLoader( manager );

		}

		if ( loader.setCrossOrigin ) loader.setCrossOrigin( this.crossOrigin );
		texture = loader.load( url, onLoad, onProgress, onError );

		if ( mapping !== undefined ) texture.mapping = mapping;

		return texture;

	}

};

},{}],26:[function(require,module,exports){
/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.OBJLoader = ( function () {

	// o object_name | g group_name
	var object_pattern = /^[og]\s*(.+)?/;
	// mtllib file_reference
	var material_library_pattern = /^mtllib /;
	// usemtl material_name
	var material_use_pattern = /^usemtl /;

	function ParserState() {

		var state = {
			objects: [],
			object: {},

			vertices: [],
			normals: [],
			colors: [],
			uvs: [],

			materialLibraries: [],

			startObject: function ( name, fromDeclaration ) {

				// If the current object (initial from reset) is not from a g/o declaration in the parsed
				// file. We need to use it for the first parsed g/o to keep things in sync.
				if ( this.object && this.object.fromDeclaration === false ) {

					this.object.name = name;
					this.object.fromDeclaration = ( fromDeclaration !== false );
					return;

				}

				var previousMaterial = ( this.object && typeof this.object.currentMaterial === 'function' ? this.object.currentMaterial() : undefined );

				if ( this.object && typeof this.object._finalize === 'function' ) {

					this.object._finalize( true );

				}

				this.object = {
					name: name || '',
					fromDeclaration: ( fromDeclaration !== false ),

					geometry: {
						vertices: [],
						normals: [],
						colors: [],
						uvs: []
					},
					materials: [],
					smooth: true,

					startMaterial: function ( name, libraries ) {

						var previous = this._finalize( false );

						// New usemtl declaration overwrites an inherited material, except if faces were declared
						// after the material, then it must be preserved for proper MultiMaterial continuation.
						if ( previous && ( previous.inherited || previous.groupCount <= 0 ) ) {

							this.materials.splice( previous.index, 1 );

						}

						var material = {
							index: this.materials.length,
							name: name || '',
							mtllib: ( Array.isArray( libraries ) && libraries.length > 0 ? libraries[ libraries.length - 1 ] : '' ),
							smooth: ( previous !== undefined ? previous.smooth : this.smooth ),
							groupStart: ( previous !== undefined ? previous.groupEnd : 0 ),
							groupEnd: - 1,
							groupCount: - 1,
							inherited: false,

							clone: function ( index ) {

								var cloned = {
									index: ( typeof index === 'number' ? index : this.index ),
									name: this.name,
									mtllib: this.mtllib,
									smooth: this.smooth,
									groupStart: 0,
									groupEnd: - 1,
									groupCount: - 1,
									inherited: false
								};
								cloned.clone = this.clone.bind( cloned );
								return cloned;

							}
						};

						this.materials.push( material );

						return material;

					},

					currentMaterial: function () {

						if ( this.materials.length > 0 ) {

							return this.materials[ this.materials.length - 1 ];

						}

						return undefined;

					},

					_finalize: function ( end ) {

						var lastMultiMaterial = this.currentMaterial();
						if ( lastMultiMaterial && lastMultiMaterial.groupEnd === - 1 ) {

							lastMultiMaterial.groupEnd = this.geometry.vertices.length / 3;
							lastMultiMaterial.groupCount = lastMultiMaterial.groupEnd - lastMultiMaterial.groupStart;
							lastMultiMaterial.inherited = false;

						}

						// Ignore objects tail materials if no face declarations followed them before a new o/g started.
						if ( end && this.materials.length > 1 ) {

							for ( var mi = this.materials.length - 1; mi >= 0; mi -- ) {

								if ( this.materials[ mi ].groupCount <= 0 ) {

									this.materials.splice( mi, 1 );

								}

							}

						}

						// Guarantee at least one empty material, this makes the creation later more straight forward.
						if ( end && this.materials.length === 0 ) {

							this.materials.push( {
								name: '',
								smooth: this.smooth
							} );

						}

						return lastMultiMaterial;

					}
				};

				// Inherit previous objects material.
				// Spec tells us that a declared material must be set to all objects until a new material is declared.
				// If a usemtl declaration is encountered while this new object is being parsed, it will
				// overwrite the inherited material. Exception being that there was already face declarations
				// to the inherited material, then it will be preserved for proper MultiMaterial continuation.

				if ( previousMaterial && previousMaterial.name && typeof previousMaterial.clone === 'function' ) {

					var declared = previousMaterial.clone( 0 );
					declared.inherited = true;
					this.object.materials.push( declared );

				}

				this.objects.push( this.object );

			},

			finalize: function () {

				if ( this.object && typeof this.object._finalize === 'function' ) {

					this.object._finalize( true );

				}

			},

			parseVertexIndex: function ( value, len ) {

				var index = parseInt( value, 10 );
				return ( index >= 0 ? index - 1 : index + len / 3 ) * 3;

			},

			parseNormalIndex: function ( value, len ) {

				var index = parseInt( value, 10 );
				return ( index >= 0 ? index - 1 : index + len / 3 ) * 3;

			},

			parseUVIndex: function ( value, len ) {

				var index = parseInt( value, 10 );
				return ( index >= 0 ? index - 1 : index + len / 2 ) * 2;

			},

			addVertex: function ( a, b, c ) {

				var src = this.vertices;
				var dst = this.object.geometry.vertices;

				dst.push( src[ a + 0 ], src[ a + 1 ], src[ a + 2 ] );
				dst.push( src[ b + 0 ], src[ b + 1 ], src[ b + 2 ] );
				dst.push( src[ c + 0 ], src[ c + 1 ], src[ c + 2 ] );

			},

			addVertexPoint: function ( a ) {

				var src = this.vertices;
				var dst = this.object.geometry.vertices;

				dst.push( src[ a + 0 ], src[ a + 1 ], src[ a + 2 ] );

			},

			addVertexLine: function ( a ) {

				var src = this.vertices;
				var dst = this.object.geometry.vertices;

				dst.push( src[ a + 0 ], src[ a + 1 ], src[ a + 2 ] );

			},

			addNormal: function ( a, b, c ) {

				var src = this.normals;
				var dst = this.object.geometry.normals;

				dst.push( src[ a + 0 ], src[ a + 1 ], src[ a + 2 ] );
				dst.push( src[ b + 0 ], src[ b + 1 ], src[ b + 2 ] );
				dst.push( src[ c + 0 ], src[ c + 1 ], src[ c + 2 ] );

			},

			addColor: function ( a, b, c ) {

				var src = this.colors;
				var dst = this.object.geometry.colors;

				dst.push( src[ a + 0 ], src[ a + 1 ], src[ a + 2 ] );
				dst.push( src[ b + 0 ], src[ b + 1 ], src[ b + 2 ] );
				dst.push( src[ c + 0 ], src[ c + 1 ], src[ c + 2 ] );

			},

			addUV: function ( a, b, c ) {

				var src = this.uvs;
				var dst = this.object.geometry.uvs;

				dst.push( src[ a + 0 ], src[ a + 1 ] );
				dst.push( src[ b + 0 ], src[ b + 1 ] );
				dst.push( src[ c + 0 ], src[ c + 1 ] );

			},

			addUVLine: function ( a ) {

				var src = this.uvs;
				var dst = this.object.geometry.uvs;

				dst.push( src[ a + 0 ], src[ a + 1 ] );

			},

			addFace: function ( a, b, c, ua, ub, uc, na, nb, nc ) {

				var vLen = this.vertices.length;

				var ia = this.parseVertexIndex( a, vLen );
				var ib = this.parseVertexIndex( b, vLen );
				var ic = this.parseVertexIndex( c, vLen );

				this.addVertex( ia, ib, ic );

				if ( this.colors.length > 0 ) {

					this.addColor( ia, ib, ic );

				}

				if ( ua !== undefined && ua !== '' ) {

					var uvLen = this.uvs.length;
					ia = this.parseUVIndex( ua, uvLen );
					ib = this.parseUVIndex( ub, uvLen );
					ic = this.parseUVIndex( uc, uvLen );
					this.addUV( ia, ib, ic );

				}

				if ( na !== undefined && na !== '' ) {

					// Normals are many times the same. If so, skip function call and parseInt.
					var nLen = this.normals.length;
					ia = this.parseNormalIndex( na, nLen );

					ib = na === nb ? ia : this.parseNormalIndex( nb, nLen );
					ic = na === nc ? ia : this.parseNormalIndex( nc, nLen );

					this.addNormal( ia, ib, ic );

				}

			},

			addPointGeometry: function ( vertices ) {

				this.object.geometry.type = 'Points';

				var vLen = this.vertices.length;

				for ( var vi = 0, l = vertices.length; vi < l; vi ++ ) {

					this.addVertexPoint( this.parseVertexIndex( vertices[ vi ], vLen ) );

				}

			},

			addLineGeometry: function ( vertices, uvs ) {

				this.object.geometry.type = 'Line';

				var vLen = this.vertices.length;
				var uvLen = this.uvs.length;

				for ( var vi = 0, l = vertices.length; vi < l; vi ++ ) {

					this.addVertexLine( this.parseVertexIndex( vertices[ vi ], vLen ) );

				}

				for ( var uvi = 0, l = uvs.length; uvi < l; uvi ++ ) {

					this.addUVLine( this.parseUVIndex( uvs[ uvi ], uvLen ) );

				}

			}

		};

		state.startObject( '', false );

		return state;

	}

	//

	function OBJLoader( manager ) {

		THREE.Loader.call( this, manager );

		this.materials = null;

	}

	OBJLoader.prototype = Object.assign( Object.create( THREE.Loader.prototype ), {

		constructor: OBJLoader,

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var loader = new THREE.FileLoader( scope.manager );
			loader.setPath( this.path );
			loader.load( url, function ( text ) {

				onLoad( scope.parse( text ) );

			}, onProgress, onError );

		},

		setMaterials: function ( materials ) {

			this.materials = materials;

			return this;

		},

		parse: function ( text ) {

			console.time( 'OBJLoader' );

			var state = new ParserState();

			if ( text.indexOf( '\r\n' ) !== - 1 ) {

				// This is faster than String.split with regex that splits on both
				text = text.replace( /\r\n/g, '\n' );

			}

			if ( text.indexOf( '\\\n' ) !== - 1 ) {

				// join lines separated by a line continuation character (\)
				text = text.replace( /\\\n/g, '' );

			}

			var lines = text.split( '\n' );
			var line = '', lineFirstChar = '';
			var lineLength = 0;
			var result = [];

			// Faster to just trim left side of the line. Use if available.
			var trimLeft = ( typeof ''.trimLeft === 'function' );

			for ( var i = 0, l = lines.length; i < l; i ++ ) {

				line = lines[ i ];

				line = trimLeft ? line.trimLeft() : line.trim();

				lineLength = line.length;

				if ( lineLength === 0 ) continue;

				lineFirstChar = line.charAt( 0 );

				// @todo invoke passed in handler if any
				if ( lineFirstChar === '#' ) continue;

				if ( lineFirstChar === 'v' ) {

					var data = line.split( /\s+/ );

					switch ( data[ 0 ] ) {

						case 'v':
							state.vertices.push(
								parseFloat( data[ 1 ] ),
								parseFloat( data[ 2 ] ),
								parseFloat( data[ 3 ] )
							);
							if ( data.length >= 7 ) {

								state.colors.push(
									parseFloat( data[ 4 ] ),
									parseFloat( data[ 5 ] ),
									parseFloat( data[ 6 ] )

								);

							}
							break;
						case 'vn':
							state.normals.push(
								parseFloat( data[ 1 ] ),
								parseFloat( data[ 2 ] ),
								parseFloat( data[ 3 ] )
							);
							break;
						case 'vt':
							state.uvs.push(
								parseFloat( data[ 1 ] ),
								parseFloat( data[ 2 ] )
							);
							break;

					}

				} else if ( lineFirstChar === 'f' ) {

					var lineData = line.substr( 1 ).trim();
					var vertexData = lineData.split( /\s+/ );
					var faceVertices = [];

					// Parse the face vertex data into an easy to work with format

					for ( var j = 0, jl = vertexData.length; j < jl; j ++ ) {

						var vertex = vertexData[ j ];

						if ( vertex.length > 0 ) {

							var vertexParts = vertex.split( '/' );
							faceVertices.push( vertexParts );

						}

					}

					// Draw an edge between the first vertex and all subsequent vertices to form an n-gon

					var v1 = faceVertices[ 0 ];

					for ( var j = 1, jl = faceVertices.length - 1; j < jl; j ++ ) {

						var v2 = faceVertices[ j ];
						var v3 = faceVertices[ j + 1 ];

						state.addFace(
							v1[ 0 ], v2[ 0 ], v3[ 0 ],
							v1[ 1 ], v2[ 1 ], v3[ 1 ],
							v1[ 2 ], v2[ 2 ], v3[ 2 ]
						);

					}

				} else if ( lineFirstChar === 'l' ) {

					var lineParts = line.substring( 1 ).trim().split( " " );
					var lineVertices = [], lineUVs = [];

					if ( line.indexOf( "/" ) === - 1 ) {

						lineVertices = lineParts;

					} else {

						for ( var li = 0, llen = lineParts.length; li < llen; li ++ ) {

							var parts = lineParts[ li ].split( "/" );

							if ( parts[ 0 ] !== "" ) lineVertices.push( parts[ 0 ] );
							if ( parts[ 1 ] !== "" ) lineUVs.push( parts[ 1 ] );

						}

					}
					state.addLineGeometry( lineVertices, lineUVs );

				} else if ( lineFirstChar === 'p' ) {

					var lineData = line.substr( 1 ).trim();
					var pointData = lineData.split( " " );

					state.addPointGeometry( pointData );

				} else if ( ( result = object_pattern.exec( line ) ) !== null ) {

					// o object_name
					// or
					// g group_name

					// WORKAROUND: https://bugs.chromium.org/p/v8/issues/detail?id=2869
					// var name = result[ 0 ].substr( 1 ).trim();
					var name = ( " " + result[ 0 ].substr( 1 ).trim() ).substr( 1 );

					state.startObject( name );

				} else if ( material_use_pattern.test( line ) ) {

					// material

					state.object.startMaterial( line.substring( 7 ).trim(), state.materialLibraries );

				} else if ( material_library_pattern.test( line ) ) {

					// mtl file

					state.materialLibraries.push( line.substring( 7 ).trim() );

				} else if ( lineFirstChar === 's' ) {

					result = line.split( ' ' );

					// smooth shading

					// @todo Handle files that have varying smooth values for a set of faces inside one geometry,
					// but does not define a usemtl for each face set.
					// This should be detected and a dummy material created (later MultiMaterial and geometry groups).
					// This requires some care to not create extra material on each smooth value for "normal" obj files.
					// where explicit usemtl defines geometry groups.
					// Example asset: examples/models/obj/cerberus/Cerberus.obj

					/*
					 * http://paulbourke.net/dataformats/obj/
					 * or
					 * http://www.cs.utah.edu/~boulos/cs3505/obj_spec.pdf
					 *
					 * From chapter "Grouping" Syntax explanation "s group_number":
					 * "group_number is the smoothing group number. To turn off smoothing groups, use a value of 0 or off.
					 * Polygonal elements use group numbers to put elements in different smoothing groups. For free-form
					 * surfaces, smoothing groups are either turned on or off; there is no difference between values greater
					 * than 0."
					 */
					if ( result.length > 1 ) {

						var value = result[ 1 ].trim().toLowerCase();
						state.object.smooth = ( value !== '0' && value !== 'off' );

					} else {

						// ZBrush can produce "s" lines #11707
						state.object.smooth = true;

					}
					var material = state.object.currentMaterial();
					if ( material ) material.smooth = state.object.smooth;

				} else {

					// Handle null terminated files without exception
					if ( line === '\0' ) continue;

					throw new Error( 'THREE.OBJLoader: Unexpected line: "' + line + '"' );

				}

			}

			state.finalize();

			var container = new THREE.Group();
			container.materialLibraries = [].concat( state.materialLibraries );

			for ( var i = 0, l = state.objects.length; i < l; i ++ ) {

				var object = state.objects[ i ];
				var geometry = object.geometry;
				var materials = object.materials;
				var isLine = ( geometry.type === 'Line' );
				var isPoints = ( geometry.type === 'Points' );
				var hasVertexColors = false;

				// Skip o/g line declarations that did not follow with any faces
				if ( geometry.vertices.length === 0 ) continue;

				var buffergeometry = new THREE.BufferGeometry();

				buffergeometry.setAttribute( 'position', new THREE.Float32BufferAttribute( geometry.vertices, 3 ) );

				if ( geometry.normals.length > 0 ) {

					buffergeometry.setAttribute( 'normal', new THREE.Float32BufferAttribute( geometry.normals, 3 ) );

				} else {

					buffergeometry.computeVertexNormals();

				}

				if ( geometry.colors.length > 0 ) {

					hasVertexColors = true;
					buffergeometry.setAttribute( 'color', new THREE.Float32BufferAttribute( geometry.colors, 3 ) );

				}

				if ( geometry.uvs.length > 0 ) {

					buffergeometry.setAttribute( 'uv', new THREE.Float32BufferAttribute( geometry.uvs, 2 ) );

				}

				// Create materials

				var createdMaterials = [];

				for ( var mi = 0, miLen = materials.length; mi < miLen; mi ++ ) {

					var sourceMaterial = materials[ mi ];
					var material = undefined;

					if ( this.materials !== null ) {

						material = this.materials.create( sourceMaterial.name );

						// mtl etc. loaders probably can't create line materials correctly, copy properties to a line material.
						if ( isLine && material && ! ( material instanceof THREE.LineBasicMaterial ) ) {

							var materialLine = new THREE.LineBasicMaterial();
							THREE.Material.prototype.copy.call( materialLine, material );
							materialLine.color.copy( material.color );
							material = materialLine;

						} else if ( isPoints && material && ! ( material instanceof THREE.PointsMaterial ) ) {

							var materialPoints = new THREE.PointsMaterial( { size: 10, sizeAttenuation: false } );
							THREE.Material.prototype.copy.call( materialPoints, material );
							materialPoints.color.copy( material.color );
							materialPoints.map = material.map;
							material = materialPoints;

						}

					}

					if ( ! material ) {

						if ( isLine ) {

							material = new THREE.LineBasicMaterial();

						} else if ( isPoints ) {

							material = new THREE.PointsMaterial( { size: 1, sizeAttenuation: false } );

						} else {

							material = new THREE.MeshPhongMaterial();

						}

						material.name = sourceMaterial.name;

					}

					material.flatShading = sourceMaterial.smooth ? false : true;
					material.vertexColors = hasVertexColors ? THREE.VertexColors : THREE.NoColors;

					createdMaterials.push( material );

				}

				// Create mesh

				var mesh;

				if ( createdMaterials.length > 1 ) {

					for ( var mi = 0, miLen = materials.length; mi < miLen; mi ++ ) {

						var sourceMaterial = materials[ mi ];
						buffergeometry.addGroup( sourceMaterial.groupStart, sourceMaterial.groupCount, mi );

					}

					if ( isLine ) {

						mesh = new THREE.LineSegments( buffergeometry, createdMaterials );

					} else if ( isPoints ) {

						mesh = new THREE.Points( buffergeometry, createdMaterials );

					} else {

						mesh = new THREE.Mesh( buffergeometry, createdMaterials );

					}

				} else {

					if ( isLine ) {

						mesh = new THREE.LineSegments( buffergeometry, createdMaterials[ 0 ] );

					} else if ( isPoints ) {

						mesh = new THREE.Points( buffergeometry, createdMaterials[ 0 ] );

					} else {

						mesh = new THREE.Mesh( buffergeometry, createdMaterials[ 0 ] );

					}

				}

				mesh.name = object.name;

				container.add( mesh );

			}

			console.timeEnd( 'OBJLoader' );

			return container;

		}

	} );

	return OBJLoader;

} )();

},{}],27:[function(require,module,exports){
/**
 * @author alteredq / http://alteredqualia.com/
 */

THREE.EffectComposer = function ( renderer, renderTarget ) {

	this.renderer = renderer;

	if ( renderTarget === undefined ) {

		var parameters = {
			minFilter: THREE.LinearFilter,
			magFilter: THREE.LinearFilter,
			format: THREE.RGBAFormat,
			stencilBuffer: false
		};

		var size = renderer.getSize( new THREE.Vector2() );
		this._pixelRatio = renderer.getPixelRatio();
		this._width = size.width;
		this._height = size.height;

		renderTarget = new THREE.WebGLRenderTarget( this._width * this._pixelRatio, this._height * this._pixelRatio, parameters );
		renderTarget.texture.name = 'EffectComposer.rt1';

	} else {

		this._pixelRatio = 1;
		this._width = renderTarget.width;
		this._height = renderTarget.height;

	}

	this.renderTarget1 = renderTarget;
	this.renderTarget2 = renderTarget.clone();
	this.renderTarget2.texture.name = 'EffectComposer.rt2';

	this.writeBuffer = this.renderTarget1;
	this.readBuffer = this.renderTarget2;

	this.renderToScreen = true;

	this.passes = [];

	// dependencies

	if ( THREE.CopyShader === undefined ) {

		console.error( 'THREE.EffectComposer relies on THREE.CopyShader' );

	}

	if ( THREE.ShaderPass === undefined ) {

		console.error( 'THREE.EffectComposer relies on THREE.ShaderPass' );

	}

	this.copyPass = new THREE.ShaderPass( THREE.CopyShader );

	this.clock = new THREE.Clock();

};

Object.assign( THREE.EffectComposer.prototype, {

	swapBuffers: function () {

		var tmp = this.readBuffer;
		this.readBuffer = this.writeBuffer;
		this.writeBuffer = tmp;

	},

	addPass: function ( pass ) {

		this.passes.push( pass );
		pass.setSize( this._width * this._pixelRatio, this._height * this._pixelRatio );

	},

	insertPass: function ( pass, index ) {

		this.passes.splice( index, 0, pass );

	},

	isLastEnabledPass: function ( passIndex ) {

		for ( var i = passIndex + 1; i < this.passes.length; i ++ ) {

			if ( this.passes[ i ].enabled ) {

				return false;

			}

		}

		return true;

	},

	render: function ( deltaTime ) {

		// deltaTime value is in seconds

		if ( deltaTime === undefined ) {

			deltaTime = this.clock.getDelta();

		}

		var currentRenderTarget = this.renderer.getRenderTarget();

		var maskActive = false;

		var pass, i, il = this.passes.length;

		for ( i = 0; i < il; i ++ ) {

			pass = this.passes[ i ];

			if ( pass.enabled === false ) continue;

			pass.renderToScreen = ( this.renderToScreen && this.isLastEnabledPass( i ) );
			pass.render( this.renderer, this.writeBuffer, this.readBuffer, deltaTime, maskActive );

			if ( pass.needsSwap ) {

				if ( maskActive ) {

					var context = this.renderer.getContext();
					var stencil = this.renderer.state.buffers.stencil;

					//context.stencilFunc( context.NOTEQUAL, 1, 0xffffffff );
					stencil.setFunc( context.NOTEQUAL, 1, 0xffffffff );

					this.copyPass.render( this.renderer, this.writeBuffer, this.readBuffer, deltaTime );

					//context.stencilFunc( context.EQUAL, 1, 0xffffffff );
					stencil.setFunc( context.EQUAL, 1, 0xffffffff );

				}

				this.swapBuffers();

			}

			if ( THREE.MaskPass !== undefined ) {

				if ( pass instanceof THREE.MaskPass ) {

					maskActive = true;

				} else if ( pass instanceof THREE.ClearMaskPass ) {

					maskActive = false;

				}

			}

		}

		this.renderer.setRenderTarget( currentRenderTarget );

	},

	reset: function ( renderTarget ) {

		if ( renderTarget === undefined ) {

			var size = this.renderer.getSize( new THREE.Vector2() );
			this._pixelRatio = this.renderer.getPixelRatio();
			this._width = size.width;
			this._height = size.height;

			renderTarget = this.renderTarget1.clone();
			renderTarget.setSize( this._width * this._pixelRatio, this._height * this._pixelRatio );

		}

		this.renderTarget1.dispose();
		this.renderTarget2.dispose();
		this.renderTarget1 = renderTarget;
		this.renderTarget2 = renderTarget.clone();

		this.writeBuffer = this.renderTarget1;
		this.readBuffer = this.renderTarget2;

	},

	setSize: function ( width, height ) {

		this._width = width;
		this._height = height;

		var effectiveWidth = this._width * this._pixelRatio;
		var effectiveHeight = this._height * this._pixelRatio;

		this.renderTarget1.setSize( effectiveWidth, effectiveHeight );
		this.renderTarget2.setSize( effectiveWidth, effectiveHeight );

		for ( var i = 0; i < this.passes.length; i ++ ) {

			this.passes[ i ].setSize( effectiveWidth, effectiveHeight );

		}

	},

	setPixelRatio: function ( pixelRatio ) {

		this._pixelRatio = pixelRatio;

		this.setSize( this._width, this._height );

	}

} );


THREE.Pass = function () {

	// if set to true, the pass is processed by the composer
	this.enabled = true;

	// if set to true, the pass indicates to swap read and write buffer after rendering
	this.needsSwap = true;

	// if set to true, the pass clears its buffer before rendering
	this.clear = false;

	// if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.
	this.renderToScreen = false;

};

Object.assign( THREE.Pass.prototype, {

	setSize: function ( /* width, height */ ) {},

	render: function ( /* renderer, writeBuffer, readBuffer, deltaTime, maskActive */ ) {

		console.error( 'THREE.Pass: .render() must be implemented in derived pass.' );

	}

} );

// Helper for passes that need to fill the viewport with a single quad.
THREE.Pass.FullScreenQuad = ( function () {

	var camera = new THREE.OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
	var geometry = new THREE.PlaneBufferGeometry( 2, 2 );

	var FullScreenQuad = function ( material ) {

		this._mesh = new THREE.Mesh( geometry, material );

	};

	Object.defineProperty( FullScreenQuad.prototype, 'material', {

		get: function () {

			return this._mesh.material;

		},

		set: function ( value ) {

			this._mesh.material = value;

		}

	} );

	Object.assign( FullScreenQuad.prototype, {

		render: function ( renderer ) {

			renderer.render( this._mesh, camera );

		}

	} );

	return FullScreenQuad;

} )();

},{}],28:[function(require,module,exports){
/**
 * @author alteredq / http://alteredqualia.com/
 */

THREE.RenderPass = function ( scene, camera, overrideMaterial, clearColor, clearAlpha ) {

	THREE.Pass.call( this );

	this.scene = scene;
	this.camera = camera;

	this.overrideMaterial = overrideMaterial;

	this.clearColor = clearColor;
	this.clearAlpha = ( clearAlpha !== undefined ) ? clearAlpha : 0;

	this.clear = true;
	this.clearDepth = false;
	this.needsSwap = false;

};

THREE.RenderPass.prototype = Object.assign( Object.create( THREE.Pass.prototype ), {

	constructor: THREE.RenderPass,

	render: function ( renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {

		var oldAutoClear = renderer.autoClear;
		renderer.autoClear = false;

		this.scene.overrideMaterial = this.overrideMaterial;

		var oldClearColor, oldClearAlpha;

		if ( this.clearColor ) {

			oldClearColor = renderer.getClearColor().getHex();
			oldClearAlpha = renderer.getClearAlpha();

			renderer.setClearColor( this.clearColor, this.clearAlpha );

		}

		if ( this.clearDepth ) {

			renderer.clearDepth();

		}

		renderer.setRenderTarget( this.renderToScreen ? null : readBuffer );

		// TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
		if ( this.clear ) renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );
		renderer.render( this.scene, this.camera );

		if ( this.clearColor ) {

			renderer.setClearColor( oldClearColor, oldClearAlpha );

		}

		this.scene.overrideMaterial = null;
		renderer.autoClear = oldAutoClear;

	}

} );

},{}],29:[function(require,module,exports){
/**
 * @author alteredq / http://alteredqualia.com/
 */

THREE.ShaderPass = function ( shader, textureID ) {

	THREE.Pass.call( this );

	this.textureID = ( textureID !== undefined ) ? textureID : "tDiffuse";

	if ( shader instanceof THREE.ShaderMaterial ) {

		this.uniforms = shader.uniforms;

		this.material = shader;

	} else if ( shader ) {

		this.uniforms = THREE.UniformsUtils.clone( shader.uniforms );

		this.material = new THREE.ShaderMaterial( {

			defines: Object.assign( {}, shader.defines ),
			uniforms: this.uniforms,
			vertexShader: shader.vertexShader,
			fragmentShader: shader.fragmentShader

		} );

	}

	this.fsQuad = new THREE.Pass.FullScreenQuad( this.material );

};

THREE.ShaderPass.prototype = Object.assign( Object.create( THREE.Pass.prototype ), {

	constructor: THREE.ShaderPass,

	render: function ( renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {

		if ( this.uniforms[ this.textureID ] ) {

			this.uniforms[ this.textureID ].value = readBuffer.texture;

		}

		this.fsQuad.material = this.material;

		if ( this.renderToScreen ) {

			renderer.setRenderTarget( null );
			this.fsQuad.render( renderer );

		} else {

			renderer.setRenderTarget( writeBuffer );
			// TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
			if ( this.clear ) renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );
			this.fsQuad.render( renderer );

		}

	}

} );

},{}],30:[function(require,module,exports){
/**
 * @author alteredq / http://alteredqualia.com/
 *
 * Full-screen textured quad shader
 */

THREE.CopyShader = {

	uniforms: {

		"tDiffuse": { value: null },
		"opacity": { value: 1.0 }

	},

	vertexShader: [

		"varying vec2 vUv;",

		"void main() {",

		"	vUv = uv;",
		"	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

		"}"

	].join( "\n" ),

	fragmentShader: [

		"uniform float opacity;",

		"uniform sampler2D tDiffuse;",

		"varying vec2 vUv;",

		"void main() {",

		"	vec4 texel = texture2D( tDiffuse, vUv );",
		"	gl_FragColor = opacity * texel;",

		"}"

	].join( "\n" )

};

},{}]},{},[23,20,21,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17])

